
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lVF98", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $8Iwqw = parcelRequire("8Iwqw");


var $8lt1a = parcelRequire("8lt1a");


var $b9k8w = parcelRequire("b9k8w");


var $1sCHt = parcelRequire("1sCHt");


var $5YDZX = parcelRequire("5YDZX");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lpNn5 = parcelRequire("lpNn5");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $93Gae = parcelRequire("93Gae");


var $dPoYT = parcelRequire("dPoYT");


var $JTIzG = parcelRequire("JTIzG");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $hU34N = parcelRequire("hU34N");

/* AIFloatingContextMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ /** @jsxFrag React.Fragment */ 









var $3ricL = parcelRequire("3ricL");


var $9DHhW = parcelRequire("9DHhW");


var $4n1IT = parcelRequire("4n1IT");








var $ExetK = parcelRequire("ExetK");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $3Am3T = parcelRequire("3Am3T");


var $NomII = parcelRequire("NomII");


var $bQm3c = parcelRequire("bQm3c");


var $7mpOv = parcelRequire("7mpOv");


var $8zMP3 = parcelRequire("8zMP3");














var $9ivsj = parcelRequire("9ivsj");

const $af25143620373faf$var$baseShadow = `0 0 0 2px ${"var(--ds-border-brand, #1868DB)"}`;
const $af25143620373faf$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $af25143620373faf$var$pulseKeyframes = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$SinglePulse = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2fBhteXHPU",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2fBhteXHPU",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$DoublePulse = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2fBhte0qPK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2fBhte0qPK",
            __cmplp.className
        ])
    });
});
const $af25143620373faf$var$defaultBorderRadius = null;
const $af25143620373faf$var$isInObjectSideBarBorderRadius = null;
const $af25143620373faf$export$cd20eff28c3c2c7f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { children: children, pulseCount: t1, isInObjectSideBar: t2 } = t0;
    const pulseCount = t1 === undefined ? 0 : t1;
    const isInObjectSideBar = t2 === undefined ? false : t2;
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    if (isReducedMotion) {
        let t3;
        if ($[0] !== children) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "contextual-pulse-none"
            }, children);
            $[0] = children;
            $[1] = t3;
        } else t3 = $[1];
        return t3;
    }
    switch(pulseCount){
        case 1:
            {
                const t3 = isInObjectSideBar && "_0bjKvDS5Zs";
                let t4;
                if ($[2] !== t3) {
                    t4 = (0, $hekY6.default)([
                        "_0bjKvDyzSk",
                        t3
                    ]);
                    $[2] = t3;
                    $[3] = t4;
                } else t4 = $[3];
                let t5;
                if ($[4] !== children || $[5] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$SinglePulse, {
                        "data-testid": "contextual-pulse-single",
                        className: t4
                    }, children);
                    $[4] = children;
                    $[5] = t4;
                    $[6] = t5;
                } else t5 = $[6];
                return t5;
            }
        case 2:
            {
                const t3 = isInObjectSideBar && "_0bjKvDS5Zs";
                let t4;
                if ($[7] !== t3) {
                    t4 = (0, $hekY6.default)([
                        "_0bjKvDyzSk",
                        t3
                    ]);
                    $[7] = t3;
                    $[8] = t4;
                } else t4 = $[8];
                let t5;
                if ($[9] !== children || $[10] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$DoublePulse, {
                        "data-testid": "contextual-pulse-double",
                        className: t4
                    }, children);
                    $[9] = children;
                    $[10] = t4;
                    $[11] = t5;
                } else t5 = $[11];
                return t5;
            }
    }
    let t3;
    if ($[12] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "contextual-pulse-none"
        }, children);
        $[12] = children;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ children: children, pulseCount: pulseCount = 0, isInObjectSideBar: isInObjectSideBar = false })=>{
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    if (isReducedMotion) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
    switch(pulseCount){
        case 1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$SinglePulse, {
                "data-testid": "contextual-pulse-single",
                className: (0, $hekY6.default)([
                    "_0bjKvDyzSk",
                    isInObjectSideBar && "_0bjKvDS5Zs"
                ])
            }, children);
        case 2:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$DoublePulse, {
                "data-testid": "contextual-pulse-double",
                className: (0, $hekY6.default)([
                    "_0bjKvDyzSk",
                    isInObjectSideBar && "_0bjKvDS5Zs"
                ])
            }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
};





















var $55fM8 = parcelRequire("55fM8");

const $5d003355575f53c0$export$cbb5dd4e54f3bea9 = (isLivePage = false)=>{
    {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const newViewPageContainer = document.getElementById('AkMainContent');
        const [scrollHeightAttributes, setScrollHeightAttributes] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cozmU.useState)({
            scrollY: 0
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const handleScroll = (0, $cozmU.useCallback)(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const viewPageScrollY = newViewPageContainer ? newViewPageContainer.scrollTop : window.scrollY;
            setScrollHeightAttributes({
                scrollY: isLivePage ? livePageContainer && livePageContainer.scrollTop : viewPageScrollY
            });
        }, [
            setScrollHeightAttributes,
            isLivePage,
            newViewPageContainer
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cozmU.useEffect)(()=>{
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const debounceScroll = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(handleScroll, 250);
            if (isLivePage) livePageContainer?.addEventListener('scroll', debounceScroll);
            else newViewPageContainer ? newViewPageContainer?.addEventListener('scroll', debounceScroll) : document.addEventListener('scroll', debounceScroll);
            return ()=>{
                if (isLivePage) livePageContainer?.removeEventListener('scroll', debounceScroll);
                else newViewPageContainer ? newViewPageContainer?.removeEventListener('scroll', debounceScroll) : document.removeEventListener('scroll', debounceScroll);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return scrollHeightAttributes;
    }
};


var $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf = /*#__PURE__*/ function(FeatureStates) {
    FeatureStates["QuickSummary"] = "quick-summary";
    FeatureStates["Comments"] = "comments";
    FeatureStates["PageCatchup"] = "page-catchup";
    FeatureStates["BulkIssueCreate"] = "bulk-issue-create";
    FeatureStates["QuickSummaryAudio"] = "quick-summary-audio";
    return FeatureStates;
}({});
var $2c4fc9e48b4f3b02$export$a913d22899a46b83 = /*#__PURE__*/ function(NonFeatureStates) {
    NonFeatureStates["Menu"] = "menu";
    NonFeatureStates["OptIn"] = "opt-in";
    NonFeatureStates["Upsell"] = "upsell";
    return NonFeatureStates;
}({});
const $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c = {
    ...$2c4fc9e48b4f3b02$export$881f3bfeb53afdcf,
    ...$2c4fc9e48b4f3b02$export$a913d22899a46b83
};
function $2c4fc9e48b4f3b02$export$4940a8f6968b63(popupState) {
    return Object.values($2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).includes(popupState);
}



var $i1vUz = parcelRequire("i1vUz");

const $83cf8da53844c2d7$export$7571cdd921b49cc0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, contentType, pageCommentsSectionInView, isLivePage)=>{
    const $ = (0, $bDgLe.c)(7);
    const { scrollY: scrollY } = (0, $5d003355575f53c0$export$cbb5dd4e54f3bea9)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === "page" ? "PAGE" : "BLOGPOST";
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    if (!isAdminHubAIEnabled) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: null
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) {
        let t0;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).Comments
            };
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) {
        let t0;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).PageCatchup
            };
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    if (scrollY !== null && scrollY < 400) {
        let t0;
        if ($[3] !== queryError) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).QuickSummary,
                queryError: queryError
            };
            $[3] = queryError;
            $[4] = t0;
        } else t0 = $[4];
        return t0;
    }
    let t0;
    if ($[5] !== queryError) {
        t0 = {
            dynamicActionTarget: null,
            queryError: queryError
        };
        $[5] = queryError;
        $[6] = t0;
    } else t0 = $[6];
    return t0;
} : (contentId, contentType, pageCommentsSectionInView, isLivePage)=>{
    const { scrollY: scrollY } = (0, $5d003355575f53c0$export$cbb5dd4e54f3bea9)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === 'page' ? 'PAGE' : 'BLOGPOST';
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    if (!isAdminHubAIEnabled) return {
        dynamicActionTarget: null
    };
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).Comments
    };
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).PageCatchup
    };
    if (scrollY !== null && scrollY < 400) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).QuickSummary,
        queryError: queryError
    };
    return {
        dynamicActionTarget: null,
        queryError: queryError
    };
};












var $ivb8S = parcelRequire("ivb8S");


var $d282Z = parcelRequire("d282Z");







const $874fd8abb2c90fe4$export$b938e63de8ec6cb1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, contentType)=>{
    const $ = (0, $bDgLe.c)(10);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $cozmU.useState)(0);
    const hasLoaded = (0, $cozmU.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === "page" ? "PAGE" : "BLOGPOST";
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    let t0;
    let t1;
    if ($[0] !== dynamicSplitButtonLoading || $[1] !== isAdminHubAIEnabled || $[2] !== onboardingStateData || $[3] !== onboardingStateLoading || $[4] !== setOnboardingState || $[5] !== showCatchupAsDefault) {
        t0 = ()=>{
            if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled) {
                hasLoaded.current = true;
                const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
                if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                    setOnboardingState({
                        key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                        value: "true"
                    });
                    setPulseCount(2);
                } else if (showCatchupAsDefault) setPulseCount(1);
            }
        };
        t1 = [
            dynamicSplitButtonLoading,
            onboardingStateData,
            onboardingStateLoading,
            setPulseCount,
            setOnboardingState,
            showCatchupAsDefault,
            isAdminHubAIEnabled
        ];
        $[0] = dynamicSplitButtonLoading;
        $[1] = isAdminHubAIEnabled;
        $[2] = onboardingStateData;
        $[3] = onboardingStateLoading;
        $[4] = setOnboardingState;
        $[5] = showCatchupAsDefault;
        $[6] = t0;
        $[7] = t1;
    } else {
        t0 = $[6];
        t1 = $[7];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[8] !== pulseCount) {
        t2 = {
            pulseCount: pulseCount
        };
        $[8] = pulseCount;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : (contentId, contentType)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $cozmU.useState)(0);
    const hasLoaded = (0, $cozmU.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === 'page' ? 'PAGE' : 'BLOGPOST';
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    // Ignoring error state as we will just not show a pulse if this errors
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    (0, $cozmU.useEffect)(()=>{
        if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled) {
            // We only want this to execute once and only once when both hooks are finished loading
            hasLoaded.current = true;
            const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
            if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                setOnboardingState({
                    key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                    value: 'true'
                });
                setPulseCount(2);
            } else if (showCatchupAsDefault) setPulseCount(1);
        }
    }, [
        dynamicSplitButtonLoading,
        onboardingStateData,
        onboardingStateLoading,
        setPulseCount,
        setOnboardingState,
        showCatchupAsDefault,
        isAdminHubAIEnabled
    ]);
    return {
        pulseCount: pulseCount
    };
};
























var $kz1Yj = parcelRequire("kz1Yj");





var $kh0hi = parcelRequire("kh0hi");


var $iODl6 = parcelRequire("iODl6");


var $57p4j = parcelRequire("57p4j");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 



var $320o0 = parcelRequire("320o0");

const $e926aed382b01d25$export$2c6a5235f6e9fe39 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
        color: "var(--ds-icon, #292A2E)",
        ...props
    });



var $1P7Cq = parcelRequire("1P7Cq");

const $7b40fa145aa0c9d8$var$i18n = (0, $kSwu1.defineMessages)({
    logoAltText: {
        id: "ai-floating-context-menu.floating-context-menu-button.logo-alt-text",
        defaultMessage: "Atlassian Intelligence"
    }
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.xlarge',
    padding: 'space.075',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.raised'
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.full'
});
const $7b40fa145aa0c9d8$var$dividerStyles = (0, $buxP3.xcss)({
    height: '100%',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar = (0, $buxP3.xcss)({
    height: '24px',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$defaultPressableStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    width: 'auto',
    maxWidth: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle',
    borderRadius: 'radius.small',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    whiteSpace: 'nowrap',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: 'border.width',
        pointerEvents: 'none',
        position: 'absolute'
    },
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
});
const $7b40fa145aa0c9d8$var$selectedPressableStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-selected, #E9F2FE)",
    color: 'color.text.selected',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    '::after': {
        content: '""',
        borderColor: 'color.border.selected',
        borderStyle: 'solid'
    },
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #1868DB)",
        background: "var(--ds-background-selected-hovered, #CFE1FD)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #1868DB)",
        background: "var(--ds-background-selected-pressed, #8FB8F6)",
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $7b40fa145aa0c9d8$var$pressableMotionStyles = (0, $buxP3.xcss)({
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    },
    ':active': {
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $7b40fa145aa0c9d8$var$sideBarPressableStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.full',
    paddingBlock: 'space.075'
});
const $7b40fa145aa0c9d8$export$c226a072142c15e9 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { dynamicActionText: dynamicActionText, isDynamicActionSelected: t1, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: t2 } = t0;
    const isDynamicActionSelected = t1 === undefined ? false : t1;
    const isInObjectSideBar = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const t3 = !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles;
    const t4 = isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar;
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = [
            t3,
            t4
        ];
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const t6 = !renderServerPlaceholder;
    let t7;
    if ($[3] !== dynamicActionText || $[4] !== isDynamicActionSelected || $[5] !== isInObjectSideBar || $[6] !== onDynamicActionClick) {
        t7 = dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "right",
            exitDirection: "right",
            duration: "medium"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                "data-vc": "ai-floating-dynamic-action"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                onClick: ()=>onDynamicActionClick?.(),
                xcss: [
                    $7b40fa145aa0c9d8$var$defaultPressableStyles,
                    isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                    isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles,
                    $7b40fa145aa0c9d8$var$pressableMotionStyles
                ]
            }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: [
                !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
            ]
        }));
        $[3] = dynamicActionText;
        $[4] = isDynamicActionSelected;
        $[5] = isInObjectSideBar;
        $[6] = onDynamicActionClick;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: t6,
            exitThenEnter: true
        }, t7);
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== formatMessage) {
        t9 = formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText);
        $[11] = formatMessage;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== onMenuButtonClick) {
        t10 = ()=>onMenuButtonClick?.();
        $[13] = onMenuButtonClick;
        $[14] = t10;
    } else t10 = $[14];
    const t11 = isInObjectSideBar ? "circle" : "default";
    let t12;
    if ($[15] !== isMenuOpen || $[16] !== t10 || $[17] !== t11 || $[18] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, $e926aed382b01d25$export$2c6a5235f6e9fe39),
            label: t9,
            onClick: t10,
            appearance: "subtle",
            isSelected: isMenuOpen,
            shape: t11
        });
        $[15] = isMenuOpen;
        $[16] = t10;
        $[17] = t11;
        $[18] = t9;
        $[19] = t12;
    } else t12 = $[19];
    let t13;
    if ($[20] !== t12 || $[21] !== t5 || $[22] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: t5,
            grow: "hug",
            space: "space.050",
            alignBlock: "center"
        }, t8, t12);
        $[20] = t12;
        $[21] = t5;
        $[22] = t8;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== t13 || $[25] !== triggerProps) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), triggerProps, t13);
        $[24] = t13;
        $[25] = triggerProps;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ dynamicActionText: dynamicActionText, isDynamicActionSelected: isDynamicActionSelected = false, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: isInObjectSideBar = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar
        ],
        grow: "hug",
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: !renderServerPlaceholder,
        exitThenEnter: true
    }, dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        entranceDirection: "right",
        exitDirection: "right",
        duration: "medium"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props,
            "data-vc": "ai-floating-dynamic-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            onClick: ()=>onDynamicActionClick?.(),
            xcss: [
                $7b40fa145aa0c9d8$var$defaultPressableStyles,
                isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles,
                $7b40fa145aa0c9d8$var$pressableMotionStyles
            ]
        }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, $e926aed382b01d25$export$2c6a5235f6e9fe39),
        label: formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText),
        onClick: ()=>onMenuButtonClick?.(),
        appearance: "subtle",
        isSelected: isMenuOpen,
        shape: isInObjectSideBar ? 'circle' : 'default'
    })));
};














// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44548221e1617185$var$PopupWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_30huDK5FKZ _0bjKvDyzSk _0KLXruqi9L _2OUyjtGk8v _39xV02nd2U _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDK5FKZ _0bjKvDyzSk _0KLXruqi9L _2OUyjtGk8v _39xV02nd2U _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ])
    });
});
const $44548221e1617185$export$2593be7073434b2d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props || $[5] !== ref) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44548221e1617185$var$PopupWrapper, {
            ...props,
            ref: ref,
            role: "dialog"
        }, children);
        $[3] = children;
        $[4] = props;
        $[5] = ref;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44548221e1617185$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog"
    }, children);
});















var $9d7Pd = parcelRequire("9d7Pd");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $1l0kj = parcelRequire("1l0kj");


var $9KSWX = parcelRequire("9KSWX");


var $3fO5l = parcelRequire("3fO5l");


var $gFEZF = parcelRequire("gFEZF");


var $eDtFr = parcelRequire("eDtFr");


var $5ZtfK = parcelRequire("5ZtfK");











var $aUTn5 = parcelRequire("aUTn5");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $1Q0l6 = parcelRequire("1Q0l6");


var $6fW2K = parcelRequire("6fW2K");


var $jln20 = parcelRequire("jln20");


var $cAdj8 = parcelRequire("cAdj8");

const $c8e282bfad3727e4$export$ddc739fc0aea988a = ({ contentId: contentId, content: content, useRovoWidth: useRovoWidth = false })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsRovoPanelWidth = (0, $hq2Sz.useSetIsRovoPanelWidth)();
    const setInsertStorageFragmentRequestPayload = (0, $hq2Sz.useSetInsertStorageFragmentRequestPayload)();
    const contentLastModifiedTimestamp = (0, $hq2Sz.useGetContentLastModifiedTimestamp)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, issueCreateSidePanelActions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $cozmU.useMemo)(()=>pageInfo?.operations?.some((op)=>op?.operation === 'update' && op?.targetType === pageInfo.type) || false, [
        pageInfo
    ]);
    return (0, $cozmU.useCallback)(()=>{
        setIsCreatedWithAi(true);
        setIsCreatedFromTable(false);
        setIsRovoPanelWidth(useRovoWidth);
        if (content.current) {
            const range = (0, $1Q0l6.getValidRange)((0, $1Q0l6.getPageContentRange)());
            const payload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), range, content.current, contentLastModifiedTimestamp);
            setInsertStorageFragmentRequestPayload(payload);
        }
        issueCreateSidePanelActions.setHasEditPermission(hasEditPermission);
        rightSidebarContext.open((0, $6fW2K.BULK_ISSUE_CREATE_SIDE_PANEL_ID), useRovoWidth ? (0, $6fW2K.ROVO_BULK_CREATE_SIDE_PANEL_WIDTH) : (0, $6fW2K.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    }, [
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        setIsRovoPanelWidth,
        useRovoWidth,
        contentId,
        content,
        contentLastModifiedTimestamp,
        setInsertStorageFragmentRequestPayload,
        issueCreateSidePanelActions,
        hasEditPermission,
        rightSidebarContext
    ]);
};












var $4aiCO = parcelRequire("4aiCO");





const $790b3996dfce6541$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    audioSummarySectionLabel: {
        id: "ai-floating-context-menu.menu.item.label.audio-summary",
        defaultMessage: "Listen to Page Summary"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    betaLabel: {
        id: "ai-floating-context-menu.menu.item.lozenge.beta",
        defaultMessage: "Beta"
    },
    summarizeSectionLabel: {
        id: "ai-floating-context-menu.summarize.section.label",
        defaultMessage: "Summarize page"
    },
    createSectionLabel: {
        id: "ai-floating-context-menu.create.section.label",
        defaultMessage: "Create"
    }
});
var $790b3996dfce6541$var$ContentActionsMenuSectionKey = /*#__PURE__*/ function(ContentActionsMenuSectionKey) {
    ContentActionsMenuSectionKey["Summarize"] = "Summarize";
    ContentActionsMenuSectionKey["Create"] = "Create";
    return ContentActionsMenuSectionKey;
}($790b3996dfce6541$var$ContentActionsMenuSectionKey || {});
const $790b3996dfce6541$export$2b7899a440558a80 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { contentId: contentId, isLivePage: t1, setIsOpen: setIsOpen, setPopupState: setPopupState } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    let t2;
    if ($[0] !== rightSidebarContext) {
        t2 = rightSidebarContext.getCurrent()?.panelId;
        $[0] = rightSidebarContext;
        $[1] = t2;
    } else t2 = $[1];
    const isSidePanelOpen = t2 === (0, $6fW2K.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = typeof document !== "undefined" ? document.querySelector("div#content") : null;
        $[2] = t3;
    } else t3 = $[2];
    const content = (0, $cozmU.useRef)(t3);
    let t4;
    if ($[3] !== contentId) {
        t4 = {
            contentId: contentId,
            content: content
        };
        $[3] = contentId;
        $[4] = t4;
    } else t4 = $[4];
    const handleBulkIssueCreate = (0, $c8e282bfad3727e4$export$ddc739fc0aea988a)(t4);
    let t5;
    if ($[5] !== contentId || $[6] !== createAnalyticsEvent || $[7] !== edition || $[8] !== footerCommentsCount || $[9] !== handleBulkIssueCreate || $[10] !== intl || $[11] !== isLivePage || $[12] !== isSidePanelOpen || $[13] !== setIsOpen || $[14] !== setPopupState || $[15] !== showWarningDialog || $[16] !== unresolvedInlineCommentsCount) {
        const menuItems = [
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
                showMenuItem: true,
                isDisabled: false,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
                showMenuItem: true,
                isDisabled: false,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
                showMenuItem: true,
                isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate,
                label: intl.formatMessage((0, $9wGTI.fg)("confluence-issue-terminology-refresh") ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
                showMenuItem: (0, $9wGTI.fg)("confluence_ai_bulk_issue_creation"),
                isDisabled: false,
                beta: false,
                section: "Create",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                    label: ""
                })
            }
        ];
        const sectionItems = [
            {
                key: "Summarize",
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
                showSection: menuItems.some($790b3996dfce6541$var$_temp)
            },
            {
                key: "Create",
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
                showSection: !isLivePage && menuItems.some($790b3996dfce6541$var$_temp2)
            }
        ];
        const onMenuItemSelection = (key)=>{
            let additionalAnalyticsAttributes = {};
            if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments) additionalAnalyticsAttributes = {
                numPageCommentsSummarized: footerCommentsCount,
                numInlineCommentsSummarized: unresolvedInlineCommentsCount
            };
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "page",
                    action: "clicked",
                    actionSubject: "menuItem",
                    actionSubjectId: `aiActionsMenuItem-${key}`,
                    attributes: {
                        contentId: contentId,
                        edition: edition,
                        ...additionalAnalyticsAttributes,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
            if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate && (0, $9wGTI.fg)("confluence_ai_bulk_issue_creation")) {
                if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
                else {
                    setIsOpen(false);
                    handleBulkIssueCreate();
                }
            } else setPopupState(key);
        };
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            testId: "ai-uber-button-menu-group"
        }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                key: section.key,
                title: section.label
            }, menuItems.map((item_1)=>item_1.showMenuItem && item_1.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    iconBefore: item_1.icon,
                    key: item_1.key,
                    isDisabled: item_1.isDisabled,
                    onClick: ()=>{
                        onMenuItemSelection(item_1.key);
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    spread: "space-between",
                    alignBlock: "center"
                }, item_1.label, item_1.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
        $[5] = contentId;
        $[6] = createAnalyticsEvent;
        $[7] = edition;
        $[8] = footerCommentsCount;
        $[9] = handleBulkIssueCreate;
        $[10] = intl;
        $[11] = isLivePage;
        $[12] = isSidePanelOpen;
        $[13] = setIsOpen;
        $[14] = setPopupState;
        $[15] = showWarningDialog;
        $[16] = unresolvedInlineCommentsCount;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ contentId: contentId, isLivePage: isLivePage = false, setIsOpen: setIsOpen, setPopupState: setPopupState })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $6fW2K.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $cozmU.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const handleBulkIssueCreate = (0, $c8e282bfad3727e4$export$ddc739fc0aea988a)({
        contentId: contentId,
        content: content
    });
    const menuItems = [
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
            showMenuItem: true,
            isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate,
            label: intl.formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
            showMenuItem: (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation'),
            isDisabled: false,
            beta: false,
            section: "Create",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                label: ""
            })
        }
    ];
    const sectionItems = [
        {
            key: "Summarize",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showSection: menuItems.some((item)=>item.section === 'Summarize' && item.showMenuItem)
        },
        {
            key: "Create",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
            showSection: !isLivePage && menuItems.some((item_0)=>item_0.section === 'Create' && item_0.showMenuItem)
        }
    ];
    const onMenuItemSelection = (key)=>{
        let additionalAnalyticsAttributes = {};
        if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments) additionalAnalyticsAttributes = {
            numPageCommentsSummarized: footerCommentsCount,
            numInlineCommentsSummarized: unresolvedInlineCommentsCount
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'menuItem',
                actionSubjectId: `aiActionsMenuItem-${key}`,
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    ...additionalAnalyticsAttributes,
                    isLivePage: isLivePage
                }
            }
        }).fire();
        if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) {
            if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
            else {
                setIsOpen(false);
                handleBulkIssueCreate();
            }
        } else setPopupState(key);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        testId: "ai-uber-button-menu-group"
    }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            key: section.key,
            title: section.label
        }, menuItems.map((item_1)=>item_1.showMenuItem && item_1.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                iconBefore: item_1.icon,
                key: item_1.key,
                isDisabled: item_1.isDisabled,
                onClick: ()=>{
                    onMenuItemSelection(item_1.key);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "center"
            }, item_1.label, item_1.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
};
function $790b3996dfce6541$var$_temp(item) {
    return item.section === "Summarize" && item.showMenuItem;
}
function $790b3996dfce6541$var$_temp2(item_0) {
    return item_0.section === "Create" && item_0.showMenuItem;
}















var $i1t43 = parcelRequire("i1t43");








var $5oPgz = parcelRequire("5oPgz");


var $jmjWc = parcelRequire("jmjWc");


const $6654dd6aa1f8b471$export$33b519b7db786337 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9WcCJ",
    name: "FooterCommentsSummaryCombined",
    loader: async ()=>(await (parcelRequire("cGlMo"))).FooterCommentsSummaryCombinedWithErrorBoundary
});



var $9VC5k = parcelRequire("9VC5k");


var $auLW1 = parcelRequire("auLW1");


var $eN3MW = parcelRequire("eN3MW");


var $brrvF = parcelRequire("brrvF");






const $0eb3a6f6be084bf0$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    aiFloatingContextMenuOptInDialogHeaderText: {
        id: "ai-floating-context-menu.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiFloatingContextMenuAdminOptInDialogBodyText: {
        id: "ai-floating-context-menu.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $0eb3a6f6be084bf0$var$FeatureContentWidthStyles = (0, $buxP3.xcss)({
    width: '500px'
});
const $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: t1 } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    let t2;
    if ($[0] !== adminLink || $[1] !== contentId || $[2] !== contentType || $[3] !== intl || $[4] !== isLivePage || $[5] !== lastModifiedDate || $[6] !== onClose || $[7] !== popupState || $[8] !== setIsOpen || $[9] !== setPopupState || $[10] !== source || $[11] !== spaceKey) {
        const formatOptInMessageValues = {
            a: $0eb3a6f6be084bf0$var$_temp,
            br: $0eb3a6f6be084bf0$var$_temp2
        };
        const renderContent = ()=>{
            switch(popupState){
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6654dd6aa1f8b471$export$33b519b7db786337), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Header,
                        spaceKey: spaceKey
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setIsOpen: onClose,
                        contentPath: window.location.pathname
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: contentType,
                        lastModifiedDate: lastModifiedDate,
                        setIsOpen: onClose,
                        source: source,
                        contentPath: window.location.pathname
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brrvF.QuickSummaryUpsell), null);
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5oPgz.default), {
                        source: "quickSummary",
                        product: "confluence",
                        isOrgAdmin: true,
                        headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                        adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                        adminLink: adminLink,
                        onAdminClose: ()=>setIsOpen(false)
                    });
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $790b3996dfce6541$export$2b7899a440558a80), {
                        contentId: contentId,
                        setPopupState: setPopupState,
                        setIsOpen: setIsOpen,
                        isLivePage: isLivePage
                    });
            }
        };
        let t3;
        if ($[13] !== popupState) {
            t3 = (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles;
            $[13] = popupState;
            $[14] = t3;
        } else t3 = $[14];
        let t4;
        if ($[15] !== t3) {
            t4 = [
                t3
            ];
            $[15] = t3;
            $[16] = t4;
        } else t4 = $[16];
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t4
        }, renderContent());
        $[0] = adminLink;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = intl;
        $[4] = isLivePage;
        $[5] = lastModifiedDate;
        $[6] = onClose;
        $[7] = popupState;
        $[8] = setIsOpen;
        $[9] = setPopupState;
        $[10] = source;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : ({ popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: isLivePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    const formatOptInMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
                target: "_blank"
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
    };
    const renderContent = ()=>{
        switch(popupState){
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6654dd6aa1f8b471$export$33b519b7db786337), {
                    contentId: contentId,
                    contentType: contentType,
                    source: (0, $9VC5k.CommentsSummarySource).Header,
                    spaceKey: spaceKey
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: spaceKey,
                    setIsOpen: onClose,
                    contentPath: window.location.pathname
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: contentType,
                    lastModifiedDate: lastModifiedDate,
                    setIsOpen: onClose,
                    source: source,
                    contentPath: window.location.pathname
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brrvF.QuickSummaryUpsell), null);
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5oPgz.default), {
                    source: "quickSummary",
                    product: "confluence",
                    isOrgAdmin: true,
                    headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                    adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                    adminLink: adminLink,
                    onAdminClose: ()=>setIsOpen(false)
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $790b3996dfce6541$export$2b7899a440558a80), {
                    contentId: contentId,
                    setPopupState: setPopupState,
                    setIsOpen: setIsOpen,
                    isLivePage: isLivePage
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles
        ]
    }, renderContent());
});
function $0eb3a6f6be084bf0$var$_temp(s) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
        target: "_blank"
    }, s);
}
function $0eb3a6f6be084bf0$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null);
}



const $b3acdd5624bc36ae$var$absoluteWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    position: 'absolute',
    right: 'space.150',
    bottom: 'space.0'
});
const $b3acdd5624bc36ae$var$FloatingContextMenuStyles = null;
const $b3acdd5624bc36ae$var$dynamicActionTextMap = {
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).summarizeSectionLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).inlineCommentsMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).pageCatchupMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).bulkIssueCreateMenuItemLabel
};
const $b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate = '', pageCommentsSectionInView: pageCommentsSectionInView = false, isLivePage: isLivePage = false, isInObjectSideBar: isInObjectSideBar = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [popupState, setPopupState] = (0, $cozmU.useState)((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
    const { dynamicActionTarget: dynamicActionTarget, queryError: queryError } = (0, $83cf8da53844c2d7$export$7571cdd921b49cc0)(contentId, contentType, pageCommentsSectionInView && !isLivePage, isLivePage);
    const { pulseCount: pulseCount } = (0, $874fd8abb2c90fe4$export$b938e63de8ec6cb1)(contentId, contentType);
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isDynamicActionSelected = isOpen && popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu; // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    const isEnabled = isAIFeatureEnabled && (isAIEnabledForContent || isSiteAdmin && !isAdminHubAIEnabled || edition !== (0, $euL71.ConfluenceEdition).PREMIUM && !isAdminHubAIEnabled);
    const getDynamicActionText = ()=>{
        if (dynamicActionTarget && !isOpen) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[dynamicActionTarget]);
        else if (isOpen && (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState)) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[popupState]);
        else return undefined;
    };
    const [prevDynamicActionTarget, setPrevDynamicActionTarget] = (0, $cozmU.useState)(null);
    if (dynamicActionTarget !== prevDynamicActionTarget) {
        setPrevDynamicActionTarget(dynamicActionTarget);
        if (dynamicActionTarget) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                source: 'page',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }
    const onClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
    }, []);
    const onDynamicActionClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen) onClose();
        else if (dynamicActionTarget) {
            setIsOpen(true);
            setPopupState(dynamicActionTarget);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        isOpen,
        onClose,
        dynamicActionTarget,
        isLivePage
    ]);
    const onMenuButtonClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen && popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu && isAdminHubAIEnabled) setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
        else if (isOpen) onClose();
        else if (!isAdminHubAIEnabled && edition !== (0, $euL71.ConfluenceEdition).PREMIUM) {
            setIsOpen(true);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell);
        } else if (!isAdminHubAIEnabled && isSiteAdmin) {
            setIsOpen(true);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn);
        } else setIsOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiActionMenuButton',
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        edition,
        isOpen,
        onClose,
        popupState,
        isAdminHubAIEnabled,
        isSiteAdmin,
        isLivePage
    ]);
    const popupComponent = ()=>{
        if (popupState === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu) return 0, $44548221e1617185$export$2593be7073434b2d;
        return 0, $NomII.CustomPopupContainer;
    };
    if (!isEnabled) return null;
    if (isAdminHubAIEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: onClose,
        offset: [
            0,
            6
        ],
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a), {
                popupState: popupState,
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                lastModifiedDate: lastModifiedDate ?? '',
                source: "view-page",
                onClose: onClose,
                setPopupState: setPopupState,
                setIsOpen: setIsOpen,
                isLivePage: isLivePage
            }),
        shouldRenderToParent: true,
        placement: "top-end",
        popupComponent: popupComponent(),
        zIndex: popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu && (0, $9wGTI.fg)('platform-dst-motion-uplift-popup') ? 1 : undefined,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af25143620373faf$export$cd20eff28c3c2c7f), {
                pulseCount: pulseCount,
                isInObjectSideBar: isInObjectSideBar
            }, !isAdminHubAIEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ExetK.AIButton), {
                ...triggerProps,
                onClick: onMenuButtonClick
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b40fa145aa0c9d8$export$c226a072142c15e9), {
                isDynamicActionSelected: isDynamicActionSelected,
                triggerProps: triggerProps,
                onMenuButtonClick: onMenuButtonClick,
                onDynamicActionClick: onDynamicActionClick,
                dynamicActionText: getDynamicActionText(),
                isMenuOpen: isOpen && popupState === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu,
                isInObjectSideBar: isInObjectSideBar
            }))
    }));
};
const $b3acdd5624bc36ae$export$71951c424ee8d4c2 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "ai-floating-context-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: props.contentId
    }, props.isInObjectSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b3acdd5624bc36ae$var$absoluteWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _0Bm75Gp0Oa _42Yu6B3p0A _1VJPcaIt9z"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props))))));
};



var $3jwuS = parcelRequire("3jwuS");





var $D7PHQ = parcelRequire("D7PHQ");


var $kM55L = parcelRequire("kM55L");


var $6mKj3 = parcelRequire("6mKj3");


var $efvKr = parcelRequire("efvKr");


var $aWwYt = parcelRequire("aWwYt");


var $eNjW4 = parcelRequire("eNjW4");








var $kvJHJ = parcelRequire("kvJHJ");


var $8uM2K = parcelRequire("8uM2K");


var $bj5fB = parcelRequire("bj5fB");


var $HmpUb = parcelRequire("HmpUb");


var $eCmUm = parcelRequire("eCmUm");


var $dppWL = parcelRequire("dppWL");


var $3tUdX = parcelRequire("3tUdX");





var $amW67 = parcelRequire("amW67");

const $b6f192cd6e2c63ff$export$b9c46d9495de208d = ({ setConfiguration: setConfiguration })=>{
    const { actionsToRender: actionsToRender } = (0, $amW67.useRovoConfigProviderProps)();
    const config = (0, $cozmU.useMemo)(()=>({
            getActions: async ()=>actionsToRender
        }), [
        actionsToRender
    ]);
    (0, $cozmU.useEffect)(()=>{
        setConfiguration(config);
    }, [
        config,
        setConfiguration
    ]);
    return null;
};






var $bXh4X = parcelRequire("bXh4X");


var $k9SyR = parcelRequire("k9SyR");














const $afee6b634376daaa$export$2e1f63b035bfb63e = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "1-i8E",
    name: "AutomationNudgeActionsLoader",
    loader: async ()=>(await (parcelRequire("69SEX"))).AutomationNudgeActionsLoader
});





















var $f1iv3 = parcelRequire("f1iv3");


var $58cpY = parcelRequire("58cpY");


var $dQeg1 = parcelRequire("dQeg1");


var $6iWVH = parcelRequire("6iWVH");








var $bqcqm = parcelRequire("bqcqm");






var $2bR8c = parcelRequire("2bR8c");


var $fQFMU = parcelRequire("fQFMU");


var $dWpd3 = parcelRequire("dWpd3");






































const $7dab2f8a87f7b6ba$var$PROJECT_TITLE_KEYWORDS = [
    'project',
    'overview',
    'poster',
    'brief',
    'scope',
    'plan',
    'launch',
    'strategy'
];
const $7dab2f8a87f7b6ba$var$titleContainsProjectKeyword = (contentTitle)=>{
    const lowerTitle = contentTitle.toLowerCase();
    return $7dab2f8a87f7b6ba$var$PROJECT_TITLE_KEYWORDS.some((keyword)=>lowerTitle.includes(keyword));
};
const $7dab2f8a87f7b6ba$export$f2eec944fba9428e = ({ contentType: contentType, contentTitle: contentTitle })=>{
    if (contentType !== 'page') return false;
    return Boolean(contentTitle && $7dab2f8a87f7b6ba$var$titleContainsProjectKeyword(contentTitle));
};



var $aFH5a = parcelRequire("aFH5a");

const $a6bade25d3c467cc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    pageCatchupMenuItemSubheaderLabel: {
        id: "page-rovo-config-common.menu.item.label.page-catchup-subheader",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "See what's changed since your last visit"
    },
    summarizeSectionLabel: {
        id: "page-rovo-config-common.summarize.section.label",
        defaultMessage: "Summarize page"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    audioBriefingMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing",
        defaultMessage: "Listen to page"
    },
    audioBriefingMenuItemLabelWithContentType: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-with-content-type",
        defaultMessage: "Listen to {contentType}"
    },
    audioBriefingContentTypePage: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-page",
        defaultMessage: "page"
    },
    audioBriefingContentTypeBlogPost: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-blogpost",
        defaultMessage: "blogpost"
    },
    audioBriefingContentTypeLiveDoc: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-live-doc",
        defaultMessage: "live doc"
    },
    audioBriefingMenuItemSubheaderLabel: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-subheader",
        defaultMessage: "Get a brief audio summary"
    },
    getProjectOverviewMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.get-project-overview",
        defaultMessage: "Get Project Overview"
    }
});
const $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES = {
    live: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypeLiveDoc,
    page: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypePage,
    blogpost: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypeBlogPost
};
const $a6bade25d3c467cc$var$isValidAudioContentTye = (key)=>key in $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES;
const $a6bade25d3c467cc$export$e0c34800d984dab2 = ()=>{
    const { contentId: contentId, contentType: contentType, contentTitle: contentTitle, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, isUnpublishedDraft: isUnpublishedDraft, isEditorEmpty: isEditorEmpty, contributorsFragmentRef: contributorsFragmentRef } = (0, $amW67.useRovoConfigProviderProps)();
    const { mode: rovoUiMode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const automationNudgeActionsDEPRECATED = (0, $fQFMU.useConfluenceAutomationNudgeActions)(contentId);
    const automationNudgeActions = (0, $aFH5a.useAutomationNudgeActions)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $6fW2K.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $cozmU.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    // Page Catchup action
    const pageCatchupAction = (0, $cozmU.useCallback)(()=>{
        if ((0, $6mKj3.expValEquals)('confluence_content_catchup_as_a_rovo_skill', 'isEnabled', true)) return {
            id: 'summarize-changes-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemLabel),
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                    label: "",
                    testId: "summarize-changes-ai-action.icon"
                }),
            type: 'skill-action',
            handleType: (0, $6iWVH.HandleActionType).Skill,
            staticPrompt: '/content-catchup',
            nudgeContext: {
                id: 'content-catchup'
            }
        };
        return {
            id: 'summarize-changes-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemLabel),
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                    label: "",
                    testId: "summarize-changes-ai-action.icon"
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setIsOpen: ()=>{},
                        contentPath: window.location.pathname,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false,
                        allowCustomFollowUp: true
                    })
            },
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            customFollowUpContext: {
                available: false,
                fetch: ()=>Promise.resolve([])
            },
            nudgeContext: {
                id: 'content-catchup'
            }
        };
    }, [
        formatMessage,
        contentId,
        contentType,
        spaceKey
    ]);
    // Summarize page action
    const quickSummaryAction = (0, $cozmU.useCallback)(()=>{
        if ((0, $6mKj3.expValEquals)('confluence_quick_summary_as_a_skill', 'isEnabled', true)) return {
            id: 'summarize-page-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.summarizeSectionLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                    label: "",
                    testId: "summarize-page-ai-action.icon"
                }),
            type: 'skill-action',
            handleType: (0, $6iWVH.HandleActionType).Skill,
            staticPrompt: '/quick-summary',
            nudgeContext: {
                id: 'page-summaries'
            }
        };
        return {
            id: 'summarize-page-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.summarizeSectionLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                    label: "",
                    testId: "summarize-page-ai-action.icon"
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                        contributorsFragmentRef: contributorsFragmentRef,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: contentType,
                        lastModifiedDate: lastModifiedDate ?? '',
                        source: "view-page",
                        setIsOpen: ()=>{},
                        contentPath: window.location.pathname,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false,
                        allowCustomFollowUp: true
                    })
            },
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            customFollowUpContext: {
                available: false,
                fetch: ()=>Promise.resolve([])
            },
            nudgeContext: {
                id: 'page-summaries'
            }
        };
    }, [
        formatMessage,
        contentId,
        contentType,
        spaceKey,
        lastModifiedDate,
        contributorsFragmentRef
    ]);
    // Summarize comments action
    const commentSummaryAction = (0, $cozmU.useCallback)(()=>({
            id: 'summarize-comments-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.inlineCommentsMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                    label: ""
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
                        contentId: contentId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6654dd6aa1f8b471$export$33b519b7db786337), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Footer,
                        spaceKey: spaceKey,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false
                    }))
            },
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base
        }), [
        formatMessage,
        contentId,
        contentType,
        spaceKey
    ]);
    // Create Jira bulk issues action
    const handleBulkIssueCreate = (0, $c8e282bfad3727e4$export$ddc739fc0aea988a)({
        contentId: contentId,
        content: content,
        useRovoWidth: true
    });
    const onBulkIssueCreate = (0, $cozmU.useCallback)(()=>{
        if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
        else handleBulkIssueCreate();
    }, [
        isSidePanelOpen,
        showWarningDialog,
        handleBulkIssueCreate
    ]);
    const bulkIssueCreateAction = (0, $cozmU.useCallback)(()=>({
            id: 'bulk-issue-create-ai-action',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $a6bade25d3c467cc$export$defe85febe8b728c.bulkWorkItemsCreateMenuItemLabel : $a6bade25d3c467cc$export$defe85febe8b728c.bulkIssueCreateMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
                    label: ""
                }),
            onClick: onBulkIssueCreate,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base
        }), [
        formatMessage,
        onBulkIssueCreate
    ]);
    // Audio briefing action
    const { openAudioPlayer: openAudioPlayer } = (0, $bqcqm.useAudioPlayerStore)();
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const { activeContent: activeContent } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const { audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState } = (0, $JTIzG.useAudioFeatureFlags)();
    const playBriefingImmediately = audioBriefingNudgeExperimentState === (0, $JTIzG.BriefingNudgeExperimentState).NUDGE_AUTOPLAY;
    const onAudioBriefingAction = (0, $cozmU.useCallback)(()=>{
        if (!!activeContent) {
            openAudioPlayer(activeContent, {
                playImmediately: playBriefingImmediately
            });
            // Close the Rovo popup or sidebar after clicking
            const isSidebarOrMiniModalOpen = rovoUiMode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR || rovoUiMode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
            if (isSidebarOrMiniModalOpen) // Close sidebar
            toggleConversationAssistantUIMode({
                targetMode: undefined,
                sidebarApi: sidebarApi
            });
        }
    }, [
        activeContent,
        openAudioPlayer,
        playBriefingImmediately,
        rovoUiMode,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const audioBriefingAction = (0, $cozmU.useCallback)(()=>{
        const key = activeContent?.subType || activeContent?.contentType;
        const contentTypeMessage = key && $a6bade25d3c467cc$var$isValidAudioContentTye(key) ? $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES[key] : undefined;
        const contentTypeLabel = contentTypeMessage ? formatMessage(contentTypeMessage) : '';
        const title = contentTypeLabel ? formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemLabelWithContentType, {
            contentType: contentTypeLabel
        }) : formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemLabel);
        return {
            id: 'audio-briefing-ai-action',
            title: title,
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($58cpY))), {
                    label: ""
                }),
            onClick: onAudioBriefingAction,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: 'proactive-audio-briefing',
                // PROACTIVE_AI_AUDIO_BRIEFING in convo-ai
                suppressionKey: activeContent?.contentId
            }
        };
    }, [
        formatMessage,
        onAudioBriefingAction,
        activeContent
    ]);
    const shouldShowAudioBriefingAction = (0, $cozmU.useMemo)(()=>!!activeContent && audioBriefingNudgeExperimentState !== (0, $JTIzG.BriefingNudgeExperimentState).CONTROL, [
        activeContent,
        audioBriefingNudgeExperimentState
    ]);
    // Get Project Overview skill action
    const getProjectOverviewAction = (0, $cozmU.useCallback)(()=>({
            id: 'get-project-overview-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.getProjectOverviewMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dQeg1))), {
                    label: ""
                }),
            handleType: (0, $6iWVH.HandleActionType).Skill,
            type: 'skill-action',
            staticPrompt: '/get-project-details'
        }), [
        formatMessage
    ]);
    // Final actions list
    const getViewPageRovoActions = (0, $cozmU.useCallback)(()=>{
        const actions = [];
        const isPageOrBlogpost = contentType === 'page' || contentType === 'blogpost';
        // needed for space overview since it doesn't have content type
        // also skip for unpublished drafts and empty live docs
        if (!isPageOrBlogpost || isUnpublishedDraft || isEditorEmpty) return actions;
        // Get Project Overview action (top of the list for published pages with project-related title)
        if ((0, $7dab2f8a87f7b6ba$export$f2eec944fba9428e)({
            contentType: contentType,
            contentTitle: contentTitle
        }) && (0, $6mKj3.expVal)('rovo_connie_empty_state_get_project_details_skill', 'isEnabled', false)) actions.push({
            actionId: 'get-project-overview',
            action: getProjectOverviewAction()
        });
        actions.push({
            actionId: 'page-catchup',
            action: pageCatchupAction()
        }, {
            actionId: 'quick-summary',
            action: quickSummaryAction()
        });
        actions.push(...(0, $9wGTI.fg)('cc_automations_nudge_actions_error_boundary') ? automationNudgeActions : automationNudgeActionsDEPRECATED);
        if (shouldShowAudioBriefingAction) actions.push({
            actionId: 'audio-briefing',
            action: audioBriefingAction()
        });
        // Only show comment summary in Rovo button when proactive_comment_summary experiment is disabled
        if ((unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0) && !(0, $6mKj3.expValEquals)('proactive_comment_summary', 'isEnabled', true)) actions.push({
            actionId: 'comment-summary',
            action: commentSummaryAction()
        });
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) actions.push({
            actionId: 'bulk-issue-create',
            action: bulkIssueCreateAction()
        });
        return actions;
    }, [
        contentType,
        contentTitle,
        bulkIssueCreateAction,
        commentSummaryAction,
        footerCommentsCount,
        getProjectOverviewAction,
        isUnpublishedDraft,
        isEditorEmpty,
        pageCatchupAction,
        pageMode,
        quickSummaryAction,
        automationNudgeActions,
        automationNudgeActionsDEPRECATED,
        unresolvedInlineCommentsCount,
        audioBriefingAction,
        shouldShowAudioBriefingAction
    ]);
    const actions = (0, $cozmU.useMemo)(()=>getViewPageRovoActions(), [
        getViewPageRovoActions
    ]);
    return actions;
};





/**
 * @generated SignedSource<<94c02a5eeed043c9858d7e1d928a6603>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fe2e9a916b6112e9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NudgeContributorFilter_contentContributors",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isCurrentUserContributor"
        }
    ],
    "type": "ContentContributors"
};
$fe2e9a916b6112e9$var$node.hash = "e56eaa011a9f1f6337981eb2eab39997";
var $fe2e9a916b6112e9$export$2e2bcd8739ae039 = $fe2e9a916b6112e9$var$node;






var $6SsN4 = parcelRequire("6SsN4");

/**
 * @generated SignedSource<<b4310f301c256ea95275f5723888b05a>>
 * @relayHash dea9c3cbfe29b9c92cdeb224b8f076c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7
const $e82e32b99e59f54f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isCurrentUserContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useNudgeContributorFilterQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useNudgeContributorFilterQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "dea9c3cbfe29b9c92cdeb224b8f076c7",
            "id": "3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7",
            "metadata": {},
            "name": "useNudgeContributorFilterQuery",
            "operationKind": "query",
            "text": "query useNudgeContributorFilterQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
        }
    };
}();
$e82e32b99e59f54f$var$node.hash = "427fb0db9de3e615035eab567b67ccf0";
var $e82e32b99e59f54f$export$2e2bcd8739ae039 = $e82e32b99e59f54f$var$node;






var $jMyy4 = parcelRequire("jMyy4");

const $fc07d009da21f8b9$var$useNudgeContributorFilterQuery = (0, $e82e32b99e59f54f$export$2e2bcd8739ae039);
function $fc07d009da21f8b9$export$cb9bdc967aae1b21(contentId, skip) {
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($fc07d009da21f8b9$var$useNudgeContributorFilterQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId || skip,
        errorPolicy: 'all',
        __callerPackage__: "page-rovo-config-common"
    });
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor ?? false;
    return (0, $cozmU.useMemo)(()=>({
            isCurrentUserContributor: isCurrentUserContributor,
            loading: loading
        }), [
        isCurrentUserContributor,
        loading
    ]);
}


const $dedaca32eeab04b3$var$NudgeContributorFilterFromQuery = ({ contentId: contentId, skip: skip, children: children })=>{
    const { isCurrentUserContributor: isCurrentUserContributor } = (0, $fc07d009da21f8b9$export$cb9bdc967aae1b21)(contentId, skip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(isCurrentUserContributor));
};
const $dedaca32eeab04b3$var$NudgeContributorFilterFromFragment = ({ contributorsFragmentRef: contributorsFragmentRef, children: children, ...props })=>{
    const data = (0, $6SsN4.useFragment)((0, $fe2e9a916b6112e9$export$2e2bcd8739ae039), contributorsFragmentRef);
    // An unavailable status must use the existing loading/error path.
    if (data.isCurrentUserContributor == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dedaca32eeab04b3$var$NudgeContributorFilterFromQuery, props, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(data.isCurrentUserContributor));
};
const $dedaca32eeab04b3$export$bfb262091ba18fc5 = (props)=>{
    if (props.contentId && !props.skip && props.contributorsFragmentRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dedaca32eeab04b3$var$NudgeContributorFilterFromFragment, {
        ...props,
        contributorsFragmentRef: props.contributorsFragmentRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dedaca32eeab04b3$var$NudgeContributorFilterFromQuery, props);
};


/**
 * @generated SignedSource<<7aa3d54126f9597e716056a7eefea026>>
 * @relayHash a0dc0a296d152cfbd6c0ca2a59e55c8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80126f44d9591dcee6cb6f9d63eb77d74968d56d29dd33c4a3e52973ee97507e
const $d9c45cee0d598413$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useNudgeFirstVisitFilterQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useNudgeFirstVisitFilterQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a0dc0a296d152cfbd6c0ca2a59e55c8b",
            "id": "80126f44d9591dcee6cb6f9d63eb77d74968d56d29dd33c4a3e52973ee97507e",
            "metadata": {},
            "name": "useNudgeFirstVisitFilterQuery",
            "operationKind": "query",
            "text": "query useNudgeFirstVisitFilterQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$d9c45cee0d598413$var$node.hash = "1e734053e31505b911fcc40be543fe6e";
var $d9c45cee0d598413$export$2e2bcd8739ae039 = $d9c45cee0d598413$var$node;








const $4a8709f90f4edadd$var$useNudgeFirstVisitFilterQuery = (0, $d9c45cee0d598413$export$2e2bcd8739ae039);
function $4a8709f90f4edadd$export$628206ea1fe1b0f7(lastViewedTimeISO) {
    if (!lastViewedTimeISO) return true;
    // Strip timezone bracket suffixes (e.g. "[America/New_York]") that cause NaN on Date.parse
    const cleaned = lastViewedTimeISO.replace(/\[.*?\]$/, '');
    return !cleaned || Number.isNaN(Date.parse(cleaned));
}
function $4a8709f90f4edadd$export$2e8f1aa0f8ab1526(contentId, skip) {
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($4a8709f90f4edadd$var$useNudgeFirstVisitFilterQuery, {
        variables: {
            contentId: contentId,
            contentType: 'PAGE'
        },
        skip: !contentId || skip,
        errorPolicy: 'all',
        __callerPackage__: "page-rovo-config-common"
    });
    const lastViewedTimeISO = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    const isFirstVisit = $4a8709f90f4edadd$export$628206ea1fe1b0f7(lastViewedTimeISO);
    return (0, $cozmU.useMemo)(()=>({
            isFirstVisit: isFirstVisit,
            loading: loading
        }), [
        isFirstVisit,
        loading
    ]);
}












var $gXKuh = parcelRequire("gXKuh");

function $97654e51bdd5d39b$export$5985165b88d806e9() {
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const handleAgentMentionSaved = (0, $cozmU.useCallback)((event)=>{
        const detail = event.detail;
        if (!detail || detail.openSidebar === false) return;
        sidebarApi.openSidebar();
    }, [
        sidebarApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        window.addEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionSaved);
        return ()=>{
            window.removeEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionSaved);
        };
    }, [
        handleAgentMentionSaved
    ]);
}


















var $h2uld = parcelRequire("h2uld");

const $e4cd8876e4f83d2e$export$b68936138edb7d6e = (contentType, contentId)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const readTimeMinutes = readTimeLoading ? null : Number(readTime);
    const minReadTimeMinutes = (0, $9wGTI.fg)('rovo_button_proactive_nudge_min_read_time_increase') ? 1.0 : 0.5;
    /**
   * Base eligibility checks (page-level, shared across all nudges):
   * 1. Rovo Button must be enabled
   * 2. Content type must be 'page' (TODO: extend to 'blogpost' when backend 500s are fixed)
   * 3. Page must not be in edit mode
   * 4. Read time query must be completed
   * 5. Read time must exceed the minimum threshold (1 min with gate on, 30s with gate off)
   */ const isBaseEligible = isRovoButtonEnabled && contentType === 'page' && pageMode !== (0, $cD1qu.PageMode).EDIT && readTimeMinutes !== null && readTimeMinutes > minReadTimeMinutes;
    return {
        isBaseEligible: isBaseEligible,
        readTimeMinutes: readTimeMinutes
    };
};



























var $arQY7 = parcelRequire("arQY7");


var $hdBxM = parcelRequire("hdBxM");


var $8jDil = parcelRequire("8jDil");










/**
 * @generated SignedSource<<121a234e3c42e43630d3846a3d8011b5>>
 * @relayHash dbfc9d0488d8e5e091eefb3079672d20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f7f49d064b1a3432b1db263547373bb9b1f98e92deeac78186cacff76fb384c3
const $d5d86cc784bbfa7d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "aqlQuery"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shardingContext"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "aqlQuery",
            "variableName": "aqlQuery"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "shardingContext",
            "variableName": "shardingContext"
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": "lastStateChangeAt DESC"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "workspaceAri",
                "variableName": "shardingContext"
            }
        ],
        "concreteType": "AgentConversationChannel",
        "kind": "LinkedField",
        "name": "conversationChannel",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "readStatus"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageAgentSessionNudgesQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "AgentSessionAssociationConnection",
                    "kind": "LinkedField",
                    "name": "agent_sessionAssociationQuery",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentSessionAssociation",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentSession",
                                    "kind": "LinkedField",
                                    "name": "agentSession",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "agent",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageAgentSessionNudgesQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "AgentSessionAssociationConnection",
                    "kind": "LinkedField",
                    "name": "agent_sessionAssociationQuery",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentSessionAssociation",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentSession",
                                    "kind": "LinkedField",
                                    "name": "agentSession",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "agent",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dbfc9d0488d8e5e091eefb3079672d20",
            "id": "f7f49d064b1a3432b1db263547373bb9b1f98e92deeac78186cacff76fb384c3",
            "metadata": {},
            "name": "PageAgentSessionNudgesQuery",
            "operationKind": "query",
            "text": "query PageAgentSessionNudgesQuery($aqlQuery:String!,$shardingContext:String!,$first:Int!){agent_sessionAssociationQuery(aqlQuery:$aqlQuery,shardingContext:$shardingContext,first:$first,sort:\"lastStateChangeAt DESC\"){nodes{agentSession{id,agent{__typename,picture,id},conversationChannel(workspaceAri:$shardingContext)@optIn(to:[\"AgentConversationChannelTeamEu26DemoOnly\"]){id,name,readStatus}},id}}}"
        }
    };
}();
$d5d86cc784bbfa7d$var$node.hash = "9c8451dadb496a292acb18c35e3614ad";
var $d5d86cc784bbfa7d$export$2e2bcd8739ae039 = $d5d86cc784bbfa7d$var$node;


/**
 * @generated SignedSource<<2802cda5a0b11177f0fedc71a0882ff7>>
 * @relayHash 2901a985ee0918584795e58494457219
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dd4d89a2e5b65ffc3702a8345417aaf05c1343f71446bf84ac64342012e941db
const $3e078185ffbf0eae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceAri",
                    "variableName": "workspaceAri"
                }
            ],
            "concreteType": "ConvoAiInboxSessionChanged",
            "kind": "LinkedField",
            "name": "convoai_onInboxSessionChanged",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "sessionAri"
                },
                {
                    "kind": "ScalarField",
                    "name": "sessionId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageAgentSessionNudgesSubscription",
            "selections": v1 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageAgentSessionNudgesSubscription",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2901a985ee0918584795e58494457219",
            "id": "dd4d89a2e5b65ffc3702a8345417aaf05c1343f71446bf84ac64342012e941db",
            "metadata": {},
            "name": "PageAgentSessionNudgesSubscription",
            "operationKind": "subscription",
            "text": "subscription PageAgentSessionNudgesSubscription($accountId:String!,$cloudId:ID!,$workspaceAri:ID!){convoai_onInboxSessionChanged(accountId:$accountId,cloudId:$cloudId,workspaceAri:$workspaceAri)@optIn(to:[\"ConvoAiInboxSessionChanged\"]){sessionAri,sessionId}}"
        }
    };
}();
$3e078185ffbf0eae$var$node.hash = "2da934814d2a6404a4bc4ec5f6d561ce";
var $3e078185ffbf0eae$export$2e2bcd8739ae039 = $3e078185ffbf0eae$var$node;


/**
 * @generated SignedSource<<9672bb577e5f57d19cd951130d79e0c9>>
 * @relayHash 0c39e59e4aa1e302911c8a32aeb2d983
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc4c6b2850d37cda46fb5f1b0760a83ba5c2a19cac79a71e09859d3266625b30
const $5a49575079295f00$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "cloudIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "product",
                            "value": "rovo"
                        }
                    ],
                    "concreteType": "TenantContextActivationId",
                    "kind": "LinkedField",
                    "name": "activationIdByProduct",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        }
                    ],
                    "storageKey": "activationIdByProduct(product:\"rovo\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RovoActivationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RovoActivationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0c39e59e4aa1e302911c8a32aeb2d983",
            "id": "bc4c6b2850d37cda46fb5f1b0760a83ba5c2a19cac79a71e09859d3266625b30",
            "metadata": {},
            "name": "RovoActivationQuery",
            "operationKind": "query",
            "text": "query RovoActivationQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){activationIdByProduct(product:\"rovo\"){active}}}"
        }
    };
}();
$5a49575079295f00$var$node.hash = "b7f5c5c652d7a1497de8e5913a025207";
var $5a49575079295f00$export$2e2bcd8739ae039 = $5a49575079295f00$var$node;


/**
 * @generated SignedSource<<e1cfb3560194d27e18b4ff1327e67198>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f006ca396dc117e1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "RovoActivationFragment_query",
    "selections": [
        {
            "args": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "cloudIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "product",
                            "value": "rovo"
                        }
                    ],
                    "concreteType": "TenantContextActivationId",
                    "kind": "LinkedField",
                    "name": "activationIdByProduct",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        }
                    ],
                    "storageKey": "activationIdByProduct(product:\"rovo\")"
                }
            ]
        }
    ],
    "type": "Query"
};
$f006ca396dc117e1$var$node.hash = "e251dc1268be3ce22a916f876adab00d";
var $f006ca396dc117e1$export$2e2bcd8739ae039 = $f006ca396dc117e1$var$node;


const $85e0ab61061db48f$export$110c060cdb8b89a1 = (0, $f006ca396dc117e1$export$2e2bcd8739ae039);


const $0f202a159dd3a2a0$var$PAGE_SIZE = 25;
const $0f202a159dd3a2a0$var$SESSION_REFRESH_DELAY_MS = 1000;
const $0f202a159dd3a2a0$var$messages = (0, $kSwu1.defineMessages)({
    fallbackTitle: {
        id: "page-rovo-config-common.agent-session-nudge.fallback-title.ai-non-final",
        defaultMessage: "Rovo conversation"
    },
    needsInputSecondaryTitle: {
        id: "page-rovo-config-common.agent-session-nudge.needs-input-secondary-title.ai-non-final",
        defaultMessage: "Needs your input"
    }
});
const $0f202a159dd3a2a0$var$DEFAULT_AGENT_SESSION_NUDGE_INVOCATION_TYPES = [
    'CONFLUENCE_COMMENT_MENTION',
    'CONFLUENCE_CHAT_EDIT',
    'CONFLUENCE_INLINE_EDIT',
    'CONFLUENCE_CWR_EDIT',
    'CONFLUENCE_CWR_CREATE',
    'CONFLUENCE_CWR_EXISTING',
    'CONFLUENCE_REMIX',
    'CONFLUENCE_REMIX_EDIT',
    'CONFLUENCE_CHAT'
];
const $0f202a159dd3a2a0$var$DEFAULT_AGENT_SESSION_NUDGE_STATES = [
    'INPUT_REQUIRED',
    'AUTH_REQUIRED'
];
// These values are interpolated inside quoted AQL literals. Escape the literal delimiters so an
// account ID can never produce malformed AQL or change the intended predicate structure.
const $0f202a159dd3a2a0$var$escapeAqlValue = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
const $0f202a159dd3a2a0$var$buildAqlOrFilter = (field, values)=>values.map((value)=>`${field} = '${$0f202a159dd3a2a0$var$escapeAqlValue(value)}'`).join('\n  OR ');
const $0f202a159dd3a2a0$export$6a23159f0cb5d46 = (userId, pageAri, invocationTypes = $0f202a159dd3a2a0$var$DEFAULT_AGENT_SESSION_NUDGE_INVOCATION_TYPES, states = $0f202a159dd3a2a0$var$DEFAULT_AGENT_SESSION_NUDGE_STATES)=>`userAccountId = '${$0f202a159dd3a2a0$var$escapeAqlValue(userId)}'\n` + `AND entityId = '${$0f202a159dd3a2a0$var$escapeAqlValue(pageAri)}'\n` + "AND deleted = 'false'\n" + `AND (\n  ${$0f202a159dd3a2a0$var$buildAqlOrFilter('state', states)}\n)\n` + `AND (\n  ${$0f202a159dd3a2a0$var$buildAqlOrFilter('invocationType', invocationTypes)}\n)`;
const $0f202a159dd3a2a0$export$bd940303ed0aeee7 = (nodes, unreadOnly = true)=>{
    // Multiple association records can resolve to the same conversation channel. Deduplicate them so
    // the same conversation is not registered as more than one nudge.
    const channelIds = new Set();
    const eligible = [];
    for (const association of nodes ?? []){
        const session = association?.agentSession;
        const channel = session?.conversationChannel;
        // readStatus is resolved from the workspace-specific conversation channel and is not an
        // AgentSessionAssociation AQL field, so unread filtering must happen after hydration.
        if (!session?.id || !channel?.id || unreadOnly && channel.readStatus !== false || channelIds.has(channel.id)) continue;
        channelIds.add(channel.id);
        eligible.push({
            agentPicture: session.agent?.picture ?? null,
            channelId: channel.id,
            channelName: channel.name ?? null,
            sessionId: session.id
        });
    }
    // Preserve the server's lastStateChangeAt DESC order.
    return eligible;
};
function $0f202a159dd3a2a0$export$c870d03c0d0604d0({ rovoActivationFragmentRef: rovoActivationFragmentRef, contentId: contentId, enabled: enabled, policy: policy, onSessionClick: onSessionClick }) {
    // View Page supplies the activation data through ContentUnifiedQuery. Edit Page omits this
    // property and retains the standalone activation lookup until it has an equivalent parent query.
    const usesActivationFragment = rovoActivationFragmentRef != null;
    const { cloudId: cloudId, isLoggedIn: isLoggedIn, userId: userId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const activationFragmentData = (0, $6SsN4.useFragment)((0, $85e0ab61061db48f$export$110c060cdb8b89a1), rovoActivationFragmentRef ?? null);
    const [activationQueryData, setActivationQueryData] = (0, $cozmU.useState)();
    const [activationError, setActivationError] = (0, $cozmU.useState)();
    const [sessionData, setSessionData] = (0, $cozmU.useState)();
    const [sessionError, setSessionError] = (0, $cozmU.useState)();
    const [subscriptionError, setSubscriptionError] = (0, $cozmU.useState)();
    // A session-change event can start a new fetch outside the initial query effect. Keep the latest
    // query subscription in a ref so a refresh can cancel an in-flight fetch and effect cleanup can
    // unsubscribe whichever fetch is current without causing another render.
    const sessionQuerySubscriptionRef = (0, $cozmU.useRef)(null);
    const sessionRefreshTimerRef = (0, $cozmU.useRef)(undefined);
    const invocationTypes = policy?.invocationTypes ?? $0f202a159dd3a2a0$var$DEFAULT_AGENT_SESSION_NUDGE_INVOCATION_TYPES;
    const states = policy?.states ?? $0f202a159dd3a2a0$var$DEFAULT_AGENT_SESSION_NUDGE_STATES;
    const unreadOnly = policy?.unreadOnly ?? true;
    const pageAri = (0, $cozmU.useMemo)(()=>cloudId && contentId ? (0, $8jDil.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : '', [
        cloudId,
        contentId
    ]);
    const canLoadActivation = Boolean(!usesActivationFragment && enabled && isLoggedIn && userId && cloudId && contentId && invocationTypes.length && states.length && (0, $9wGTI.fg)('confluence_rovo_agent_session_nudges'));
    (0, $cozmU.useEffect)(()=>{
        if (!canLoadActivation) {
            setActivationQueryData(undefined);
            setActivationError(undefined);
            return;
        }
        const activationQuerySubscription = (0, $6SsN4.fetchQuery)(environment, (0, $5a49575079295f00$export$2e2bcd8739ae039), {
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                setActivationQueryData(data);
                setActivationError(undefined);
            },
            error: (error)=>setActivationError(error)
        });
        return ()=>activationQuerySubscription.unsubscribe();
    }, [
        canLoadActivation,
        cloudId,
        environment
    ]);
    const activationData = usesActivationFragment ? activationFragmentData : activationQueryData;
    const rovoActivationId = activationData?.tenantContexts?.[0]?.activationIdByProduct?.active;
    const workspaceAri = rovoActivationId ? `ari:cloud:rovo::workspace/${rovoActivationId}` : '';
    const aqlQuery = (0, $cozmU.useMemo)(()=>userId && pageAri && invocationTypes.length && states.length ? $0f202a159dd3a2a0$export$6a23159f0cb5d46(userId, pageAri, invocationTypes, states) : '', [
        userId,
        pageAri,
        invocationTypes,
        states
    ]);
    const hasAgentSessionNudgeContext = Boolean(enabled && isLoggedIn && aqlQuery && workspaceAri && (0, $9wGTI.fg)('confluence_rovo_agent_session_nudges'));
    const fetchSessions = (0, $cozmU.useCallback)((isRefresh = false)=>{
        if (!hasAgentSessionNudgeContext) return;
        sessionQuerySubscriptionRef.current?.unsubscribe();
        sessionQuerySubscriptionRef.current = (0, $6SsN4.fetchQuery)(environment, (0, $d5d86cc784bbfa7d$export$2e2bcd8739ae039), {
            aqlQuery: aqlQuery,
            shardingContext: workspaceAri,
            first: $0f202a159dd3a2a0$var$PAGE_SIZE
        }, {
            fetchPolicy: isRefresh ? 'network-only' : 'store-or-network'
        }).subscribe({
            next: (data)=>{
                setSessionData(data);
                setSessionError(undefined);
            },
            error: (error)=>setSessionError(error)
        });
    }, [
        aqlQuery,
        environment,
        hasAgentSessionNudgeContext,
        workspaceAri
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!hasAgentSessionNudgeContext) {
            setSessionData(undefined);
            setSessionError(undefined);
            return;
        }
        // Route changes keep the View Page subtree mounted. When the page-scoped query changes,
        // clear the previous snapshot instead of retaining it while the new request is pending.
        setSessionData(undefined);
        setSessionError(undefined);
        fetchSessions();
        return ()=>sessionQuerySubscriptionRef.current?.unsubscribe();
    }, [
        fetchSessions,
        hasAgentSessionNudgeContext
    ]);
    const connection = sessionData?.agent_sessionAssociationQuery;
    const eligibleSessions = (0, $cozmU.useMemo)(()=>{
        if (!hasAgentSessionNudgeContext) return [];
        return $0f202a159dd3a2a0$export$bd940303ed0aeee7(connection?.nodes, unreadOnly);
    }, [
        connection?.nodes,
        hasAgentSessionNudgeContext,
        unreadOnly
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!hasAgentSessionNudgeContext || !userId || !cloudId) {
            setSubscriptionError(undefined);
            return;
        }
        const inboxSessionChangedSubscription = (0, $6SsN4.requestSubscription)(environment, {
            subscription: (0, $3e078185ffbf0eae$export$2e2bcd8739ae039),
            variables: {
                accountId: userId,
                cloudId: cloudId,
                workspaceAri: workspaceAri
            },
            onNext: (data)=>{
                if (!data?.convoai_onInboxSessionChanged) return;
                setSubscriptionError(undefined);
                clearTimeout(sessionRefreshTimerRef.current);
                sessionRefreshTimerRef.current = setTimeout(()=>{
                    sessionRefreshTimerRef.current = undefined;
                    fetchSessions(true);
                }, $0f202a159dd3a2a0$var$SESSION_REFRESH_DELAY_MS);
            },
            onError: (error)=>setSubscriptionError(error)
        });
        return ()=>{
            clearTimeout(sessionRefreshTimerRef.current);
            sessionRefreshTimerRef.current = undefined;
            inboxSessionChangedSubscription.dispose();
        };
    }, [
        cloudId,
        environment,
        fetchSessions,
        hasAgentSessionNudgeContext,
        userId,
        workspaceAri
    ]);
    const nudges = (0, $cozmU.useMemo)(()=>eligibleSessions.map((session)=>{
            const actionId = `agent-session-nudge-${session.sessionId}`;
            return {
                id: actionId,
                title: session.channelName || formatMessage($0f202a159dd3a2a0$var$messages.fallbackTitle),
                secondaryTitle: formatMessage($0f202a159dd3a2a0$var$messages.needsInputSecondaryTitle),
                proactiveNudgeStatus: 'needs-input',
                icon: ()=>session.agentPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                        appearance: "hexagon",
                        name: "",
                        size: "xxsmall",
                        src: session.agentPicture
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
                onClick: ()=>{
                    if (onSessionClick) {
                        onSessionClick(session);
                        return;
                    }
                    publish({
                        type: 'chat-open',
                        data: {
                            channelId: session.channelId
                        },
                        openChatMode: 'mini-modal',
                        source: 'confluence-agent-session-nudge'
                    });
                },
                type: 'ai-action',
                handleType: (0, $6iWVH.HandleActionType).Base,
                nudgeContext: {
                    id: actionId,
                    selfEligible: true,
                    suppressionKey: session.channelId
                }
            };
        }), [
        eligibleSessions,
        formatMessage,
        onSessionClick,
        publish
    ]);
    const errors = (0, $cozmU.useMemo)(()=>[
            activationError,
            sessionError,
            subscriptionError
        ].filter((error)=>error instanceof Error), [
        activationError,
        sessionError,
        subscriptionError
    ]);
    return {
        nudges: nudges,
        errors: errors
    };
}










var $jXbuX = parcelRequire("jXbuX");







const $b985b864a3dfeb42$export$560e3a8567843c82 = 'daily-brief-nudge';
const $b985b864a3dfeb42$export$98808fd4b2dc119e = 300000;
const $b985b864a3dfeb42$var$messages = (0, $kSwu1.defineMessages)({
    dailyBriefNudgeTitle: {
        id: "page-rovo-config-common.daily-brief-nudge-title",
        defaultMessage: "Review your daily brief"
    },
    dailyBriefNudgeSubtitle: {
        id: "page-rovo-config-common.daily-brief-nudge-subtitle",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "See today's highlights at a glance"
    },
    dailyBriefNudgeIconLabel: {
        id: "page-rovo-config-common.daily-brief-nudge-icon-label",
        defaultMessage: "Daily brief"
    }
});
function $b985b864a3dfeb42$export$9c69eb1d10bb0a06(conversationId) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (conversationId) publish({
            type: 'chat-open',
            data: {
                channelId: conversationId
            },
            openChatMode: 'mini-modal',
            source: 'daily-brief-nudge'
        });
    }, [
        conversationId,
        publish
    ]);
    return (0, $cozmU.useMemo)(()=>({
            id: $b985b864a3dfeb42$export$560e3a8567843c82,
            title: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeTitle),
            secondaryTitle: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeSubtitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXbuX))), {
                    size: "small",
                    label: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeIconLabel)
                }),
            onClick: onClick,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: $b985b864a3dfeb42$export$560e3a8567843c82,
                selfEligible: true,
                suppressionKey: conversationId ?? undefined
            }
        }), [
        onClick,
        formatMessage,
        conversationId
    ]);
}









var $9Ke0t = parcelRequire("9Ke0t");


var $bGNkz = parcelRequire("bGNkz");





var $1AJi3 = parcelRequire("1AJi3");

function $c81b38e83d47b2f2$export$efc596861aea1477() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    } catch  {
        return 'UTC';
    }
}
function $c81b38e83d47b2f2$export$a7ad45fa39bda500(date, timeZone) {
    try {
        return $c81b38e83d47b2f2$var$getIsoWeekKeyForTimeZone(date, timeZone);
    } catch  {
        return $c81b38e83d47b2f2$var$getIsoWeekKeyForTimeZone(date, 'UTC');
    }
}
function $c81b38e83d47b2f2$var$getIsoWeekKeyForTimeZone(date, timeZone) {
    const dateParts = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    }).formatToParts(date);
    let year = 0;
    let month = 0;
    let day = 0;
    for (const part of dateParts){
        if (part.type === 'year') year = Number(part.value);
        else if (part.type === 'month') month = Number(part.value);
        else if (part.type === 'day') day = Number(part.value);
    }
    const localDate = new Date(Date.UTC(year, month - 1, day));
    const isoDay = localDate.getUTCDay() || 7;
    localDate.setUTCDate(localDate.getUTCDate() + 4 - isoDay);
    const isoYear = localDate.getUTCFullYear();
    const firstDayOfIsoYear = new Date(Date.UTC(isoYear, 0, 1));
    const week = Math.ceil(((localDate.getTime() - firstDayOfIsoYear.getTime()) / 86400000 + 1) / 7);
    return `${isoYear}-W${String(week).padStart(2, '0')}`;
}


const $c3e3eb1b5def3766$var$messages = (0, $kSwu1.defineMessages)({
    insightsNudgeTitle: {
        id: "page-rovo-config-common.digest-nudge-title.v2",
        defaultMessage: "Explore your Rovo digest"
    },
    insightsNudgeIconLabel: {
        id: "page-rovo-config-common.digest-nudge-icon-label",
        defaultMessage: "Digest icon"
    },
    insightsNudgeSecondaryTitle: {
        id: "page-rovo-config-common.digest-nudge-secondary-title",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "See this week's highlights at a glance"
    }
});
function $c3e3eb1b5def3766$export$efd7aeb42217b406() {
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStore)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { mode: mode, toggleConversationAssistant: toggleConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const [analyticsAttributes, setAnalyticsAttributes] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        const localTimeZone = (0, $c81b38e83d47b2f2$export$efc596861aea1477)();
        setAnalyticsAttributes({
            localTimeZone: localTimeZone,
            localIsoWeekKey: (0, $c81b38e83d47b2f2$export$a7ad45fa39bda500)(new Date(), localTimeZone)
        });
    }, []);
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (!mode) toggleConversationAssistant();
        setActiveMenu('pulse');
    }, [
        mode,
        toggleConversationAssistant,
        setActiveMenu
    ]);
    return (0, $cozmU.useMemo)(()=>({
            id: 'rovo-insights-nudge',
            title: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeTitle),
            secondaryTitle: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeSecondaryTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Ke0t))), {
                    size: "small",
                    label: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeIconLabel)
                }),
            onClick: onClick,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: 'rovo-insights',
                ...analyticsAttributes ? {
                    analyticsAttributes: analyticsAttributes
                } : {}
            }
        }), [
        analyticsAttributes,
        onClick,
        formatMessage
    ]);
}









var $4nhQC = parcelRequire("4nhQC");


var $TTB05 = parcelRequire("TTB05");




const $c07f2db40a5a574b$var$CONVO_STARTER_NUDGE_ID = 'convo-starter';
/**
 * Checks whether the user has consented to Functional storage.
 * The convo starter nudge uses sessionStorage for suppression, which requires
 * Functional cookie consent per Atlassian policy.
 * Returns null while pending, true if granted, false if denied.
 */ function $c07f2db40a5a574b$var$useCanShowConvoStarterNudge() {
    const [hasFunctionalConsent, setHasFunctionalConsent] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('rovo_button_convostarter_nudge_cookie_policy_check')) {
            setHasFunctionalConsent(true);
            return;
        }
        (0, $4nhQC.getPreferences)().then((preferences)=>{
            setHasFunctionalConsent(Boolean(preferences?.[(0, $TTB05.PreferenceCategory).Functional]));
        }).catch(()=>{
            setHasFunctionalConsent(false);
        });
    }, []);
    return hasFunctionalConsent;
}
function $c07f2db40a5a574b$export$26385239543be8d2() {
    const hasFunctionalConsent = $c07f2db40a5a574b$var$useCanShowConvoStarterNudge();
    return (0, $cozmU.useMemo)(()=>{
        if (!(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled')) return null;
        if (hasFunctionalConsent !== true) return null;
        return {
            id: $c07f2db40a5a574b$var$CONVO_STARTER_NUDGE_ID,
            title: '',
            type: 'convo-starter-action',
            handleType: (0, $6iWVH.HandleActionType).Chat,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
            staticPrompt: '',
            starterType: 'static'
        };
    }, [
        hasFunctionalConsent
    ]);
}


const $fa24c3761347e030$export$5d0421d6a355c531 = (entry)=>'action' in entry;


/** Minimum read time (in minutes) required for the convo starter nudge. */ const $8bdd9ea855fe08b8$var$CONVO_STARTER_MIN_READ_TIME_MINUTES = 2;
function $8bdd9ea855fe08b8$export$730669e74cd8a0c9({ rovoActivationFragmentRef: rovoActivationFragmentRef, contentId: contentId, contentType: contentType, dailyBriefStatus: dailyBriefStatus, isBaseEligible: isBaseEligible, isCurrentUserContributor: isCurrentUserContributor, isFirstVisit: isFirstVisit, isSessionReady: isSessionReady, readTimeMinutes: readTimeMinutes }) {
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const { nudges: sessionNudges, errors: sessionErrors } = (0, $0f202a159dd3a2a0$export$c870d03c0d0604d0)({
        rovoActivationFragmentRef: rovoActivationFragmentRef,
        contentId: contentId,
        enabled: Boolean(isSessionReady && isRovoButtonEnabled && contentType === 'page' && contentId)
    });
    const dailyBriefNudgeAction = (0, $b985b864a3dfeb42$export$9c69eb1d10bb0a06)(dailyBriefStatus?.conversationId ?? null);
    const insightsNudgeAction = (0, $c3e3eb1b5def3766$export$efd7aeb42217b406)();
    const convoStartersNudgeAction = (0, $c07f2db40a5a574b$export$26385239543be8d2)();
    const { eligibleForChangeboarding: eligibleForChangeboarding } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const actionsById = (0, $cozmU.useMemo)(()=>new Map(viewPageRovoActions.map((registeredAction)=>[
                registeredAction.actionId,
                registeredAction.action
            ])), [
        viewPageRovoActions
    ]);
    const baseNudges = (0, $cozmU.useMemo)(()=>{
        if (!isBaseEligible) return [];
        const nudgeEntries = [
            {
                actionId: 'page-catchup',
                enabled: true
            },
            {
                actionId: 'audio-briefing',
                enabled: !eligibleForChangeboarding
            },
            {
                action: dailyBriefNudgeAction,
                enabled: !!dailyBriefStatus?.conversationId && !!dailyBriefStatus?.completedAt && Date.now() - new Date(dailyBriefStatus.completedAt).getTime() < (0, $b985b864a3dfeb42$export$98808fd4b2dc119e) && (0, $9wGTI.fg)('rovo_button_daily_brief_nudge')
            },
            // Insights nudge — 1 min read time threshold covered by isBaseEligible
            {
                action: insightsNudgeAction,
                enabled: (0, $6mKj3.expVal)('rovo_growth_chat_pulse', 'isEnabled', false)
            },
            // Convo starter nudge — requires higher read time than the base threshold
            // Excluded for contributors and first-time visitors
            {
                action: convoStartersNudgeAction,
                enabled: !isCurrentUserContributor && !isFirstVisit && readTimeMinutes !== null && readTimeMinutes > $8bdd9ea855fe08b8$var$CONVO_STARTER_MIN_READ_TIME_MINUTES && (0, $9wGTI.fg)('aix_convo_starter_nudge_enabled')
            },
            // Action items nudge — eligibility gated in useViewPageRovoActions
            {
                actionId: 'action-items-nudge',
                enabled: true
            },
            {
                actionId: 'status-updates-automation',
                enabled: (0, $9wGTI.fg)('cc_automations_discovery_nudges')
            },
            {
                actionId: 'content-reviewer-nudge',
                enabled: true
            },
            {
                actionId: 'meeting-notes-nudge',
                enabled: true
            }
        ];
        return nudgeEntries.reduce((acc, nudgeEntry)=>{
            if (!nudgeEntry.enabled) return acc;
            const action = (0, $fa24c3761347e030$export$5d0421d6a355c531)(nudgeEntry) ? nudgeEntry.action : actionsById.get(nudgeEntry.actionId);
            if (action) acc.push(action);
            return acc;
        }, []);
    }, [
        isBaseEligible,
        readTimeMinutes,
        eligibleForChangeboarding,
        isCurrentUserContributor,
        isFirstVisit,
        dailyBriefStatus,
        dailyBriefNudgeAction,
        insightsNudgeAction,
        convoStartersNudgeAction,
        actionsById
    ]);
    return (0, $cozmU.useMemo)(()=>({
            errors: sessionErrors,
            nudges: [
                ...sessionNudges,
                ...baseNudges
            ]
        }), [
        baseNudges,
        sessionErrors,
        sessionNudges
    ]);
}


const $2b7ed8ae830eb95a$var$AgentMentionSidebarListener = ()=>{
    (0, $97654e51bdd5d39b$export$5985165b88d806e9)();
    return null;
};
const $2b7ed8ae830eb95a$var$ViewPageConfigProviderInner = (props)=>{
    const { contentType: contentType, contentId: contentId, contributorsFragmentRef: contributorsFragmentRef } = (0, $amW67.useRovoConfigProviderProps)();
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isSessionReady = isLoggedIn && isLicensed && !!cloudId;
    const { isBaseEligible: isBaseEligible, readTimeMinutes: readTimeMinutes } = (0, $e4cd8876e4f83d2e$export$b68936138edb7d6e)(contentType, contentId);
    const skipContributorFilter = !isBaseEligible || !isSessionReady || !(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dedaca32eeab04b3$export$bfb262091ba18fc5), {
        contentId: contentId,
        skip: skipContributorFilter,
        contributorsFragmentRef: contributorsFragmentRef
    }, (isCurrentUserContributor)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2b7ed8ae830eb95a$var$ViewPageConfigProviderWithContributorStatus, {
            ...props,
            isBaseEligible: isBaseEligible,
            readTimeMinutes: readTimeMinutes,
            isCurrentUserContributor: isCurrentUserContributor,
            skipContributorFilter: skipContributorFilter,
            isSessionReady: isSessionReady
        }));
};
const $2b7ed8ae830eb95a$var$ViewPageConfigProviderWithContributorStatus = ({ setConfiguration: setConfiguration, isBaseEligible: isBaseEligible, readTimeMinutes: readTimeMinutes, isCurrentUserContributor: isCurrentUserContributor, skipContributorFilter: skipContributorFilter, isSessionReady: isSessionReady })=>{
    const { rovoActivationFragmentRef: rovoActivationFragmentRef, contentId: contentId, contentType: contentType } = (0, $amW67.useRovoConfigProviderProps)();
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const { isFirstVisit: isFirstVisit } = (0, $4a8709f90f4edadd$export$2e8f1aa0f8ab1526)(contentId, skipContributorFilter);
    const dailyBriefStatus = (0, $k9SyR.useDailyBriefUnread)();
    const { nudges: nudges, errors: nudgeErrors } = (0, $8bdd9ea855fe08b8$export$730669e74cd8a0c9)({
        rovoActivationFragmentRef: rovoActivationFragmentRef,
        contentId: contentId,
        contentType: contentType,
        isBaseEligible: isBaseEligible,
        readTimeMinutes: readTimeMinutes,
        isCurrentUserContributor: isCurrentUserContributor,
        isFirstVisit: isFirstVisit,
        dailyBriefStatus: dailyBriefStatus,
        isSessionReady: isSessionReady
    });
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const rovoConfiguration = (0, $cozmU.useMemo)(()=>{
        return {
            getActions: async ()=>{
                const actions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve(actions);
            }
        };
    }, [
        viewPageRovoActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        setConfiguration(rovoConfiguration);
        setNudges(nudges);
    }, [
        rovoConfiguration,
        setConfiguration,
        nudges,
        setNudges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, nudgeErrors.map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            key: `${error.name}-${index}`,
            error: error
        })), (0, $9wGTI.fg)('cc_automations_nudge_actions_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $afee6b634376daaa$export$2e1f63b035bfb63e), {
        contentId: contentId
    }) : null, (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2b7ed8ae830eb95a$var$AgentMentionSidebarListener, null));
};
const $2b7ed8ae830eb95a$export$299010de885adda = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2b7ed8ae830eb95a$var$ViewPageConfigProviderInner, props));
};












var $ZKswU = parcelRequire("ZKswU");









































const $23e0c73c9feee0cc$export$5569745b4d0a5343 = (contentType)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const isLiveDoc = pageMode === (0, $cD1qu.PageMode).LIVE;
    /**
	 * Filters to prevent high request volume checking for nudge recommendations on live docs
	 * 1. Feature gate 'confluence_rovo_live_doc_nudges' must be enabled
	 * 2. Page must be a live doc
	 * 3. Rovo Button must be enabled
	 * 4. Content type must be 'page'
	 */ return isLiveDoc && isRovoButtonEnabled && contentType === 'page' && isAdminHubAIEnabled && (0, $9wGTI.fg)('confluence_rovo_live_doc_nudges');
};



















var $mfdwv = parcelRequire("mfdwv");


var $6gGPb = parcelRequire("6gGPb");


var $dStyd = parcelRequire("dStyd");





var $2khPJ = parcelRequire("2khPJ");













const $8732973ed376fa07$var$messages = (0, $kSwu1.defineMessages)({
    agentMentionNudgeTitle: {
        id: "page-rovo-config-common.agent-mention-nudge-title",
        defaultMessage: "Start chatting with agent"
    },
    agentMentionNudgeTitleWithAgentName: {
        id: "page-rovo-config-common.agent-mention-nudge-title-with-agent-name.ai-non-final",
        defaultMessage: "Start chatting with {agentName}"
    },
    agentMentionNudgeTitle2: {
        id: "page-rovo-config-common.agent-mention-nudge-title-2",
        defaultMessage: "Give agent a task?"
    },
    agentMentionNudgeTitleWithAgentName2: {
        id: "page-rovo-config-common.agent-mention-nudge-title-with-agent-name.ai-non-final-2",
        defaultMessage: "Give {agentName} a task?"
    },
    agentMentionNudgeIconLabel: {
        id: "page-rovo-config-common.agent-mention-nudge-icon-label",
        defaultMessage: "Agent icon"
    },
    agentMentionNudgeSecondaryTitle: {
        id: "page-rovo-config-common.agent-mention-nudge-secondary-title",
        defaultMessage: "Start a conversation using this agent"
    }
});
const $8732973ed376fa07$export$d8e8e9b085d2396e = 'agent-mention-nudge';
/** Defined outside the hook so React keeps the same DOM node across re-renders. */ const $8732973ed376fa07$var$AgentMentionIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        size: "small",
        label: label
    });
/**
 * Legacy avatar for the mentioned agent, used when the account picture experiment and gate are off.
 * Keyed by the agent's Atlassian account id (AAID), from which AgentAvatar derives a stable
 * generated image. Decorative:
 * the nudge title already names the agent, so the avatar is not separately labelled (a label would
 * put aria-label on a role-less element). Defined outside the hook for a stable component identity.
 */ const $8732973ed376fa07$var$AgentMentionAvatar = ({ agentIdentityAccountId: agentIdentityAccountId, size: size = 'small' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentIdentityAccountId: agentIdentityAccountId,
        size: size,
        showBorder: false
    });
/**
 * Returns true only when the active element is inside the main page editor,
 * excluding comment editors, AI modals and the Rovo prompt screen.
 *
 * Mirrors isMainEditorContent from @confluence/editor-presets — kept local to
 * avoid adding editor-presets as a dependency of this package.
 */ const $8732973ed376fa07$var$isMainEditorContent = (target)=>{
    if (!(target instanceof HTMLElement)) return false;
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') return false;
    if (target.closest('[data-testid="ak-editor-plugin-ai-modal"]')) return false;
    if (target.closest('[data-testid^="ak-editor-ai"]')) return false;
    if (target.closest('[data-testid="rovo-prompt-session-screen"]')) return false;
    if (target.closest('[data-testid="chromeless-editor"]')) return false;
    return target.closest('.ProseMirror') !== null;
};
function $8732973ed376fa07$export$3e06c63ab8775ee2(agentId, agentMentionContext, agentMentionPrompt, agentMentionInsertionCount, agentMentionName, agentIdentityAccountId, invokedByNodeLocalId) {
    const resolvedAgentId = agentId ?? null;
    // Convert bare AAID to full IdentityUserAri
    const resolvedAgentIdentityAccountId = agentIdentityAccountId ? (0, $2khPJ.IdentityUserAri).create({
        userId: agentIdentityAccountId
    }).toString() : null;
    const resolvedPrompt = agentMentionPrompt ?? '';
    const resolvedPromptAdf = agentMentionContext ?? null;
    const resolvedAgentMentionName = agentMentionName?.trim() || null;
    const nudgeId = agentMentionInsertionCount && agentMentionInsertionCount > 0 ? `${$8732973ed376fa07$export$d8e8e9b085d2396e}-${agentMentionInsertionCount}` : $8732973ed376fa07$export$d8e8e9b085d2396e;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen } = (0, $93Gae.useRovoExperienceAPIStore)();
    // Keep a ref to the latest prompt so onClick doesn't need it as a dep.
    // agentMentionContext changes on every keystroke; without this, onClick would
    // recreate on each keystroke → cascading memo invalidations → setNudges on every keystroke.
    const resolvedPromptRef = (0, $cozmU.useRef)(resolvedPrompt);
    resolvedPromptRef.current = resolvedPrompt;
    const resolvedPromptAdfRef = (0, $cozmU.useRef)(resolvedPromptAdf);
    resolvedPromptAdfRef.current = resolvedPromptAdf;
    // Keep a ref to the latest agentId so onClick doesn't capture a stale null.
    // agentId resolves asynchronously; without this, the callback created before
    // resolution would permanently close over null.
    const resolvedAgentIdRef = (0, $cozmU.useRef)(resolvedAgentId);
    resolvedAgentIdRef.current = resolvedAgentId;
    const resolvedAgentIdentityAccountIdRef = (0, $cozmU.useRef)(resolvedAgentIdentityAccountId);
    resolvedAgentIdentityAccountIdRef.current = resolvedAgentIdentityAccountId;
    const invokedByNodeLocalIdRef = (0, $cozmU.useRef)(invokedByNodeLocalId ?? null);
    invokedByNodeLocalIdRef.current = invokedByNodeLocalId ?? null;
    const iconLabel = formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeIconLabel);
    // We capture focus on mousedown so we have the correct pre-click value.
    // The handler is bound directly to the nudge button via the action's onMouseDown prop
    const editorHadFocusAtMouseDownRef = (0, $cozmU.useRef)(false);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        if (!(0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes')) return;
        editorHadFocusAtMouseDownRef.current = typeof document !== 'undefined' && $8732973ed376fa07$var$isMainEditorContent(document.activeElement);
    }, []);
    const onClick = (0, $cozmU.useCallback)(()=>{
        // Use the mousedown snapshot — focus has already moved to the nudge button
        // by the time this click handler runs.
        if ((0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes')) {
            const editorHadFocus = editorHadFocusAtMouseDownRef.current;
            setEditorHadFocusBeforeChatOpen?.(editorHadFocus);
        }
        publish({
            type: 'chat-new',
            source: 'agentMentionEditorNudge',
            openChatMode: 'mini-modal',
            data: {
                prompt: resolvedPromptAdfRef.current ?? resolvedPromptRef.current,
                // The nudge pre-fills as a draft and skips creating a seeded conversation, so the
                // manual send creates and names the conversation instead of leaving a date-named one.
                overrideAutoSend: true,
                ...(0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
                    skipCreatingSeededConversation: true
                } : {},
                dialogues: [],
                mode: {
                    useCurrentPageContext: true
                },
                ...resolvedAgentIdRef.current ? {
                    agentId: resolvedAgentIdRef.current
                } : {},
                ...resolvedAgentIdentityAccountIdRef.current ? {
                    agentIdentityAccountId: resolvedAgentIdentityAccountIdRef.current
                } : {},
                // Seed the agent-run-state bridge with the invoking node, behind its experiment.
                // Consumed on the manual send via the stash in the pubsub listener.
                ...invokedByNodeLocalIdRef.current && (0, $6mKj3.expValEquals)('platform_editor_agent_state_bridge', 'isEnabled', true) ? {
                    invokedByNodeLocalId: invokedByNodeLocalIdRef.current
                } : {}
            }
        });
    }, [
        publish,
        setEditorHadFocusBeforeChatOpen
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const title = resolvedAgentMentionName ? formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitleWithAgentName, {
            agentName: resolvedAgentMentionName
        }) : formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitle);
        const title2 = resolvedAgentMentionName ? formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitleWithAgentName2, {
            agentName: resolvedAgentMentionName
        }) : formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitle2);
        // The experiment or rollout gate enables account pictures within the CTA redesign.
        // When both are off, retain the legacy generated avatar.
        return {
            id: nudgeId,
            title: (0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes') ? title2 : title,
            secondaryTitle: formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeSecondaryTitle),
            icon: (0, $9wGTI.fg)('platform_editor_agent_mentions_cta_redesign') ? (0, $6mKj3.expValEquals)('platform_editor_mention_rovo', 'isEnabled', true) || (0, $9wGTI.fg)('confluence_rovo_agent_mention_resolved_avatar') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dStyd.ResolvedAgentAvatar), {
                    agentIdentityAccountId: resolvedAgentIdentityAccountId,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                        appearance: "hexagon",
                        borderColor: "transparent",
                        size: (0, $9wGTI.fg)('confluence_rovo_agent_session_nudges') ? 'xxsmall' : 'small'
                    }),
                    size: (0, $9wGTI.fg)('confluence_rovo_agent_session_nudges') ? 'xxsmall' : 'small'
                }) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8732973ed376fa07$var$AgentMentionAvatar, {
                    agentIdentityAccountId: agentIdentityAccountId,
                    size: (0, $9wGTI.fg)('confluence_rovo_agent_session_nudges') ? 'xxsmall' : 'small'
                }) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8732973ed376fa07$var$AgentMentionIcon, {
                    label: iconLabel
                }),
            onClick: onClick,
            onMouseDown: onMouseDown,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: $8732973ed376fa07$export$d8e8e9b085d2396e,
                selfEligible: true,
                experimentName: 'platform_editor_agent_mentions'
            }
        };
    }, [
        formatMessage,
        iconLabel,
        nudgeId,
        onClick,
        onMouseDown,
        resolvedAgentMentionName,
        agentIdentityAccountId,
        resolvedAgentIdentityAccountId
    ]);
}




const $1dc1702d58bb7989$var$AUDIO_BRIEFING_MIN_READ_TIME_MINUTES = 5;
function $1dc1702d58bb7989$export$60835107d4b45e85(enableLiveDocNudges, eligibleForChangeboarding, isFirstVisit, isCurrentUserContributor, isEligibilityLoading, readTimeMinutes, /**
	 * controls nudge *presence* (truthy = mention exists). Presence also requires
	 * `resolvedAgentMentionId` below, so the nudge never renders (and can't be clicked) before
	 * the Agent Studio UUID has resolved — clicking before resolution would fire `chat-new`
	 * without a routable agentId.
	 */ agentMentionId, /** control nudge *presence* (see above) and *payload* (forwarded to useAgentMentionNudgeAction). */ resolvedAgentMentionId, /** control nudge *payload* (forwarded to useAgentMentionNudgeAction). */ agentMentionContext, /** control nudge fallback prompt (forwarded to useAgentMentionNudgeAction). */ agentMentionPrompt, /** controls the nudge action id so each inserted mention is treated as a new nudge. */ agentMentionInsertionCount, /** control nudge title (forwarded to useAgentMentionNudgeAction). */ agentMentionName, /** invoking mention node localId (forwarded to seed the agent-run-state bridge). */ invokedByNodeLocalId, /** current page ID used to retrieve page-scoped agent-session nudges. */ contentId = '') {
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const { nudges: sessionNudges, errors: sessionErrors } = (0, $0f202a159dd3a2a0$export$c870d03c0d0604d0)({
        contentId: contentId,
        enabled: true
    });
    const agentMentionNudgeAction = (0, $8732973ed376fa07$export$3e06c63ab8775ee2)(resolvedAgentMentionId, agentMentionContext, agentMentionPrompt, agentMentionInsertionCount, agentMentionName, agentMentionId, invokedByNodeLocalId);
    const actionsById = (0, $cozmU.useMemo)(()=>new Map(viewPageRovoActions.map((registeredAction)=>[
                registeredAction.actionId,
                registeredAction.action
            ])), [
        viewPageRovoActions
    ]);
    const nudges = (0, $cozmU.useMemo)(()=>{
        // Require resolvedAgentMentionId too: without it, a click fired before the AAID→UUID
        // resolution completes would publish `chat-new` with no agentId, silently routing to
        // the default/current conversation agent instead of the mentioned one.
        const alwaysOnNudges = [
            ...sessionNudges,
            ...agentMentionId && resolvedAgentMentionId ? [
                agentMentionNudgeAction
            ] : []
        ];
        const contentReviewerNudge = actionsById.get('content-reviewer-nudge');
        if (contentReviewerNudge) alwaysOnNudges.push(contentReviewerNudge);
        if (!enableLiveDocNudges) return alwaysOnNudges;
        const isAudioBriefingEligible = !isEligibilityLoading && !eligibleForChangeboarding && isFirstVisit && !isCurrentUserContributor && readTimeMinutes !== null && readTimeMinutes >= $1dc1702d58bb7989$var$AUDIO_BRIEFING_MIN_READ_TIME_MINUTES;
        const nudgeEntries = [
            {
                actionId: 'status-updates-automation',
                enabled: (0, $9wGTI.fg)('cc_automations_discovery_nudges')
            },
            {
                actionId: 'audio-briefing',
                enabled: isAudioBriefingEligible
            }
        ];
        const liveDocNudges = nudgeEntries.reduce((acc, nudgeEntry)=>{
            if (!nudgeEntry.enabled) return acc;
            const action = (0, $fa24c3761347e030$export$5d0421d6a355c531)(nudgeEntry) ? nudgeEntry.action : actionsById.get(nudgeEntry.actionId);
            if (action) acc.push(action);
            return acc;
        }, []);
        return [
            ...alwaysOnNudges,
            ...liveDocNudges
        ];
    }, [
        sessionNudges,
        agentMentionId,
        // resolvedAgentMentionId now also gates presence (see above), so it must be a dep.
        // agentMentionContext/agentMentionName remain payload-only: agentMentionNudgeAction
        // already invalidates on those values.
        resolvedAgentMentionId,
        agentMentionNudgeAction,
        enableLiveDocNudges,
        isEligibilityLoading,
        eligibleForChangeboarding,
        isFirstVisit,
        isCurrentUserContributor,
        readTimeMinutes,
        actionsById
    ]);
    return {
        nudges: nudges,
        errors: sessionErrors
    };
}



var $02cx8 = parcelRequire("02cx8");

/* getEmptyPageCreationActions.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $4ez2K = parcelRequire("4ez2K");


var $jQDPt = parcelRequire("jQDPt");




const $efb362169c233167$export$4b8c4c333cdd165d = [
    'create-product-requirements-document',
    'create-customer-onboarding-strategy',
    'create-background-research-plan'
]; /* istanbul ignore next */ 
const $efb362169c233167$var$styles = {
    iconContainer: "_4FKVYEgVvo"
};
const $efb362169c233167$export$4e5c71902381581b = (promptCards)=>{
    const promptCardsById = new Map(promptCards.map((card)=>[
            card.id,
            card
        ]));
    return $efb362169c233167$export$4b8c4c333cdd165d.reduce((actions, targetId)=>{
        const card = promptCardsById.get(targetId);
        if (card) actions.push({
            handleType: (0, $6iWVH.HandleActionType).Chat,
            id: card.id,
            title: card.title,
            dynamicPrompt: card.prompt,
            icon: ()=>{
                const Icon = (0, $jQDPt.getUseCaseIcon)(card.useCase);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    alignItems: "center",
                    justifyContent: "center",
                    xcss: $efb362169c233167$var$styles.iconContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, null));
            }
        });
        return actions;
    }, []);
};


var $4c762b6d974e46d5$exports = {};
$4c762b6d974e46d5$exports = new URL("empty-page-greeting-icon.9a2c7bfb.svg", import.meta.url).toString();


const $7e583ad86f1e8aa8$var$messages = (0, $kSwu1.defineMessages)({
    emptyPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.empty-page-greeting-title",
        defaultMessage: "Start your doc with a prompt"
    },
    copiedPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.copied-page-greeting-title",
        defaultMessage: "Need help editing your copied page?"
    }
});
const $7e583ad86f1e8aa8$var$EditPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const editorActions = (0, $02cx8.useEditorRovoButtonActionsActions)();
    const editorActionsContext = (0, $02cx8.useEditorRovoButtonActionsContext)();
    const copiedPageContentId = (0, $02cx8.useEditorRovoButtonCopiedPageContentId)();
    const copiedPageActions = (0, $02cx8.useEditorRovoButtonCopiedPageActions)();
    const rovoConfigProviderProps = (0, $amW67.useRovoConfigProviderProps)();
    const isEditorEmpty = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) && rovoConfigProviderProps.isEditorEmpty;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { promptCards: promptCards } = (0, $ZKswU.usePromptCards)();
    const isEmptyPageWithPromptCards = isEditorEmpty && Array.isArray(promptCards);
    const pageProps = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) ? rovoConfigProviderProps : null;
    const contentType = pageProps?.contentType ?? '';
    const contentId = pageProps?.contentId ?? '';
    const readTimeMinutes = pageProps?.readTime ?? null;
    const readTimeLoading = pageProps?.readTimeLoading ?? false;
    const enableLiveDocNudges = (0, $23e0c73c9feee0cc$export$5569745b4d0a5343)(contentType);
    const { eligibleForChangeboarding: eligibleForChangeboarding } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const { isFirstVisit: isFirstVisit, loading: isFirstVisitLoading } = (0, $4a8709f90f4edadd$export$2e8f1aa0f8ab1526)(contentId, !enableLiveDocNudges);
    const { isCurrentUserContributor: isCurrentUserContributor, loading: isContributorLoading } = (0, $fc07d009da21f8b9$export$cb9bdc967aae1b21)(contentId, !enableLiveDocNudges);
    const isEligibilityLoading = isFirstVisitLoading || isContributorLoading || readTimeLoading;
    const agentMentionId = (0, $02cx8.useEditorRovoButtonAgentMentionId)();
    const agentMentionInsertionCount = (0, $02cx8.useEditorRovoButtonAgentMentionInsertionCount)();
    const resolvedAgentMentionId = (0, $02cx8.useEditorRovoButtonResolvedAgentMentionId)();
    const agentMentionContext = (0, $02cx8.useEditorRovoButtonAgentMentionContext)();
    const agentMentionPrompt = (0, $02cx8.useEditorRovoButtonAgentMentionPrompt)();
    const agentMentionName = (0, $02cx8.useEditorRovoButtonAgentMentionName)();
    const agentMentionNodeLocalId = (0, $02cx8.useEditorRovoButtonAgentMentionNodeLocalId)();
    const { nudges: nudges, errors: nudgeErrors } = (0, $1dc1702d58bb7989$export$60835107d4b45e85)(enableLiveDocNudges, eligibleForChangeboarding, isFirstVisit, isCurrentUserContributor, isEligibilityLoading, readTimeMinutes, (0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) ? agentMentionId : null, resolvedAgentMentionId, agentMentionContext, agentMentionPrompt, agentMentionInsertionCount, agentMentionName, agentMentionNodeLocalId, contentId);
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const config = (0, $cozmU.useMemo)(()=>{
        // The copied-page slice is the only copy signal — never infer it from `editorActions`, which
        // the editor's smart-button plugin fills (with no selection reference) on every edit page.
        // Experiment evaluated last so exposure only fires for a genuine copied page.
        const isCopiedPageRovoChat = !!contentId && copiedPageContentId === contentId && copiedPageActions.length > 0 && !editorActionsContext?.reference && (0, $6mKj3.expValEquals)('cc_fd_copy_with_rovo', 'cohort', 'rovoChat');
        const getCustomGreeting = ()=>{
            if (isEmptyPageWithPromptCards && !isCopiedPageRovoChat) return {
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($4c762b6d974e46d5$exports))),
                title: formatMessage($7e583ad86f1e8aa8$var$messages.emptyPageGreetingTitle)
            };
            if (isCopiedPageRovoChat) return {
                title: formatMessage($7e583ad86f1e8aa8$var$messages.copiedPageGreetingTitle)
            };
            return undefined;
        };
        const customGreeting = getCustomGreeting();
        const baseConfig = {
            getActions: async ()=>{
                // Only the copied-page action(s), so nothing sits above copy-with-rovo. Paired with
                // `prioritizeCustomActionResults` below.
                if (isCopiedPageRovoChat) return Promise.resolve(copiedPageActions);
                if (isEmptyPageWithPromptCards) return Promise.resolve((0, $efb362169c233167$export$4e5c71902381581b)(promptCards));
                if (editorActionsContext?.reference) return Promise.resolve(editorActions);
                const viewPageActions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve([
                    ...editorActions,
                    ...viewPageActions
                ]);
            },
            customGreeting: customGreeting,
            shouldShowGreeting: customGreeting !== undefined || undefined,
            prioritizeCustomActionResults: isCopiedPageRovoChat || isEmptyPageWithPromptCards ? true : undefined
        };
        return baseConfig;
    }, [
        editorActions,
        editorActionsContext,
        contentId,
        copiedPageContentId,
        copiedPageActions,
        viewPageRovoActions,
        isEmptyPageWithPromptCards,
        promptCards,
        formatMessage
    ]);
    (0, $cozmU.useEffect)(()=>{
        setConfiguration(config);
        setNudges(nudges);
    }, [
        config,
        setConfiguration,
        nudges,
        setNudges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $9wGTI.fg)('cc_automations_nudge_actions_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $afee6b634376daaa$export$2e1f63b035bfb63e), {
        contentId: contentId
    }) : null, nudgeErrors.map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            key: `${error.name}-${index}`,
            error: error
        })));
};
const $7e583ad86f1e8aa8$export$d95c465cd9bfae9f = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e583ad86f1e8aa8$var$EditPageConfigProviderInner, props));
};









var $c9vDa = parcelRequire("c9vDa");




















var $4u3xL = parcelRequire("4u3xL");








var $dF5G8 = parcelRequire("dF5G8");

const $f7deda53c4334bac$export$a15e5171a3cb34f2 = (0, $3u0dr.isReactCompilerActiveV2)() ? function ReviewButtonPlaceholder() {
    const $ = (0, $bDgLe.c)(8);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $dF5G8.reviewButtonMessages).reviewSuggestionsLabel);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    const label = t0;
    const t1 = isRovoButtonEnabled ? "default" : "circle";
    let t2;
    if ($[2] !== label || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))),
            label: label,
            shape: t1,
            isDisabled: true,
            testId: "object-sidebar-review-button"
        });
        $[2] = label;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== label || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: label,
            position: "left",
            delay: 0
        }, t2);
        $[5] = label;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : function ReviewButtonPlaceholder() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const label = formatMessage((0, $dF5G8.reviewButtonMessages).reviewSuggestionsLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: label,
        position: "left",
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))),
        label: label,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        isDisabled: true,
        testId: "object-sidebar-review-button"
    }));
};

const $f7deda53c4334bac$export$ff0e0e22e0001f5b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fnpd8",
    name: "ReviewButtonLoader",
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7deda53c4334bac$export$a15e5171a3cb34f2, null),
    loader: async ()=>(await Promise.resolve((parcelRequire("6pfrs")))).ReviewButton
});



var $6pfrs = parcelRequire("6pfrs");








var $5qQdB = parcelRequire("5qQdB");


const $c0d001f61b78e98b$export$41c46dd9735e3599 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "y3Elg",
    name: "TableOfContentsPopupButtonLoader",
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5qQdB.TableOfContentsButtonPlaceholder), null),
    loader: async ()=>(await Promise.resolve((parcelRequire("hMNzI")))).TableOfContentsPopupButton
});



var $hMNzI = parcelRequire("hMNzI");

















var $gIaMn = parcelRequire("gIaMn");




var $5Abqh = parcelRequire("5Abqh");


const $8a4bdd953279ff48$export$75b705e7e413826a = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "h5GrM",
    name: "AudioButtonLoaderActivatable",
    loader: async ()=>(await (parcelRequire("4Ep2c"))).AudioButton,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).AudioButton
});

const $8a4bdd953279ff48$export$2cf028d3aae3c5f9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IJrya",
    name: "AudioButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("4Ep2c"))).AudioButton
});


const $46bbba5af56c1c8e$export$6210e0bba7c89213 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)("confluence_selective_hydration_audio_button", "isEnabled", false)) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== contentId || $[3] !== contentTitle || $[4] !== contentType || $[5] !== isDisabled || $[6] !== spaceKey) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isDisabled
        });
        $[2] = contentId;
        $[3] = contentTitle;
        $[4] = contentType;
        $[5] = isDisabled;
        $[6] = spaceKey;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
} : (props)=>{
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)('confluence_selective_hydration_audio_button', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
    // functionality is unchanged, AudioButton is only wrapped in a Loadable
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isDisabled
    });
};
/**
 * Internal component used only when selective hydration is enabled.
 * Contains all SH-specific logic (browser support, keyboard focus unlock).
 *
 * JS for AudioButton is delayed until user hovers (currently for View Page and Space Overviews)
 * Cases for immediate unlock (bypassing selective hydration) include:
 *
 * Disabled browser (Firefox)
 * User activation via keyboard (tab)
 *
 */ const $46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $cozmU.useState)(false);
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const isAudioSupportedByBrowser = typeof MediaSource !== "undefined" && MediaSource.isTypeSupported("audio/mpeg");
            if (!isAudioSupportedByBrowser) (0, $cozmU.startTransition)(()=>{
                setAudioSupportedByBrowser(false);
            });
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const wrapper = wrapperRef.current;
            if (!wrapper) return;
            const handleFocus = (event)=>{
                const target = event.target;
                if (!target || !target.matches("button, [role=\"button\"]")) return;
                const isKeyboardFocus = target.matches(":focus-visible");
                if (!isKeyboardFocus) return;
                (0, $cozmU.startTransition)(()=>{
                    setIsFocusActivated(true);
                });
            };
            wrapper.addEventListener("focus", handleFocus, true);
            return ()=>{
                wrapper.removeEventListener("focus", handleFocus, true);
            };
        };
        t4 = [];
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const immediateActivationCondition = audioSupportedByBrowser === false || isFocusActivated;
    const isButtonDisabled = isDisabled || !renderServerPlaceholder && !audioSupportedByBrowser;
    const t5 = audioSupportedByBrowser ?? true;
    let t6;
    if ($[4] !== t5) {
        t6 = {
            audioSupportedByBrowserFromWrapper: t5
        };
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    const wrapperProps = t6;
    let t7;
    if ($[6] !== contentId || $[7] !== contentTitle || $[8] !== contentType || $[9] !== immediateActivationCondition || $[10] !== isButtonDisabled || $[11] !== spaceKey || $[12] !== wrapperProps) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: wrapperRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isButtonDisabled,
            immediateActivationCondition: immediateActivationCondition,
            selectiveHydrationEnabled: true,
            ...wrapperProps
        }));
        $[6] = contentId;
        $[7] = contentTitle;
        $[8] = contentType;
        $[9] = immediateActivationCondition;
        $[10] = isButtonDisabled;
        $[11] = spaceKey;
        $[12] = wrapperProps;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    // Assume audio is enabled for SSR until client-side useEffect checks browser support
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $cozmU.useState)(false);
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    (0, $cozmU.useEffect)(()=>{
        // Only check audio support when selective hydration is enabled.
        // For FG-OFF we rely on the browser check within AudioButton.
        const isAudioSupportedByBrowser = typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg');
        if (!isAudioSupportedByBrowser) (0, $cozmU.startTransition)(()=>{
            setAudioSupportedByBrowser(false);
        });
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // Focus listener to determine if a user has tabbed to the button via keyboard, in which case
        // the component is immediately hydrated. This listener must live outside AudioButton code and hydrate if button is activated.
        const wrapper = wrapperRef.current;
        if (!wrapper) return;
        const handleFocus = (event)=>{
            const target = event.target;
            if (!target || !target.matches('button, [role="button"]')) return;
            const isKeyboardFocus = target.matches(':focus-visible');
            if (!isKeyboardFocus) return;
            (0, $cozmU.startTransition)(()=>{
                setIsFocusActivated(true);
            });
        };
        wrapper.addEventListener('focus', handleFocus, true);
        return ()=>{
            wrapper.removeEventListener('focus', handleFocus, true);
        };
    }, []);
    // Only immediately hydrate if:
    // 1) audio button is not supported by browser (firefox) and component needs to hydrate to show as disabled on page load
    // 2) user activates the button via keyboard focus
    const immediateActivationCondition = audioSupportedByBrowser === false || isFocusActivated;
    const isButtonDisabled = isDisabled || !renderServerPlaceholder && !audioSupportedByBrowser;
    const wrapperProps = {
        audioSupportedByBrowserFromWrapper: audioSupportedByBrowser ?? true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isButtonDisabled,
        immediateActivationCondition: immediateActivationCondition,
        selectiveHydrationEnabled: true,
        ...wrapperProps
    }));
};











/* HerButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $iMnC5 = parcelRequire("iMnC5");





var $gRv41 = parcelRequire("gRv41");


var $5xmyM = parcelRequire("5xmyM");

const $31e30a93afdc1384$var$styles = {
    icon: "_0jFU0VoWWg _39xV02oWWg"
};
const $31e30a93afdc1384$var$getAudioLevel = ()=>0;
function $31e30a93afdc1384$export$eca6b6ab857179f1({ contentId: contentId, cloudId: cloudId, contentType: contentType }) {
    const { isHerActive: isHerActive, toggleHer: toggleHer } = (0, $gRv41.useHerStore)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        toggleHer(contentId, cloudId, contentType);
    }, [
        toggleHer,
        contentId,
        cloudId,
        contentType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: "Rovo Voice",
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                xcss: $31e30a93afdc1384$var$styles.icon
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5xmyM.Constellation), {
                active: isHerActive,
                getAudioLevel: $31e30a93afdc1384$var$getAudioLevel,
                paused: false,
                pose: "still"
            })),
        label: "Rovo Voice",
        shape: "default",
        isSelected: isHerActive,
        onClick: handleClick,
        testId: "enterprise-her-button"
    }));
}





const $d34346cf549a725a$export$2501aa4690daf770 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { contentId: contentId, contentType: contentType } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== contentType) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31e30a93afdc1384$export$eca6b6ab857179f1), {
            contentId: contentId,
            contentType: contentType,
            cloudId: cloudId
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ contentId: contentId, contentType: contentType })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31e30a93afdc1384$export$eca6b6ab857179f1), {
        contentId: contentId,
        contentType: contentType,
        cloudId: cloudId
    });
};



var $4ZXww = parcelRequire("4ZXww");


var $fgdVB = parcelRequire("fgdVB");

const $3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar = [
    '--right',
    'PanelWidth'
].join('');

const $3265ee1fae39f7d6$var$CommentPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R3F99",
    name: "CommentPanelButton",
    loader: async ()=>(await (parcelRequire("kONYb"))).CommentPanelButton
});

const $3265ee1fae39f7d6$var$DetailsPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wgj5o",
    name: "DetailsPanelButton",
    loader: async ()=>(await (parcelRequire("9BuFn"))).DetailsPanelButton
});

const $3265ee1fae39f7d6$var$AgentReceiptPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R8yoa",
    name: "AgentReceiptPanelButton",
    loader: async ()=>(await (parcelRequire("2sYsz"))).AgentReceiptPanelButton
});

const $3265ee1fae39f7d6$var$EditorAIActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gSc9d",
    name: "EditorAIActions",
    loader: async ()=>(await (parcelRequire("cv9SU"))).EditorAIActions
});

const $3265ee1fae39f7d6$var$UndoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KP43A",
    name: "UndoButton",
    loader: async ()=>(await (parcelRequire("3zDXO"))).UndoButton
});

const $3265ee1fae39f7d6$var$RedoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jZ8ML",
    name: "RedoButton",
    loader: async ()=>(await (parcelRequire("3zDXO"))).RedoButton
});

const $3265ee1fae39f7d6$var$ShowDiffButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "41USm",
    name: "ShowDiffButton",
    loader: async ()=>(await (parcelRequire("jyQuB"))).ShowDiffButton
});

const $3265ee1fae39f7d6$var$RemixPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CmH6Z",
    name: "RemixPanelButton",
    loader: async ()=>(await (parcelRequire("k2dFi"))).RemixPanelButton
});

const $3265ee1fae39f7d6$var$AgentsPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RyToS",
    name: "AgentsPanelButton",
    loader: async ()=>(await (parcelRequire("iLeiU"))).AgentsPanelButton
});

const $3265ee1fae39f7d6$var$AudioListenButtonWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bAx22",
    name: "AudioListenButtonWrapper",
    loader: async ()=>(await (parcelRequire("jzzzm"))).AudioListenButtonWrapper
});

const $3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "hFsXW",
    name: "ObjectSidebarSpotlightTour",
    loader: async ()=>(await (parcelRequire("3R9tJ"))).ObjectSidebarSpotlightTour
});
const $3265ee1fae39f7d6$var$objectSidebarStyles = null;
const $3265ee1fae39f7d6$var$markdownModeObjectSidebarStyles = null;
const $3265ee1fae39f7d6$var$objectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$databaseObjectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$largeBottomPaddingStyles = null;
const $3265ee1fae39f7d6$var$viewModeStyles = null;
const $3265ee1fae39f7d6$var$miniModalModeStyles = null;
const $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleContainerStyles = null;
const $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.100',
    marginBottom: 'space.050'
});
const $3265ee1fae39f7d6$var$rovoButtonCollapsibleBottomSidebarStyles = null;
const $3265ee1fae39f7d6$var$collapsibleToggleStyles = null;
const $3265ee1fae39f7d6$var$dividerStyle = (0, $buxP3.xcss)({
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    display: 'inline-block',
    width: '16px',
    height: '1px'
});
const $3265ee1fae39f7d6$var$hiddenStyles = null;
const $3265ee1fae39f7d6$var$i18n = (0, $kSwu1.defineMessages)({
    expandToggleLabel: {
        id: "object-sidebar-components.expand-toggle-label",
        defaultMessage: "Expand action bar"
    },
    collapseToggleLabel: {
        id: "object-sidebar-components.collapse-toggle-label",
        defaultMessage: "Collapse action bar"
    }
});
const $3265ee1fae39f7d6$var$ObjectSidebarControlContent = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(261);
    const { hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasAgentReceiptButton: hasAgentReceiptButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, hasRemixButton: hasRemixButton, hasReviewButton: hasReviewButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, aiSuggestionsButtonActions: aiSuggestionsButtonActions, hasAudioButton: hasAudioButton, agentTrustReceipt: agentTrustReceipt, contentId: contentId, contributorsFragmentRef: contributorsFragmentRef, rovoActivationFragmentRef: rovoActivationFragmentRef, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: t1, pageCommentsSectionInView: pageCommentsSectionInView, contentBodyDynamic: contentBodyDynamic, editorApi: editorApi, scrollToEditorHeading: scrollToEditorHeading, getAdfDocument: getAdfDocument, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: t2, isDatabasesStagingArea: t3, disabled: disabled, isEditorEmpty: isEditorEmpty, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled, actionsToRender: actionsToRender, preloadedCanAddComments: preloadedCanAddComments } = t0;
    const aiIsStreaming = t1 === undefined ? false : t1;
    const shouldDisableUndoRedo = t2 === undefined ? false : t2;
    const isDatabasesStagingArea = t3 === undefined ? false : t3;
    const [t4] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t4;
    const isNetworkDisabled = isCollabOffline;
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $cozmU.useState)(false);
    const objectSidebarControlRef = (0, $cozmU.useRef)(null);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { setSidebarControlState: setSidebarControlState, showSidebarControlIfNoPanel: showSidebarControlIfNoPanel, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const { mode: rovoExperienceMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            selector: $3265ee1fae39f7d6$var$_temp
        };
        $[0] = t5;
    } else t5 = $[0];
    const isOnPDFExportPageRouteArgs = t5;
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [t6] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode } = t6;
    let t7;
    if ($[1] !== isAdminHubAIEnabled || $[2] !== isLiveViewMode || $[3] !== isRovoButtonEnabled || $[4] !== pageMode) {
        t7 = !isAdminHubAIEnabled || !isRovoButtonEnabled || pageMode !== (0, $cD1qu.PageMode).LIVE || isLiveViewMode || !(0, $9wGTI.fg)("confluence_rovo_live_doc_nudges");
        $[1] = isAdminHubAIEnabled;
        $[2] = isLiveViewMode;
        $[3] = isRovoButtonEnabled;
        $[4] = pageMode;
        $[5] = t7;
    } else t7 = $[5];
    const skipReadTime = t7;
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, skipReadTime);
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { isAudioV3Enabled: isAudioV3Enabled } = (0, $JTIzG.useAudioFeatureFlags)();
    let t8;
    if ($[6] !== editorApi?.aiExperience?.actions) {
        t8 = ()=>{
            editorApi?.aiExperience?.actions.toggleAiEntryPoints?.(false);
        };
        $[6] = editorApi?.aiExperience?.actions;
        $[7] = t8;
    } else t8 = $[7];
    const releaseEditorAiEntryPoints = t8;
    let t9;
    if ($[8] !== releaseEditorAiEntryPoints) {
        t9 = {
            onHandedOffGenerationEnded: releaseEditorAiEntryPoints
        };
        $[8] = releaseEditorAiEntryPoints;
        $[9] = t9;
    } else t9 = $[9];
    const objectSidebarRemixLifecycleAdapter = (0, $eCmUm.useObjectSidebarRemixLifecycleAdapter)(t9);
    let t10;
    if ($[10] !== setSidebarControlExpandCollapsedState) {
        t10 = ()=>{
            setSidebarControlExpandCollapsedState("expanded");
        };
        $[10] = setSidebarControlExpandCollapsedState;
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== contentId || $[13] !== setSidebarControlExpandCollapsedState) {
        t11 = [
            contentId,
            setSidebarControlExpandCollapsedState
        ];
        $[12] = contentId;
        $[13] = setSidebarControlExpandCollapsedState;
        $[14] = t11;
    } else t11 = $[14];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    let t13;
    if ($[15] !== isObjectSidebarShown || $[16] !== setSidebarControlExpandCollapsedState || $[17] !== setSidebarControlState || $[18] !== showSidebarControlIfNoPanel) {
        t12 = ()=>{
            if ((0, $6mKj3.expValEquals)("cc_comments_detached_in_open_view", "isEnabled", true)) showSidebarControlIfNoPanel();
            else if (!isObjectSidebarShown) setSidebarControlState("shown");
            setSidebarControlExpandCollapsedState("expanded");
            return ()=>{
                setSidebarControlExpandCollapsedState("collapsed");
            };
        };
        t13 = [
            showSidebarControlIfNoPanel,
            setSidebarControlState,
            setSidebarControlExpandCollapsedState,
            isObjectSidebarShown
        ];
        $[15] = isObjectSidebarShown;
        $[16] = setSidebarControlExpandCollapsedState;
        $[17] = setSidebarControlState;
        $[18] = showSidebarControlIfNoPanel;
        $[19] = t12;
        $[20] = t13;
    } else {
        t12 = $[19];
        t13 = $[20];
    }
    (0, $cozmU.useEffect)(t12, t13);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === "expanded" || renderServerPlaceholder;
    let collapsedActions;
    let isRemixEntryEligible;
    let primaryActions;
    let secondaryActionsTeam25;
    let shouldRenderFloatingTableOfContents;
    if ($[21] !== agentTrustReceipt || $[22] !== aiIsStreaming || $[23] !== aiSuggestionsButtonActions || $[24] !== contentBodyDynamic?.value || $[25] !== contentId || $[26] !== contentTitle || $[27] !== contentType || $[28] !== contributorsFragmentRef || $[29] !== disabled || $[30] !== editorAIActions || $[31] !== editorApi || $[32] !== getAdfDocument || $[33] !== hasAgentReceiptButton || $[34] !== hasAudioButton || $[35] !== hasCommentsButton || $[36] !== hasDetailsButton || $[37] !== hasLoomButton || $[38] !== hasRemixButton || $[39] !== hasReviewButton || $[40] !== hasUndoRedoButton || $[41] !== isAudioV3Enabled || $[42] !== isDatabasesStagingArea || $[43] !== isEditorEmpty || $[44] !== isLivePage || $[45] !== isLiveViewMode || $[46] !== isLoomDisabled || $[47] !== isNetworkDisabled || $[48] !== isRovoButtonEnabled || $[49] !== pageMode || $[50] !== preloadedCanAddComments || $[51] !== renderServerPlaceholder || $[52] !== scrollToEditorHeading || $[53] !== shouldDisableUndoRedo || $[54] !== showDiffButtonActions || $[55] !== sidebarControlState || $[56] !== sidebarIsExpanded || $[57] !== spaceKey || $[58] !== undoRedoButtonActions) {
        collapsedActions = [];
        if ($[64] !== aiIsStreaming || $[65] !== hasUndoRedoButton || $[66] !== isDatabasesStagingArea || $[67] !== isLiveViewMode || $[68] !== shouldDisableUndoRedo || $[69] !== showDiffButtonActions || $[70] !== undoRedoButtonActions) {
            primaryActions = [];
            if (hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
                const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
                if (undo && canUndo !== undefined) {
                    const t14 = aiIsStreaming || shouldDisableUndoRedo;
                    let t15;
                    if ($[72] !== canUndo || $[73] !== t14 || $[74] !== undo) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$UndoButton, {
                            canUndo: canUndo,
                            undo: undo,
                            isDisabled: t14
                        });
                        $[72] = canUndo;
                        $[73] = t14;
                        $[74] = undo;
                        $[75] = t15;
                    } else t15 = $[75];
                    primaryActions.push(t15);
                }
                if (redo && canRedo !== undefined) {
                    const t14 = aiIsStreaming || shouldDisableUndoRedo;
                    let t15;
                    if ($[76] !== canRedo || $[77] !== redo || $[78] !== t14) {
                        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RedoButton, {
                            canRedo: canRedo,
                            redo: redo,
                            isDisabled: t14
                        });
                        $[76] = canRedo;
                        $[77] = redo;
                        $[78] = t14;
                        $[79] = t15;
                    } else t15 = $[79];
                    primaryActions.push(t15);
                }
            }
            if (showDiffButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
                const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
                const t14 = isShowDiffEnabled && !aiIsStreaming;
                let t15;
                if ($[80] !== isShowDiffSelected || $[81] !== onShowDiff || $[82] !== t14) {
                    t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
                        isShowDiffSelected: isShowDiffSelected,
                        isShowDiffEnabled: t14,
                        onShowDiff: onShowDiff
                    });
                    $[80] = isShowDiffSelected;
                    $[81] = onShowDiff;
                    $[82] = t14;
                    $[83] = t15;
                } else t15 = $[83];
                primaryActions.push(t15);
            }
            $[64] = aiIsStreaming;
            $[65] = hasUndoRedoButton;
            $[66] = isDatabasesStagingArea;
            $[67] = isLiveViewMode;
            $[68] = shouldDisableUndoRedo;
            $[69] = showDiffButtonActions;
            $[70] = undoRedoButtonActions;
            $[71] = primaryActions;
        } else primaryActions = $[71];
        const isPageOrBlogpost = contentType === "page" || contentType === "blogpost";
        let t14;
        if ($[84] !== contentId || $[85] !== hasCommentsButton || $[86] !== isNetworkDisabled || $[87] !== preloadedCanAddComments) {
            t14 = hasCommentsButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled,
                preloadedCanAddComments: preloadedCanAddComments
            }) : null;
            $[84] = contentId;
            $[85] = hasCommentsButton;
            $[86] = isNetworkDisabled;
            $[87] = preloadedCanAddComments;
            $[88] = t14;
        } else t14 = $[88];
        const commentsButton = t14;
        let t15;
        if ($[89] !== contentId || $[90] !== hasCommentsButton || $[91] !== isNetworkDisabled || $[92] !== preloadedCanAddComments || $[93] !== sidebarIsExpanded) {
            t15 = hasCommentsButton && !sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                key: "comment-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled,
                preloadedCanAddComments: preloadedCanAddComments
            }) : null;
            $[89] = contentId;
            $[90] = hasCommentsButton;
            $[91] = isNetworkDisabled;
            $[92] = preloadedCanAddComments;
            $[93] = sidebarIsExpanded;
            $[94] = t15;
        } else t15 = $[94];
        const collapsedCommentsButton = t15;
        let t16;
        if ($[95] !== contentId || $[96] !== hasDetailsButton || $[97] !== isNetworkDisabled) {
            t16 = hasDetailsButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }) : null;
            $[95] = contentId;
            $[96] = hasDetailsButton;
            $[97] = isNetworkDisabled;
            $[98] = t16;
        } else t16 = $[98];
        const detailsButton = t16;
        let t17;
        if ($[99] !== contentId || $[100] !== hasDetailsButton || $[101] !== isNetworkDisabled || $[102] !== sidebarIsExpanded) {
            t17 = hasDetailsButton && !sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                key: "details-panel-button-collapsed",
                contentId: contentId,
                collapsed: true,
                isDisabled: isNetworkDisabled
            }) : null;
            $[99] = contentId;
            $[100] = hasDetailsButton;
            $[101] = isNetworkDisabled;
            $[102] = sidebarIsExpanded;
            $[103] = t17;
        } else t17 = $[103];
        const collapsedDetailsButton = t17;
        let t18;
        if ($[104] !== agentTrustReceipt || $[105] !== hasAgentReceiptButton || $[106] !== isNetworkDisabled) {
            t18 = hasAgentReceiptButton && agentTrustReceipt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentReceiptPanelButton, {
                key: "agent-receipt-panel-button",
                receipt: agentTrustReceipt,
                isDisabled: isNetworkDisabled
            }) : null;
            $[104] = agentTrustReceipt;
            $[105] = hasAgentReceiptButton;
            $[106] = isNetworkDisabled;
            $[107] = t18;
        } else t18 = $[107];
        const agentReceiptButton = t18;
        let t19;
        if ($[108] !== contentId || $[109] !== contentType) {
            t19 = (0, $6mKj3.isExperimentEnabled)("enterprise_her") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d34346cf549a725a$export$2501aa4690daf770), {
                key: "enterprise-her-button-wrapper",
                contentId: contentId,
                contentType: contentType ?? ""
            }) : null;
            $[108] = contentId;
            $[109] = contentType;
            $[110] = t19;
        } else t19 = $[110];
        const enterpriseHerButton = t19;
        let audioButton = null;
        if (hasAudioButton) {
            let t20;
            if ($[111] !== contentId || $[112] !== contentTitle || $[113] !== contentType || $[114] !== disabled || $[115] !== isAudioV3Enabled || $[116] !== isLivePage || $[117] !== isNetworkDisabled || $[118] !== isRovoButtonEnabled || $[119] !== pageMode || $[120] !== spaceKey) {
                t20 = isAudioV3Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                    key: "audio-listen-button-wrapper",
                    isRovoButtonEnabled: isRovoButtonEnabled,
                    contentId: contentId,
                    contentType: contentType ?? "",
                    isLivePage: isLivePage,
                    spaceKey: spaceKey ?? "",
                    title: contentTitle ?? "",
                    isAutoOpenDisabled: disabled
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                    key: "audio-button-loader-wrapper",
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: spaceKey,
                    contentTitle: contentTitle,
                    isDisabled: isNetworkDisabled,
                    isView: pageMode === (0, $cD1qu.PageMode).VIEW
                });
                $[111] = contentId;
                $[112] = contentTitle;
                $[113] = contentType;
                $[114] = disabled;
                $[115] = isAudioV3Enabled;
                $[116] = isLivePage;
                $[117] = isNetworkDisabled;
                $[118] = isRovoButtonEnabled;
                $[119] = pageMode;
                $[120] = spaceKey;
                $[121] = t20;
            } else t20 = $[121];
            audioButton = t20;
        }
        let t20;
        if ($[122] !== contentId || $[123] !== contentType || $[124] !== contributorsFragmentRef || $[125] !== hasLoomButton || $[126] !== isLoomDisabled || $[127] !== isNetworkDisabled || $[128] !== isPageOrBlogpost || $[129] !== isRovoButtonEnabled || $[130] !== spaceKey) {
            t20 = hasLoomButton && !isLoomDisabled && !(isPageOrBlogpost && (0, $6mKj3.UNSAFE_expValNoExposure)("platform_editor_ai_content_suggested_edits", "isEnabled", false)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
                contributorsFragmentRef: contributorsFragmentRef,
                key: "page-header-loom-entry-point",
                contentId: contentId,
                crossSellPopupPlacement: "left-end",
                crossSellSpotlightPlacement: "left-start",
                spaceKey: spaceKey ?? "",
                contentType: contentType ?? "",
                isCircle: !isRovoButtonEnabled,
                testId: "sidebar-loom-button",
                source: "contentWrapper",
                isDisabled: isNetworkDisabled
            }) : null;
            $[122] = contentId;
            $[123] = contentType;
            $[124] = contributorsFragmentRef;
            $[125] = hasLoomButton;
            $[126] = isLoomDisabled;
            $[127] = isNetworkDisabled;
            $[128] = isPageOrBlogpost;
            $[129] = isRovoButtonEnabled;
            $[130] = spaceKey;
            $[131] = t20;
        } else t20 = $[131];
        const loomButton = t20;
        let t21;
        if ($[132] !== aiIsStreaming || $[133] !== editorAIActions) {
            t21 = editorAIActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
                key: "editor-ai-actions",
                editorAIActions: editorAIActions,
                isDisabled: aiIsStreaming
            }) : null;
            $[132] = aiIsStreaming;
            $[133] = editorAIActions;
            $[134] = t21;
        } else t21 = $[134];
        const editorAIActionsButton = t21;
        let t22;
        if ($[135] !== hasRemixButton) {
            t22 = hasRemixButton && !(0, $HmpUb.isRemixOptedOut)() && (0, $6mKj3.expValEquals)("cc-maui-object-level-remix-experiment", "isEnabled", true);
            $[135] = hasRemixButton;
            $[136] = t22;
        } else t22 = $[136];
        isRemixEntryEligible = Boolean(t22);
        let t23;
        if ($[137] !== contentBodyDynamic?.value || $[138] !== contentId || $[139] !== getAdfDocument || $[140] !== isEditorEmpty || $[141] !== isNetworkDisabled || $[142] !== isRemixEntryEligible) {
            t23 = isRemixEntryEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RemixPanelButton, {
                key: "remix-panel-button",
                contentId: contentId,
                contentBodyValue: contentBodyDynamic?.value,
                getAdfDocument: getAdfDocument,
                isEditorEmpty: isEditorEmpty,
                isDisabled: isNetworkDisabled
            }) : null;
            $[137] = contentBodyDynamic?.value;
            $[138] = contentId;
            $[139] = getAdfDocument;
            $[140] = isEditorEmpty;
            $[141] = isNetworkDisabled;
            $[142] = isRemixEntryEligible;
            $[143] = t23;
        } else t23 = $[143];
        const remixButton = t23;
        let t24;
        if ($[144] !== contentType || $[145] !== editorApi || $[146] !== pageMode) {
            t24 = (contentType === "page" || contentType === "blogpost") && (pageMode === (0, $cD1qu.PageMode).VIEW || editorApi || pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) && (0, $6mKj3.expValEquals)("platform_editor_floating_toc", "isEnabled", true);
            $[144] = contentType;
            $[145] = editorApi;
            $[146] = pageMode;
            $[147] = t24;
        } else t24 = $[147];
        shouldRenderFloatingTableOfContents = t24;
        let t25;
        if ($[148] !== contentBodyDynamic?.value || $[149] !== contentType || $[150] !== editorApi || $[151] !== pageMode || $[152] !== scrollToEditorHeading || $[153] !== shouldRenderFloatingTableOfContents) {
            t25 = shouldRenderFloatingTableOfContents ? (0, $9wGTI.fg)("confluence_object_sidebar_buttons_vc_fix") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMNzI.TableOfContentsPopupButton), {
                key: "table-of-contents-popup-button",
                isDisabled: pageMode !== (0, $cD1qu.PageMode).VIEW && !editorApi,
                contentBodyValue: contentBodyDynamic?.value,
                contentType: contentType,
                editorApi: editorApi,
                pageMode: pageMode,
                popupPositioningRef: objectSidebarControlRef,
                scrollToEditorHeading: scrollToEditorHeading
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0d001f61b78e98b$export$41c46dd9735e3599), {
                key: "table-of-contents-popup-button",
                isDisabled: pageMode !== (0, $cD1qu.PageMode).VIEW && !editorApi,
                contentBodyValue: contentBodyDynamic?.value,
                contentType: contentType,
                editorApi: editorApi,
                pageMode: pageMode,
                popupPositioningRef: objectSidebarControlRef,
                scrollToEditorHeading: scrollToEditorHeading
            }) : null;
            $[148] = contentBodyDynamic?.value;
            $[149] = contentType;
            $[150] = editorApi;
            $[151] = pageMode;
            $[152] = scrollToEditorHeading;
            $[153] = shouldRenderFloatingTableOfContents;
            $[154] = t25;
        } else t25 = $[154];
        const tableOfContentsButton = t25;
        const isEditingPage = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode;
        let t26;
        if ($[155] !== aiSuggestionsButtonActions || $[156] !== hasReviewButton || $[157] !== isEditingPage || $[158] !== isNetworkDisabled || $[159] !== renderServerPlaceholder || $[160] !== sidebarControlState) {
            t26 = (aiSuggestionsButtonActions || hasReviewButton) && isEditingPage && (0, $6mKj3.expValEquals)("platform_editor_ai_content_suggested_edits", "isEnabled", true) ? (0, $9wGTI.fg)("confluence_object_sidebar_buttons_vc_fix") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6pfrs.ReviewButton), {
                key: "review-button",
                onStartThinking: aiSuggestionsButtonActions?.onStartThinking,
                fireAnalyticsEvent: aiSuggestionsButtonActions?.fireAnalyticsEvent,
                isDisabled: isNetworkDisabled,
                isVisible: renderServerPlaceholder || sidebarControlState !== "hidden",
                showNotificationDot: aiSuggestionsButtonActions?.showNotificationDot
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7deda53c4334bac$export$ff0e0e22e0001f5b), {
                key: "review-button",
                onStartThinking: aiSuggestionsButtonActions?.onStartThinking,
                fireAnalyticsEvent: aiSuggestionsButtonActions?.fireAnalyticsEvent,
                isDisabled: !aiSuggestionsButtonActions || isNetworkDisabled,
                isVisible: renderServerPlaceholder || sidebarControlState !== "hidden",
                showNotificationDot: aiSuggestionsButtonActions?.showNotificationDot
            }) : null;
            $[155] = aiSuggestionsButtonActions;
            $[156] = hasReviewButton;
            $[157] = isEditingPage;
            $[158] = isNetworkDisabled;
            $[159] = renderServerPlaceholder;
            $[160] = sidebarControlState;
            $[161] = t26;
        } else t26 = $[161];
        const reviewButton = t26;
        let t27;
        if ($[162] !== contentId || $[163] !== isNetworkDisabled) {
            t27 = (0, $9wGTI.fg)("confluence_ai_agents_sidebar_button") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentsPanelButton, {
                key: "agents-panel-button",
                contentId: contentId,
                isDisabled: isNetworkDisabled
            }) : null;
            $[162] = contentId;
            $[163] = isNetworkDisabled;
            $[164] = t27;
        } else t27 = $[164];
        const agentsButton = t27;
        if ($[165] !== agentReceiptButton || $[166] !== agentsButton || $[167] !== audioButton || $[168] !== commentsButton || $[169] !== detailsButton || $[170] !== editorAIActionsButton || $[171] !== enterpriseHerButton || $[172] !== isPageOrBlogpost || $[173] !== loomButton || $[174] !== remixButton || $[175] !== reviewButton || $[176] !== tableOfContentsButton) {
            const orderedSecondaryActions = isPageOrBlogpost && (0, $6mKj3.UNSAFE_expValNoExposure)("platform_editor_ai_content_suggested_edits", "isEnabled", false) ? [
                tableOfContentsButton,
                detailsButton,
                agentReceiptButton,
                enterpriseHerButton,
                audioButton,
                commentsButton,
                reviewButton,
                editorAIActionsButton,
                remixButton,
                agentsButton
            ] : [
                tableOfContentsButton,
                commentsButton,
                detailsButton,
                agentReceiptButton,
                enterpriseHerButton,
                audioButton,
                loomButton,
                editorAIActionsButton,
                remixButton,
                reviewButton,
                agentsButton
            ];
            secondaryActionsTeam25 = [];
            for (const action of orderedSecondaryActions)if (action) secondaryActionsTeam25.push(action);
            $[165] = agentReceiptButton;
            $[166] = agentsButton;
            $[167] = audioButton;
            $[168] = commentsButton;
            $[169] = detailsButton;
            $[170] = editorAIActionsButton;
            $[171] = enterpriseHerButton;
            $[172] = isPageOrBlogpost;
            $[173] = loomButton;
            $[174] = remixButton;
            $[175] = reviewButton;
            $[176] = tableOfContentsButton;
            $[177] = secondaryActionsTeam25;
        } else secondaryActionsTeam25 = $[177];
        let t28;
        if ($[178] !== collapsedCommentsButton || $[179] !== collapsedDetailsButton || $[180] !== isPageOrBlogpost) {
            t28 = isPageOrBlogpost && (0, $6mKj3.UNSAFE_expValNoExposure)("platform_editor_ai_content_suggested_edits", "isEnabled", false) ? [
                collapsedDetailsButton,
                collapsedCommentsButton
            ] : [
                collapsedCommentsButton,
                collapsedDetailsButton
            ];
            $[178] = collapsedCommentsButton;
            $[179] = collapsedDetailsButton;
            $[180] = isPageOrBlogpost;
            $[181] = t28;
        } else t28 = $[181];
        const orderedCollapsedActions = t28;
        for (const action_0 of orderedCollapsedActions)if (action_0) collapsedActions.push(action_0);
        $[21] = agentTrustReceipt;
        $[22] = aiIsStreaming;
        $[23] = aiSuggestionsButtonActions;
        $[24] = contentBodyDynamic?.value;
        $[25] = contentId;
        $[26] = contentTitle;
        $[27] = contentType;
        $[28] = contributorsFragmentRef;
        $[29] = disabled;
        $[30] = editorAIActions;
        $[31] = editorApi;
        $[32] = getAdfDocument;
        $[33] = hasAgentReceiptButton;
        $[34] = hasAudioButton;
        $[35] = hasCommentsButton;
        $[36] = hasDetailsButton;
        $[37] = hasLoomButton;
        $[38] = hasRemixButton;
        $[39] = hasReviewButton;
        $[40] = hasUndoRedoButton;
        $[41] = isAudioV3Enabled;
        $[42] = isDatabasesStagingArea;
        $[43] = isEditorEmpty;
        $[44] = isLivePage;
        $[45] = isLiveViewMode;
        $[46] = isLoomDisabled;
        $[47] = isNetworkDisabled;
        $[48] = isRovoButtonEnabled;
        $[49] = pageMode;
        $[50] = preloadedCanAddComments;
        $[51] = renderServerPlaceholder;
        $[52] = scrollToEditorHeading;
        $[53] = shouldDisableUndoRedo;
        $[54] = showDiffButtonActions;
        $[55] = sidebarControlState;
        $[56] = sidebarIsExpanded;
        $[57] = spaceKey;
        $[58] = undoRedoButtonActions;
        $[59] = collapsedActions;
        $[60] = isRemixEntryEligible;
        $[61] = primaryActions;
        $[62] = secondaryActionsTeam25;
        $[63] = shouldRenderFloatingTableOfContents;
    } else {
        collapsedActions = $[59];
        isRemixEntryEligible = $[60];
        primaryActions = $[61];
        secondaryActionsTeam25 = $[62];
        shouldRenderFloatingTableOfContents = $[63];
    }
    let t14;
    bb0: {
        if (contentType === "folder") {
            let t15;
            if ($[182] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = {
                    experience: (0, $dppWL.RegisteredExperience).FOLDER,
                    provider: (0, $b6f192cd6e2c63ff$export$b9c46d9495de208d)
                };
                $[182] = t15;
            } else t15 = $[182];
            t14 = t15;
            break bb0;
        }
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) {
            let t15;
            if ($[183] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = {
                    experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
                    provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
                };
                $[183] = t15;
            } else t15 = $[183];
            t14 = t15;
            break bb0;
        }
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) {
            let t15;
            if ($[184] === Symbol.for("react.memo_cache_sentinel")) {
                t15 = {
                    experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
                    provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
                };
                $[184] = t15;
            } else t15 = $[184];
            t14 = t15;
            break bb0;
        }
        t14 = undefined;
    }
    const rovoConfiguration = t14;
    if (isOnPDFExportPageRoute) return null;
    let t15;
    if ($[185] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
        $[185] = t15;
    } else t15 = $[185];
    const isEmbeddedConfluence = t15;
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence;
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded;
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    let t16;
    if ($[186] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>{
            setActionBarIsHovered(true);
        };
        $[186] = t16;
    } else t16 = $[186];
    const handleMouseEnter = t16;
    let t17;
    if ($[187] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = ()=>{
            setActionBarIsHovered(false);
        };
        $[187] = t17;
    } else t17 = $[187];
    const handleMouseLeave = t17;
    let t18;
    if ($[188] !== sidebarIsExpanded || $[189] !== toggleObjectSidebarControl) {
        t18 = ()=>{
            toggleObjectSidebarControl();
            setActionBarIsHovered(!sidebarIsExpanded);
        };
        $[188] = sidebarIsExpanded;
        $[189] = toggleObjectSidebarControl;
        $[190] = t18;
    } else t18 = $[190];
    const onToggleClick = t18;
    let t19;
    if ($[191] !== formatMessage || $[192] !== sidebarIsExpanded) {
        t19 = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[191] = formatMessage;
        $[192] = sidebarIsExpanded;
        $[193] = t19;
    } else t19 = $[193];
    const toggleLabel = t19;
    let t20;
    if ($[194] !== formatMessage) {
        t20 = formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[194] = formatMessage;
        $[195] = t20;
    } else t20 = $[195];
    let t21;
    if ($[196] !== toggleLabel || $[197] !== toggleObjectSidebarControl) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: $3265ee1fae39f7d6$var$_temp2,
            label: toggleLabel,
            onClick: toggleObjectSidebarControl,
            shape: "circle",
            testId: "integrated-expand-button"
        });
        $[196] = toggleLabel;
        $[197] = toggleObjectSidebarControl;
        $[198] = t21;
    } else t21 = $[198];
    let t22;
    if ($[199] !== t20 || $[200] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: t20,
            hideTooltipOnClick: true
        }, t21);
        $[199] = t20;
        $[200] = t21;
        $[201] = t22;
    } else t22 = $[201];
    const integratedExpandButton = t22;
    let t23;
    if ($[202] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = (0, $6mKj3.UNSAFE_expValNoExposure)("cc_maui_remix_button_hover_corridor", "isEnabled", false) ? (0, $5YDZX.blockControlsSuppressionProps) : {};
        $[202] = t23;
    } else t23 = $[202];
    const t24 = "object-sidebar-container";
    const t25 = "object-sidebar-container";
    const t26 = pageMode === (0, $cD1qu.PageMode).VIEW ? `calc(var(${$3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar}, 0px))` : "0px";
    let t27;
    if ($[203] !== t26) {
        t27 = {
            right: t26,
            marginRight: 0
        };
        $[203] = t26;
        $[204] = t27;
    } else t27 = $[204];
    const t28 = (0, $hekY6.default)([
        "_23rrnH9JLe _1mT5xdy1CL _0Bm75GdnbC _42Yu6BPvK5 _1pp6NdYbGa _27asfwIZbP",
        isMarkdownMode && isMarkdownModeSyntaxViewToggled && "_0Bm75GS40j",
        (contentType === "page" || contentType === "blogpost" || pageMode === (0, $cD1qu.PageMode).VIEW) && "_1ZnuxbNHnM _1wydGW2ADO",
        (contentType === "database" || contentType === "slide") && "_1Znuxb2ADO _1wydGW2ADO",
        largeBottomPadding && "_1wydGWNHnM",
        isRovoMiniModalShown && "_42Yu6BFIQA",
        pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && "_42Yu6BiZR3",
        !renderServerPlaceholder && sidebarControlState === "hidden" && "_3iDTPbYbGa"
    ]);
    const t29 = contentBodyDynamic?.value;
    let t30;
    if ($[205] !== collapsedActions || $[206] !== contentId || $[207] !== integratedExpandButton || $[208] !== isMobileApp || $[209] !== isRovoButtonEnabled || $[210] !== onToggleClick || $[211] !== primaryActions || $[212] !== renderServerPlaceholder || $[213] !== secondaryActionsTeam25 || $[214] !== shouldDisplayHoverToggle || $[215] !== shouldRenderFloatingTableOfContents || $[216] !== shouldRenderIntegratedExpandButton || $[217] !== shouldRenderWhenEmbedded || $[218] !== sidebarIsExpanded || $[219] !== toggleLabel) {
        t30 = primaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle || sidebarIsExpanded ? "visible" : "hidden",
                opacity: !shouldDisplayHoverToggle && sidebarIsExpanded ? 0 : undefined
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $hekY6.default)([
                "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps_0,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                    ...iconProps_0,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
            name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle || sidebarIsExpanded ? "visible" : "hidden",
                opacity: !shouldDisplayHoverToggle && sidebarIsExpanded ? 0 : undefined
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $hekY6.default)([
                "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (iconProps_1)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps_1,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                    ...iconProps_1,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        }))))), (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions)), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, integratedExpandButton)) : null, (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        })));
        $[205] = collapsedActions;
        $[206] = contentId;
        $[207] = integratedExpandButton;
        $[208] = isMobileApp;
        $[209] = isRovoButtonEnabled;
        $[210] = onToggleClick;
        $[211] = primaryActions;
        $[212] = renderServerPlaceholder;
        $[213] = secondaryActionsTeam25;
        $[214] = shouldDisplayHoverToggle;
        $[215] = shouldRenderFloatingTableOfContents;
        $[216] = shouldRenderIntegratedExpandButton;
        $[217] = shouldRenderWhenEmbedded;
        $[218] = sidebarIsExpanded;
        $[219] = toggleLabel;
        $[220] = t30;
    } else t30 = $[220];
    let t31;
    if ($[221] !== actionsToRender || $[222] !== contentId || $[223] !== contentTitle || $[224] !== contentType || $[225] !== contributorsFragmentRef || $[226] !== isEditorEmpty || $[227] !== isEmbeddedConfluence || $[228] !== isLivePage || $[229] !== isNetworkDisabled || $[230] !== isRovoButtonEnabled || $[231] !== isUnpublishedDraft || $[232] !== lastModifiedDate || $[233] !== pageCommentsSectionInView || $[234] !== pageMode || $[235] !== readTime || $[236] !== readTimeLoading || $[237] !== rovoActivationFragmentRef || $[238] !== rovoConfiguration?.experience || $[239] !== rovoConfiguration?.provider || $[240] !== shouldRenderAISmartButton || $[241] !== spaceKey) {
        t31 = shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_0Of8r22ADO _1DCdHi5zaO _2XsHFMHZdu"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3tUdX.RovoConfigProvider), {
            experience: rovoConfiguration?.experience,
            provider: rovoConfiguration?.provider,
            contributorsFragmentRef: contributorsFragmentRef,
            rovoActivationFragmentRef: rovoActivationFragmentRef,
            contentId: contentId,
            contentType: contentType ?? "",
            spaceKey: spaceKey ?? "",
            contentTitle: contentTitle ?? "",
            lastModifiedDate: lastModifiedDate,
            isUnpublishedDraft: isUnpublishedDraft,
            isEditorEmpty: isEditorEmpty,
            readTime: readTime ?? undefined,
            readTimeLoading: readTimeLoading,
            actionsToRender: actionsToRender ?? []
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hU34N.AISmartButtonWrapper), {
            contentId: contentId,
            contentType: contentType ?? "",
            pageMode: pageMode,
            isDisabled: isNetworkDisabled,
            spaceKey: spaceKey,
            isSidebarAvailable: isEmbeddedConfluence ? false : undefined
        })) : contentType !== "database" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3acdd5624bc36ae$export$71951c424ee8d4c2), {
            spaceKey: spaceKey ?? "",
            contentId: contentId,
            contentType: contentType ?? "",
            lastModifiedDate: lastModifiedDate,
            pageCommentsSectionInView: pageCommentsSectionInView,
            isLivePage: isLivePage,
            isInObjectSideBar: true
        })));
        $[221] = actionsToRender;
        $[222] = contentId;
        $[223] = contentTitle;
        $[224] = contentType;
        $[225] = contributorsFragmentRef;
        $[226] = isEditorEmpty;
        $[227] = isEmbeddedConfluence;
        $[228] = isLivePage;
        $[229] = isNetworkDisabled;
        $[230] = isRovoButtonEnabled;
        $[231] = isUnpublishedDraft;
        $[232] = lastModifiedDate;
        $[233] = pageCommentsSectionInView;
        $[234] = pageMode;
        $[235] = readTime;
        $[236] = readTimeLoading;
        $[237] = rovoActivationFragmentRef;
        $[238] = rovoConfiguration?.experience;
        $[239] = rovoConfiguration?.provider;
        $[240] = shouldRenderAISmartButton;
        $[241] = spaceKey;
        $[242] = t31;
    } else t31 = $[242];
    let t32;
    if ($[243] !== getAdfDocument || $[244] !== isRemixEntryEligible || $[245] !== objectSidebarRemixLifecycleAdapter || $[246] !== sidebarIsExpanded || $[247] !== t29 || $[248] !== t30 || $[249] !== t31) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9vDa.ObjectSidebarRemixLifecycleSessionProvider), {
            lifecycleAdapter: objectSidebarRemixLifecycleAdapter,
            contentBodyValue: t29,
            getAdfDocument: getAdfDocument,
            isRemixEntryEligible: isRemixEntryEligible,
            isObjectSidebarExpanded: sidebarIsExpanded
        }, t30, t31);
        $[243] = getAdfDocument;
        $[244] = isRemixEntryEligible;
        $[245] = objectSidebarRemixLifecycleAdapter;
        $[246] = sidebarIsExpanded;
        $[247] = t29;
        $[248] = t30;
        $[249] = t31;
        $[250] = t32;
    } else t32 = $[250];
    let t33;
    if ($[251] !== handleMouseEnter || $[252] !== handleMouseLeave || $[253] !== t23 || $[254] !== t27 || $[255] !== t28 || $[256] !== t32) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...t23,
            "data-testid": t24,
            "data-vc": t25,
            style: t27,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleMouseEnter,
            onBlur: handleMouseLeave,
            className: t28
        }, t32);
        $[251] = handleMouseEnter;
        $[252] = handleMouseLeave;
        $[253] = t23;
        $[254] = t27;
        $[255] = t28;
        $[256] = t32;
        $[257] = t33;
    } else t33 = $[257];
    let t34;
    if ($[258] === Symbol.for("react.memo_cache_sentinel")) {
        t34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[258] = t34;
    } else t34 = $[258];
    let t35;
    if ($[259] !== t33) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t33, t34);
        $[259] = t33;
        $[260] = t35;
    } else t35 = $[260];
    return t35;
} : ({ hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasAgentReceiptButton: hasAgentReceiptButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, hasRemixButton: hasRemixButton, hasReviewButton: hasReviewButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, aiSuggestionsButtonActions: aiSuggestionsButtonActions, hasAudioButton: hasAudioButton, agentTrustReceipt: agentTrustReceipt, contentId: contentId, contributorsFragmentRef: contributorsFragmentRef, rovoActivationFragmentRef: rovoActivationFragmentRef, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: aiIsStreaming = false, pageCommentsSectionInView: pageCommentsSectionInView, contentBodyDynamic: contentBodyDynamic, editorApi: editorApi, scrollToEditorHeading: scrollToEditorHeading, getAdfDocument: getAdfDocument, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: shouldDisableUndoRedo = false, isDatabasesStagingArea: isDatabasesStagingArea = false, disabled: disabled, isEditorEmpty: isEditorEmpty, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled, actionsToRender: actionsToRender, preloadedCanAddComments: preloadedCanAddComments })=>{
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)();
    const isNetworkDisabled = isCollabOffline;
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $cozmU.useState)(false);
    const objectSidebarControlRef = (0, $cozmU.useRef)(null);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { setSidebarControlState: setSidebarControlState, showSidebarControlIfNoPanel: showSidebarControlIfNoPanel, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const { mode: rovoExperienceMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isOnPDFExportPageRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
        }
    };
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const skipReadTime = !isAdminHubAIEnabled || !isRovoButtonEnabled || pageMode !== (0, $cD1qu.PageMode).LIVE || isLiveViewMode || // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    !(0, $9wGTI.fg)('confluence_rovo_live_doc_nudges');
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, skipReadTime);
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { isAudioV3Enabled: isAudioV3Enabled } = (0, $JTIzG.useAudioFeatureFlags)(); // Rovo streams a handed-off Remix into the editor and disables its AI entry points, but a stop or
    // panel close never reaches the editor, so they would stay disabled until the stream times out.
    const releaseEditorAiEntryPoints = (0, $cozmU.useCallback)(()=>{
        editorApi?.aiExperience?.actions.toggleAiEntryPoints?.(false);
    }, [
        editorApi
    ]);
    const objectSidebarRemixLifecycleAdapter = (0, $eCmUm.useObjectSidebarRemixLifecycleAdapter)({
        onHandedOffGenerationEnded: releaseEditorAiEntryPoints
    }); // whenever the contentID changes we needed to reset the action bar to be expanded
    (0, $cozmU.useEffect)(()=>{
        setSidebarControlExpandCollapsedState('expanded');
    }, [
        contentId,
        setSidebarControlExpandCollapsedState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $6mKj3.expValEquals)('cc_comments_detached_in_open_view', 'isEnabled', true)) showSidebarControlIfNoPanel();
        else if (!isObjectSidebarShown) setSidebarControlState('shown');
        setSidebarControlExpandCollapsedState('expanded');
        return ()=>{
            setSidebarControlExpandCollapsedState('collapsed');
        };
    }, [
        showSidebarControlIfNoPanel,
        setSidebarControlState,
        setSidebarControlExpandCollapsedState,
        isObjectSidebarShown
    ]);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === 'expanded' || renderServerPlaceholder; // Collapsed actions are rendered when collapsed. These can be used e.g. to enable keyboard shortcuts while collapsed.
    const collapsedActions = [];
    const primaryActions = [];
    if (hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
        const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
        if (undo && canUndo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$UndoButton, {
            canUndo: canUndo,
            undo: undo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
        if (redo && canRedo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RedoButton, {
            canRedo: canRedo,
            redo: redo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
    }
    if (showDiffButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
        const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
        primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
            isShowDiffSelected: isShowDiffSelected,
            isShowDiffEnabled: isShowDiffEnabled && !aiIsStreaming,
            onShowDiff: onShowDiff
        }));
    }
    const isPageOrBlogpost = contentType === 'page' || contentType === 'blogpost';
    const commentsButton = hasCommentsButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
        key: "comment-panel-button",
        contentId: contentId,
        isDisabled: isNetworkDisabled,
        preloadedCanAddComments: preloadedCanAddComments
    }) : null;
    const collapsedCommentsButton = hasCommentsButton && !sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
        key: "comment-panel-button-collapsed",
        contentId: contentId,
        collapsed: true,
        isDisabled: isNetworkDisabled,
        preloadedCanAddComments: preloadedCanAddComments
    }) : null;
    const detailsButton = hasDetailsButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
        key: "details-panel-button",
        contentId: contentId,
        isDisabled: isNetworkDisabled
    }) : null;
    const collapsedDetailsButton = hasDetailsButton && !sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
        key: "details-panel-button-collapsed",
        contentId: contentId,
        collapsed: true,
        isDisabled: isNetworkDisabled
    }) : null;
    const agentReceiptButton = hasAgentReceiptButton && agentTrustReceipt ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentReceiptPanelButton, {
        key: "agent-receipt-panel-button",
        receipt: agentTrustReceipt,
        isDisabled: isNetworkDisabled
    }) : null;
    const enterpriseHerButton = (0, $6mKj3.isExperimentEnabled)('enterprise_her') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d34346cf549a725a$export$2501aa4690daf770), {
        key: "enterprise-her-button-wrapper",
        contentId: contentId,
        contentType: contentType ?? ''
    }) : null;
    let audioButton = null;
    if (hasAudioButton) audioButton = isAudioV3Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
        key: "audio-listen-button-wrapper",
        isRovoButtonEnabled: isRovoButtonEnabled,
        contentId: contentId,
        contentType: contentType ?? '',
        isLivePage: isLivePage,
        spaceKey: spaceKey ?? '',
        title: contentTitle ?? '',
        isAutoOpenDisabled: disabled
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
        key: "audio-button-loader-wrapper",
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isNetworkDisabled,
        isView: pageMode === (0, $cD1qu.PageMode).VIEW
    });
     // AI Suggested Edits ships a reorganised toolbar without Loom on pages and blog posts.
    // Read without exposure because the toolbar also renders on view pages, where the Review
    // entry point (which logs exposure) never does.
    const loomButton = hasLoomButton && !isLoomDisabled && !(isPageOrBlogpost && (0, $6mKj3.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
        contributorsFragmentRef: contributorsFragmentRef,
        key: "page-header-loom-entry-point",
        contentId: contentId,
        crossSellPopupPlacement: "left-end",
        crossSellSpotlightPlacement: "left-start",
        spaceKey: spaceKey ?? '',
        contentType: contentType ?? '',
        isCircle: !isRovoButtonEnabled,
        testId: "sidebar-loom-button",
        source: "contentWrapper",
        isDisabled: isNetworkDisabled
    }) : null;
    const editorAIActionsButton = editorAIActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
        key: "editor-ai-actions",
        editorAIActions: editorAIActions,
        isDisabled: aiIsStreaming
    }) : null; // Computed once: the Remix entry point gates both this button and the persistently hosted
    // Rovo submit coordinator, and `expValEquals` records an exposure on every call.
    const isRemixEntryEligible = Boolean(hasRemixButton && !(0, $HmpUb.isRemixOptedOut)() && (0, $6mKj3.expValEquals)('cc-maui-object-level-remix-experiment', 'isEnabled', true));
    const remixButton = isRemixEntryEligible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RemixPanelButton, {
        key: "remix-panel-button",
        contentId: contentId,
        contentBodyValue: contentBodyDynamic?.value,
        getAdfDocument: getAdfDocument,
        isEditorEmpty: isEditorEmpty,
        isDisabled: isNetworkDisabled
    }) : null;
    const shouldRenderFloatingTableOfContents = (contentType === 'page' || contentType === 'blogpost') && (pageMode === (0, $cD1qu.PageMode).VIEW || editorApi || pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE) && (0, $6mKj3.expValEquals)('platform_editor_floating_toc', 'isEnabled', true); // Rendered without a loadable boundary when gated so the trigger never swaps from a
    // placeholder to the real button, which is a VC mutation.
    const tableOfContentsButton = shouldRenderFloatingTableOfContents ? // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    (0, $9wGTI.fg)('confluence_object_sidebar_buttons_vc_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMNzI.TableOfContentsPopupButton), {
        key: "table-of-contents-popup-button",
        isDisabled: pageMode !== (0, $cD1qu.PageMode).VIEW && !editorApi,
        contentBodyValue: contentBodyDynamic?.value,
        contentType: contentType,
        editorApi: editorApi,
        pageMode: pageMode,
        popupPositioningRef: objectSidebarControlRef,
        scrollToEditorHeading: scrollToEditorHeading
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0d001f61b78e98b$export$41c46dd9735e3599), {
        key: "table-of-contents-popup-button",
        isDisabled: pageMode !== (0, $cD1qu.PageMode).VIEW && !editorApi,
        contentBodyValue: contentBodyDynamic?.value,
        contentType: contentType,
        editorApi: editorApi,
        pageMode: pageMode,
        popupPositioningRef: objectSidebarControlRef,
        scrollToEditorHeading: scrollToEditorHeading
    }) : null;
    const isEditingPage = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode;
    const reviewButton = (aiSuggestionsButtonActions || hasReviewButton) && isEditingPage && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    (0, $9wGTI.fg)('confluence_object_sidebar_buttons_vc_fix') ? // Rendered without a loadable boundary, and enabled while the editor's AI suggestions
    // load, so the button never swaps from a disabled placeholder (a VC mutation). Until
    // then `onStartThinking` is undefined, so clicks are no-ops.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6pfrs.ReviewButton), {
        key: "review-button",
        onStartThinking: aiSuggestionsButtonActions?.onStartThinking,
        fireAnalyticsEvent: aiSuggestionsButtonActions?.fireAnalyticsEvent,
        isDisabled: isNetworkDisabled,
        isVisible: renderServerPlaceholder || sidebarControlState !== 'hidden',
        showNotificationDot: aiSuggestionsButtonActions?.showNotificationDot
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7deda53c4334bac$export$ff0e0e22e0001f5b), {
        key: "review-button",
        onStartThinking: aiSuggestionsButtonActions?.onStartThinking,
        fireAnalyticsEvent: aiSuggestionsButtonActions?.fireAnalyticsEvent,
        isDisabled: !aiSuggestionsButtonActions || isNetworkDisabled,
        isVisible: renderServerPlaceholder || sidebarControlState !== 'hidden',
        showNotificationDot: aiSuggestionsButtonActions?.showNotificationDot
    }) : null; // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    const agentsButton = (0, $9wGTI.fg)('confluence_ai_agents_sidebar_button') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentsPanelButton, {
        key: "agents-panel-button",
        contentId: contentId,
        isDisabled: isNetworkDisabled
    }) : null;
    const orderedSecondaryActions = isPageOrBlogpost && (0, $6mKj3.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false) ? [
        // Consumer actions
        tableOfContentsButton,
        detailsButton,
        agentReceiptButton,
        enterpriseHerButton,
        audioButton,
        // Collaboration actions
        commentsButton,
        reviewButton,
        // Creator actions
        editorAIActionsButton,
        remixButton,
        agentsButton
    ] : [
        tableOfContentsButton,
        commentsButton,
        detailsButton,
        agentReceiptButton,
        enterpriseHerButton,
        audioButton,
        loomButton,
        editorAIActionsButton,
        remixButton,
        reviewButton,
        agentsButton
    ];
    const secondaryActionsTeam25 = [];
    for (const action of orderedSecondaryActions)if (action) secondaryActionsTeam25.push(action);
    const orderedCollapsedActions = isPageOrBlogpost && (0, $6mKj3.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false) ? [
        collapsedDetailsButton,
        collapsedCommentsButton
    ] : [
        collapsedCommentsButton,
        collapsedDetailsButton
    ];
    for (const action_0 of orderedCollapsedActions)if (action_0) collapsedActions.push(action_0);
    const rovoConfiguration = (0, $cozmU.useMemo)(()=>{
        if (contentType === 'folder') return {
            experience: (0, $dppWL.RegisteredExperience).FOLDER,
            provider: (0, $b6f192cd6e2c63ff$export$b9c46d9495de208d)
        };
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
            provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
        };
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
            provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
        };
        return undefined;
    }, [
        contentType,
        pageMode,
        isLiveViewMode
    ]);
    if (isOnPDFExportPageRoute) return null;
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(); // For databases in staging area, always allow rendering (isFullScreenEmbedView is typically undefined)
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence; // If there's no AI button, when we collapse the action bar, we need to render an expand icon within the
    // existing action bar container. If there is an AI button, hovering over it should render the expand icon
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded; // We always render the toggle component into the DOM, but we change its visibility based on:
    // If the action bar is expanded: show on hover (regardless of AI button)
    // If the action bar is collapsed: always show if AI button present, otherwise never show
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const handleMouseEnter = ()=>{
        setActionBarIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setActionBarIsHovered(false);
    };
    const onToggleClick = ()=>{
        toggleObjectSidebarControl(); // need to make sure the hover (dis)appears after clicking it
        setActionBarIsHovered(!sidebarIsExpanded);
    };
    const toggleLabel = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
    const integratedExpandButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                ...iconProps,
                size: "small"
            }),
        label: toggleLabel,
        onClick: toggleObjectSidebarControl,
        shape: "circle",
        testId: "integrated-expand-button"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...(0, $6mKj3.UNSAFE_expValNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', false) ? (0, $5YDZX.blockControlsSuppressionProps) : {},
        "data-testid": "object-sidebar-container",
        "data-vc": "object-sidebar-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            right: pageMode === (0, $cD1qu.PageMode).VIEW ? `calc(var(${$3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar}, 0px))` : '0px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            marginRight: 0
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
        className: (0, $hekY6.default)([
            "_23rrnH9JLe _1mT5xdy1CL _0Bm75GdnbC _42Yu6BPvK5 _1pp6NdYbGa _27asfwIZbP",
            isMarkdownMode && isMarkdownModeSyntaxViewToggled && "_0Bm75GS40j",
            (contentType === 'page' || contentType === 'blogpost' || pageMode === (0, $cD1qu.PageMode).VIEW) && "_1ZnuxbNHnM _1wydGW2ADO",
            (contentType === 'database' || contentType === 'slide') && "_1Znuxb2ADO _1wydGW2ADO",
            largeBottomPadding && "_1wydGWNHnM",
            isRovoMiniModalShown && "_42Yu6BFIQA",
            pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && "_42Yu6BiZR3",
            !renderServerPlaceholder && sidebarControlState === 'hidden' && "_3iDTPbYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9vDa.ObjectSidebarRemixLifecycleSessionProvider), {
        lifecycleAdapter: objectSidebarRemixLifecycleAdapter,
        contentBodyValue: contentBodyDynamic?.value,
        getAdfDocument: getAdfDocument,
        isRemixEntryEligible: isRemixEntryEligible,
        isObjectSidebarExpanded: sidebarIsExpanded
    }, primaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle || sidebarIsExpanded ? 'visible' : 'hidden',
            opacity: !shouldDisplayHoverToggle && sidebarIsExpanded ? 0 : undefined
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps_0,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                ...iconProps_0,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
        name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle || sidebarIsExpanded ? 'visible' : 'hidden',
            opacity: !shouldDisplayHoverToggle && sidebarIsExpanded ? 0 : undefined
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_1)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps_1,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                ...iconProps_1,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    }))))), (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions)), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, integratedExpandButton)) : null, (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }))), shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0Of8r22ADO _1DCdHi5zaO _2XsHFMHZdu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3tUdX.RovoConfigProvider), {
        experience: rovoConfiguration?.experience,
        provider: rovoConfiguration?.provider,
        contributorsFragmentRef: contributorsFragmentRef,
        rovoActivationFragmentRef: rovoActivationFragmentRef,
        contentId: contentId,
        contentType: contentType ?? '',
        spaceKey: spaceKey ?? '',
        contentTitle: contentTitle ?? '',
        lastModifiedDate: lastModifiedDate,
        isUnpublishedDraft: isUnpublishedDraft,
        isEditorEmpty: isEditorEmpty,
        readTime: readTime ?? undefined,
        readTimeLoading: readTimeLoading,
        actionsToRender: actionsToRender ?? []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hU34N.AISmartButtonWrapper), {
        contentId: contentId,
        contentType: contentType ?? '',
        pageMode: pageMode,
        isDisabled: isNetworkDisabled,
        spaceKey: spaceKey,
        isSidebarAvailable: isEmbeddedConfluence ? false : undefined
    })) : contentType !== 'database' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3acdd5624bc36ae$export$71951c424ee8d4c2), {
        spaceKey: spaceKey ?? '',
        contentId: contentId,
        contentType: contentType ?? '',
        lastModifiedDate: lastModifiedDate,
        pageCommentsSectionInView: pageCommentsSectionInView,
        isLivePage: isLivePage,
        isInObjectSideBar: true
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }));
});
const $3265ee1fae39f7d6$export$3fab07431350539e = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $9wGTI.fg)("remix_state_rearchitecture_enabled") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCmUm.ObjectSidebarRemixLifecycleOwnerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarControlContent, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarControlContent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    (0, $9wGTI.fg)('remix_state_rearchitecture_enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCmUm.ObjectSidebarRemixLifecycleOwnerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarControlContent, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarControlContent, props));
function $3265ee1fae39f7d6$var$_temp(routeName) {
    if (!routeName) return false;
    return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
}
function $3265ee1fae39f7d6$var$_temp2(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["ObjectSidebarControl"] = $3265ee1fae39f7d6$export$3fab07431350539e;

});

parcelRegister("5YDZX", function(module, exports) {
const $d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE = 'data-block-controls-suppression';
const $d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR = `[${$d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE}]`;
const $d9d643acafd25457$export$7a4820babe675d08 = {
    [$d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE]: 'true'
};
const $d9d643acafd25457$export$8d5d08f345eecbf1 = (target)=>target instanceof Element && target.closest($d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR) !== null;
module.exports["blockControlsSuppressionProps"] = $d9d643acafd25457$export$7a4820babe675d08;
module.exports["isBlockControlsSuppressionTarget"] = $d9d643acafd25457$export$8d5d08f345eecbf1;

});

parcelRegister("93Gae", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $6UvXN = parcelRequire("6UvXN");

const $081573ec09156b80$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    initialPrompt: undefined,
    openWithChatHistory: false,
    targetConversationId: null,
    targetConversationMetadata: null,
    autoFocusInput: true,
    wasAutoOpened: false,
    editorHadFocusBeforeChatOpen: false
};
const $081573ec09156b80$var$store = (0, $8s9DV.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $081573ec09156b80$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($081573ec09156b80$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode,
                    wasAutoOpened: false
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        setOpenWithChatHistory: (openWithChatHistory)=>({ setState: setState })=>{
                setState({
                    openWithChatHistory: openWithChatHistory
                });
            },
        setTargetConversationId: (targetConversationId, metadata)=>({ setState: setState })=>{
                setState({
                    targetConversationId: targetConversationId,
                    targetConversationMetadata: metadata?.id === targetConversationId ? metadata : null
                });
            },
        setWasAutoOpened: (wasAutoOpened)=>({ setState: setState })=>{
                setState({
                    wasAutoOpened: wasAutoOpened
                });
            },
        setEditorHadFocusBeforeChatOpen: (editorHadFocusBeforeChatOpen)=>({ setState: setState })=>{
                setState({
                    editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined,
                        autoFocusInput: true,
                        wasAutoOpened: false
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
              which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined,
                            autoFocusInput: true,
                            wasAutoOpened: false
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt, autoFocusInput: autoFocusInput = true })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR,
                            autoFocusInput: autoFocusInput,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        // wasAutoOpened is managed by the dedicated setWasAutoOpened action and reset on close/toggle/setMode.
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            autoFocusInput: autoFocusInput
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            }
    }
});
const $081573ec09156b80$var$useStore = (0, $kBr4q.createHook)($081573ec09156b80$var$store);
const $081573ec09156b80$export$37440b51449f7ac6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(21);
    const [t0, t1] = $081573ec09156b80$var$useStore();
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, targetConversationMetadata: targetConversationMetadata, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen } = t0;
    const { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable } = t1;
    let t2;
    if ($[0] !== autoFocusInput || $[1] !== clearInitialPrompt || $[2] !== editorHadFocusBeforeChatOpen || $[3] !== initialPrompt || $[4] !== isMiniModalAvailable || $[5] !== isSidebarAvailable || $[6] !== mode || $[7] !== openConversationAssistantUIMode || $[8] !== openWithChatHistory || $[9] !== reset || $[10] !== setEditorHadFocusBeforeChatOpen || $[11] !== setIsMiniModalAvailable || $[12] !== setIsSidebarAvailable || $[13] !== setOpenWithChatHistory || $[14] !== setTargetConversationId || $[15] !== setWasAutoOpened || $[16] !== targetConversationId || $[17] !== targetConversationMetadata || $[18] !== toggleConversationAssistantUIMode || $[19] !== wasAutoOpened) {
        t2 = {
            mode: mode,
            initialPrompt: initialPrompt,
            openWithChatHistory: openWithChatHistory,
            targetConversationId: targetConversationId,
            targetConversationMetadata: targetConversationMetadata,
            autoFocusInput: autoFocusInput,
            wasAutoOpened: wasAutoOpened,
            editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
            reset: reset,
            clearInitialPrompt: clearInitialPrompt,
            setOpenWithChatHistory: setOpenWithChatHistory,
            setTargetConversationId: setTargetConversationId,
            setWasAutoOpened: setWasAutoOpened,
            setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
            toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
            openConversationAssistantUIMode: openConversationAssistantUIMode,
            setIsMiniModalAvailable: setIsMiniModalAvailable,
            setIsSidebarAvailable: setIsSidebarAvailable,
            isMiniModalAvailable: isMiniModalAvailable,
            isSidebarAvailable: isSidebarAvailable
        };
        $[0] = autoFocusInput;
        $[1] = clearInitialPrompt;
        $[2] = editorHadFocusBeforeChatOpen;
        $[3] = initialPrompt;
        $[4] = isMiniModalAvailable;
        $[5] = isSidebarAvailable;
        $[6] = mode;
        $[7] = openConversationAssistantUIMode;
        $[8] = openWithChatHistory;
        $[9] = reset;
        $[10] = setEditorHadFocusBeforeChatOpen;
        $[11] = setIsMiniModalAvailable;
        $[12] = setIsSidebarAvailable;
        $[13] = setOpenWithChatHistory;
        $[14] = setTargetConversationId;
        $[15] = setWasAutoOpened;
        $[16] = targetConversationId;
        $[17] = targetConversationMetadata;
        $[18] = toggleConversationAssistantUIMode;
        $[19] = wasAutoOpened;
        $[20] = t2;
    } else t2 = $[20];
    return t2;
} : ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, targetConversationId: targetConversationId, targetConversationMetadata: targetConversationMetadata, autoFocusInput: autoFocusInput, wasAutoOpened: wasAutoOpened, editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen }, { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setTargetConversationId: setTargetConversationId, setWasAutoOpened: setWasAutoOpened, setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable }] = $081573ec09156b80$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        openWithChatHistory: openWithChatHistory,
        targetConversationId: targetConversationId,
        targetConversationMetadata: targetConversationMetadata,
        autoFocusInput: autoFocusInput,
        wasAutoOpened: wasAutoOpened,
        editorHadFocusBeforeChatOpen: editorHadFocusBeforeChatOpen,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        setOpenWithChatHistory: setOpenWithChatHistory,
        setTargetConversationId: setTargetConversationId,
        setWasAutoOpened: setWasAutoOpened,
        setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable
    };
};
const $081573ec09156b80$export$66cf76b7e04da11f = (0, $kBr4q.createActionsHook)($081573ec09156b80$var$store);
module.exports["useRovoExperienceAPIStore"] = $081573ec09156b80$export$37440b51449f7ac6;

});

parcelRegister("6UvXN", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ // oxlint-disable-next-line eslint/no-redeclare
const $7c0481f515a47ac9$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $7c0481f515a47ac9$export$bc36ebf73899a71d;

});

parcelRegister("dPoYT", function(module, exports) {
const $8dbc220cf14fe789$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal'
};
module.exports["ConversationAssistantUIModes"] = $8dbc220cf14fe789$export$bc36ebf73899a71d;

});

parcelRegister("JTIzG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const { isAIPolicyEnabled: isAIPolicyEnabled, isAudioV3EnabledForPolicy: isAudioV3EnabledForPolicy, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $cozmU.useMemo)(()=>{
        const aiPolicyEnabled = !isAtlassianHostedLLMOnlyEnabled && isAdminHubAIEnabled && isAIEarlyAccessEnabled;
        const audioV3EnabledForPolicy = aiPolicyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3');
        return {
            isAIPolicyEnabled: aiPolicyEnabled,
            isAudioV3EnabledForPolicy: audioV3EnabledForPolicy,
            // Keep byline visibility stable through SSR and hydration. ListenByline checks browser
            // support after hydration and disables its trigger when audio playback is unsupported.
            isAudioBylineEntrypointEnabled: audioV3EnabledForPolicy
        };
    }, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAudioV3Enabled = isAudioV3EnabledForPolicy && audioSupportedByBrowser;
    const audioBriefingNudgeExperimentState = (0, $cozmU.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyEnabled && audioSupportedByBrowser,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("NomII", function(module, exports) {
/* CustomPopupContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dinVW = parcelRequire("dinVW");


var $bmowW = parcelRequire("bmowW");

const $7ecedb5cea5467d4$var$PopupWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvD8fU6 _2OUyjtGk8v _42Yu6B7dHp _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ])
    });
});
const $7ecedb5cea5467d4$export$2db9b01e44994880 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...props }, ref)=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7ecedb5cea5467d4$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog",
        "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, children));
});
module.exports["CustomPopupContainer"] = $7ecedb5cea5467d4$export$2db9b01e44994880;

});

parcelRegister("bmowW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");

const $c2de17ff654b3217$var$i18nBase = (0, $kSwu1.defineMessages)({
    quickSummaryLabel: {
        id: "quick-summary.label.text",
        defaultMessage: "Quick summary"
    },
    quickSummaryToolTipText: {
        id: "quick-summary.tooltip.text",
        defaultMessage: "Summarize"
    },
    quickSummaryFeatureSpotlightText: {
        id: "quick-summary.feature-spotlight-one.text",
        defaultMessage: "This might be a longer read. Save time and read a quick summary from Atlassian Intelligence."
    },
    quickSummarySpotlightSummarizeText: {
        id: "quick-summary.spotlight.summarize.button.text",
        defaultMessage: "Summarize"
    },
    quickSummarySpotlightCloseButtonText: {
        id: "quick-summary.spotlight.close.button.text",
        defaultMessage: "Dismiss"
    },
    quickSummaryOptInDialogHeaderText: {
        id: "quick-summary.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page, live doc, or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page or live doc with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($c2de17ff654b3217$var$i18nBase, $c2de17ff654b3217$var$i18nLiveDocs);
module.exports["i18n"] = $c2de17ff654b3217$export$a7357cdd1f0b0168;

});

parcelRegister("7mpOv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");

const $7ae32555811cd45f$export$cc5edac91cdebf9b = (_props = {})=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: isRovoLLMEnabled
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("i1vUz", function(module, exports) {

var $4qmCZ = parcelRequire("4qmCZ");


var $8SLNj = parcelRequire("8SLNj");


var $8G3G6 = parcelRequire("8G3G6");


var $5L7V6 = parcelRequire("5L7V6");


var $8uM2K = parcelRequire("8uM2K");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $h2uld = parcelRequire("h2uld");

const $649e6d4fa880ffb0$export$308bf82a9a0ad7d = (0, $5L7V6.default);
const $649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery = (0, $8G3G6.default);
const $649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery = (0, $8SLNj.default);
const $649e6d4fa880ffb0$export$ca7c63318c849d7a = (contentId, contentType, isRefreshRovoButton = false)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const { data: data, loading: catchupLastViewedLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery, {
        variables: {
            contentId: contentId,
            contentType: contentType
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT,
        __callerPackage__: "ai-floating-context-menu"
    });
    const { data: lastModifiedDateData, loading: lastModifiedLoading } = (0, $jMyy4.useQueryInterop)((0, $4qmCZ.default), {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT,
        __callerPackage__: "ai-floating-context-menu"
    });
    const { data: contentHistoryData, loading: contentHistoryLoading } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery, {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT || !isRovoButtonEnabled,
        fetchPolicy: 'network-only',
        __callerPackage__: "ai-floating-context-menu"
    });
    const lastModifiedDate = lastModifiedDateData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ?? '';
    const lastViewedTime = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    // Guard against cases where lastViewedTime would otherwise cause a NaN parse result
    const cleanedLastViewedTime = lastViewedTime.replace(/\[.*?\]$/, '');
    const parsedLastViewedTime = Date.parse(cleanedLastViewedTime);
    const parsedLastModifiedDate = Date.parse(lastModifiedDate);
    const lastEditedCollaborators = contentHistoryData?.contentHistory?.nodes?.[0]?.collaborators?.userAccountIds ?? [];
    const isCurrentUserARecentCollaborator = lastEditedCollaborators.some((collaborator)=>collaborator === userId);
    const isFirstTimeVisit = Number.isNaN(parsedLastViewedTime);
    const lastViewedDate = isFirstTimeVisit ? undefined : new Date(parsedLastViewedTime);
    const queryLoading = catchupLastViewedLoading || lastModifiedLoading || contentHistoryLoading || readTimeLoading;
    let showCatchupAsDefault = false;
    let showSummarizeAsDefault = true;
    if (!parsedLastViewedTime && !isFirstTimeVisit || !parsedLastModifiedDate || queryError) return {
        showCatchupAsDefault: showCatchupAsDefault,
        queryLoading: queryLoading,
        queryError: queryError
    };
    if (isRovoButtonEnabled && pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && isFirstTimeVisit && readTime && readTime >= 5 && !isCurrentUserARecentCollaborator) {
        if (isRefreshRovoButton) return {
            showCatchupAsDefault: showCatchupAsDefault,
            showSummarizeAsDefault: showSummarizeAsDefault,
            queryLoading: queryLoading
        };
    }
    showCatchupAsDefault = pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && parsedLastModifiedDate > parsedLastViewedTime && !isCurrentUserARecentCollaborator;
    showSummarizeAsDefault = false;
    return {
        showCatchupAsDefault: showCatchupAsDefault,
        showSummarizeAsDefault: showSummarizeAsDefault,
        queryLoading: queryLoading,
        lastViewedDate: lastViewedDate
    };
};
module.exports["useDynamicSplitButton"] = $649e6d4fa880ffb0$export$ca7c63318c849d7a;

});

parcelRegister("4qmCZ", function(module, exports) {
/**
 * @generated SignedSource<<b18880c95a88e91ee675a5ab3e7a2f6a>>
 * @relayHash 53828d84c0acb319d0f0762fbd51cfb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37
const $3f3bb2f2b7df90db$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "53828d84c0acb319d0f0762fbd51cfb9",
            "id": "3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37",
            "metadata": {},
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonLastModifiedDateQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{lastModifiedDate}}}}"
        }
    };
}();
$3f3bb2f2b7df90db$var$node.hash = "cb78a829ad38a06c36dc9615c22411b7";
var $3f3bb2f2b7df90db$export$2e2bcd8739ae039 = $3f3bb2f2b7df90db$var$node;
module.exports["default"] = $3f3bb2f2b7df90db$export$2e2bcd8739ae039;

});

parcelRegister("8SLNj", function(module, exports) {
/**
 * @generated SignedSource<<6135257c8df94a440f547d327ee53e8c>>
 * @relayHash c82cedffd514ace9062cc5a7ea29b433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190
const $a7452eae54a23656$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "PaginatedContentHistoryList",
            "kind": "LinkedField",
            "name": "contentHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentHistory",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ContributorUsers",
                            "kind": "LinkedField",
                            "name": "collaborators",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "userAccountIds"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c82cedffd514ace9062cc5a7ea29b433",
            "id": "7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190",
            "metadata": {},
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonContentHistoryQuery($contentId:ID!){contentHistory(contentId:$contentId,first:1){nodes{collaborators{userAccountIds}}}}"
        }
    };
}();
$a7452eae54a23656$var$node.hash = "428e55c833e4f9ecc04af6435214d702";
var $a7452eae54a23656$export$2e2bcd8739ae039 = $a7452eae54a23656$var$node;
module.exports["default"] = $a7452eae54a23656$export$2e2bcd8739ae039;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<e1177a1d3670ae73598e531cc663b738>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "ca230a2a5e683b85178d392f9c872c98";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("5L7V6", function(module, exports) {
/**
 * @generated SignedSource<<369f3309f8f6ec03427d92d39f832dab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $923ef1fe064db781$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useDynamicSplitButton_catchupLastViewedTime",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "lastViewedTimeISO"
        }
    ],
    "type": "CatchupLastViewedTimeResponse"
};
$923ef1fe064db781$var$node.hash = "297588dba1b1d203b8ad0275eaa0e0a8";
var $923ef1fe064db781$export$2e2bcd8739ae039 = $923ef1fe064db781$var$node;
module.exports["default"] = $923ef1fe064db781$export$2e2bcd8739ae039;

});

parcelRegister("8uM2K", function(module, exports) {

var $3ricL = parcelRequire("3ricL");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("h2uld", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $j25oo = parcelRequire("j25oo");


var $gS4ry = parcelRequire("gS4ry");


var $6SsN4 = parcelRequire("6SsN4");


var $cUB5n = parcelRequire("cUB5n");


var $2TTFH = parcelRequire("2TTFH");


var $jtuBN = parcelRequire("jtuBN");


var $6mKj3 = parcelRequire("6mKj3");


var $72md5 = parcelRequire("72md5");


var $h3vPv = parcelRequire("h3vPv");

const $8b6571c5cd7e604c$export$121a42a106fd51fa = (0, $gS4ry.default);
const $8b6571c5cd7e604c$export$9a0a69714186a2dc = (0, $j25oo.default);
const $8b6571c5cd7e604c$var$getAdfStringFromContent = (content)=>{
    const dynamic = content?.body?.dynamic;
    if (dynamic?.representation === 'atlas_doc_format' && dynamic?.value) return dynamic.value;
    return null;
};
const $8b6571c5cd7e604c$var$EMPTY_RESULT = {
    adf: undefined,
    readTime: null,
    wordCount: null,
    features: null,
    featuresSkipExpand: null,
    isReadTimeCapped: false
};
const $8b6571c5cd7e604c$var$deriveReadTimeResult = (contentId, adfString)=>{
    let parsed;
    try {
        if ((0, $6mKj3.expValEquals)('cc-proj-xl-use-shared-adf-parsing', 'isEnabled', true)) {
            const result = (0, $cUB5n.getOrParseContentBodyAdf)(contentId, adfString);
            parsed = result.ok ? result.doc : null;
        } else parsed = JSON.parse(adfString);
    } catch  {
        parsed = null;
    }
    if (!parsed) return $8b6571c5cd7e604c$var$EMPTY_RESULT;
    const { features: allFeatures, featuresSkipExpand: allFeaturesSkipExpand, nodeCount: nodeCount } = (0, $h3vPv.extractAllContentFeatures)(parsed, adfString.length);
    const { readTime: computedReadTime, isReadTimeCapped: computedCapped } = (0, $72md5.readTimeFromFeatures)(allFeaturesSkipExpand, nodeCount);
    if (computedCapped) return {
        adf: parsed,
        readTime: computedReadTime,
        wordCount: null,
        features: null,
        featuresSkipExpand: null,
        isReadTimeCapped: true
    };
    return {
        adf: parsed,
        readTime: computedReadTime,
        wordCount: allFeaturesSkipExpand.wordCount,
        features: allFeatures,
        featuresSkipExpand: allFeaturesSkipExpand,
        isReadTimeCapped: false
    };
};
const $8b6571c5cd7e604c$var$readTimeDerivationMemo = (0, $2TTFH.createAdfDerivationMemo)();
const $8b6571c5cd7e604c$var$getReadTimeResult = ({ content: content, contentId: contentId, loading: loading, error: error })=>{
    const adfString = $8b6571c5cd7e604c$var$getAdfStringFromContent(content);
    if (!adfString || loading || error || !contentId) return $8b6571c5cd7e604c$var$EMPTY_RESULT;
    if ((0, $6mKj3.expValEquals)('cc-proj-xl-dedup-readtime-derivation', 'isEnabled', true)) return $8b6571c5cd7e604c$var$readTimeDerivationMemo.derive(contentId, adfString, ()=>$8b6571c5cd7e604c$var$deriveReadTimeResult(contentId, adfString));
    return $8b6571c5cd7e604c$var$deriveReadTimeResult(contentId, adfString);
};
const $8b6571c5cd7e604c$export$bf3941b9bff5380a = (contentId, skipQuery)=>{
    const $ = (0, $bDgLe.c)(20);
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== skipQuery || $[3] !== t0) {
        t1 = {
            variables: t0,
            skip: skipQuery
        };
        $[2] = skipQuery;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const readTimeQueryOptions = t1;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($8b6571c5cd7e604c$export$9a0a69714186a2dc, {
        ...readTimeQueryOptions,
        __callerPackage__: "read-time"
    });
    const contentNode = data?.content?.nodes?.[0];
    let t2;
    if ($[5] !== contentId || $[6] !== contentNode || $[7] !== error || $[8] !== loading) {
        t2 = $8b6571c5cd7e604c$var$getReadTimeResult({
            content: contentNode,
            contentId: contentId,
            loading: loading,
            error: error
        });
        $[5] = contentId;
        $[6] = contentNode;
        $[7] = error;
        $[8] = loading;
        $[9] = t2;
    } else t2 = $[9];
    const { adf: adf, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand, isReadTimeCapped: isReadTimeCapped } = t2;
    const contentType = contentNode?.type;
    let t3;
    if ($[10] !== adf || $[11] !== contentType || $[12] !== error || $[13] !== features || $[14] !== featuresSkipExpand || $[15] !== isReadTimeCapped || $[16] !== loading || $[17] !== readTime || $[18] !== wordCount) {
        t3 = {
            loading: loading,
            error: error,
            adf: adf,
            contentType: contentType,
            readTime: readTime,
            wordCount: wordCount,
            features: features,
            featuresSkipExpand: featuresSkipExpand,
            isReadTimeCapped: isReadTimeCapped
        };
        $[10] = adf;
        $[11] = contentType;
        $[12] = error;
        $[13] = features;
        $[14] = featuresSkipExpand;
        $[15] = isReadTimeCapped;
        $[16] = loading;
        $[17] = readTime;
        $[18] = wordCount;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
};
const $8b6571c5cd7e604c$export$55ef3f673ed91721 = (contentId, contentFragmentRef)=>{
    const $ = (0, $bDgLe.c)(11);
    const content = (0, $6SsN4.useFragment)($8b6571c5cd7e604c$export$121a42a106fd51fa, contentFragmentRef);
    let t0;
    if ($[0] !== content || $[1] !== contentId) {
        t0 = $8b6571c5cd7e604c$var$getReadTimeResult({
            content: content,
            contentId: contentId,
            loading: false,
            error: undefined
        });
        $[0] = content;
        $[1] = contentId;
        $[2] = t0;
    } else t0 = $[2];
    const { adf: adf, readTime: readTime, wordCount: wordCount, features: features, featuresSkipExpand: featuresSkipExpand, isReadTimeCapped: isReadTimeCapped } = t0;
    const t1 = content?.type;
    let t2;
    if ($[3] !== adf || $[4] !== features || $[5] !== featuresSkipExpand || $[6] !== isReadTimeCapped || $[7] !== readTime || $[8] !== t1 || $[9] !== wordCount) {
        t2 = {
            loading: false,
            error: undefined,
            adf: adf,
            contentType: t1,
            readTime: readTime,
            wordCount: wordCount,
            features: features,
            featuresSkipExpand: featuresSkipExpand,
            isReadTimeCapped: isReadTimeCapped
        };
        $[3] = adf;
        $[4] = features;
        $[5] = featuresSkipExpand;
        $[6] = isReadTimeCapped;
        $[7] = readTime;
        $[8] = t1;
        $[9] = wordCount;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
};
module.exports["ReadTimeQuery"] = $8b6571c5cd7e604c$export$9a0a69714186a2dc;
module.exports["useReadTime"] = $8b6571c5cd7e604c$export$bf3941b9bff5380a;
module.exports["useReadTimeFromFragment"] = $8b6571c5cd7e604c$export$55ef3f673ed91721;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<b0ed3f943392beb78acd9d9ea9b42788>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("gS4ry", function(module, exports) {
/**
 * @generated SignedSource<<6d2e35212274a5a5e4ffaebef5eea5ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dbcbc011f25bc85c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useReadTime_content",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "ContentBodyPerRepresentation",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentBody",
                    "kind": "LinkedField",
                    "name": "dynamic",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "representation"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "operation"
                },
                {
                    "kind": "ScalarField",
                    "name": "targetType"
                }
            ]
        }
    ],
    "type": "Content"
};
$dbcbc011f25bc85c$var$node.hash = "178ac19b0f75ed9e14e9b3895368a8aa";
var $dbcbc011f25bc85c$export$2e2bcd8739ae039 = $dbcbc011f25bc85c$var$node;
module.exports["default"] = $dbcbc011f25bc85c$export$2e2bcd8739ae039;

});

parcelRegister("cUB5n", function(module, exports) {

var $2TTFH = parcelRequire("2TTFH");

const $e002af656dcf6977$var$parsedAdfByContent = (0, $2TTFH.createAdfDerivationMemo)(2);
const $e002af656dcf6977$var$parse = (adfString)=>{
    try {
        return {
            ok: true,
            doc: JSON.parse(adfString)
        };
    } catch (error) {
        return {
            ok: false,
            error: error instanceof Error ? error : new Error('Failed to parse ADF')
        };
    }
};
const $e002af656dcf6977$export$a56d8cc81690f0df = (contentId, adfString)=>{
    return $e002af656dcf6977$var$parsedAdfByContent.derive(contentId, adfString, ()=>$e002af656dcf6977$var$parse(adfString));
};
const $e002af656dcf6977$export$12c00d9f2aef8d16 = (contentId, adfString, doc)=>{
    $e002af656dcf6977$var$parsedAdfByContent.set(contentId, adfString, {
        ok: true,
        doc: doc
    });
};
module.exports["getOrParseContentBodyAdf"] = $e002af656dcf6977$export$a56d8cc81690f0df;
module.exports["seedContentBodyAdfCache"] = $e002af656dcf6977$export$12c00d9f2aef8d16;

});

parcelRegister("2TTFH", function(module, exports) {
// A generic cross-instance memo for an expensive derivation of a page's ADF,
// shared so N consumers of the same document parse + walk it once, not N times.
// Keyed by a small id (e.g. contentId) with a reference-compared `token` (e.g.
// the ADF string) — the multi-MB body is never hashed or used as a Map key, and
// a new document version is a natural miss.
const $e20b61f673ca0f0b$var$DEFAULT_MAX_ENTRIES = 4;
const $e20b61f673ca0f0b$export$b7c51a1bf63861b2 = (maxEntries = $e20b61f673ca0f0b$var$DEFAULT_MAX_ENTRIES)=>{
    const store = new Map();
    const set = (key, token, value)=>{
        if (store.has(key)) store.delete(key);
        else if (store.size >= maxEntries) {
            const oldest = store.keys().next().value;
            if (oldest !== undefined) store.delete(oldest);
        }
        store.set(key, {
            token: token,
            value: value
        });
    };
    return {
        derive: (key, token, compute)=>{
            const existing = store.get(key);
            if (existing && Object.is(existing.token, token)) {
                // Re-insert to mark most-recently-used (Map preserves insertion order).
                store.delete(key);
                store.set(key, existing);
                return existing.value;
            }
            const value = compute();
            set(key, token, value);
            return value;
        },
        clear: ()=>{
            store.clear();
        },
        set: set
    };
};
module.exports["createAdfDerivationMemo"] = $e20b61f673ca0f0b$export$b7c51a1bf63861b2;

});

parcelRegister("72md5", function(module, exports) {

var $cUB5n = parcelRequire("cUB5n");


var $6mKj3 = parcelRequire("6mKj3");


var $h3vPv = parcelRequire("h3vPv");

const $7a7682e083b4bc67$var$wpm = 265; // words per minute, inspired by Medium.com
const $7a7682e083b4bc67$var$minute = 60;
const $7a7682e083b4bc67$export$f9eb840a4201b60 = 60;
const $7a7682e083b4bc67$export$dbd433271872c208 = (imageCount)=>{
    let readTime = 0;
    for(let i = 0; i < imageCount; i++)readTime += Math.max(12 - i, 3);
    return readTime;
};
const $7a7682e083b4bc67$export$28bc0da800afa077 = (features)=>{
    const readTime = (features.wordCount / $7a7682e083b4bc67$var$wpm * 60 + $7a7682e083b4bc67$export$dbd433271872c208(features.imageCount)) / $7a7682e083b4bc67$var$minute;
    if (readTime > 0.5) return Math.round(readTime);
    else return 0;
};
const $7a7682e083b4bc67$export$b9c2b26e8995bdbe = (features, nodeCount)=>{
    if (nodeCount > (0, $h3vPv.READ_TIME_MAX_NODES)) return {
        readTime: $7a7682e083b4bc67$export$f9eb840a4201b60,
        isReadTimeCapped: true
    };
    else return {
        readTime: $7a7682e083b4bc67$export$28bc0da800afa077(features),
        isReadTimeCapped: false
    };
};
const $7a7682e083b4bc67$export$25cb9585b72d578c = (response)=>{
    const dynamic = response?.content?.nodes?.[0]?.body?.dynamic;
    if (dynamic?.representation === 'atlas_doc_format' && dynamic?.value) return dynamic.value;
    else return null;
};
const $7a7682e083b4bc67$export$da369a1128d64cc6 = (response, contentId)=>{
    const representation = response?.content?.nodes?.[0]?.body?.dynamic?.representation;
    if (representation === 'atlas_doc_format') {
        const adfString = response?.content?.nodes?.[0]?.body?.dynamic?.value;
        if (adfString) try {
            if (contentId && (0, $6mKj3.expValEquals)('cc-proj-xl-use-shared-adf-parsing', 'isEnabled', true)) {
                const result = (0, $cUB5n.getOrParseContentBodyAdf)(contentId, adfString);
                return result.ok ? result.doc : null;
            }
            return JSON.parse(adfString);
        } catch  {
            return null;
        }
    }
    return null;
};
const $7a7682e083b4bc67$export$a093aebe05ca9c48 = ({ contentType: contentType, contentId: contentId, features: features, isInEditor: isInEditor })=>({
        type: 'sendOperationalEvent',
        data: {
            source: 'confluence-frontend',
            action: 'extracted',
            actionSubject: 'contentFeature',
            objectType: contentType,
            objectId: contentId,
            attributes: {
                ...features,
                isInEditor: isInEditor
            }
        }
    });
const $7a7682e083b4bc67$export$d7ca718a8dbe1f35 = ({ contentType: contentType, contentId: contentId, adf: adf, isInEditor: isInEditor })=>$7a7682e083b4bc67$export$a093aebe05ca9c48({
        contentType: contentType,
        contentId: contentId,
        features: (0, $h3vPv.extractContentFeatures)(adf),
        isInEditor: isInEditor
    });
const $7a7682e083b4bc67$export$2ac19802f4188b34 = (bodyDynamic)=>{
    if (!bodyDynamic || bodyDynamic.representation !== 'atlas_doc_format') return false;
    const adfString = bodyDynamic.value;
    if (!adfString) return false;
    let adf;
    try {
        adf = JSON.parse(adfString);
    } catch  {
        return false;
    }
    const { wordCount: wordCount, imageCount: imageCount } = (0, $h3vPv.extractContentFeaturesSkipExpand)(adf);
    return wordCount > 0 || imageCount > 0;
};
module.exports["calculateImageReadTime"] = $7a7682e083b4bc67$export$dbd433271872c208;
module.exports["readTimeFromFeatures"] = $7a7682e083b4bc67$export$b9c2b26e8995bdbe;
module.exports["getAdfString"] = $7a7682e083b4bc67$export$25cb9585b72d578c;
module.exports["getAdf"] = $7a7682e083b4bc67$export$da369a1128d64cc6;
module.exports["getContentFeatureExtractedEventObjectFromFeatures"] = $7a7682e083b4bc67$export$a093aebe05ca9c48;
module.exports["getContentFeatureExtractedEventObject"] = $7a7682e083b4bc67$export$d7ca718a8dbe1f35;

});

parcelRegister("h3vPv", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

// helper function to traverse ADF tree while skipping expand nodes
const $a8469c4e0ee76bb2$var$reduceSkipExpand = (node, reducer, initialValue)=>{
    // skip if this is an expand node
    if (node.type === 'expand' || node.type === 'nestedExpand') return initialValue;
    // process current node
    let result = reducer(initialValue, node);
    // process child nodes if they exist
    if (node.content) result = node.content.reduce((acc, child)=>$a8469c4e0ee76bb2$var$reduceSkipExpand(child, reducer, acc), result);
    return result;
};
const $a8469c4e0ee76bb2$var$wordCount = (text)=>{
    if (text) {
        const matches = text.match(/\S+/g);
        if (matches) return matches.length;
    }
    return 0;
};
const $a8469c4e0ee76bb2$var$processADFNode = (currentValue, node)=>{
    switch(node.type){
        case 'text':
            return {
                ...currentValue,
                textLength: currentValue.textLength + (node.text ? node.text.length : 0),
                wordCount: currentValue.wordCount + $a8469c4e0ee76bb2$var$wordCount(node.text)
            };
        case 'media':
            return {
                ...currentValue,
                imageCount: currentValue.imageCount + 1,
                mediaFiles: node.attrs?.type === 'file' && node.attrs?.id ? currentValue.mediaFiles.concat(node.attrs.id) : currentValue.mediaFiles
            };
        case 'inlineExtension':
            // Legacy quirk (inlineMacroCount derived from macroCount) preserved so this
            // extractor's output stays byte-identical to before. The single pass
            // corrects this — see applyADFNode.
            return {
                ...currentValue,
                inlineMacroCount: currentValue.macroCount + 1
            };
        case 'extension':
            return {
                ...currentValue,
                macroCount: currentValue.macroCount + 1
            };
        case 'table':
            return {
                ...currentValue,
                tableCount: currentValue.tableCount + 1
            };
        case 'embedCard':
            const url = node.attrs?.url;
            if (!url.includes('loom')) return currentValue;
            const videoId = url?.split('/').pop().split('?')[0];
            return {
                ...currentValue,
                looms: videoId ? currentValue.looms.concat({
                    id: videoId,
                    url: url
                }) : currentValue.looms
            };
    }
    return currentValue;
};
const $a8469c4e0ee76bb2$export$a148305df2eb5487 = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return (0, $4EPzQ.reduce)(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
const $a8469c4e0ee76bb2$export$8e18062037dcc9dd = (adf)=>{
    const initialFeatures = {
        rawLength: JSON.stringify(adf).length,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    };
    return $a8469c4e0ee76bb2$var$reduceSkipExpand(adf, (currentValue, node)=>$a8469c4e0ee76bb2$var$processADFNode(currentValue, node), initialFeatures);
};
const $a8469c4e0ee76bb2$var$makeInitialFeatures = (rawLength)=>({
        rawLength: rawLength,
        textLength: 0,
        wordCount: 0,
        imageCount: 0,
        inlineMacroCount: 0,
        macroCount: 0,
        tableCount: 0,
        mediaFiles: [],
        looms: []
    });
// Mutating equivalent of processADFNode, used by the single-pass path. Matches
// the legacy processADFNode EXCEPT it corrects inlineMacroCount to count
// inlineExtension nodes; processADFNode keeps the historic `macroCount + 1`
// quirk so its output is unchanged.
const $a8469c4e0ee76bb2$var$applyADFNode = (acc, node)=>{
    switch(node.type){
        case 'text':
            acc.textLength += node.text ? node.text.length : 0;
            acc.wordCount += $a8469c4e0ee76bb2$var$wordCount(node.text);
            return;
        case 'media':
            acc.imageCount += 1;
            if (node.attrs?.type === 'file' && node.attrs?.id) acc.mediaFiles.push(node.attrs.id);
            return;
        case 'inlineExtension':
            acc.inlineMacroCount += 1;
            return;
        case 'extension':
            acc.macroCount += 1;
            return;
        case 'table':
            acc.tableCount += 1;
            return;
        case 'embedCard':
            {
                const url = node.attrs?.url;
                if (!url || !url.includes('loom')) return;
                const videoId = url.split('/').pop()?.split('?')[0];
                if (videoId) acc.looms.push({
                    id: videoId,
                    url: url
                });
                return;
            }
    }
};
const $a8469c4e0ee76bb2$export$cbd7f03eb4dd69c7 = 50000;
const $a8469c4e0ee76bb2$export$393093723bf85dd6 = (adf, rawLength, maxNodes = $a8469c4e0ee76bb2$export$cbd7f03eb4dd69c7)=>{
    const features = $a8469c4e0ee76bb2$var$makeInitialFeatures(rawLength ?? 0);
    const featuresSkipExpand = $a8469c4e0ee76bb2$var$makeInitialFeatures(rawLength ?? 0);
    let nodeCount = 0;
    const visit = (node, countSkip)=>{
        nodeCount += 1;
        if (nodeCount > maxNodes) return;
        $a8469c4e0ee76bb2$var$applyADFNode(features, node);
        const isExpand = node.type === 'expand' || node.type === 'nestedExpand';
        const skipHere = countSkip && !isExpand;
        if (skipHere) $a8469c4e0ee76bb2$var$applyADFNode(featuresSkipExpand, node);
        const children = node.content;
        if (children) for (const child of children){
            if (nodeCount > maxNodes) break;
            // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- single pre-order DFS; each ADF node is visited exactly once (O(total nodes)), not quadratic
            visit(child, skipHere);
        }
    };
    visit(adf, true);
    return {
        features: features,
        featuresSkipExpand: featuresSkipExpand,
        nodeCount: nodeCount
    };
};
module.exports["extractContentFeatures"] = $a8469c4e0ee76bb2$export$a148305df2eb5487;
module.exports["extractContentFeaturesSkipExpand"] = $a8469c4e0ee76bb2$export$8e18062037dcc9dd;
module.exports["READ_TIME_MAX_NODES"] = $a8469c4e0ee76bb2$export$cbd7f03eb4dd69c7;
module.exports["extractAllContentFeatures"] = $a8469c4e0ee76bb2$export$393093723bf85dd6;

});

parcelRegister("d282Z", function(module, exports) {
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen',
    AUDIO_V3_CHANGEBOARDING: 'onboarding-insights:hasAudioV3ChangeboardingBeenSeen',
    FLOATING_TABLE_OF_CONTENTS: 'onboarding-insights:hasFloatingTableOfContentsBeenInteractedWith'
};
const $a18eeb1d05dccc62$export$fac0a92023e58acd = Object.values($a18eeb1d05dccc62$export$fc9b2402bb5adac2);
module.exports["ONBOARDING_INSIGHTS"] = $a18eeb1d05dccc62$export$fc9b2402bb5adac2;
module.exports["InsightsOnboardingKeys"] = $a18eeb1d05dccc62$export$fac0a92023e58acd;

});

parcelRegister("cAdj8", function(module, exports) {

var $69Jl3 = parcelRequire("69Jl3");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");


var $jMyy4 = parcelRequire("jMyy4");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $69Jl3.default);
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "page-info"
    });
    return (0, $cozmU.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("69Jl3", function(module, exports) {
/**
 * @generated SignedSource<<a52aa17c9371e87ad68639adf48d413b>>
 * @relayHash ece963db192ceabc724d67f753bee503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4
const $c7d0a8215908754e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "archived",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ece963db192ceabc724d67f753bee503",
            "id": "2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4",
            "metadata": {},
            "name": "usePageInfoPageInfoQuery",
            "operationKind": "query",
            "text": "query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId,status:[\"current\",\"archived\",\"draft\"]){nodes{id,type,status,space{id,operations{operation,targetType}},operations{operation,targetType},version{number}}}}"
        }
    };
}();
$c7d0a8215908754e$var$node.hash = "a5580c0bc26236652ac23ad7c3f4bf51";
var $c7d0a8215908754e$export$2e2bcd8739ae039 = $c7d0a8215908754e$var$node;
module.exports["default"] = $c7d0a8215908754e$export$2e2bcd8739ae039;

});

parcelRegister("cGlMo", function(module, exports) {

let $93ba4d3888fcc884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $93ba4d3888fcc884$var$load("5lfr5").then(()=>parcelRequire('ebALC'));

});

parcelRegister("9VC5k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $7akNQ = parcelRequire("7akNQ");


var $I7hWB = parcelRequire("I7hWB");


var $9DHhW = parcelRequire("9DHhW");


var $b8pma = parcelRequire("b8pma");


var $cFVPs = parcelRequire("cFVPs");

















var $a9aSv = parcelRequire("a9aSv");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


const $96aaefbcbab4ea71$export$b58d43d92d088553 = ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4473 7.99998C11.4473 7.63179 11.7457 7.33331 12.1139 7.33331H13.3339C13.7021 7.33331 14.0006 7.63179 14.0006 7.99998C14.0006 8.36817 13.7021 8.66665 13.3339 8.66665H12.1139C11.7457 8.66665 11.4473 8.36817 11.4473 7.99998Z",
        fill: "url(#paint0_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00065 2C8.36884 2 8.66732 2.29848 8.66732 2.66667V3.88667C8.66732 4.25486 8.36884 4.55333 8.00065 4.55333C7.63246 4.55333 7.33398 4.25486 7.33398 3.88667V2.66667C7.33398 2.29848 7.63246 2 8.00065 2Z",
        fill: "url(#paint1_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 7.99998C2 7.63179 2.29848 7.33331 2.66667 7.33331H3.88667C4.25486 7.33331 4.55333 7.63179 4.55333 7.99998C4.55333 8.36817 4.25486 8.66665 3.88667 8.66665H2.66667C2.29848 8.66665 2 8.36817 2 7.99998Z",
        fill: "url(#paint2_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00065 11.4467C8.36884 11.4467 8.66732 11.7451 8.66732 12.1133V13.3333C8.66732 13.7015 8.36884 14 8.00065 14C7.63246 14 7.33398 13.7015 7.33398 13.3333V12.1133C7.33398 11.7451 7.63246 11.4467 8.00065 11.4467Z",
        fill: "url(#paint3_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.52925 9.52858C9.7896 9.26823 10.2117 9.26823 10.4721 9.52858L13.1387 12.1952C13.3991 12.4556 13.3991 12.8777 13.1387 13.1381C12.8784 13.3984 12.4563 13.3984 12.1959 13.1381L9.52925 10.4714C9.2689 10.211 9.2689 9.78892 9.52925 9.52858Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.1387 2.86195C13.3991 3.1223 13.3991 3.54441 13.1387 3.80476L10.4721 6.47142C10.2117 6.73177 9.7896 6.73177 9.52925 6.47142C9.2689 6.21108 9.2689 5.78897 9.52925 5.52862L12.1959 2.86195C12.4563 2.6016 12.8784 2.6016 13.1387 2.86195Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.86128 2.86195C3.12163 2.6016 3.54374 2.6016 3.80409 2.86195L6.47075 5.52862C6.7311 5.78897 6.7311 6.21108 6.47075 6.47142C6.2104 6.73177 5.78829 6.73177 5.52794 6.47142L2.86128 3.80476C2.60093 3.54441 2.60093 3.1223 2.86128 2.86195Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.47075 9.52858C6.7311 9.78892 6.7311 10.211 6.47075 10.4714L3.80409 13.1381C3.54374 13.3984 3.12163 13.3984 2.86128 13.1381C2.60093 12.8777 2.60093 12.4556 2.86128 12.1952L5.52794 9.52858C5.78829 9.26823 6.2104 9.26823 6.47075 9.52858Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_2378_7139",
        x1: "14.0006",
        y1: "7.99998",
        x2: "11.6672",
        y2: "7.99998",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.270833",
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#0052CC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint1_linear_2378_7139",
        x1: "8.33398",
        y1: "2",
        x2: "8.33398",
        y2: "4.33333",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.1875",
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#0052CC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint2_linear_2378_7139",
        x1: "4.5533",
        y1: "7.99998",
        x2: "2.21997",
        y2: "7.99998",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.791667",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint3_linear_2378_7139",
        x1: "8.33398",
        y1: "11.3333",
        x2: "8.33398",
        y2: "14",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.802083",
        stopColor: "#2684FF"
    }))));


const $333270f2f5cd2de3$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummary: {
        id: "ai-skeleton-loading.title",
        defaultMessage: "Atlassian Intelligence is generating a summary..."
    },
    logoAltText: {
        id: "ai-skeleton-loading.logo-alt",
        defaultMessage: "Atlassian Intelligence Logo"
    }
});
const $333270f2f5cd2de3$var$loadingTextContainer = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    marginBottom: 'space.200',
    font: 'font.body.small',
    color: 'color.text.subtle'
});
const $333270f2f5cd2de3$export$e93f99a4d30f6d75 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $333270f2f5cd2de3$var$loadingTextContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96aaefbcbab4ea71$export$b58d43d92d088553), {
        alt: intl.formatMessage($333270f2f5cd2de3$var$i18n.logoAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, intl.formatMessage($333270f2f5cd2de3$var$i18n.generatingSummary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    })));
};



var $lpJCW = parcelRequire("lpJCW");

















var $7m1U4 = parcelRequire("7m1U4");

const $82345f9002994123$var$BoxStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    backgroundColor: 'elevation.surface.sunken',
    padding: 'space.150',
    borderRadius: 'radius.large',
    borderBottomLeftRadius: 'radius.small'
});
const $82345f9002994123$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-summary-loading.title",
        defaultMessage: "Writing a summary"
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $82345f9002994123$export$dd8c26521b6a2fec = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $82345f9002994123$var$BoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $82345f9002994123$var$i18n.generatingSummaryText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($82345f9002994123$var$i18n.generatingSummaryAnimationAlt)
    })));
};



var $5GgqH = parcelRequire("5GgqH");


var $bQm3c = parcelRequire("bQm3c");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $3Am3T = parcelRequire("3Am3T");


var $8jP1I = parcelRequire("8jP1I");

var $161368acfff8028f$export$ec72d0267c37019f = /*#__PURE__*/ function(CommentsSummaryAnalyticsType) {
    CommentsSummaryAnalyticsType["FOOTER"] = "FOOTER";
    CommentsSummaryAnalyticsType["INLINE"] = "INLINE";
    return CommentsSummaryAnalyticsType;
}({});



var $dchHi = parcelRequire("dchHi");


var $bbNJt = parcelRequire("bbNJt");


var $jhwJP = parcelRequire("jhwJP");

/**
 * @generated SignedSource<<29553362f1cef877309db445c48df90d>>
 * @relayHash 53eb9fa8cec0a522c06e9697c10f440b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0e7f7022453c20fb771fa2185effa02f458d286aad7e6ce54aeb8f5bfb846a33
const $24226cfbd28917e5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentsType",
                    "variableName": "commentsType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "SmartFeaturesCommentsSummary",
            "kind": "LinkedField",
            "name": "getCommentsSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "summaryId"
                },
                {
                    "kind": "ScalarField",
                    "name": "language"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "53eb9fa8cec0a522c06e9697c10f440b",
            "id": "0e7f7022453c20fb771fa2185effa02f458d286aad7e6ce54aeb8f5bfb846a33",
            "metadata": {},
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "operationKind": "query",
            "text": "query useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery($contentId:ID!,$contentType:SummaryType!,$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId,contentType:$contentType,commentsType:$commentsType){contentId,summary,summaryId,language}}"
        }
    };
}();
$24226cfbd28917e5$var$node.hash = "6db2d91039b90f64f08e4e052c0a32d7";
var $24226cfbd28917e5$export$2e2bcd8739ae039 = $24226cfbd28917e5$var$node;


/**
 * @generated SignedSource<<c4777a9cf5f8e5b40c54145fa6f43328>>
 * @relayHash dc798cc8cc74b72655c7a19090058c0e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 436e25f2aa1fdf30c756b274ef8ce2de7a4f4bec1699fe1e3c1dc074e47484bb
const $050fce5e42c00d97$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentsType",
                    "variableName": "commentsType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "SmartFeaturesCommentsSummary",
            "kind": "LinkedField",
            "name": "getCommentsSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "summaryId"
                },
                {
                    "kind": "ScalarField",
                    "name": "language"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "dc798cc8cc74b72655c7a19090058c0e",
            "id": "436e25f2aa1fdf30c756b274ef8ce2de7a4f4bec1699fe1e3c1dc074e47484bb",
            "metadata": {},
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "operationKind": "query",
            "text": "query useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery($contentId:ID!,$contentType:SummaryType!,$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId,contentType:$contentType,commentsType:$commentsType){contentId,summary,summaryId,language}}"
        }
    };
}();
$050fce5e42c00d97$var$node.hash = "ffce51d12c39ccd238d2cb848107c61a";
var $050fce5e42c00d97$export$2e2bcd8739ae039 = $050fce5e42c00d97$var$node;



var $jMyy4 = parcelRequire("jMyy4");

/**
 * @generated SignedSource<<1f05a50a15753c67b4b42e99a5cdfd85>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $ac5fc6262abb25ff$export$e9466e0faeadf399 = /*#__PURE__*/ function(CommentsType) {
    CommentsType["FOOTER"] = "FOOTER";
    CommentsType["INLINE"] = "INLINE";
    return CommentsType;
}({});
var $ac5fc6262abb25ff$export$5bf35143f8d5729a = /*#__PURE__*/ function(SummaryType) {
    SummaryType["PAGE"] = "PAGE";
    SummaryType["BLOGPOST"] = "BLOGPOST";
    return SummaryType;
}({});


const $0edd62bded09ab4f$export$7bdbf0c72871fa1f = ({ contentId: contentId, contentType: contentType, shouldSkipFooterCommentsQuery: shouldSkipFooterCommentsQuery = false, shouldSkipInlineCommentsQuery: shouldSkipInlineCommentsQuery = false })=>{
    const { data: footerCommentsSummaryData, loading: footerCommentsQueryLoading, error: footerCommentsSummaryError, refetch: footerCommentsRefetch } = (0, $jMyy4.useQueryInterop)((0, $050fce5e42c00d97$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            contentType: contentType,
            commentsType: (0, $ac5fc6262abb25ff$export$e9466e0faeadf399).FOOTER
        },
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipFooterCommentsQuery,
        __callerPackage__: "ai-comments-summary"
    });
    const { data: inlineCommentsSummaryData, loading: inlineCommentsQueryLoading, error: inlineCommentsSummaryError, refetch: inlineCommentsRefetch } = (0, $jMyy4.useQueryInterop)((0, $24226cfbd28917e5$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            contentType: contentType,
            commentsType: (0, $ac5fc6262abb25ff$export$e9466e0faeadf399).INLINE
        },
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipInlineCommentsQuery,
        __callerPackage__: "ai-comments-summary"
    });
    const refetch = ()=>{
        footerCommentsRefetch();
        inlineCommentsRefetch();
    };
    return {
        data: {
            footerCommentsSummaryData: footerCommentsSummaryData,
            inlineCommentsSummaryData: inlineCommentsSummaryData
        },
        loading: footerCommentsQueryLoading || inlineCommentsQueryLoading,
        errors: {
            footerCommentsSummaryError: footerCommentsSummaryError,
            inlineCommentsSummaryError: inlineCommentsSummaryError
        },
        refetch: refetch
    };
};


const $ea0c56ea9695a839$export$2f5736e19049ec78 = '775fa156-8bed-4310-af75-c6d1148b88fb';


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $17fd4a0f0d6084c8$export$e9466e0faeadf399 = /*#__PURE__*/ function(CommentsType) {
    CommentsType["FOOTER"] = "FOOTER";
    CommentsType["INLINE"] = "INLINE";
    return CommentsType;
}({});
var $17fd4a0f0d6084c8$export$5bf35143f8d5729a = /*#__PURE__*/ function(SummaryType) {
    SummaryType["BLOGPOST"] = "BLOGPOST";
    SummaryType["PAGE"] = "PAGE";
    return SummaryType;
}({});



var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $f6bfaf9677f19070$export$9ad53c330569860e = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.COMMENTS_SUMMARY_COMPONENT_INTERACTION)
});


// eslint-disable-next-line import/order







var $i1t43 = parcelRequire("i1t43");











var $6Pqow = parcelRequire("6Pqow");





var $b3j2Y = parcelRequire("b3j2Y");


var $dL3KX = parcelRequire("dL3KX");


var $53ZHq = parcelRequire("53ZHq");

















var $7Sm4c = parcelRequire("7Sm4c");








const $883f6dcc92761560$export$37675c48b66aa091 = (contentId, source, footerCommentsError, inlineCommentsError)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { errorType: footerCommentsErrorType, isExpectedError: footerCommentsIsExpectedError } = (0, $dL3KX.useSummaryErrorHelper)((0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE), footerCommentsError);
    const { errorType: inlineCommentsErrorType, isExpectedError: inlineCommentsIsExpectedError } = (0, $dL3KX.useSummaryErrorHelper)((0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE), inlineCommentsError);
    const { errorType: errorType, commentsType: commentsType } = (0, $cozmU.useMemo)(()=>{
        let memoErrorType;
        let memoCommentsType = [];
        if (footerCommentsError && inlineCommentsError) {
            if (footerCommentsErrorType === inlineCommentsErrorType) memoErrorType = footerCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).FOOTER,
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).INLINE
            ];
        } else if (footerCommentsError) {
            memoErrorType = footerCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).FOOTER
            ];
        } else if (inlineCommentsError) {
            memoErrorType = inlineCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).INLINE
            ];
        }
        return {
            errorType: memoErrorType || (0, $dL3KX.HandledErrorType).GeneralError,
            commentsType: memoCommentsType
        };
    }, [
        inlineCommentsError,
        inlineCommentsErrorType,
        footerCommentsError,
        footerCommentsErrorType
    ]);
    if (footerCommentsIsExpectedError) (0, $7Sm4c.markErrorAsHandled)(footerCommentsError);
    if (inlineCommentsIsExpectedError) (0, $7Sm4c.markErrorAsHandled)(inlineCommentsError);
    // Experience should only be a failure if both queries have erred
    // OR either query has failed when the other query was skipped due to 0 comments
    const isExperienceFailure = footerCommentsError && (inlineCommentsError || unresolvedInlineCommentsCount === 0) || inlineCommentsError && footerCommentsCount === 0;
    const isExpectedError = footerCommentsIsExpectedError && (inlineCommentsIsExpectedError || unresolvedInlineCommentsCount === 0) || inlineCommentsIsExpectedError && footerCommentsCount === 0;
    if (isExperienceFailure) {
        if (isExpectedError) experienceTracker.abort({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            reason: `Can not generate summary due to ${errorType}`,
            attributes: {
                contentId: contentId,
                source: source
            }
        });
        else // Experience tracker can only fail with a single error. Since both queries have failed we will use the footer
        // comments failure to end the experience and pass both types of failures as attributes for further debugging
        experienceTracker.fail({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            // TS does not interpret the isExperienceFailure logic above correctly. Letting the compiler know
            error: footerCommentsError || inlineCommentsError,
            attributes: {
                footerCommentsErrorType: footerCommentsErrorType,
                inlineCommentsErrorType: inlineCommentsErrorType
            }
        });
    }
    return {
        erredQueries: commentsType,
        errorType: errorType,
        shouldCallErrorDisplayForFooterComments: !!footerCommentsError && !footerCommentsIsExpectedError,
        shouldCallErrorDisplayForInlineComments: !!inlineCommentsError && !inlineCommentsIsExpectedError
    };
};


const $6a674942f4f35f24$var$textStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $6a674942f4f35f24$var$i18nBase = (0, $kSwu1.defineMessages)({
    combinedErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-general",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a summary right now. You can try again later or read more <a>in our support documentation</a>."
    },
    combinedErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-too-much-content",
        defaultMessage: "There are too many comments for Atlassian Intelligence (AI) to summarize. Try again on content with fewer comments."
    },
    combinedErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-too-little-content",
        defaultMessage: "There aren\u2019t enough comments for Atlassian Intelligence (AI) to summarize. Try again when more comments have been added."
    },
    combinedErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-rate-limit",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    combinedErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-aup-violation",
        defaultMessage: "Atlassian Intelligence (AI) can\u2019t provide a summary of the comments on this content, as some comments may not comply with our <a>Acceptable Use Policy</a>."
    },
    footerCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-general",
        defaultMessage: "There is no summary of page comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    footerCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content",
        defaultMessage: "This summary only includes inline comments, as there are too many page comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content",
        defaultMessage: "This summary only includes inline comments, as there aren\u2019t enough page comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit",
        defaultMessage: "This summary only includes inline comments, as we\u2019ve received too many page comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    footerCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation",
        defaultMessage: "This summary only includes inline comments, as some page comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    },
    inlineCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-general",
        defaultMessage: "There is no summary of inline comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    inlineCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content",
        defaultMessage: "This summary only includes page comments, as there are too many inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-error-too-little-content",
        defaultMessage: "This summary only includes page comments, as there aren\u2019t enough inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit",
        defaultMessage: "This summary only includes page comments, as we\u2019ve received too many inline comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    inlineCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation",
        defaultMessage: "This summary only includes page comments, as some inline comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $6a674942f4f35f24$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    footerCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-general.livedocs",
        defaultMessage: "There is no summary of general comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    footerCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content.livedocs",
        defaultMessage: "This summary only includes inline comments, as there are too many general comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content.livedocs",
        defaultMessage: "This summary only includes inline comments, as there aren\u2019t enough general comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit.livedocs",
        defaultMessage: "This summary only includes inline comments, as we\u2019ve received too many general comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    footerCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation.livedocs",
        defaultMessage: "This summary only includes inline comments, as some general comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    },
    inlineCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content.livedocs",
        defaultMessage: "This summary only includes general comments, as there are too many inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-error-too-little-content.livedocs",
        defaultMessage: "This summary only includes general comments, as there aren\u2019t enough inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit.livedocs",
        defaultMessage: "This summary only includes general comments, as we\u2019ve received too many inline comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    inlineCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation.livedocs",
        defaultMessage: "This summary only includes general comments, as some inline comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $6a674942f4f35f24$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($6a674942f4f35f24$var$i18nBase, $6a674942f4f35f24$var$i18nLiveDocs);
const $6a674942f4f35f24$export$b0cd94004126f4ff = ({ contentId: contentId, footerCommentsError: footerCommentsError, inlineCommentsError: inlineCommentsError, source: source })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { trackAIResultError: trackAIResultError } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { erredQueries: erredQueries, errorType: errorType, shouldCallErrorDisplayForFooterComments: shouldCallErrorDisplayForFooterComments, shouldCallErrorDisplayForInlineComments: shouldCallErrorDisplayForInlineComments } = (0, $883f6dcc92761560$export$37675c48b66aa091)(contentId, source, footerCommentsError, inlineCommentsError);
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    (0, $cozmU.useEffect)(()=>{
        trackAIResultError({
            aiErrorMessage: errorType,
            // TODO Ideally we should pass the real code from the response
            aiErrorCode: 400
        }, {
            attributes: {
                contentId: contentId,
                errorType: errorType,
                commentsType: erredQueries,
                source: source
            }
        });
    }, [
        erredQueries,
        contentId,
        trackAIResultError,
        errorType,
        source
    ]);
    const onDocsLinkClicked = (linkName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'commentsSummaryError',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: `atlassianIntelligence${linkName}DocsLink`,
                attributes: {
                    contentId: contentId,
                    errorType: errorType,
                    commentsType: erredQueries,
                    source: source
                }
            }
        }).fire();
    };
    const errorMessage = ()=>{
        let i18nPrefix = "combined";
        if (footerCommentsError && !inlineCommentsError && unresolvedInlineCommentsCount > 0) i18nPrefix = "footerComments";
        if (inlineCommentsError && !footerCommentsError && footerCommentsCount > 0) i18nPrefix = "inlineComments";
        switch(errorType){
            case (0, $dL3KX.HandledErrorType).TooMuchContent:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorTooMuchContent`]);
            case (0, $dL3KX.HandledErrorType).NotEnoughContent:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorNotEnoughContent`]);
            case (0, $dL3KX.HandledErrorType).AUPViolation:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorAUPViolation`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.ACCEPTABLE_USE_POLICY_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('AupViolation')
                        }, chunks)
                });
            case (0, $dL3KX.HandledErrorType).RateLimit:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorRateLimit`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.USAGE_LIMITS_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('RateLimit')
                        }, chunks)
                });
            default:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorGeneral`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.TROUBLE_SHOOTING_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('Troubleshooting')
                        }, chunks)
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6a674942f4f35f24$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "p"
    }, errorMessage()), footerCommentsError && shouldCallErrorDisplayForFooterComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: footerCommentsError
    }), inlineCommentsError && shouldCallErrorDisplayForInlineComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: inlineCommentsError
    }));
};


const $28602bba7ed7c957$var$styles = (0, $buxP3.xcss)({
    height: '100%',
    font: 'font.body.large'
});
const $28602bba7ed7c957$var$FooterObjectSidebarStyles = (0, $buxP3.xcss)({
    // Object sidebar padding is 16px, this ensures that the footer isn't cutoff by parent padding
    width: 'calc(100% + 32px)',
    marginLeft: 'space.negative.200'
});
const $28602bba7ed7c957$var$i18nBase = (0, $kSwu1.defineMessages)({
    pageCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.page-comments-header",
        defaultMessage: "Page comments"
    },
    inlineCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.inline-comments-header",
        defaultMessage: "Inline comments"
    }
});
const $28602bba7ed7c957$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    pageCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.page-comments-header.livedocs",
        defaultMessage: "General comments"
    }
});
const $28602bba7ed7c957$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($28602bba7ed7c957$var$i18nBase, $28602bba7ed7c957$var$i18nLiveDocs);
var $28602bba7ed7c957$export$92985523ee81b88c = /*#__PURE__*/ function(CommentsSummarySource) {
    CommentsSummarySource["Footer"] = "footer";
    CommentsSummarySource["Header"] = "header";
    CommentsSummarySource["Feed"] = "feed";
    return CommentsSummarySource;
}({});
const $28602bba7ed7c957$export$dd076aaa63869f66 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, onRefresh: onRefresh, shouldRefetchCommentsSummary: shouldRefetchCommentsSummary = false, source: source, isInObjectSidebar: isInObjectSidebar, showAIDisclaimer: showAIDisclaimer = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cFVPs.useAIEventsInstrumentation)();
    const containerRef = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(containerRef);
    const contentTypeEnum = contentType === 'page' ? (0, $17fd4a0f0d6084c8$export$5bf35143f8d5729a).PAGE : (0, $17fd4a0f0d6084c8$export$5bf35143f8d5729a).BLOGPOST;
    const { data: data, errors: errors, loading: loading, refetch: refetch } = (0, $0edd62bded09ab4f$export$7bdbf0c72871fa1f)({
        contentId: contentId,
        contentType: contentTypeEnum,
        shouldSkipFooterCommentsQuery: footerCommentsCount === 0,
        shouldSkipInlineCommentsQuery: unresolvedInlineCommentsCount === 0
    });
    const refreshHandler = ()=>{
        if (!loading) {
            refetch();
            onRefresh?.();
        }
    };
    const startExperienceTracking = (0, $cozmU.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: source
            }
        });
        (0, $f6bfaf9677f19070$export$9ad53c330569860e).start();
    }, [
        contentId,
        experienceTracker,
        source
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (loading) startExperienceTracking();
        if (!loading) (0, $f6bfaf9677f19070$export$9ad53c330569860e).stop();
    }, [
        loading,
        startExperienceTracking
    ]);
    const footerCommentsSummary = data.footerCommentsSummaryData?.getCommentsSummary?.summary ?? '';
    const inlineCommentsSummary = data.inlineCommentsSummaryData?.getCommentsSummary?.summary ?? '';
    const loadingRef = (0, $cozmU.useRef)(loading);
    (0, $cozmU.useEffect)(()=>{
        loadingRef.current = loading;
    }, [
        loading
    ]);
    (0, $cozmU.useEffect)(()=>{
        trackAIInteractionInit();
        if (shouldRefetchCommentsSummary) {
            refetch();
            onRefresh?.();
        }
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'commentsSummary',
                    source: 'commentsSummary',
                    actionSubjectId: 'commentsSummaryDialog',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        dwellTime: getDwellTime()
                    }
                }
            }).fire();
            if (loadingRef.current) trackAIInteractionDismiss();
        };
    // Only check auto refetch on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const summaryLocale = (0, $cozmU.useMemo)(()=>{
        // Ok to just choose first of whichever is available from data team
        return data.footerCommentsSummaryData?.getCommentsSummary?.language || data.inlineCommentsSummaryData?.getCommentsSummary?.language;
    }, [
        data.footerCommentsSummaryData,
        data.inlineCommentsSummaryData
    ]);
    const commentsType = (0, $cozmU.useMemo)(()=>{
        const commentsTypeCollection = [];
        if (data.footerCommentsSummaryData) commentsTypeCollection.push((0, $161368acfff8028f$export$ec72d0267c37019f).FOOTER);
        if (data.inlineCommentsSummaryData) commentsTypeCollection.push((0, $161368acfff8028f$export$ec72d0267c37019f).INLINE);
        return commentsTypeCollection;
    }, [
        data.footerCommentsSummaryData,
        data.inlineCommentsSummaryData
    ]);
    const feedbackContext = {
        commentsType: commentsType,
        source: source
    };
    const analyticsProperties = {
        source: 'commentsSummary',
        additionalAnalyticsAttributes: {
            commentsType: commentsType
        }
    };
    (0, $cozmU.useEffect)(()=>{
        if (!loading) {
            if (!errors.footerCommentsSummaryError || !errors.inlineCommentsSummaryError) {
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'commentsSummaryContainer',
                        attributes: {
                            contentId: contentId,
                            edition: edition,
                            commentsType: commentsType,
                            summaryLocale: summaryLocale,
                            numPageCommentsSummarized: footerCommentsCount,
                            numInlineCommentsSummarized: unresolvedInlineCommentsCount
                        }
                    }
                }).fire();
                trackAIResultView();
            }
        }
    }, [
        createAnalyticsEvent,
        contentId,
        edition,
        loading,
        commentsType,
        summaryLocale,
        errors.footerCommentsSummaryError,
        errors.inlineCommentsSummaryError,
        footerCommentsCount,
        trackAIResultView,
        unresolvedInlineCommentsCount
    ]);
    const fullTextToCopy = ()=>{
        return `${footerCommentsSummary && `${intl.formatMessage($28602bba7ed7c957$var$i18n.pageCommentsHeader)}\n${footerCommentsSummary}`}\n\n${inlineCommentsSummary && `${intl.formatMessage($28602bba7ed7c957$var$i18n.inlineCommentsHeader)}\n${inlineCommentsSummary}`}`;
    };
    const renderContentBody = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.200"
        }, inlineCommentsSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, intl.formatMessage($28602bba7ed7c957$var$i18n.inlineCommentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
            options: {
                disableParsingRawHTML: true
            }
        }, inlineCommentsSummary)), footerCommentsSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, intl.formatMessage($28602bba7ed7c957$var$i18n.pageCommentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
            options: {
                disableParsingRawHTML: true
            }
        }, footerCommentsSummary)), (!errors.footerCommentsSummaryError || !errors.inlineCommentsSummaryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: source
            }
        }), (errors.footerCommentsSummaryError || errors.inlineCommentsSummaryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a674942f4f35f24$export$b0cd94004126f4ff), {
            contentId: contentId,
            footerCommentsError: errors.footerCommentsSummaryError,
            inlineCommentsError: errors.inlineCommentsSummaryError,
            source: source
        }));
    };
    const renderContent = ()=>{
        if (loading) return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            paddingInline: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82345f9002994123$export$dd8c26521b6a2fec), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $333270f2f5cd2de3$export$e93f99a4d30f6d75), null);
        const shouldShowFooterError = !!errors.footerCommentsSummaryError && !!errors.inlineCommentsSummaryError || !!errors.footerCommentsSummaryError && inlineCommentsSummary.length === 0 || !!errors.inlineCommentsSummaryError && footerCommentsSummary.length === 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            xcss: $28602bba7ed7c957$var$styles,
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            padding: isInObjectSidebar ? 'space.100' : 'space.250'
        }, source !== "footer" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bbNJt.SummaryPopupScrollableBody), {
            "data-testid": "scrollable-comments-summary"
        }, renderContentBody()) : renderContentBody()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: isInObjectSidebar && $28602bba7ed7c957$var$FooterObjectSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jP1I.AISummaryFooter), {
            analyticsProperties: analyticsProperties,
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            error: shouldShowFooterError,
            summaryText: fullTextToCopy(),
            showBetaLozenge: true,
            shouldHighlightRefresh: shouldRefetchCommentsSummary,
            refreshHandler: refreshHandler,
            showAIDisclaimer: showAIDisclaimer
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dchHi.FeedbackCollectorPropertiesProvider), {
        entrypointId: (0, $ea0c56ea9695a839$export$2f5736e19049ec78),
        feedbackContext: feedbackContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "comments-summary-content",
        hold: loading
    }), isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderContent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpJCW.AIBorder), {
        loading: loading
    }, renderContent()))));
};
module.exports["CommentsSummarySource"] = $28602bba7ed7c957$export$92985523ee81b88c;
module.exports["CommentsSummaryContent"] = $28602bba7ed7c957$export$dd076aaa63869f66;

});

parcelRegister("lpJCW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8jQuQ = parcelRequire("8jQuQ");


var $9ivsj = parcelRequire("9ivsj");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5e4f95acdf8fc4d$var$GradientPropertyContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _1mT5xdRAKS _0NUa3rOLYo",
            __cmplp.className
        ])
    });
});
const $f5e4f95acdf8fc4d$var$outerContainerStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $8jQuQ.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f5e4f95acdf8fc4d$var$animationStyles = (0, $buxP3.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f5e4f95acdf8fc4d$var$baseGlowStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f5e4f95acdf8fc4d$var$defaultBorderRadiusStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.large'
});
const $f5e4f95acdf8fc4d$var$modalBorderRadiusStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small'
});
const $f5e4f95acdf8fc4d$var$innerContainerStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f5e4f95acdf8fc4d$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f5e4f95acdf8fc4d$var$outerContainerStyles,
        $f5e4f95acdf8fc4d$var$animationStyles
    ] : [
        $f5e4f95acdf8fc4d$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f5e4f95acdf8fc4d$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f5e4f95acdf8fc4d$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f5e4f95acdf8fc4d$var$modalBorderRadiusStyles : $f5e4f95acdf8fc4d$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5e4f95acdf8fc4d$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props
    }, shouldRotate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles,
            ...hideGlow ? [] : glowStyles
        ],
        testId: "loading-glow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: "space.025",
        xcss: [
            $f5e4f95acdf8fc4d$var$innerContainerStyles,
            borderRadiusStyles,
            customInnerContainerStyles
        ]
    }, children)));
};
module.exports["AIBorder"] = $f5e4f95acdf8fc4d$export$6ed1e39f4dbe0bbf;

});

parcelRegister("8jQuQ", function(module, exports) {
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $cfd6e6a22c7a51c3$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
module.exports["reduceMotionAsPerUserPreference"] = $cfd6e6a22c7a51c3$export$f0f789643ba5a83c;

});

parcelRegister("8jP1I", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fc609ae5f11b40a5$export$409c83e49353f3fb = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0IK46",
    name: "AISummaryFooter",
    loader: async ()=>(await (parcelRequire("5mkqn"))).AISummaryFooter
});
module.exports["AISummaryFooter"] = $fc609ae5f11b40a5$export$409c83e49353f3fb;

});

parcelRegister("5mkqn", function(module, exports) {

let $0101c9b479c9a4d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0101c9b479c9a4d0$var$load("6wr18"),
    $0101c9b479c9a4d0$var$load("isCfG"),
    $0101c9b479c9a4d0$var$load("ffEVr"),
    $0101c9b479c9a4d0$var$load("kUbT8")
]).then(()=>parcelRequire('4KbgO'));

});

parcelRegister("dchHi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $cozmU.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("bbNJt", function(module, exports) {
/* SummaryPopupScrollableBody.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d3be62f9dcca5536$export$8fdeb1797011aead = 358;
const $d3be62f9dcca5536$export$3b687fa050c6eb18 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { useMaxHeight: useMaxHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg20Hp _2WAcuGIZbP _3zvHkHwPeg _1ANEUSzUZr _4ho0wCjOvk _3ILZpPRi7C _2Ins1S8fU6 _0Gam4UDMqu _3ZpBalKcZT",
            __cmplp.useMaxHeight ? "_0NUa3rO3MJ" : "_0NUa3rZqHV",
            __cmplp.className
        ])
    });
});
module.exports["MAX_SUMMARY_HEIGHT"] = $d3be62f9dcca5536$export$8fdeb1797011aead;
module.exports["SummaryPopupScrollableBody"] = $d3be62f9dcca5536$export$3b687fa050c6eb18;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("dL3KX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6ahXt = parcelRequire("6ahXt");


var $1kHsc = parcelRequire("1kHsc");


var $7Sm4c = parcelRequire("7Sm4c");

const $926c216e16fb1b0c$export$64cc6b1b62510d3 = "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is too much content to summarize.";
const $926c216e16fb1b0c$export$1403052b2e306597 = "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is not enough content to summarize. You can try again later if more is added!";
var $926c216e16fb1b0c$export$6841b1da468d3071 = /*#__PURE__*/ function(HandledErrorType) {
    HandledErrorType["TooMuchContent"] = "tooMuchContent";
    HandledErrorType["NotEnoughContent"] = "notEnoughContent";
    HandledErrorType["RateLimit"] = "rateLimit";
    HandledErrorType["AUPViolation"] = "aupViolation";
    HandledErrorType["GeneralError"] = "generalError";
    return HandledErrorType;
}({});
const $926c216e16fb1b0c$var$ERROR_MAP = {
    [$926c216e16fb1b0c$export$64cc6b1b62510d3]: "tooMuchContent",
    [$926c216e16fb1b0c$export$1403052b2e306597]: "notEnoughContent",
    TOO_MANY_REQUEST: "rateLimit",
    AUP_VIOLATION: "aupViolation"
};
const $926c216e16fb1b0c$var$STREAM_ERROR_MAP = {
    [(0, $6ahXt.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT]: "notEnoughContent",
    [(0, $6ahXt.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR]: "notEnoughContent",
    [(0, $6ahXt.ConvoAIErrorMessage).RATE_LIMIT]: "rateLimit",
    [(0, $6ahXt.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS]: "aupViolation"
};
const $926c216e16fb1b0c$var$expectedErrorTypes = [
    "tooMuchContent",
    "notEnoughContent",
    "aupViolation"
];
const $926c216e16fb1b0c$export$628a9b3d5b2b9729 = (experienceName, errorFromApolloOrStream)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { errorType: errorType, isExpectedError: isExpectedError, error: error } = (0, $cozmU.useMemo)(()=>{
        if (!errorFromApolloOrStream) return {
            isExpectedError: false,
            stopExperienceTracking: ()=>{},
            errorType: undefined,
            error: new Error('[useSummaryErrorHelper]: error instance is missing')
        };
        let errorMessageFromGQLorStream = '';
        let errorTypeFromGQLorStream = '';
        if ('graphQLErrors' in errorFromApolloOrStream) {
            // The BE only returns one error (the first that it encounters).
            // Therefore, we don't need to loop through the array, and can just rely on index 0
            errorMessageFromGQLorStream = errorFromApolloOrStream.graphQLErrors[0].message;
            errorTypeFromGQLorStream = $926c216e16fb1b0c$var$ERROR_MAP[errorMessageFromGQLorStream];
            return {
                isExpectedError: $926c216e16fb1b0c$var$expectedErrorTypes.includes(errorTypeFromGQLorStream),
                error: errorFromApolloOrStream,
                errorType: errorTypeFromGQLorStream
            };
        } else {
            errorMessageFromGQLorStream = errorFromApolloOrStream.message.message_template;
            errorTypeFromGQLorStream = $926c216e16fb1b0c$var$STREAM_ERROR_MAP[errorMessageFromGQLorStream];
            return {
                isExpectedError: $926c216e16fb1b0c$var$expectedErrorTypes.includes(errorTypeFromGQLorStream),
                error: new Error(errorFromApolloOrStream.message.content),
                errorType: errorTypeFromGQLorStream
            };
        }
    }, [
        errorFromApolloOrStream
    ]);
    const stopExperienceTracking = ()=>{
        if (isExpectedError) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            experienceTracker.abort({
                name: experienceName,
                reason: `Can not generate summary due to ${errorType}`
            });
        } else experienceTracker.fail({
            name: experienceName,
            error: error
        });
    };
    return {
        isExpectedError: isExpectedError,
        stopExperienceTracking: stopExperienceTracking,
        error: error,
        errorType: errorType
    };
};
module.exports["HandledErrorType"] = $926c216e16fb1b0c$export$6841b1da468d3071;
module.exports["useSummaryErrorHelper"] = $926c216e16fb1b0c$export$628a9b3d5b2b9729;

});

parcelRegister("6ahXt", function(module, exports) {
var $75c4b38c8370fd53$export$cb6667e6b65615 = /*#__PURE__*/ function(ConvoAIErrorMessage) {
    ConvoAIErrorMessage["RATE_LIMIT"] = "RATE_LIMIT";
    ConvoAIErrorMessage["ANSWER_UNAVAILABLE_FOR_CONTENT"] = "ANSWER_UNAVAILABLE_FOR_CONTENT";
    ConvoAIErrorMessage["ACCEPTABLE_USE_VIOLATIONS"] = "ACCEPTABLE_USE_VIOLATIONS";
    ConvoAIErrorMessage["NOT_ENOUGH_CONTENT_ERROR"] = "NOT_ENOUGH_CONTENT_ERROR";
    ConvoAIErrorMessage["NOT_FOUND"] = "NOT_FOUND";
    ConvoAIErrorMessage["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ConvoAIErrorMessage["BAD_REQUEST"] = "BAD_REQUEST";
    ConvoAIErrorMessage["UNEXPECTED"] = "UNEXPECTED";
    ConvoAIErrorMessage["TIMEOUT"] = "TIMEOUT";
    return ConvoAIErrorMessage;
}({});
const $75c4b38c8370fd53$export$26a36d98cab4996b = 0;
module.exports["ConvoAIErrorMessage"] = $75c4b38c8370fd53$export$cb6667e6b65615;
module.exports["CONVOAI_DEFAULT_ERROR_CODE"] = $75c4b38c8370fd53$export$26a36d98cab4996b;

});

parcelRegister("53ZHq", function(module, exports) {
const $ddccf0ae2c3101d9$export$6c1f59b2f89fe4f1 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $ddccf0ae2c3101d9$export$b4fefae0b724683f = 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/';
const $ddccf0ae2c3101d9$export$2876254020381b5e = 'https://www.atlassian.com/legal/acceptable-use-policy';
module.exports["TROUBLE_SHOOTING_DOCS_URL"] = $ddccf0ae2c3101d9$export$6c1f59b2f89fe4f1;
module.exports["USAGE_LIMITS_DOCS_URL"] = $ddccf0ae2c3101d9$export$b4fefae0b724683f;
module.exports["ACCEPTABLE_USE_POLICY_URL"] = $ddccf0ae2c3101d9$export$2876254020381b5e;

});

parcelRegister("auLW1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b253f08be2669ace$export$c463287b61deee24 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wRZLE",
    name: "PageCatchupComponent",
    loader: async ()=>(await (parcelRequire("5OKal"))).PageCatchupComponentWithErrorBoundary
});
module.exports["PageCatchupComponent"] = $b253f08be2669ace$export$c463287b61deee24;

});

parcelRegister("5OKal", function(module, exports) {

let $43c56ed32c39e782$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $43c56ed32c39e782$var$load("ahEIC"),
    $43c56ed32c39e782$var$load("b19pM"),
    $43c56ed32c39e782$var$load("7qCqs"),
    $43c56ed32c39e782$var$load("7Y0AX"),
    $43c56ed32c39e782$var$load("4aKct"),
    $43c56ed32c39e782$var$load("ariuh"),
    $43c56ed32c39e782$var$load("hhss7"),
    $43c56ed32c39e782$var$load("eN6nL")
]).then(()=>parcelRequire('4RbVT'));

});

parcelRegister("eN3MW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bee98af9586f2941$export$e6e415a985158eb3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EZkxH",
    name: "QuickSummaryStreamingComponent",
    loader: async ()=>(await (parcelRequire("1uvd8"))).QuickSummaryStreamingEntryPoint
});
module.exports["QuickSummaryStreamingComponent"] = $bee98af9586f2941$export$e6e415a985158eb3;

});

parcelRegister("1uvd8", function(module, exports) {

let $1160cda1ac0a2fe2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1160cda1ac0a2fe2$var$load("dEA3e"),
    $1160cda1ac0a2fe2$var$load("cIET7"),
    $1160cda1ac0a2fe2$var$load("ahEIC"),
    $1160cda1ac0a2fe2$var$load("hcY7w"),
    $1160cda1ac0a2fe2$var$load("6wr18"),
    $1160cda1ac0a2fe2$var$load("isCfG"),
    $1160cda1ac0a2fe2$var$load("kUbT8"),
    $1160cda1ac0a2fe2$var$load("b19pM"),
    $1160cda1ac0a2fe2$var$load("4nZ85"),
    $1160cda1ac0a2fe2$var$load("hhss7"),
    $1160cda1ac0a2fe2$var$load("ariuh"),
    $1160cda1ac0a2fe2$var$load("aCJpU"),
    $1160cda1ac0a2fe2$var$load("kHXvF"),
    $1160cda1ac0a2fe2$var$load("ffEVr"),
    $1160cda1ac0a2fe2$var$load("jrchu")
]).then(()=>parcelRequire('9zqwo'));

});

parcelRegister("brrvF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1ytiN = parcelRequire("1ytiN");


var $42MJM = parcelRequire("42MJM");


var $ffOSw = parcelRequire("ffOSw");


var $fvOg5 = parcelRequire("fvOg5");

const $a68160926e693700$var$i18n = (0, $kSwu1.defineMessages)({
    headerText: {
        id: "quick-summary.upsell.header.text",
        defaultMessage: "Improve productivity with Rovo"
    },
    headerTextAdmin: {
        id: "quick-summary.upsell.header.text.admin",
        defaultMessage: "Improve team productivity with Rovo"
    },
    learnMoreLinkTextUser: {
        id: "quick-summary.upsell.learn-more.link.text.user",
        defaultMessage: "Learn more about Rovo"
    },
    bodyTextAdmin: {
        id: "quick-summary.upsell.body.text.admin",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Upgrade to Premium"
    },
    bodyTextUser: {
        id: "quick-summary.upsell.body.text.user",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Try Rovo today"
    }
});
const $a68160926e693700$export$37172947b8f9cb48 = 'https://www.atlassian.com/software/rovo/guides/end-user-guide/introduction';
const $a68160926e693700$export$9f5718677d288e24 = 'https://www.atlassian.com/software/rovo/guides/admin-guide/introduction';
const $a68160926e693700$export$f552fbd4bef744fa = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const headerText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.headerTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.headerText);
    const bodyText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.bodyTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.bodyTextUser);
    const learnMoreLink = isSiteAdmin ? $a68160926e693700$export$9f5718677d288e24 : $a68160926e693700$export$37172947b8f9cb48;
    const learnMoreText = intl.formatMessage($a68160926e693700$var$i18n.learnMoreLinkTextUser);
    const learnMoreLinkProps = (0, $cozmU.useMemo)(()=>({
            href: learnMoreLink,
            message: learnMoreText
        }), [
        learnMoreLink,
        learnMoreText
    ]);
    const imageProps = (0, $cozmU.useMemo)(()=>({
            src: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($ffOSw))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($fvOg5)))
            },
            alt: ''
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $42MJM.AIUpsell), {
        title: headerText,
        body: bodyText,
        feature: "quickSummary",
        learnMoreLink: learnMoreLinkProps,
        image: imageProps
    });
};
module.exports["QuickSummaryUpsell"] = $a68160926e693700$export$f552fbd4bef744fa;

});

parcelRegister("ffOSw", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerLight.edcc3647.svg", import.meta.url).toString();

});

parcelRegister("fvOg5", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerDark.e27429f6.svg", import.meta.url).toString();

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3ricL = parcelRequire("3ricL");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("dppWL", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ var $56fbda2769629a59$export$50526ee9b1846f6c = /*#__PURE__*/ function(RegisteredExperience) {
    RegisteredExperience["VIEW_PAGE"] = "view-page";
    RegisteredExperience["EDIT_PAGE"] = "edit-page";
    RegisteredExperience["WHITEBOARD"] = "whiteboard";
    RegisteredExperience["SEARCH_PAGE"] = "search-page";
    RegisteredExperience["HOME"] = "home";
    RegisteredExperience["FOLDER"] = "folder";
    return RegisteredExperience;
}({});
const $56fbda2769629a59$export$1e3f84bae31640f2 = (props)=>'actionsToRender' in props;
const $56fbda2769629a59$export$73c8d1f99070570a = (props)=>'actionsToRender' in props;
const $56fbda2769629a59$export$9fdd72360ade08c0 = (props)=>'contentType' in props;
const $56fbda2769629a59$export$b8a252bbcf90a2cb = (props)=>'getSearchQuery' in props;
module.exports["RegisteredExperience"] = $56fbda2769629a59$export$50526ee9b1846f6c;
module.exports["isWhiteboardRovoConfigProviderProps"] = $56fbda2769629a59$export$1e3f84bae31640f2;
module.exports["isFolderRovoConfigProviderProps"] = $56fbda2769629a59$export$73c8d1f99070570a;
module.exports["isPageRovoConfigProviderProps"] = $56fbda2769629a59$export$9fdd72360ade08c0;

});

parcelRegister("3tUdX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dppWL = parcelRequire("dppWL");


var $amW67 = parcelRequire("amW67");


var $8hjAS = parcelRequire("8hjAS");

const $f4bf02d66e85d52a$export$44a9046b553a8167 = (props)=>{
    if (props.experience === (0, $dppWL.RegisteredExperience).WHITEBOARD && !(0, $dppWL.isWhiteboardRovoConfigProviderProps)(props)) return null;
    if (props.experience === (0, $dppWL.RegisteredExperience).FOLDER && !(0, $dppWL.isFolderRovoConfigProviderProps)(props)) return null;
    if ((props.experience === (0, $dppWL.RegisteredExperience).VIEW_PAGE || props.experience === (0, $dppWL.RegisteredExperience).EDIT_PAGE) && !(0, $dppWL.isPageRovoConfigProviderProps)(props)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $amW67.RovoConfigProviderContextProvider), {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8hjAS.RovoCurrentConfigProvider), {
        provider: props.provider
    }));
};
module.exports["RovoConfigProvider"] = $f4bf02d66e85d52a$export$44a9046b553a8167;

});

parcelRegister("amW67", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $23a8183fa434531d$var$RovoConfigProviderContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $23a8183fa434531d$export$3ae1f97e9390a638 = ()=>{
    const context = (0, $cozmU.useContext)($23a8183fa434531d$var$RovoConfigProviderContext);
    if (!context) throw new Error('useRovoConfigProviderProps must be used within an RovoConfigProviderContext.Provider');
    return context;
};
const $23a8183fa434531d$export$45b0916bb24b31be = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23a8183fa434531d$var$RovoConfigProviderContext.Provider, {
        value: value
    }, children);
};
module.exports["useRovoConfigProviderProps"] = $23a8183fa434531d$export$3ae1f97e9390a638;
module.exports["RovoConfigProviderContextProvider"] = $23a8183fa434531d$export$45b0916bb24b31be;

});

parcelRegister("8hjAS", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $8MKuN = parcelRequire("8MKuN");


var $6mKj3 = parcelRequire("6mKj3");


var $5ruin = parcelRequire("5ruin");

const $4d3968fc98119c84$export$9ef355ca939f0be9 = ({ provider: provider })=>{
    const { resetConfiguration: resetConfiguration, setConfiguration: setConfiguration } = (0, $5ruin.useRovoCurrentConfigStoreActions)();
    (0, $cozmU.useEffect)(()=>{
        if (!provider) resetConfiguration();
        return ()=>{
            resetConfiguration();
        };
    }, [
        resetConfiguration,
        provider
    ]);
    if (!provider) return null;
    const ActiveProviderComponent = provider;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).AI_MATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "rovo-current-configuration-provider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ActiveProviderComponent, {
        setConfiguration: setConfiguration
    })));
    return (0, $6mKj3.expVal)('confluence_edit_page_conditional_ufohold_ignore', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MKuN.ConditionalUfoHoldIgnore), null, content) : content;
};
module.exports["RovoCurrentConfigProvider"] = $4d3968fc98119c84$export$9ef355ca939f0be9;

});

parcelRegister("8MKuN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a33Aa = parcelRequire("a33Aa");


var $jb2gB = parcelRequire("jb2gB");

const $88668855474bc367$export$27cee8d00af73bce = [
    'edit-page.page_load',
    'edit-page.transition',
    'space-overview-edit-page.page_load',
    'space-overview-edit-page.transition',
    'live-edit.page_load',
    'live-edit.transition'
];
function $88668855474bc367$export$2510d15b8c74a469({ children: children, excludedInteractions: excludedInteractions = $88668855474bc367$export$27cee8d00af73bce }) {
    // Capture the interaction once at mount time to ensure stable behavior for the
    // component's lifetime. getActiveInteraction() can return null mid-render cycle
    // if the UFO interaction ends, which would cause the ignore prop to toggle
    // between renders and effectively un-ignore the hold on a subsequent re-render.
    const ignoreHoldsRef = (0, $cozmU.useRef)(null);
    if (ignoreHoldsRef.current === null) {
        const interaction = (0, $a33Aa.getActiveInteraction)();
        if (interaction) {
            const { type: type, ufoName: ufoName } = interaction;
            ignoreHoldsRef.current = excludedInteractions.includes(`${ufoName}.${type}`);
        } else ignoreHoldsRef.current = false;
    }
    const ignoreHolds = ignoreHoldsRef.current ?? false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), {
        ignore: ignoreHolds
    }, children);
}
module.exports["ConditionalUfoHoldIgnore"] = $88668855474bc367$export$2510d15b8c74a469;

});

parcelRegister("5ruin", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $8s9DV.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $kBr4q.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
const $2b71e6bc29f732db$export$77b1364ae13e9bf5 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.numStartersToShow
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;
module.exports["useRovoConfigNumStartersToShow"] = $2b71e6bc29f732db$export$77b1364ae13e9bf5;

});

parcelRegister("bXh4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $5251c9f91178493b$export$d4c72bab9d6cc13a = {
    nudges: [],
    dailyBriefUnread: null,
    isNudgeVisible: false
};
const $5251c9f91178493b$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        },
    setDailyBriefUnread: (dailyBriefUnread)=>({ setState: setState })=>{
            setState({
                dailyBriefUnread: dailyBriefUnread
            });
        },
    setIsNudgeVisible: (isNudgeVisible)=>({ setState: setState })=>{
            setState({
                isNudgeVisible: isNudgeVisible
            });
        }
};
const $5251c9f91178493b$export$72552b26ebb37b2 = (0, $8s9DV.createStore)({
    initialState: $5251c9f91178493b$export$d4c72bab9d6cc13a,
    actions: $5251c9f91178493b$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $5251c9f91178493b$export$af36d029992e7a8c = (0, $kBr4q.createActionsHook)($5251c9f91178493b$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $5251c9f91178493b$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $5251c9f91178493b$export$af36d029992e7a8c;

});

parcelRegister("k9SyR", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bXh4X = parcelRequire("bXh4X");

const $4a243273df5696f3$export$b854997b7299d67f = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.nudges
});
const $4a243273df5696f3$export$9af0fbebebbfec35 = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.buttonClickedTimestamp
});
const $4a243273df5696f3$export$2d43c7fdbd36cd6c = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.dailyBriefUnread
});
const $4a243273df5696f3$export$17170223ff11d032 = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.isNudgeVisible
});
module.exports["useAINudges"] = $4a243273df5696f3$export$b854997b7299d67f;
module.exports["useDailyBriefUnread"] = $4a243273df5696f3$export$2d43c7fdbd36cd6c;
module.exports["useIsNudgeVisible"] = $4a243273df5696f3$export$17170223ff11d032;

});

parcelRegister("69SEX", function(module, exports) {

let $47bdfb9bacde42e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47bdfb9bacde42e8$var$load("cPxo3").then(()=>parcelRequire('7MW6I'));

});

parcelRegister("58cpY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c32f66999dc5247fcc5963be2762eee1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc7550dcb3a0996$var$_react = $3bc7550dcb3a0996$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3bc7550dcb3a0996$var$_iconNew = $3bc7550dcb3a0996$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $3bc7550dcb3a0996$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeAudioBriefing".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-audio-briefing
 * Usage guidance:
 * Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc7550dcb3a0996$var$AiGenerativeAudioBriefingIcon = (props)=>/*#__PURE__*/ $3bc7550dcb3a0996$var$_react.default.createElement($3bc7550dcb3a0996$var$_iconNew.default, Object.assign({
        name: "AiGenerativeAudioBriefingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0c.97 0 1.88.2 2.72.55l-.24.09c-.52.19-.93.56-1.19 1.02A5.5 5.5 0 0 0 2.5 7v.71A2.5 2.5 0 0 1 6 10v3.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 12V7a7 7 0 0 1 7-7M3.5 9a1 1 0 0 0-1 1v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42V10a1 1 0 0 0-1-1m11.46-2.78Q15 6.6 15 7v5a3.08 3.08 0 0 1-3.08 3A1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 3.5-2.29v-.73a2.25 2.25 0 0 0 1.46-.77M12.5 9a1 1 0 0 0-1 1v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58V10a1 1 0 0 0-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M13.365.009a.75.75 0 0 1 .541.378l.05.106.334.92a.5.5 0 0 0 .298.297l.919.335a.75.75 0 0 1 0 1.41l-.92.335a.5.5 0 0 0-.297.298l-.335.919a.75.75 0 0 1-1.41 0l-.335-.92a.5.5 0 0 0-.298-.297l-.919-.335a.75.75 0 0 1-.484-.589L10.5 2.75l.009-.116a.75.75 0 0 1 .484-.59l.92-.334a.5.5 0 0 0 .297-.298l.335-.919A.75.75 0 0 1 13.249 0z"/>`
    }, props));
$3bc7550dcb3a0996$var$AiGenerativeAudioBriefingIcon.displayName = 'AiGenerativeAudioBriefingIcon';
var $3bc7550dcb3a0996$var$_default = module.exports.default = $3bc7550dcb3a0996$var$AiGenerativeAudioBriefingIcon;

});

parcelRegister("6iWVH", function(module, exports) {
var $b76a5cfcb2493fac$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $b76a5cfcb2493fac$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'manage-user-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-permissions',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'saml-troubleshooting',
    'scim-troubleshooting',
    'review-api-security',
    'policy-assist'
]);
var $b76a5cfcb2493fac$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_CREATE_PULL_REQUEST"] = "bitbucket-create-pull-request";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_BOARD"] = "jira-board";
    PageContextType["JIRA_BACKLOG"] = "jira-backlog";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["FOCUS_FOCUS_AREA_FUNDS_VIEW"] = "focus-focus-area-funds-view";
    PageContextType["SAC"] = "sac";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["STUDIO_AGENT_BUILDER"] = "studio-agent-builder";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $b76a5cfcb2493fac$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $b76a5cfcb2493fac$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $b76a5cfcb2493fac$export$c91e07269f22915a;
module.exports["PageContextType"] = $b76a5cfcb2493fac$export$7f7a6f1c2ab5127;
module.exports["PROMPT_OF_DAY_ACTION_ID"] = $b76a5cfcb2493fac$export$4f757e7d9540e8f9;

});

parcelRegister("2bR8c", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kQqCc = parcelRequire("kQqCc");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $cozmU.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("kQqCc", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $d52db76b74818184$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $d52db76b74818184$export$64aee74ba59709e5 = 439; // px
const $d52db76b74818184$export$1c07393c5bb1bc27 = 439; // px
const $d52db76b74818184$export$aa3478deee7adbeb = 350; // px
const $d52db76b74818184$export$21e515a86cd1733b = 'Chat';
const $d52db76b74818184$export$e942bf04e23ff966 = 'Rovo';
const $d52db76b74818184$var$CONFLUENCE_AGENT_CREATION_ENTRY_POINTS = new Set([
    'globalCreateDropdown-inlineCreateAgent',
    'pageTreeItemContextualCreate-inlineCreateAgent',
    'spaceLevelContextualCreate-inlineCreateAgent',
    'endOfContentTreeContextualCreate-inlineCreateAgent',
    'globalCreateDropdown-smartCreate',
    'pageTreeItemContextualCreate-smartCreate',
    'spaceLevelContextualCreate-smartCreate',
    'endOfContentTreeContextualCreate-smartCreate',
    'confluence-rovo-agent-menu-create-agent'
]);
const $d52db76b74818184$export$f834c05603f390d3 = (source)=>$d52db76b74818184$var$CONFLUENCE_AGENT_CREATION_ENTRY_POINTS.has(source);
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $d52db76b74818184$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $d52db76b74818184$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $d52db76b74818184$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $d52db76b74818184$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $d52db76b74818184$export$e942bf04e23ff966;
module.exports["isConfluenceAgentCreationEntryPoint"] = $d52db76b74818184$export$f834c05603f390d3;

});

parcelRegister("fQFMU", function(module, exports) {
/**
 * @generated SignedSource<<c691598616878362b73526082636fffb>>
 * @relayHash 22a043234be95fa20e060d60e168d985
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a27e98c00c60c5125bb9573000f3e2184fa0546ddf6338da0ee78c015eada92b
const $86cb04399e002e13$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipContentReviewerNudge"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipStatusUpdatesAutomation"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipUserEmails"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            {
                "condition": "skipUserEmails",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "AtlassianUserEmail",
                        "kind": "LinkedField",
                        "name": "emails",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isPrimary"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v9 = {
        "condition": "skipContentReviewerNudge",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "isDraft",
                        "variableName": "isDraft"
                    }
                ],
                "concreteType": "ContentState",
                "kind": "LinkedField",
                "name": "contentState",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    }
                ]
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v6 /*: any*/ 
        ]
    }, v12 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v14 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            }
        ]
    }, v15 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 25
            }
        ],
        "concreteType": "PaginatedContentList",
        "kind": "LinkedField",
        "name": "children",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v6 /*: any*/ ,
                    v10 /*: any*/ ,
                    {
                        "concreteType": "ContentMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "createdDate"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "children(first:25)"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useConfluenceAutomationNudgeActionsQuery",
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "condition": "skipStatusUpdatesAutomation",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ ,
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useConfluenceAutomationNudgeActionsQuery",
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": v8 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v9 /*: any*/ ,
                        {
                            "condition": "skipStatusUpdatesAutomation",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v14 /*: any*/ ,
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "22a043234be95fa20e060d60e168d985",
            "id": "a27e98c00c60c5125bb9573000f3e2184fa0546ddf6338da0ee78c015eada92b",
            "metadata": {},
            "name": "useConfluenceAutomationNudgeActionsQuery",
            "operationKind": "query",
            "text": "query useConfluenceAutomationNudgeActionsQuery($contentId:ID!,$skipStatusUpdatesAutomation:Boolean!,$skipContentReviewerNudge:Boolean!,$skipUserEmails:Boolean!,$isDraft:Boolean!){user:confluence_atlassianUser(current:true){__typename,id,emails@skip(if:$skipUserEmails){value,isPrimary}},singleContent(id:$contentId){__typename,id,contentState(isDraft:$isDraft)@skip(if:$skipContentReviewerNudge){id,name},title@skip(if:$skipStatusUpdatesAutomation)\n    space@skip(if:$skipStatusUpdatesAutomation){id}\n    ancestors@skip(if:$skipStatusUpdatesAutomation){id,title}\n    history@skip(if:$skipStatusUpdatesAutomation){ownedBy{__typename,...on KnownUser{accountId}}}\n    metadata@skip(if:$skipStatusUpdatesAutomation){sourceTemplateEntityId}\n    children(first:25)@skip(if:$skipStatusUpdatesAutomation){nodes{id,title,metadata{createdDate}}}}}"
        }
    };
}();
$86cb04399e002e13$var$node.hash = "afe62dfdde51fc06658664d145c28bd1";
var $86cb04399e002e13$export$2e2bcd8739ae039 = $86cb04399e002e13$var$node;



var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $jMyy4 = parcelRequire("jMyy4");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");





var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $dK51B = parcelRequire("dK51B");


var $bQm3c = parcelRequire("bQm3c");


var $355fY = parcelRequire("355fY");

const $6ae174e9ec58ddf7$var$RULES_FETCH_LIMIT = 50;
const $6ae174e9ec58ddf7$export$8f3f951eb67a9ea8 = ({ skip: skip = false } = {})=>{
    const { studioSpaceAri: studioSpaceAri, isLoading: isStudioSpaceLoading } = (0, $355fY.useStudioSpaceAri)({
        skip: skip
    });
    const { userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = studioSpaceAri?.workspaceId;
    const spaceId = studioSpaceAri?.spaceId;
    const envSegment = environment === 'STAGING' ? 'staging' : 'pro';
    const shouldRunQuery = !skip && Boolean(workspaceId) && Boolean(spaceId);
    const { data: data, loading: loading, error: error } = (0, $dK51B.useExperimentalQuery)({
        url: `/gateway/api/automation/sc3/o/studio/t/workspace/i/${workspaceId}/internal-api/${envSegment}/rest/${spaceId}/rules`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        variables: {
            authorAccountId: userId ?? '',
            limit: $6ae174e9ec58ddf7$var$RULES_FETCH_LIMIT
        },
        parseResult: (response)=>({
                rules: Array.isArray(response?.values) ? response.values : []
            }),
        skip: !shouldRunQuery,
        fetchPolicy: 'cache-first',
        onError: (error)=>{
            if ((0, $aMcHK.isStatusCodeError)(error, '403') || (0, $aMcHK.isStatusCodeError)(error, '404')) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    return {
        rules: data?.rules ?? [],
        isLoading: shouldRunQuery && loading || !skip && isStudioSpaceLoading,
        error: error
    };
};


/** Trigger fired when a page's status changes; carries the target statuses in `value.pageStatuses`. */ const $b05197d75836b426$var$PAGE_STATUS_CHANGED_TRIGGER_TYPE = 'confluence.page-status-changed.trigger';
/** Trigger fired when a page is published. */ const $b05197d75836b426$var$PAGE_PUBLISHED_TRIGGER_TYPE = 'confluence.page-published.trigger';
/** Action that runs a Rovo agent (the Content Reviewer agent, for our purposes). */ const $b05197d75836b426$var$INVOKE_AGENT_ACTION_TYPE = 'rovo.invoke-agent.action';
/** Action that sends a templated email (the meeting-notes recap). */ const $b05197d75836b426$var$SEND_TEMPLATED_EMAIL_ACTION_TYPE = 'action.send-templated-email';
/** The page status that triggers the Content Reviewer nudge. */ const $b05197d75836b426$var$READY_FOR_REVIEW = 'ready for review';
/** Text a meeting-notes rule's name/description is expected to contain. */ const $b05197d75836b426$var$MEETING_NOTES_TEXT = 'meeting notes';
const $b05197d75836b426$var$equalsIgnoreCase = (value, expectedLower)=>typeof value === 'string' && value.toLowerCase() === expectedLower;
const $b05197d75836b426$var$isRule = (rule)=>rule != null && typeof rule === 'object';
const $b05197d75836b426$var$hasComponentOfType = (rule, typeLower)=>Array.isArray(rule.components) && rule.components.some((component)=>$b05197d75836b426$var$equalsIgnoreCase(component?.type, typeLower));
/** True when the rule's trigger is of the given type. */ const $b05197d75836b426$var$hasTriggerType = (rule, typeLower)=>$b05197d75836b426$var$equalsIgnoreCase(rule.trigger?.type, typeLower);
/** True when the rule is triggered by a page-status change to "Ready for review". */ const $b05197d75836b426$var$triggersOnReadyForReview = (rule)=>{
    if (!$b05197d75836b426$var$hasTriggerType(rule, $b05197d75836b426$var$PAGE_STATUS_CHANGED_TRIGGER_TYPE)) return false;
    const statuses = rule.trigger?.value?.pageStatuses;
    return Array.isArray(statuses) && statuses.some((status)=>$b05197d75836b426$var$equalsIgnoreCase(status?.label, $b05197d75836b426$var$READY_FOR_REVIEW));
};
const $b05197d75836b426$export$54e55f0a7b30024a = (rules)=>rules.some((rule)=>$b05197d75836b426$var$isRule(rule) && $b05197d75836b426$var$hasTriggerType(rule, $b05197d75836b426$var$PAGE_PUBLISHED_TRIGGER_TYPE) && `${rule.name ?? ''} ${rule.description ?? ''}`.toLowerCase().includes($b05197d75836b426$var$MEETING_NOTES_TEXT) && $b05197d75836b426$var$hasComponentOfType(rule, $b05197d75836b426$var$SEND_TEMPLATED_EMAIL_ACTION_TYPE));
const $b05197d75836b426$export$43c5d03a3885883b = (rules)=>rules.some((rule)=>$b05197d75836b426$var$isRule(rule) && $b05197d75836b426$var$triggersOnReadyForReview(rule) && $b05197d75836b426$var$hasComponentOfType(rule, $b05197d75836b426$var$INVOKE_AGENT_ACTION_TYPE));






var $kSwu1 = parcelRequire("kSwu1");


var $hMcNB = parcelRequire("hMcNB");


var $hdBxM = parcelRequire("hdBxM");


var $6iWVH = parcelRequire("6iWVH");





var $6mKj3 = parcelRequire("6mKj3");


var $5v7QA = parcelRequire("5v7QA");


var $hTxAd = parcelRequire("hTxAd");


var $7IVHS = parcelRequire("7IVHS");

const $af67c5ecccab3dfa$export$11ac115c001a028b = 'automation-discovery-content-reviewer-nudge';
const $af67c5ecccab3dfa$var$ROVO_CHAT_SOURCE = $af67c5ecccab3dfa$export$11ac115c001a028b;
const $af67c5ecccab3dfa$var$DYNAMIC_CONFIG_CONFIG_KEY = 'confluence-content-reviewer-discovery-prompt';
const $af67c5ecccab3dfa$var$DEFAULT_CONTENT_REVIEWER_PROMPT = `/build-automation

#### Trigger: \`PageStatusChangedTrigger\`
- Run whenever a Confluence page's status changes in the target Confluence space.
- Take the space from the context this chat is running in, namely the page or space the Rovo chat was opened from. It is always available there, so resolve it from that context and never stop to ask which space to use.
- Pass \`space\` as \`type: ARI\` when a Confluence space ARI is available (\`ari:cloud:confluence:<cloudId>:space/<spaceId>\`), otherwise as \`type: ID\` with the numeric space id. Both identify a space uniquely, and one of them is almost always available from the context.
- Treat \`type: NAME\` as a last resort, because space names are not unique and two spaces can share one.
- Never pass \`type: KEY\`, and never use the segment after \`/spaces/\` in a page URL as any kind of identifier. That segment is a URL alias rather than the space key, a KEY is looked up strictly as a key with no fallback, and passing the alias fails validation with \`TRANSFORMATION_FAILED\`. Searching for the alias does not work either: space search is semantic, and an opaque alias matches nothing.
- Scope the trigger to the single status \`Ready for review\`, so it fires on nothing else. The status must already be configured in that space, since content statuses are space-specific.
- Put the status filter on the trigger itself; do not add a separate condition after it.

#### Action 1: \`InvokeAgentAction\`
- **Agent:** Content Reviewer
- Adds the suggestions and writes the email body in one step.
- The agent emits progress narration ahead of its reply, such as \`Reviewing page...Preparing suggestions...Finalising suggestions...\`. That text is plain, never contains HTML tags, and always precedes the reply, so Action 2 strips it by cutting at the first \`<p>\`. The prompt below therefore requires the email to begin with \`<p>Hi\`.
- **Prompt:**

\`\`\`\`text
You review a Confluence page that has just been marked ready for review, add suggestions to it, then write a short HTML email about it.

Act immediately. Never ask questions, offer options, or explain what you'll do.

Recipient name (the person who moved the page to ready for review): {{page.editor.publicName}}

Page title: {{page.title}}

Page URL: {{page.url}}

PERMITTED ACTIONS

Fetch the page from the URL above, analyse it, and use your "Add suggestions to content" skill to add suggestions to it. That skill is the only write you may make, anywhere: never create, publish, move, archive, rename or delete anything, never change the page's status or labels, never rewrite the body yourself, and never accept your own suggestions, which are proposals for a human to act on.

Run the skill once. If it fails or adds nothing, write the email anyway, omitting the count sentence. Do not retry it, reword your suggestions to force a result, or fall back to editing the page or commenting on it.

Look nothing else up. The page is all you need.

THE LINK

The email needs a link that opens the page where your suggestions are visible, not a read-only view that hides them. The content you fetched tells you what kind of page it is, and different kinds are edited in different ways, so work the URL out yourself. Link only to this page and never invent a URL.

THE EMAIL

You are the recipient's review assistant, handing their draft back. Write in the first person about what you did, then point them at the page. The suggestions themselves live on the page: summarise their overall shape, but never reproduce individual suggestions, quote the wording you proposed, or list them one by one.

Never judge the writing. Do not say the draft is good, weak, nearly there or needs work, and never grade or score it. Describing what your suggestions focus on is fine; passing verdict on the author is not.

Write to the recipient alone. They moved the page to ready for review but may not have written it, so never name anyone else and never address a group.

Tone: warm, direct, plain, using contractions, no corporate filler. Never congratulate. Aim for 90 words and never exceed 130. No next steps, deadlines or offers of further help.

Reproduce the page title exactly wherever you use it; never paraphrase, shorten or reshape it.

STRUCTURE

Write these paragraphs in order, using only p, a and em tags. No lists, headings, other tags, inline CSS, markdown or code fences.

1. The greeting, alone in its paragraph: "Hi", a space, the recipient's first name, then a comma. The first name is the first word of the recipient name above. If that name is empty, write exactly <p>Hi,</p>

2. Two sentences. First: "Your draft of " then the exact page title then " is ready for you." Second: "As your review assistant, I went ahead and left " then the number of suggestions then " inline suggestions for " then the areas they cover, as two or three plain nouns joined naturally, for example flow, clarity and formatting. Take the number from the skill's own result and never estimate it. Take the areas from the suggestions you actually made rather than from that example, and never pad the list to three.

3. One or two sentences, 40 words at most, summarising what the suggestions add up to across the page as a whole: the recurring themes, and the sections most affected if a few stand out. Stay at the level of patterns. Never walk through suggestions individually, never quote replacement text, and never number them.

4. A single anchor, href set to the link described above and text "Review suggestions". It is the only link and the only call to action.

5. <em>Automated review by Content Reviewer Agent</em>

When the skill added exactly one suggestion, write paragraph 2 in the singular. When it reported no usable count, drop the number and write "some inline suggestions", keeping the rest of the sentence as it is. When it added nothing at all, replace paragraphs 2 and 3 with a single sentence saying the draft is ready for them and you found nothing to suggest, then continue with paragraphs 4 and 5 unchanged.

OUTPUT

The email must begin with the literal characters <p>Hi and end with the closing tag of paragraph 5. A later step finds the email by cutting your reply at its first <p>, so no HTML tag of any kind may appear before the greeting.

Write no commentary after the email: no summary of what you did, no description of the suggestions, no sign-off of your own.
\`\`\`\`

#### Action 2: \`SendTemplatedEmailAction\`
- Sends the email with bodyType=HTML.
- **To:** {{page.editor.emailAddress}} \u{2014} the person who moved the page to ready for review, only
- **Subject:** Ready for review: {{page.title}}
- **Body:** \`<p>{{agentResponse.asString().substringAfter("<p>")}}\`
- Use that body exactly as written, ending with the closing brace. It is deliberately an unclosed \`<p>\`, so do not add a closing \`</p>\` to balance it: the agent's reply already closes every paragraph it opens, and a closing tag here lands after the final paragraph as a stray orphan.
- The expression drops the agent's progress narration by keeping only what follows the first \`<p>\`, then restores that opening tag. The narration is plain text and contains no tags, so the whole email survives intact.

#### Output
- One flat sequence: trigger, Action 1, Action 2. No nesting, branches or conditions.
- Create every component fully configured, with nothing left to add by hand in the flow editor.
`;
const $af67c5ecccab3dfa$var$CONTENT_REVIEWER_PROMPT_CONFIG = {
    configKey: $af67c5ecccab3dfa$var$DYNAMIC_CONFIG_CONFIG_KEY,
    fallback: $af67c5ecccab3dfa$var$DEFAULT_CONTENT_REVIEWER_PROMPT
};
const $af67c5ecccab3dfa$export$2821fd2708ed8940 = (isEnabled)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publishRovoChat = (0, $hdBxM.usePublish)('ai-mate');
    const handleLocalStorageUpdate = (0, $cozmU.useCallback)(()=>{
        (0, $hTxAd.markDiscoveryExperienceAsSeen)((0, $1UApO.keys).AUTOMATION_DISCOVER_CONTENT_REVIEWER);
    }, []);
    return (0, $cozmU.useMemo)(()=>isEnabled && (0, $6mKj3.expVal)('confluence-automations-content-reviewer-nudge', 'isEnabled', false) ? {
            id: $af67c5ecccab3dfa$export$11ac115c001a028b,
            title: formatMessage((0, $5v7QA.contentReviewerNudgeI18n).title),
            secondaryTitle: formatMessage((0, $5v7QA.contentReviewerNudgeI18n).secondaryTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
                    size: "small",
                    label: formatMessage((0, $5v7QA.contentReviewerNudgeI18n).iconLabel)
                }),
            handleType: (0, $6iWVH.HandleActionType).Skill,
            type: 'skill-action',
            onClick: ()=>{
                publishRovoChat({
                    type: 'chat-new',
                    source: $af67c5ecccab3dfa$var$ROVO_CHAT_SOURCE,
                    openChat: true,
                    openChatMode: 'sidebar',
                    data: {
                        dialogues: [],
                        prompt: (0, $7IVHS.resolveDynamicConfigStringValue)($af67c5ecccab3dfa$var$CONTENT_REVIEWER_PROMPT_CONFIG),
                        placeholderType: 'skill',
                        resultAttributionContext: {
                            launchSource: $af67c5ecccab3dfa$var$ROVO_CHAT_SOURCE
                        }
                    }
                });
            },
            nudgeContext: {
                id: $af67c5ecccab3dfa$export$11ac115c001a028b,
                selfEligible: true,
                onAccept: handleLocalStorageUpdate,
                onDismiss: (reason)=>{
                    if (reason?.dismissedMethod === 'manual') handleLocalStorageUpdate();
                }
            }
        } : null, [
        formatMessage,
        handleLocalStorageUpdate,
        publishRovoChat,
        isEnabled
    ]);
};















var $kDhla = parcelRequire("kDhla");




const $e1303b52b0ab60dc$export$24bc364b8af91e6f = ()=>{
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const [documentSnapshot, setDocumentSnapshot] = (0, $cozmU.useState)(null);
    const captureSnapshot = (0, $cozmU.useCallback)(()=>{
        fullPageEditorPresetAPI?.core?.actions.requestDocument((doc)=>{
            if (doc) setDocumentSnapshot(doc);
        }, {
            alwaysFire: (0, $9wGTI.fg)('cc_automations_nudge_actions_error_boundary')
        });
    }, [
        fullPageEditorPresetAPI
    ]);
    return [
        documentSnapshot,
        captureSnapshot
    ];
};


const $7368a45ebdde8034$var$MAX_NODES = 50000;
const $7368a45ebdde8034$var$countWordsInText = (text)=>text?.match(/\S+/g)?.length ?? 0;
const $7368a45ebdde8034$export$2069d83620194dba = (doc)=>{
    if (!doc) return 0;
    let wordCount = 0;
    let nodeCount = 0;
    const visit = (node)=>{
        nodeCount += 1;
        if (nodeCount > $7368a45ebdde8034$var$MAX_NODES) return;
        if (node.type === 'expand' || node.type === 'nestedExpand') return;
        if (node.type === 'text') wordCount += $7368a45ebdde8034$var$countWordsInText(node.text);
        const children = node.content;
        if (children) for (const child of children){
            if (nodeCount > $7368a45ebdde8034$var$MAX_NODES) break;
            if (child) // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- single pre-order DFS; each ADF node is visited exactly once (O(total nodes)), not quadratic
            visit(child);
        }
    };
    visit(doc);
    return wordCount;
};

















const $d58deec0f5f8c3d0$export$4ce9149b14868c81 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const hasUserSeenNudge = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_CONTENT_REVIEWER);
    return !hasUserSeenNudge && isRovoLLMEnabled && isAIEarlyAccessEnabled && isAdminHubAIEnabled && (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE);
};


const $140fd2278e447c47$var$TRIGGERING_CONTENT_STATE_NAME = 'Ready for review';
// The page must have at least this many words to be a meaningful review target.
const $140fd2278e447c47$var$MIN_WORD_COUNT = 500;
const $140fd2278e447c47$export$bae9d6abac858b24 = ({ content: content })=>{
    const isEligible = (0, $d58deec0f5f8c3d0$export$4ce9149b14868c81)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const initialContentStateNameRef = (0, $cozmU.useRef)(undefined);
    const [editorDocumentSnapshot, captureEditorDocumentSnapshot] = (0, $e1303b52b0ab60dc$export$24bc364b8af91e6f)();
    const currentContentStateName = content?.contentState?.name ?? null;
    const initialContentStateName = initialContentStateNameRef.current;
    (0, $cozmU.useEffect)(()=>{
        if (initialContentStateNameRef.current === undefined && content != null) initialContentStateNameRef.current = currentContentStateName;
    }, [
        currentContentStateName,
        content
    ]);
    const localizedTriggeringStateName = formatMessage((0, $5v7QA.contentReviewerNudgeI18n).readyForReviewState);
    const matchesTriggeringState = (value)=>value === $140fd2278e447c47$var$TRIGGERING_CONTENT_STATE_NAME || value === localizedTriggeringStateName;
    const hasTransitionedToTriggeringState = initialContentStateName !== undefined && !matchesTriggeringState(initialContentStateName) && matchesTriggeringState(currentContentStateName);
    // Capture the document only once the page becomes a review candidate (eligible + transitioned to
    // the triggering state), so we evaluate the word-count gate against the content at that moment.
    const shouldCaptureDocument = isEligible && hasTransitionedToTriggeringState;
    (0, $cozmU.useEffect)(()=>{
        if (shouldCaptureDocument) captureEditorDocumentSnapshot();
    }, [
        shouldCaptureDocument,
        captureEditorDocumentSnapshot
    ]);
    const wordCount = (0, $cozmU.useMemo)(()=>editorDocumentSnapshot ? (0, $7368a45ebdde8034$export$2069d83620194dba)(editorDocumentSnapshot) : null, [
        editorDocumentSnapshot
    ]);
    const hasEnoughWords = wordCount !== null && wordCount >= $140fd2278e447c47$var$MIN_WORD_COUNT;
    return isEligible && hasTransitionedToTriggeringState && hasEnoughWords;
};


















var $kv1hV = parcelRequire("kv1hV");


// A page must have at least this many words to be a meaningful review target.
const $4210ccd982a80d4f$var$MIN_WORD_COUNT = 500;
// A well-structured page has roughly one heading per this many words. A page with fewer headings
// than that ratio implies is considered to have "low heading density".
const $4210ccd982a80d4f$var$WORDS_PER_HEADING = 300;
// A single plain-text paragraph with at least this many words is considered a "dense" block that
// would benefit from being broken up.
const $4210ccd982a80d4f$var$DENSE_PARAGRAPH_MIN_WORDS = 150;
const $4210ccd982a80d4f$var$MAX_NODES = 50000;
const $4210ccd982a80d4f$var$countWordsInText = (text)=>text?.match(/\S+/g)?.length ?? 0;
const $4210ccd982a80d4f$export$8746d5f8bfda931c = (doc)=>{
    if (!doc) return false;
    const wordCount = (0, $7368a45ebdde8034$export$2069d83620194dba)(doc);
    if (wordCount < $4210ccd982a80d4f$var$MIN_WORD_COUNT) return false;
    let headingCount = 0;
    let hasDenseParagraph = false;
    let nodeCount = 0;
    const visit = (node)=>{
        nodeCount += 1;
        if (nodeCount > $4210ccd982a80d4f$var$MAX_NODES) return;
        // Ignore collapsed content so structure is measured on the same basis as the word count.
        if (node.type === 'expand' || node.type === 'nestedExpand') return;
        if (node.type === 'heading') headingCount += 1;
        if (node.type === 'paragraph') {
            const children = node.content;
            const isPlainTextOnly = !!children && children.length > 0 && children.every((child)=>child?.type === 'text');
            if (isPlainTextOnly) {
                const paragraphWordCount = children.reduce((total, child)=>total + $4210ccd982a80d4f$var$countWordsInText(child?.text), 0);
                if (paragraphWordCount >= $4210ccd982a80d4f$var$DENSE_PARAGRAPH_MIN_WORDS) hasDenseParagraph = true;
            }
            // A paragraph only holds inline content, so there is nothing structural to recurse into.
            return;
        }
        const children = node.content;
        if (children) for (const child of children){
            if (nodeCount > $4210ccd982a80d4f$var$MAX_NODES) break;
            if (child) // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- single pre-order DFS; each ADF node is visited exactly once (O(total nodes)), not quadratic
            visit(child);
        }
    };
    visit(doc);
    const hasLowHeadingDensity = headingCount < wordCount / $4210ccd982a80d4f$var$WORDS_PER_HEADING;
    return hasLowHeadingDensity || hasDenseParagraph;
};


const $a4dd19d86c9be313$export$74fa9b01e1f418fd = (contentId)=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const hasDismissedNudge = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_CONTENT_REVIEWER);
    const hasPageJustPublishedSignalForThisContent = Boolean(contentId) && (0, $kv1hV.pageJustPublishedSignal).contentId === contentId;
    return Boolean(isRovoLLMEnabled && isAIEarlyAccessEnabled && isAdminHubAIEnabled && pageMode === (0, $cD1qu.PageMode).VIEW && !hasDismissedNudge && hasPageJustPublishedSignalForThisContent && (0, $4210ccd982a80d4f$export$8746d5f8bfda931c)((0, $kv1hV.pageJustPublishedSignal).adf));
};


const $70bf4384341b00a6$export$616a7f72e384ce8e = ({ content: content, contentId: contentId })=>{
    const matchesCriteria = (0, $140fd2278e447c47$export$bae9d6abac858b24)({
        content: content
    });
    const hasOnPublishSignal = (0, $a4dd19d86c9be313$export$74fa9b01e1f418fd)(contentId);
    const isCandidate = matchesCriteria || hasOnPublishSignal;
    const { rules: rules, isLoading: isLoading, error: error } = (0, $6ae174e9ec58ddf7$export$8f3f951eb67a9ea8)({
        skip: !isCandidate || !(0, $9wGTI.fg)('automations-integration-to-rovo-button-nudges')
    });
    const hasCreatedContentReviewerAutomation = (0, $b05197d75836b426$export$43c5d03a3885883b)(rules);
    // Fail closed: only surface the nudge once we've confirmed it is relevant — i.e. the rules have
    // loaded without error and the user does not already have a matching automation. If the fetch is
    // in flight or errors we can't confirm relevance, so we withhold (and, since `isEnabled` is then
    // false, avoid exposing the experiment) rather than risk nudging someone who already automated.
    return (0, $af67c5ecccab3dfa$export$2821fd2708ed8940)(isCandidate && !isLoading && !error && !hasCreatedContentReviewerAutomation);
};















var $9DHhW = parcelRequire("9DHhW");














var $cLo2u = parcelRequire("cLo2u");





var $d0Ide = parcelRequire("d0Ide");







const $eb88b9929cdd6620$var$DEFAULT_MEETING_NOTES_PROMPT = `/build-automation

#### Trigger: \`PagePublishedTrigger\`
- Run whenever a Confluence page is published in the target Confluence space.
- Take the space from the context this chat is running in, namely the page or space the Rovo chat was opened from. It is always available there, so resolve it from that context and never stop to ask which space to use.
- Pass \`space\` as \`type: ARI\` when a Confluence space ARI is available (\`ari:cloud:confluence:<cloudId>:space/<spaceId>\`), otherwise as \`type: ID\` with the numeric space id. Both identify a space uniquely, and one of them is almost always available from the context.
- Treat \`type: NAME\` as a last resort, because space names are not unique and two spaces can share one.
- Never pass \`type: KEY\`, and never use the segment after \`/spaces/\` in a page URL as any kind of identifier. That segment is a URL alias rather than the space key, a KEY is looked up strictly as a key with no fallback, and passing the alias fails validation with \`TRANSFORMATION_FAILED\`. Searching for the alias does not work either: space search is semantic, and an opaque alias matches nothing.

#### Condition 1: Smart values condition
- Add one smart values condition comparing \`{{page.title}}\` against regex \`(?i)\\b(notes?|syncs?|meetings?|1:1s?)\\b\`. Match the title only: do not compare the page body.
- The regex matches any one of note, sync, meeting or 1:1, singular or plural, in any case. One condition only: do not turn the alternatives into separate conditions and do not use an if/else block, because there is no OR and no branch to build.
- The rule stops when the comparison does not match. This is the cheap pre-filter, so Condition 2 only ever runs on candidate pages.

#### Condition 2: Rovo AI relevance check
- Use a \`GenerateResponseAction\`-style Rovo AI condition to classify whether the page title and content relate to meeting notes (prompt returns YES or NO).
- Smart values condition \u{2014} continues the flow only when the AI classification contains "YES".
- Add the generate-response step and the check on its result as two flat steps after Condition 1. Do not nest either one inside the other and do not wrap them in an if/else block.

#### Action 1: \`InvokeAgentAction\`
- **Agent:** Meeting insights reporter
- **Prompt:**

\`\`\`\`text
You are the Meeting Notes Action agent. Write the email body sent to the person who published meeting notes in Confluence.

Write immediately, every time. Never ask questions, offer options, acknowledge input, or explain what you'll do. Your entire response is the HTML email, with no preamble or closing remarks.

Recipient email: {{USER_EMAIL}}

Meeting notes page title: {{page.title}}

Meeting notes page URL: {{page.url}}

Meeting notes page content:

{{page.body.adf}}

PERMITTED ACTIONS

You are read-only. Your entire job is to return the HTML email as your response. You must never create, update, publish, move, delete or otherwise modify anything: no Confluence page, blog, comment or whiteboard, no Jira issue, no file, no record of any kind. Never call a tool that writes. Creating a page is never correct in this task, for any reason. In particular, never create, or attempt to create, a page, a draft or any other object as a way to trigger a search, surface context, test a tool or work around a search that returned nothing. If you find yourself about to write something in order to read something, stop: that is always wrong here.

You are allowed one read-only lookup, and only one, for a single purpose: finding out who the recipient email address belongs to, so you can greet them by first name. Nothing else may be looked up. Do not search the Teamwork Graph, Jira, Confluence or anywhere else for the meeting, its attendees, the action owners, related work, transcripts, projects, tickets or background of any kind. None of that is necessary and none of it belongs in this email: everything you need is in the page content below.

Make the recipient lookup once. If it returns nothing, returns something unusable, or returns more than one person, stop there. Do not retry it, do not reword the query, do not try a different tool, and do not look for the name by another route. Repeating a failed lookup is never correct. Use the fallback greeting and write the email as normal; a missing first name is not a reason to keep searching, to stall, or to skip the email.

CORE BEHAVIOR

Sparse or ambiguous notes: write the email anyway, covering what is supported and omitting sections lacking material. Thin input is never a reason to stop. Where information is missing or unclear, leave it out rather than guessing.

Address one person only, the person at the recipient email above, who published the notes. Write directly to them. Never address a group, thank attendees, or list participants.

Tone: you are their assistant handing back a recap. Warm, direct, specific, using contractions. Skip corporate filler. Never congratulate anyone or use words like valuable, insightful or exciting.

Keep the email succinct. Aim for 250 words or fewer; 500 is a hard ceiling. Recap the meeting itself, not the document: never refer to "the notes", "the page", "the entries", "the document" or "the thread" in your prose, and never describe what a section of the page contains. The one exception is the opening sentence below.

SOURCING

Treat page content as authoritative. Carry exact figures, dates, counts, percentages and amounts across, but do not stack several figures into one sentence; give dense material short sentences and split it across the two opening paragraphs.

The page title is the name of the notes only. Never paraphrase it into a claim about the meeting. Do not state or imply meeting cadence, series membership or subject. Weekly, bi-weekly, monthly, recurring, kickoff, retro, standup and 1:1, and any meeting type, may appear only if the page content states them. Meeting date comes from page content only. Write calendar dates as D MMM, for example 18 Sep, and use that format consistently. When the notes give a calendar date for a deadline anywhere, even alongside a relative phrase, use that date in D MMM form. When the notes give only a relative or vague deadline, such as tonight, Friday, this week or end of week, reproduce their wording exactly and never convert it into a calendar date, because you cannot know which date they meant. Give each deadline one form only: never write a relative phrase and a date together, as in "EOW (28 Aug)".

Recurring-meeting pages hold several meetings under separate dates or headings. Before writing anything, find the latest date on the page and locate the section under it. Every action, decision and open question in your email must come from text inside that section. Check each one against it before you include it. Treat everything else on the page as background you may not draw from, including earlier dated sections, standing agendas and undated lists. Pulling an action from an older section is the most common failure on these pages.

Apart from the single recipient lookup, work only from the page content given to you. Do not search for transcripts or related work, and do not try to enrich the notes from any other source. Never state anything unsupported by the page content. Never invent details, owners, dates or URLs.

STRUCTURE

Open with exactly one paragraph holding the whole greeting: the word "Hi", a space, the recipient's first name alone, then a comma. Use the first name from the recipient lookup, and only a name that lookup actually returned. Never build a name out of the email address itself. If the lookup gave you no usable name, the paragraph is exactly <p>Hi,</p>. Never use the full name or a surname, never take a name from the page content, and never split the greeting across two paragraphs.

Then a paragraph beginning "Your ", the meeting date, then the meeting type when the page content states one, then " notes are published." Follow it with one sentence giving the meeting's purpose or focus. Use the date of the meeting itself. When the notes do not state one, write "Your notes are published." with no date rather than borrowing a deadline or event date from elsewhere on the page.

Then a paragraph of one sentence giving the primary outcome.

Actions paragraph: the word "Actions" in strong, followed by a bulleted list, one action per item. Include every task the most recent section records as work still to be done.

You do not know which of the named people is the recipient, so never single one out and never write "Your action:". Every task is listed the same way, under its own owner. Order actions by deadline, earliest first, with undated ones last. Write each as the owner's name in strong, then a colon, then the verb-led task, then " Due " and the date when stated. Wrap the owner's name in its own strong element and the deadline date in its own strong element, in every item. When several people share one task, join their names with "and" in a single strong element. When the notes name nobody, begin with the verb-led task and append " (no owner recorded)". Never use a placeholder name.

Start every task with a verb. Work the notes record as already finished, scheduled or sent is not an action, and a date on a completed event is not a deadline. A question nobody agreed to act on belongs under Open question, not here. If the most recent section records no outstanding work, replace the list with a single paragraph saying so.

Decisions paragraph: the word "Decisions" in strong, followed by a bulleted list. Write each as one plain past-tense sentence stating what was settled and, where the notes give it, why. Do not open items with a bolded label. Never use vague verbs like discussed, covered, looked at or talked about: if that is all the notes support, it was not a decision.

A decision is a settled choice about what will happen or how something will work. The notes need not contain the word agreed or decided: a plain declarative statement of what will be done, a priority assigned, an option chosen, a date fixed or an approval given all count. Figures, performance results, observations, status updates and anything the notes label proposed, suggested, draft, an option under consideration, an idea or still to be confirmed are not decisions.

State each decision with the same force the notes give it and no more. Do not turn a positive reaction into an approval or sign-off, or a target into something set or locked in. Keep each item traceable to one bullet or line: never fold two bullets into one sentence or pull clauses from different bullets. Sub-bullets are separate points, not qualifiers for their parents. Combine points only where the notes state the connection in words. Omit this paragraph and list when the notes settled nothing.

Open question: a paragraph containing only the words "Open question" wrapped in strong, then a separate paragraph containing one unresolved question from the notes, written as a complete question ending in a question mark, followed by who is following up and how when the notes say so. Keep the label and the question in separate paragraphs. Omit when the notes record no open question.

Then, when the notes state a date for the next meeting or review, a paragraph reading "Next review: " and that date.

Close with a single paragraph containing one anchor whose href is the page URL and whose text is "View full notes". This is the only call to action in the email.

Finish with a paragraph wholly wrapped in em reading "Generated via Meeting Notes Action agent."

LINKS

Do not include a resources section and do not list links for reference. Include a link inline only when it is required to complete the recipient's action, time-sensitive, or blocking, using an anchor with a descriptive label and the exact absolute URL from the notes. Add no other links, and never invent a URL. The View full notes anchor is the only other link permitted.

HTML ONLY

Use only these tags: p, ul, ol, li, a, strong, em. No heading tags. No html, head, body or style tags. No inline CSS. No markdown or code fences.

Output HTML only, starting with the greeting. No preamble, questions, options or closing remarks.
\`\`\`\`

#### Action 2: \`SendTemplatedEmailAction\`
- Automation sends the generated email with bodyType=HTML.
- **To:** {{USER_EMAIL}} \u{2014} current/publishing user only
- **Subject:** Meeting notes: {{page.title}}
- **Body:** {{agentResponse}}

#### Output
- Build the rule as one flat sequence, in this order: trigger, Condition 1, Condition 2, Action 1, Action 2. Nothing is nested inside anything else and there are no branches.
- Create every component fully configured. Do not create a partial flow, and do not leave a condition or either action to be added by hand in the flow editor.
`;
const $eb88b9929cdd6620$export$460835d3745cc1e6 = {
    configKey: 'confluence-meeting-notes-discovery-prompt',
    fallback: $eb88b9929cdd6620$var$DEFAULT_MEETING_NOTES_PROMPT,
    variables: [
        'USER_EMAIL'
    ]
};


const $f240c166d591ee22$export$aa64575f454dbbcf = 'automation-discovery-meeting-notes-nudge';
const $f240c166d591ee22$var$ROVO_CHAT_SOURCE = $f240c166d591ee22$export$aa64575f454dbbcf;
const $f240c166d591ee22$export$c9e0cc69e3e070a6 = ({ isEnabled: isEnabled, user: user })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publishRovoChat = (0, $hdBxM.usePublish)('ai-mate');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const spaceKey = (0, $cLo2u.useSpaceKey)() ?? undefined;
    (0, $cozmU.useEffect)(()=>{
        if (isEnabled) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: (0, $d0Ide.EventSourceName).MEETING_NOTES,
                source: (0, $d0Ide.EventSourceName).MEETING_NOTES
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isEnabled
    ]);
    const emails = user?.emails;
    const userEmail = (0, $cozmU.useMemo)(()=>{
        const candidates = emails?.filter((email)=>Boolean(email?.value)) ?? [];
        return candidates.find((email)=>email?.isPrimary)?.value ?? candidates[0]?.value ?? null;
    }, [
        emails
    ]);
    const handleLocalStorageUpdate = (0, $cozmU.useCallback)(()=>{
        (0, $hTxAd.markDiscoveryExperienceAsSeen)((0, $1UApO.keys).AUTOMATION_DISCOVER_MEETING_NOTES_TEMPLATE);
    }, []);
    return (0, $cozmU.useMemo)(()=>isEnabled ? {
            id: $f240c166d591ee22$export$aa64575f454dbbcf,
            title: formatMessage((0, $5v7QA.meetingNotesNudgeI18n).title),
            secondaryTitle: formatMessage((0, $5v7QA.meetingNotesNudgeI18n).secondaryTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
                    size: "small",
                    label: formatMessage((0, $5v7QA.meetingNotesNudgeI18n).iconLabel)
                }),
            handleType: (0, $6iWVH.HandleActionType).Skill,
            type: 'skill-action',
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'automationDiscoveryWhenPublishingMeetingNotesProceed',
                        source: (0, $d0Ide.EventSourceName).MEETING_NOTES,
                        attributes: {
                            spaceKey: spaceKey,
                            template: 'scheduleRecurringPublishMeetingNotesPage'
                        }
                    }
                }).fire();
                publishRovoChat({
                    type: 'chat-new',
                    source: $f240c166d591ee22$var$ROVO_CHAT_SOURCE,
                    interactionSource: $f240c166d591ee22$var$ROVO_CHAT_SOURCE,
                    openChat: true,
                    openChatMode: 'sidebar',
                    data: {
                        dialogues: [],
                        prompt: (0, $7IVHS.resolvePromptTemplate)((0, $eb88b9929cdd6620$export$460835d3745cc1e6), {
                            USER_EMAIL: `${userEmail ?? null}`
                        }),
                        placeholderType: 'skill',
                        resultAttributionContext: {
                            launchSource: $f240c166d591ee22$var$ROVO_CHAT_SOURCE
                        }
                    }
                });
            },
            nudgeContext: {
                id: $f240c166d591ee22$export$aa64575f454dbbcf,
                selfEligible: true,
                onAccept: handleLocalStorageUpdate,
                onDismiss: (reason)=>{
                    if (reason?.dismissedMethod === 'manual') handleLocalStorageUpdate();
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'automationDiscoveryWhenPublishingMeetingNotesCancel',
                            source: (0, $d0Ide.EventSourceName).MEETING_NOTES,
                            attributes: {
                                spaceKey: spaceKey
                            }
                        }
                    }).fire();
                }
            }
        } : null, [
        formatMessage,
        handleLocalStorageUpdate,
        publishRovoChat,
        isEnabled,
        userEmail,
        createAnalyticsEvent,
        spaceKey
    ]);
};



var $euL71 = parcelRequire("euL71");























var $7cI9Q = parcelRequire("7cI9Q");

const $3f4852915e4f596a$export$b2de40c66456019c = (contentId)=>{
    const { edition: edition, isRovoLLMEnabled: isRovoLLMEnabled, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const hasDismissedNudge = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_MEETING_NOTES_TEMPLATE);
    const hasPageJustPublishedSignalForThisContent = Boolean(contentId) && (0, $kv1hV.pageJustPublishedSignal).contentId === contentId;
    return Boolean(hasPageJustPublishedSignalForThisContent && pageMode === (0, $cD1qu.PageMode).VIEW && !hasDismissedNudge && isRovoLLMEnabled && isAdminHubAIEnabled && (edition === (0, $euL71.ConfluenceEdition).STANDARD || edition === (0, $euL71.ConfluenceEdition).PREMIUM) && (0, $7cI9Q.matchesMeetingNotesSignal)({
        title: (0, $kv1hV.pageJustPublishedSignal).title,
        sourceTemplateEntityId: (0, $kv1hV.pageJustPublishedSignal).sourceTemplateEntityId ?? ''
    }).matches && (0, $6mKj3.expValEquals)('confluence-automation-meeting-notes', 'isEnabled', true));
};


const $063b348ef7b18c93$export$9890936e97386657 = ({ user: user, contentId: contentId })=>{
    const isCandidate = (0, $3f4852915e4f596a$export$b2de40c66456019c)(contentId);
    const { rules: rules, isLoading: isLoading, error: error } = (0, $6ae174e9ec58ddf7$export$8f3f951eb67a9ea8)({
        skip: !isCandidate || !(0, $9wGTI.fg)('automations-integration-to-rovo-button-nudges')
    });
    const hasCreatedMeetingNotesAutomation = (0, $b05197d75836b426$export$54e55f0a7b30024a)(rules);
    // Fail closed: withhold until the rules have loaded without error and confirm the user has no
    // matching automation, and until the user (the recap email recipient) has resolved.
    return (0, $f240c166d591ee22$export$c9e0cc69e3e070a6)({
        isEnabled: isCandidate && !isLoading && !error && !hasCreatedMeetingNotesAutomation && user != null,
        user: user
    });
};






















var $1xpoY = parcelRequire("1xpoY");
















const $4d932fb0466bb92f$var$MS_PER_DAY = 86400000;
/** A cadence needs at least this many consecutive dates on the same rhythm. */ const $4d932fb0466bb92f$var$MIN_CONSECUTIVE_DATES = 3;
/**
 * Inclusive gap windows (in days) for each cadence, kept tight around a true 7-,
 * 14-, ~30- and ~91-day rhythm to avoid false positives. A cadence needs two
 * back-to-back gaps in the same window, so the intentional spacing between
 * windows — and, because every window starts well above zero, any zero gap (a
 * duplicate date) — never reads as a cadence.
 */ const $4d932fb0466bb92f$var$CADENCE_WINDOWS = [
    {
        cadence: 'daily',
        minDays: 1,
        maxDays: 1
    },
    {
        cadence: 'weekly',
        minDays: 6,
        maxDays: 8
    },
    {
        cadence: 'biweekly',
        minDays: 13,
        maxDays: 15
    },
    {
        cadence: 'monthly',
        minDays: 28,
        maxDays: 32
    },
    {
        cadence: 'quarterly',
        minDays: 85,
        maxDays: 95
    }
];
const $4d932fb0466bb92f$var$toTimestamp = (date)=>{
    if (date instanceof Date) return date.getTime();
    if (typeof date === 'number') return date;
    return new Date(date).getTime();
};
const $4d932fb0466bb92f$var$daysBetween = (earlier, later)=>(later - earlier) / $4d932fb0466bb92f$var$MS_PER_DAY;
/** The cadence a gap of the given length (in days) matches, if any. */ const $4d932fb0466bb92f$var$cadenceForGap = (gapInDays)=>$4d932fb0466bb92f$var$CADENCE_WINDOWS.find(({ minDays: minDays, maxDays: maxDays })=>gapInDays >= minDays && gapInDays <= maxDays)?.cadence;
const $4d932fb0466bb92f$export$ab851cffe4f65379 = (dates)=>{
    const timestamps = [];
    for (const date of dates ?? []){
        const value = $4d932fb0466bb92f$var$toTimestamp(date);
        if (Number.isFinite(value)) timestamps.push(value);
    }
    timestamps.sort((a, b)=>a - b);
    let cadence;
    let datesInARow = 1;
    for(let index = 1; index < timestamps.length; index++){
        const previousDay = timestamps[index - 1];
        const currentDay = timestamps[index];
        const gapCadence = $4d932fb0466bb92f$var$cadenceForGap($4d932fb0466bb92f$var$daysBetween(previousDay, currentDay));
        if (gapCadence !== undefined && gapCadence === cadence) datesInARow += 1;
        else // The run resets: a broken gap starts over at 1, a new rhythm at 2.
        datesInARow = gapCadence === undefined ? 1 : 2;
        cadence = gapCadence;
        if (datesInARow >= $4d932fb0466bb92f$var$MIN_CONSECUTIVE_DATES) return cadence;
    }
    return undefined;
};


const $8a66e0cca9583743$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const $8a66e0cca9583743$var$BOUNDARY_START = '(?<![\\p{L}\\p{N}])';
const $8a66e0cca9583743$var$BOUNDARY_END = '(?![\\p{L}\\p{N}])';
const $8a66e0cca9583743$var$buildKeywordRegExp = (keyword)=>{
    const trimmed = keyword.trim();
    if (!trimmed) return null;
    const pattern = $8a66e0cca9583743$var$escapeRegExp(trimmed).replace(/\\?\s+/g, '\\s+');
    return new RegExp(`${$8a66e0cca9583743$var$BOUNDARY_START}${pattern}${$8a66e0cca9583743$var$BOUNDARY_END}`, 'iu');
};
const $8a66e0cca9583743$var$matchesKeyword = (text, keyword)=>{
    if (!text) return false;
    const regExp = $8a66e0cca9583743$var$buildKeywordRegExp(keyword);
    return regExp ? regExp.test(text) : false;
};
const $8a66e0cca9583743$export$a6743727bac81426 = (text, keywords)=>{
    if (!text || keywords.length === 0) return false;
    return keywords.some((keyword)=>$8a66e0cca9583743$var$matchesKeyword(text, keyword));
};


/**
 * Template ID fragments for Confluence status update templates.
 *
 */ const $88b3979ada4b7131$var$STATUS_UPDATE_TEMPLATE_KEY_FRAGMENTS = [
    'eow-status-report',
    'status-update'
];
const $88b3979ada4b7131$export$bc8ca4ebff481bd2 = (templateId)=>{
    if (!templateId) return false;
    const normalised = templateId.toLowerCase();
    return $88b3979ada4b7131$var$STATUS_UPDATE_TEMPLATE_KEY_FRAGMENTS.some((fragment)=>normalised.includes(fragment));
};


const $ba98b4ec79a0d394$export$2ee80a92fd5fb770 = Object.freeze([
    'status update',
    'status report',
    'project update',
    'progress update',
    'team update',
    'week in review',
    'weekly recap'
]);
const $ba98b4ec79a0d394$export$ca7e8c37959a2440 = Object.freeze([
    'status updates',
    'weekly updates',
    'monthly',
    'updates',
    'weekly recaps',
    'monthly recaps'
]);
const $ba98b4ec79a0d394$export$8f9dca962eeb5fbc = Object.freeze({
    daily: [
        'daily'
    ],
    weekly: [
        'weekly'
    ],
    biweekly: [
        'biweekly',
        'bi-weekly',
        'fortnightly'
    ],
    monthly: [
        'monthly'
    ],
    quarterly: [
        'quarterly'
    ]
});
const $ba98b4ec79a0d394$export$d36c074c5bf1162b = Object.freeze(Object.values($ba98b4ec79a0d394$export$8f9dca962eeb5fbc).flat());
const $ba98b4ec79a0d394$export$d25b81fa1817a53b = 'week';
const $ba98b4ec79a0d394$export$8a2675cee5b59a91 = Object.freeze([
    $ba98b4ec79a0d394$export$d25b81fa1817a53b,
    'end of week'
]);
const $ba98b4ec79a0d394$export$35278965681ce09e = Object.freeze([
    'update',
    'status',
    'recap',
    'report'
]);
const $ba98b4ec79a0d394$var$buildMonthEntries = ()=>{
    const long = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        timeZone: 'UTC'
    });
    const short = new Intl.DateTimeFormat('en-US', {
        month: 'short',
        timeZone: 'UTC'
    });
    const entries = [];
    for(let index = 0; index < 12; index++){
        const date = new Date(Date.UTC(2021, index, 1));
        entries.push({
            name: long.format(date),
            index: index
        });
        entries.push({
            name: short.format(date),
            index: index
        });
    }
    return entries;
};
const $ba98b4ec79a0d394$var$MONTH_ENTRIES = $ba98b4ec79a0d394$var$buildMonthEntries();
const $ba98b4ec79a0d394$export$90072b28f6344da9 = Object.freeze($ba98b4ec79a0d394$var$MONTH_ENTRIES.map((entry)=>entry.name));
const $ba98b4ec79a0d394$export$ac65c1d9a31bfa9d = new Map($ba98b4ec79a0d394$var$MONTH_ENTRIES.map((entry)=>[
        entry.name.toLowerCase(),
        entry.index
    ]));
const $ba98b4ec79a0d394$export$9a673300d96e605 = Object.freeze([
    ...$ba98b4ec79a0d394$export$d36c074c5bf1162b,
    ...$ba98b4ec79a0d394$export$8a2675cee5b59a91,
    ...$ba98b4ec79a0d394$export$90072b28f6344da9
]);


const $ee79dd299f11a151$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const $ee79dd299f11a151$var$BOUNDARY_START = '(?<![\\p{L}\\p{N}])';
const $ee79dd299f11a151$var$BOUNDARY_END = '(?![\\p{L}\\p{N}])';
const $ee79dd299f11a151$var$MS_PER_DAY = 86400000;
/**
 * Year assumed for title dates that omit one ("17/06", "Aug 11", "W24").
 */ const $ee79dd299f11a151$var$ASSUMED_YEAR = 2000;
const $ee79dd299f11a151$var$isValidMonthDay = (month, day)=>month >= 1 && month <= 12 && day >= 1 && day <= 31;
/** ISO date, e.g. "2026-08-12". */ const $ee79dd299f11a151$var$parseIso = (text)=>{
    const match = new RegExp(`${$ee79dd299f11a151$var$BOUNDARY_START}(\\d{4})-(\\d{2})-(\\d{2})${$ee79dd299f11a151$var$BOUNDARY_END}`, 'u').exec(text);
    if (!match) return undefined;
    const month = Number(match[2]);
    const day = Number(match[3]);
    return $ee79dd299f11a151$var$isValidMonthDay(month, day) ? Date.UTC(Number(match[1]), month - 1, day) : undefined;
};
/** Numeric slash date, e.g. "17/06", "08/12", "12/08/2026". Interpreted as day/month. */ const $ee79dd299f11a151$var$parseSlash = (text)=>{
    const match = new RegExp(`${$ee79dd299f11a151$var$BOUNDARY_START}(\\d{1,2})/(\\d{1,2})(?:/(\\d{2,4}))?${$ee79dd299f11a151$var$BOUNDARY_END}`, 'u').exec(text);
    if (!match) return undefined;
    const first = Number(match[1]);
    const second = Number(match[2]);
    // Day/month by default; only flip when the numbers make month/day unambiguous.
    let day = first;
    let month = second;
    if (first <= 12 && second > 12) {
        month = first;
        day = second;
    }
    if (!$ee79dd299f11a151$var$isValidMonthDay(month, day)) return undefined;
    let year = $ee79dd299f11a151$var$ASSUMED_YEAR;
    if (match[3] !== undefined) {
        const parsed = Number(match[3]);
        year = parsed < 100 ? 2000 + parsed : parsed;
    }
    return Date.UTC(year, month - 1, day);
};
/**
 * Week number, e.g. "W24" or "Week 24". Consecutive week numbers resolve exactly
 * seven days apart, which is all cadence detection needs.
 */ const $ee79dd299f11a151$var$parseWeek = (text)=>{
    const weekWord = $ee79dd299f11a151$var$escapeRegExp((0, $ba98b4ec79a0d394$export$d25b81fa1817a53b).trim());
    const patterns = [
        `${$ee79dd299f11a151$var$BOUNDARY_START}W(\\d{1,2})${$ee79dd299f11a151$var$BOUNDARY_END}`
    ];
    if (weekWord) patterns.push(`${$ee79dd299f11a151$var$BOUNDARY_START}${weekWord}\\s+(\\d{1,2})${$ee79dd299f11a151$var$BOUNDARY_END}`);
    for (const pattern of patterns){
        const match = new RegExp(pattern, 'iu').exec(text);
        if (match) {
            const week = Number(match[1]);
            if (week >= 1 && week <= 53) return Date.UTC($ee79dd299f11a151$var$ASSUMED_YEAR, 0, 1) + (week - 1) * 7 * $ee79dd299f11a151$var$MS_PER_DAY;
        }
    }
    return undefined;
};
/** Month name next to a day in either order, e.g. "Aug 11", "12 Aug", "Week of Aug 11". */ const $ee79dd299f11a151$var$parseMonthDay = (text)=>{
    const monthIndexByName = (0, $ba98b4ec79a0d394$export$ac65c1d9a31bfa9d);
    const monthNamePatterns = [];
    for (const name of monthIndexByName.keys()){
        const escaped = $ee79dd299f11a151$var$escapeRegExp(name);
        if (escaped.length > 0) monthNamePatterns.push(escaped);
    }
    const alternation = monthNamePatterns.join('|');
    if (!alternation) return undefined;
    const monthFirst = new RegExp(`${$ee79dd299f11a151$var$BOUNDARY_START}(${alternation})\\s+(\\d{1,2})${$ee79dd299f11a151$var$BOUNDARY_END}`, 'iu').exec(text);
    const dayFirst = monthFirst ? null : new RegExp(`${$ee79dd299f11a151$var$BOUNDARY_START}(\\d{1,2})\\s+(${alternation})${$ee79dd299f11a151$var$BOUNDARY_END}`, 'iu').exec(text);
    const match = monthFirst ?? dayFirst;
    if (!match) return undefined;
    const monthName = (monthFirst ? match[1] : match[2]).toLowerCase();
    const day = Number(monthFirst ? match[2] : match[1]);
    const monthIndex = monthIndexByName.get(monthName);
    if (monthIndex === undefined || day < 1 || day > 31) return undefined;
    return Date.UTC($ee79dd299f11a151$var$ASSUMED_YEAR, monthIndex, day);
};
const $ee79dd299f11a151$export$a62abe7e6e176c03 = (text)=>{
    if (!text) return undefined;
    return $ee79dd299f11a151$var$parseIso(text) ?? $ee79dd299f11a151$var$parseSlash(text) ?? $ee79dd299f11a151$var$parseWeek(text) ?? $ee79dd299f11a151$var$parseMonthDay(text);
};



/**
 * A recurring status-update title pairs a recurrence indicator (a cadence word,
 * "weekly", "monthly", "quarterly", "yearly") with an update word ("update",
 * "status", "recap", "report") — e.g. "Aug update", "weekly report".
 */ const $47817d5b3794d616$var$isRecurringUpdateTitle = (title)=>(0, $8a66e0cca9583743$export$a6743727bac81426)(title, (0, $ba98b4ec79a0d394$export$9a673300d96e605)) && (0, $8a66e0cca9583743$export$a6743727bac81426)(title, (0, $ba98b4ec79a0d394$export$35278965681ce09e));
/**
 * Signals a recurring status-update series from a set of children.
 * A child only counts when its title uses an update word ("update", "status",
 * "recap", "report")
 */ const $47817d5b3794d616$var$doesChildrenLookLikeSeries = (children)=>{
    if (!children || children.length === 0) return false;
    // Only consider children with an update-related keyword in their title.
    const statusUpdateRelatedKeywords = (0, $ba98b4ec79a0d394$export$35278965681ce09e);
    const childrenWithUpdateRelatedKeyword = children.filter((child)=>(0, $8a66e0cca9583743$export$a6743727bac81426)(child.title, statusUpdateRelatedKeywords));
    if (childrenWithUpdateRelatedKeyword.length === 0) return false;
    const titleDates = [];
    const creationDates = [];
    for (const child of childrenWithUpdateRelatedKeyword){
        creationDates.push(child.createdAt);
        const titleDate = (0, $ee79dd299f11a151$export$a62abe7e6e176c03)(child.title);
        if (titleDate !== undefined) titleDates.push(titleDate);
    }
    return Boolean((0, $4d932fb0466bb92f$export$ab851cffe4f65379)(creationDates)) || Boolean((0, $4d932fb0466bb92f$export$ab851cffe4f65379)(titleDates));
};
const $47817d5b3794d616$export$7c124a2235c0e7d1 = (input)=>{
    const { title: title, parentTitle: parentTitle } = input;
    const matchedTitle = (0, $8a66e0cca9583743$export$a6743727bac81426)(title, (0, $ba98b4ec79a0d394$export$2ee80a92fd5fb770)) || $47817d5b3794d616$var$isRecurringUpdateTitle(title);
    const matchedChildren = $47817d5b3794d616$var$doesChildrenLookLikeSeries(input.children);
    const matchedTemplate = (0, $88b3979ada4b7131$export$bc8ca4ebff481bd2)(input.templateId);
    const matchedParentTitle = (0, $8a66e0cca9583743$export$a6743727bac81426)(parentTitle, (0, $ba98b4ec79a0d394$export$ca7e8c37959a2440));
    return {
        matches: matchedTitle || matchedChildren || matchedTemplate || matchedParentTitle,
        matchedTitle: matchedTitle,
        matchedChildren: matchedChildren,
        matchedTemplate: matchedTemplate,
        matchedParentTitle: matchedParentTitle
    };
};





/**
 * Order in which cadences are tested. More specific cadences are checked
 * first so that overlapping text resolves deterministically.
 */ const $4b0b7f83b74c9d28$var$CADENCE_PRECEDENCE = [
    'quarterly',
    'monthly',
    'biweekly',
    'weekly',
    'daily'
];
const $4b0b7f83b74c9d28$export$485e4010a68f9292 = (text)=>{
    if (!text) return undefined;
    for (const cadence of $4b0b7f83b74c9d28$var$CADENCE_PRECEDENCE){
        if ((0, $8a66e0cca9583743$export$a6743727bac81426)(text, (0, $ba98b4ec79a0d394$export$8f9dca962eeb5fbc)[cadence])) return cadence;
    }
    return undefined;
};





const $3929127c2007f269$export$91b745d209412614 = 'weekly';
/**
 * Detects the cadence of a status-update series from its children by looking at
 * the rhythm of their dates. Only children whose title carries an update word
 * ("update", "status", "recap", "report") are considered, mirroring
 * `getStatusUpdateSignalMatch`. Title dates are preferred over creation dates
 * because an author-controlled title date ("Update 17/06") is a stronger cadence
 * signal than when the page happened to be created.
 */ const $3929127c2007f269$var$detectChildrenCadence = (children)=>{
    if (!children || children.length === 0) return undefined;
    const statusUpdateKeywords = (0, $ba98b4ec79a0d394$export$35278965681ce09e);
    const relevantChildren = children.filter((child)=>(0, $8a66e0cca9583743$export$a6743727bac81426)(child.title, statusUpdateKeywords));
    if (relevantChildren.length === 0) return undefined;
    const titleDates = [];
    const creationDates = [];
    for (const child of relevantChildren){
        creationDates.push(child.createdAt);
        const titleDate = (0, $ee79dd299f11a151$export$a62abe7e6e176c03)(child.title);
        if (titleDate !== undefined) titleDates.push(titleDate);
    }
    return (0, $4d932fb0466bb92f$export$ab851cffe4f65379)(titleDates) ?? (0, $4d932fb0466bb92f$export$ab851cffe4f65379)(creationDates);
};
const $3929127c2007f269$export$aaea763fe2a58871 = (input)=>{
    const { title: title, parentTitle: parentTitle, children: children } = input;
    const titleCadence = title ? (0, $4b0b7f83b74c9d28$export$485e4010a68f9292)(title) : undefined;
    if (titleCadence) return titleCadence;
    const childrenCadence = $3929127c2007f269$var$detectChildrenCadence(children);
    if (childrenCadence) return childrenCadence;
    const parentCadence = parentTitle ? (0, $4b0b7f83b74c9d28$export$485e4010a68f9292)(parentTitle) : undefined;
    if (parentCadence) return parentCadence;
    return $3929127c2007f269$export$91b745d209412614;
};


const $13bd41970a846636$export$d547eb960ffae1ac = ({ title: title, parentTitle: parentTitle, sourceTemplateEntityId: sourceTemplateEntityId, children: children })=>{
    return (0, $cozmU.useMemo)(()=>{
        const input = {
            title: title ?? undefined,
            parentTitle: parentTitle ?? null,
            templateId: sourceTemplateEntityId ?? null,
            children: children
        };
        return {
            ...(0, $47817d5b3794d616$export$7c124a2235c0e7d1)(input),
            cadence: (0, $3929127c2007f269$export$aaea763fe2a58871)(input)
        };
    }, [
        title,
        parentTitle,
        sourceTemplateEntityId,
        children
    ]);
};


const $743450a0eca9e493$var$STATUS_UPDATES_NUDGE_ID = 'automation-discovery-status-updates-nudge';
const $743450a0eca9e493$var$ROVO_CHAT_SOURCE = 'automation-discovery-status-updates-nudge';
const $743450a0eca9e493$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "automation-discovery.status-updates-automation-discovery-nudge-action.title",
        defaultMessage: "Automate this status update"
    },
    iconLabel: {
        id: "automation-discovery.status-updates-automation-discovery-nudge-action.icon-label",
        defaultMessage: "Automation icon"
    }
});
/**
 * Per-cadence copy used to shape the automation prompt so the generated report,
 * its lookback window and its schedule all match the detected cadence.
 */ const $743450a0eca9e493$var$CADENCE_PROMPT_CONFIG = {
    daily: {
        reportLabel: 'Daily',
        lookbackDays: 1,
        schedule: 'Run every weekday at 9am'
    },
    weekly: {
        reportLabel: 'Weekly',
        lookbackDays: 7,
        schedule: 'Run every Monday at 9am'
    },
    biweekly: {
        reportLabel: 'Biweekly',
        lookbackDays: 14,
        schedule: 'Run every second Monday at 9am'
    },
    monthly: {
        reportLabel: 'Monthly',
        lookbackDays: 30,
        schedule: 'Run on the 1st of every month at 9am'
    },
    quarterly: {
        reportLabel: 'Quarterly',
        lookbackDays: 90,
        schedule: 'Run on the 1st of every quarter at 9am'
    }
};
const $743450a0eca9e493$var$DEFAULT_STATUS_UPDATE_DISCOVERY_PROMPT = `/build-automation

### Trigger: Scheduled
- {{CADENCE_SCHEDULE}}
### Action: Send this prompt to the "Jira Work Agent"

\`\`\`\`text
# {{CADENCE_LABEL}} team and workstream report

Research the teams and workstreams connected to one seed user, publish a Confluence status page, then return an HTML email announcing it.

The seed user is a discovery seed, not the subject. Never put their name in the page title, headings, or executive summary. This is a scheduled run with no active Jira work item; never pass an identity ARI to **Get work item**.

**Reporting window:** the {{REPORT_LOOKBACK_DAYS}} days ending now. Compute both bounds in UTC and use the same pair everywhere.

**Empty results:** an empty or near-empty tool result is an answer, not a failure. Never repeat a call with the same arguments, and never chase the same object through a different tool. Record it as a coverage gap and move on. Research is never a reason to skip publishing.

## Stage 1 \u{2014} Inventory

Call each of these exactly once, with \`startTime\` and \`endTime\` set to the reporting window:

- **Get Work Summary For Given User in Twg** \u{2014} \`userId = {{SEED_USER_ARI}}\`
- **Get Ranked Work Summary for User** \u{2014} \`person = {{SEED_USER_ARI}}\`

Treat the first as the inventory and the second as the ranking. Inspect every facet, count, timestamp, status, URL, and pagination marker.

Classify each returned item:

**Strong** \u{2014} authored PR created or materially updated in window; Confluence page created in window; Loom created in window; Atlas project or goal returned directly.

**Conditional** \u{2014} contributed Confluence page (needs a native page read confirming relevance); assigned Jira issue (needs current activity or a linked strong artifact); reviewed PR (only to reinforce an anchor already established by strong evidence).

**Ineligible** \u{2014} anything outside the window, archived content, previously generated weekly reports, Automation test output, personal account requests, dependency-bot activity, mechanical notifications.

Record for each eligible item: exact URL or ARI, product, source host, timestamp, container, and candidate anchor.

Atlas projects arrive here already carrying state, start and due dates, last-updated time, update and watcher counts, and linked goals. That is reportable evidence on its own \u{2014} keep it, and do not treat a project as thin just because a later hydration call adds nothing.

## Stage 2 \u{2014} Anchors

Cluster eligible artifacts by workstream, not by product. Pick **at most 5** anchors, preferring: Atlas project or goal > Jira epic/initiative/parent > repository or service with authored PRs > current Confluence planning or decision page > named program with two independent current signals.

Each anchor needs either one strong artifact or two independent current signals joined by an exact key, URL, repository, project, or explicit link. Never anchor on an isolated review, comment, feature flag, or cleanup ticket when a stable parent exists.

## Stage 3 \u{2014} Owning teams

Call **Get user's teams** once with the seed user ARI. Membership is a candidate list only, never proof of ownership.

Discard teams whose name or description signals test data, generated data, scorecards, samples, or "ignore me". Discard any team you cannot connect to a selected anchor.

For **at most 3** survivors call **Get team information** with the exact team ARI, requesting members, active projects and spaces. A team is reportable only when its canonical metadata or explicit anchor ownership ties it to a selected anchor.

## Stage 4 \u{2014} Hydrate

Finish Stage 3 before you begin Stage 4. The rows below depend on identifiers that Stage 3 returns, and running them early is why a hydration call comes back empty.

Hydrate only what could change an anchor's status, ownership, progress, decisions, milestones, risks, dependencies, or confidence. Skip any row below whose artifact type did not appear in Stage 1 \u{2014} do not go looking for it.

| Anchor artifact | Tool and constraint |
| --- | --- |
| Jira issue or epic | **Get work item** with an exact key, ARI or URL from a verified result, read against the site that result came from. Plus **Get Work-Item Context in Teamwork Graph** for at most 2 central Jira anchors. **Get Related Repos for Work-Item in TwG** only if a Jira anchor still needs repository resolution. |
| Pull request or repo | Use the PR and repo metadata already returned by Stage 1. There is no provider-native PR-detail tool; do not invent one. |
| Confluence page | **Get page** with the exact numeric content ID, for at most 3 evidence pages. Verify title, author, created date, version, relevance. |
| Atlas project or goal | **Get project context**, but only with an ARI you have literally seen in an \`ari=\` field of a tool result \u{2014} in practice the \`active_projects\` entries returned by **Get team information** in Stage 3. A valid Atlas project ARI ends in a UUID, as in \`ari:cloud:townsquare:<cloudId>:project/f5138818-0875-42aa-a890-e79333564598\`. The \`ATLAS-nnnnn\` at the end of a project URL is a display key, not an ARI segment: never paste it into an ARI, and never assemble an ARI from a URL. No \`ari=\` field for a project means no call \u{2014} report it from its Stage 1 fields instead. |
| Loom | Use only videos returned in the window, and only when they explain a selected anchor. |

Never call **Get work item** for an identity ARI, for a key inferred from a PR title or branch name, or for a key whose Jira site is unknown. A failed cross-site read is a coverage gap \u{2014} do not retry elsewhere or substitute a similar key. An empty typed result is a coverage gap. Never use raw Teamwork Graph Cypher.

If contributor context is still missing, call **Get Ranked Collaboration Summary Between Users in Twg, V2** at most once, with the seed user, one already-verified collaborator, and the same window.

## Stage 5 \u{2014} Search fallback

If a selected anchor returned empty from Stage 4 and still lacks one named fact that would change the report, you **must** attempt exactly one **Search** call for it. Otherwise make no Search calls. Hard cap: 1 call for the whole run, and it belongs to report evidence only \u{2014} never spend it locating a destination, a parent, or a previous report.

The query must carry an exact full URL, repository name, canonical project name, exact Confluence title, or distinctive workstream name, plus the reporting dates. Never search a bare Jira key. Reject hits that match only on an acronym or keyword, and reject the parent page and any previously generated summary. Open an accepted hit with its product-native tool before using it. If Search also comes back empty, record a coverage gap and move on.

## Stage 6 \u{2014} Gate

Do not draft until all of these hold: every Stage 1 facet and pagination marker inspected; timestamps rechecked against the window; ineligible items removed; every anchor meets the evidence threshold; every reportable team has ownership evidence beyond membership; every Jira read used its source site; Confluence evidence pages read natively and none of them generated reports; Atlas ARIs copied not constructed; Search candidates hydrated or discarded; every claim, status, owner, milestone, decision, risk and URL traceable to a named source; coverage gaps stated honestly.

Resolve any check that fails by dropping the anchor or recording a coverage gap, never by making more tool calls. Then stop gathering and go to Stage 7.

## Report content

Every item must trace: eligible seed-user artifact \u{2192} selected anchor \u{2192} verified owning team. Once an anchor is selected, include material work by other contributors that advances it, but do not go mining their unrelated activity.

Build only the sections you have evidence for. Never invent metrics, owners, statuses, dates, relationships, or URLs, and never force an empty section.

Never emit a placeholder. No \`[Add Owner]\`, no \`TBD\`, no \`TODO\`, no square-bracketed prompt to fill something in later. A field you have a verified value for gets that value; a field you do not gets its line dropped entirely.

**Owners:** the owner or DRI of an Atlas project is in that project's \`Get project context\` result. Extract the name during Stage 4 and carry it through to the page.

1. **Executive summary** \u{2014} information panel: selected teams and anchors, momentum, milestones and decisions, material risks.
2. **Evidence coverage** \u{2014} the window dates and only the source categories that returned usable evidence. Name every gap; never claim complete coverage.
3. **Teams at a glance** \u{2014} wide table: Team, Relevant anchors, Current status, What changed, Evidence. Canonical team names, status lozenges.
4. **Workstream updates** \u{2014} one section per anchor: canonical name and link, status, verified owner or DRI, progress across contributors, decisions and milestones, dependencies and risks, sources.
5. **Completed work and decisions** \u{2014} source-backed outcomes closed inside the window only. Do not promote a review, comment, or cleanup ticket into a team outcome.
6. **Risks and blockers** \u{2014} warning panels, verified current risks only: affected anchor, consequence, sourced mitigation, evidence.

Every link must be copied verbatim from a tool result. Never build a URL from a title, key, ARI, or content ID. Never link to the publishing destination \`{{PARENT_PAGE_ID}}\`, to anything already filed under it, or to a previously generated summary.

## Visual specification

Executive status report, not a chat transcript or a bullet dump.

- Full-width information panel for the executive summary.
- Clear heading levels for each section and each workstream.
- Wide table for the team overview so it spans the content area.
- Native status lozenges for every status value: green on track or shipped, yellow at risk, red blocked, blue in progress, grey unknown.
- Two-column layout only where two short blocks genuinely sit side by side.
- Warning panels for risks, note panel for coverage caveats.
- Dividers between major sections.
- Short paragraphs, scannable bullets, bold leading label on each bullet.
- Evidence as inline Smart Links, never a raw URL or a raw ARI in body text. ARIs are tool arguments and must never be visible to a reader; cite the thing by its name, linked.
- No emoji, decorative icons, prose in code blocks, or nested tables.

## Stage 7 \u{2014} Publish

Publishing is the point of this run. You must reach 7.1 and you must call it exactly once. Never abandon the run with no page created.

**7.1** Call **Create content** exactly once, with exactly these arguments:

- \`spaceId\` = \`{{OUTPUT_SPACE_ID}}\`
- \`parentId\` = \`{{PARENT_PAGE_ID}}\`
- \`semanticQuery\` = the text described below

All three are required. A call missing \`parentId\` is malformed and publishes to the wrong place; if you are about to send this call without \`parentId\`, add it. If the tool exposes \`title\`, \`contentType\` or \`shouldAutoExecute\`, also pass \`title\` verbatim as specified, \`contentType\` = \`page\`, \`shouldAutoExecute\` = \`true\`.

\`{{PARENT_PAGE_ID}}\` is the destination parent. Pass the value exactly as given and let the tool resolve what kind of content it is: do not reason about whether it is a page, a folder or anything else, do not add a parent-type argument, and do not vary any other argument based on it. Otherwise leave it alone entirely \u{2014} never call **Get page**, **Search** or any read tool on it, never treat it as evidence, and never mention it inside \`semanticQuery\` or in the report body.

The \`semanticQuery\` must be self-contained and must begin with exactly these two lines:

\`\`\`
Use this exact page title, verbatim, unchanged: {{CADENCE_LABEL}} Team and Workstream Status Update \u{2014} {{now.format("MMM d, yyyy")}}
Preserve every fact and URL below exactly as given. Do not rediscover, re-research, re-word, or re-title anything.
\`\`\`

Then, in this order: the visual specification restated in full; the reporting window dates; the executive summary; the selected teams with ARIs; each anchor with its status, verified owner or DRI, progress, decisions, milestones and risks; contributor attribution; and every allowed source URL.

\`semanticQuery\` is the only thing the page generator can see. Anything the report is supposed to contain but that you leave out here will be missing from the page or filled in with an invented placeholder. Walk the six report sections and confirm every field each one requires is present before you send the call. Use native Confluence markup for status lozenges, panels and inline Smart Links so the formatting survives. These IDs belong in the tool's arguments only, so keep them out of the prose. Do not emit literal ADF JSON.

Do not call the legacy Create page or Edit page actions, Copy page, Rename page, or any move action.

**7.2** Read the result of 7.1. It returns the new page's URL, title and content ID. Record all three verbatim \u{2014} these are the only values Stage 8 may use.

Publishing is now final. Whatever 7.1 returned, do not call it again, and never move, copy, rename, reparent, delete or recreate the page. If the returned title differs from the title you specified, leave the page alone and say so in the email.

## Stage 8 \u{2014} Email

Your entire final response is the email body and nothing else. No preamble, no "I have created", no coverage notes, no closing question, no generated-by footer, no code fences.

Emit exactly this HTML, substituting the real title, URL and one-sentence summary:

\`\`\`html
<p>The weekly team and workstream status update has been published.</p>
<p><a href="PAGE_URL">PAGE_TITLE</a></p>
<p>ONE_SENTENCE_SUMMARY</p>
\`\`\`

\`PAGE_URL\` and \`PAGE_TITLE\` must be copied verbatim from the Stage 7.1 result and from nowhere else. A URL that came from a work summary, a search hit, an evidence page, or the parent page is never valid here. If you did not create a page, you have no URL, and you must not supply one.

\`ONE_SENTENCE_SUMMARY\` is a single plain sentence naming the teams covered and the headline of the week. If the title came back different from the one you specified, append one further \`<p>\` stating that plainly.

If Stage 7.1 did not return a page, emit exactly this instead, with no link:

\`\`\`html
<p>The weekly team and workstream status update could not be published this week.</p>
<p>REASON</p>
\`\`\`
\`\`\`\`
`;
// https://switcheroo.atlassian.com/ui/configurations/ecf5f0c8-e57a-4054-a74f-b75444e2c4ea/key/confluence-status-update-discovery-prompt
const $743450a0eca9e493$var$STATUS_UPDATE_DISCOVERY_PROMPT_CONFIG = 'confluence-status-update-discovery-prompt';
const $743450a0eca9e493$var$STATUS_UPDATE_PROMPT_TOKEN_PATTERN = /\{\{[A-Z0-9_]+\}\}/gu;
const $743450a0eca9e493$var$getStatusUpdatesAutomationPrompt = (input)=>{
    const template = (0, $1xpoY.default).getString($743450a0eca9e493$var$STATUS_UPDATE_DISCOVERY_PROMPT_CONFIG, $743450a0eca9e493$var$DEFAULT_STATUS_UPDATE_DISCOVERY_PROMPT) || $743450a0eca9e493$var$DEFAULT_STATUS_UPDATE_DISCOVERY_PROMPT;
    const { publishParentId: publishParentId, spaceId: spaceId, userId: userId, userEmail: userEmail, contentId: contentId, cadence: cadence } = input;
    const cadenceConfig = $743450a0eca9e493$var$CADENCE_PROMPT_CONFIG[cadence] ?? $743450a0eca9e493$var$CADENCE_PROMPT_CONFIG.weekly;
    const replacements = {
        '{{SEED_USER_ARI}}': userId ? `ari:cloud:identity::user/${userId}` : `${null}`,
        '{{PARENT_PAGE_ID}}': `${publishParentId ?? null}`,
        '{{NUDGE_PAGE_ID}}': `${contentId ?? null}`,
        '{{OUTPUT_SPACE_ID}}': `${spaceId ?? null}`,
        '{{CADENCE_LABEL}}': cadenceConfig.reportLabel,
        '{{CADENCE_SCHEDULE}}': cadenceConfig.schedule,
        '{{REPORT_LOOKBACK_DAYS}}': `${cadenceConfig.lookbackDays}`,
        '{{USER_EMAIL}}': `${userEmail ?? null}`
    };
    return template.replace($743450a0eca9e493$var$STATUS_UPDATE_PROMPT_TOKEN_PATTERN, (token)=>replacements[token] ?? token);
};
const $743450a0eca9e493$export$f18a9b6dd3f73a8 = ({ content: content, user: user })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publishRovoChat = (0, $hdBxM.usePublish)('ai-mate');
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const hasUserSeenAutomationDiscoveryMessage = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_STATUS_UPDATES);
    const contentId = content?.id ?? '';
    const ancestors = content?.ancestors;
    const parent = ancestors?.[ancestors.length - 1];
    const spaceId = content?.space?.id;
    const ownerId = content?.history?.ownedBy?.accountId;
    const isDocOwner = Boolean(userId) && Boolean(ownerId) && userId === ownerId;
    const emails = user?.emails;
    const userEmail = (0, $cozmU.useMemo)(()=>{
        const candidates = emails?.filter((email)=>Boolean(email?.value)) ?? [];
        return candidates.find((email)=>email?.isPrimary)?.value ?? candidates[0]?.value ?? null;
    }, [
        emails
    ]);
    const children = (0, $cozmU.useMemo)(()=>content?.children?.nodes?.flatMap((child)=>child?.title && child.metadata?.createdDate ? [
                {
                    title: child.title,
                    createdAt: child.metadata.createdDate
                }
            ] : []) ?? [], [
        content?.children?.nodes
    ]);
    const { matches: matchesStatusUpdate, matchedChildren: matchedChildren, cadence: cadence } = (0, $13bd41970a846636$export$d547eb960ffae1ac)({
        title: content?.title,
        parentTitle: parent?.title,
        sourceTemplateEntityId: content?.metadata?.sourceTemplateEntityId,
        children: children
    });
    const handleLocalStorageUpdate = (0, $cozmU.useCallback)(()=>{
        (0, $hTxAd.markDiscoveryExperienceAsSeen)((0, $1UApO.keys).AUTOMATION_DISCOVER_STATUS_UPDATES);
    }, []);
    return (0, $cozmU.useMemo)(()=>matchesStatusUpdate && isDocOwner && !hasUserSeenAutomationDiscoveryMessage && (0, $9wGTI.fg)('cc_automations_discovery_nudges') ? {
            id: $743450a0eca9e493$var$STATUS_UPDATES_NUDGE_ID,
            title: formatMessage($743450a0eca9e493$var$i18n.title),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
                    size: "small",
                    label: formatMessage($743450a0eca9e493$var$i18n.iconLabel)
                }),
            handleType: (0, $6iWVH.HandleActionType).Skill,
            type: 'skill-action',
            onClick: ()=>{
                publishRovoChat({
                    type: 'chat-new',
                    source: $743450a0eca9e493$var$ROVO_CHAT_SOURCE,
                    openChat: true,
                    openChatMode: 'sidebar',
                    data: {
                        dialogues: [],
                        prompt: $743450a0eca9e493$var$getStatusUpdatesAutomationPrompt({
                            publishParentId: matchedChildren ? contentId : parent?.id,
                            spaceId: spaceId,
                            userId: userId,
                            userEmail: userEmail,
                            contentId: contentId,
                            cadence: cadence
                        }),
                        placeholderType: 'skill',
                        resultAttributionContext: {
                            launchSource: $743450a0eca9e493$var$ROVO_CHAT_SOURCE
                        }
                    }
                });
            },
            nudgeContext: {
                id: $743450a0eca9e493$var$STATUS_UPDATES_NUDGE_ID,
                selfEligible: true,
                onAccept: handleLocalStorageUpdate,
                onDismiss: (reason)=>{
                    if (reason?.dismissedMethod === 'manual') handleLocalStorageUpdate();
                }
            }
        } : null, [
        formatMessage,
        handleLocalStorageUpdate,
        matchesStatusUpdate,
        isDocOwner,
        publishRovoChat,
        spaceId,
        userId,
        userEmail,
        cadence,
        parent?.id,
        matchedChildren,
        contentId,
        hasUserSeenAutomationDiscoveryMessage
    ]);
};








const $7c0ff345a5acb74a$export$fb3671a0eecaec42 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    return isLoggedIn && isRovoLLMEnabled && (edition === (0, $euL71.ConfluenceEdition).STANDARD || edition === (0, $euL71.ConfluenceEdition).PREMIUM);
};



var $lpWis = parcelRequire("lpWis");

/**
 * Runs the nudge-actions query and returns ONLY settled, content-matched entities — never the raw
 * `useQueryInterop` result.
 *
 * IMPORTANT: DO NOT USE FRAGMENT SPREADS HERE
 *
 * Every field the sub-hooks need is selected DIRECTLY on this query (no colocated fragments), so the
 * reactive `useQueryInterop` data can be passed straight down as plain props. That keeps the whole
 * subtree suspense-free — there are no fragment reads left to suspend on a torn-down record — while
 * staying fully reactive.
 */ const $7277a9bb4afcec4a$var$useConfluenceAutomationNudgeActionsQuery = ({ contentId: contentId, skipStatusUpdatesAutomation: skipStatusUpdatesAutomation, skipContentReviewerNudge: skipContentReviewerNudge, skipUserEmails: skipUserEmails, isDraft: isDraft, skip: skip })=>{
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $86cb04399e002e13$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            skipStatusUpdatesAutomation: skipStatusUpdatesAutomation,
            skipContentReviewerNudge: skipContentReviewerNudge,
            skipUserEmails: skipUserEmails,
            isDraft: isDraft
        },
        skip: skip,
        __callerPackage__: "automation-discovery"
    });
    if (loading || !data) return {
        singleContent: undefined,
        user: undefined
    };
    const settledContent = data.singleContent && data.singleContent.id === contentId ? data.singleContent : undefined;
    return {
        singleContent: settledContent,
        user: data.user ?? undefined
    };
};
const $7277a9bb4afcec4a$export$2a2b9e9c33e1951e = (contentId)=>{
    const hasBaseEligibility = (0, $7c0ff345a5acb74a$export$fb3671a0eecaec42)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const hasUserSeenStatusUpdatesAutomationNudge = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).AUTOMATION_DISCOVER_STATUS_UPDATES);
    const includeStatusUpdatesAutomation = !hasUserSeenStatusUpdatesAutomationNudge && (0, $9wGTI.fg)('cc_automations_discovery_nudges');
    const includeContentReviewerNudge = (0, $d58deec0f5f8c3d0$export$4ce9149b14868c81)();
    const includeMeetingNotesNudge = (0, $3f4852915e4f596a$export$b2de40c66456019c)(contentId);
    const isAnyNudgeEligible = includeStatusUpdatesAutomation || includeContentReviewerNudge || includeMeetingNotesNudge;
    const isDraft = pageMode === (0, $cD1qu.PageMode).EDIT;
    const { singleContent: singleContent, user: user } = $7277a9bb4afcec4a$var$useConfluenceAutomationNudgeActionsQuery({
        contentId: contentId,
        skipStatusUpdatesAutomation: !includeStatusUpdatesAutomation,
        skipContentReviewerNudge: !includeContentReviewerNudge,
        skipUserEmails: !includeStatusUpdatesAutomation && !includeMeetingNotesNudge,
        isDraft: isDraft,
        skip: !hasBaseEligibility || !contentId || !isAnyNudgeEligible || !(0, $9wGTI.fg)('automations-integration-to-rovo-button-nudges')
    });
    const contentReviewerNudgeAction = (0, $70bf4384341b00a6$export$616a7f72e384ce8e)({
        content: singleContent,
        contentId: contentId
    });
    const statusUpdatesAutomationNudgeAction = (0, $743450a0eca9e493$export$f18a9b6dd3f73a8)({
        content: singleContent,
        user: user
    });
    const meetingNotesNudgeAction = (0, $063b348ef7b18c93$export$9890936e97386657)({
        user: user,
        contentId: contentId
    });
    const matchedActions = (0, $cozmU.useMemo)(()=>[
            {
                actionId: 'status-updates-automation',
                action: statusUpdatesAutomationNudgeAction
            },
            {
                actionId: 'content-reviewer-nudge',
                action: contentReviewerNudgeAction
            },
            {
                actionId: 'meeting-notes-nudge',
                action: meetingNotesNudgeAction
            }
        ].filter((entry)=>entry.action != null), [
        statusUpdatesAutomationNudgeAction,
        contentReviewerNudgeAction,
        meetingNotesNudgeAction
    ]);
    // Defer the Studio permission check until at least one nudge has matched, so
    // the permission query never runs for the common case where nothing matches —
    // while still only running it once for all nudges.
    const { canCreateStudioAutomation: canCreateStudioAutomation } = (0, $lpWis.useStudioPermissions)({
        skip: matchedActions.length === 0
    });
    return (0, $cozmU.useMemo)(()=>canCreateStudioAutomation && hasBaseEligibility ? matchedActions : [], [
        matchedActions,
        canCreateStudioAutomation,
        hasBaseEligibility
    ]);
};
module.exports["useConfluenceAutomationNudgeActions"] = $7277a9bb4afcec4a$export$2a2b9e9c33e1951e;

});

parcelRegister("355fY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5QN2y = parcelRequire("5QN2y");


var $dK51B = parcelRequire("dK51B");


var $bQm3c = parcelRequire("bQm3c");


var $9KNO1 = parcelRequire("9KNO1");

const $e7f6ba06f42fb231$export$d053c5e11724145b = ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [automationStack, setAutomationStack] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        let cancelled = false;
        (0, $9KNO1.getAutomationStack)(environment).then((stack)=>{
            if (!cancelled) setAutomationStack(stack);
        }).catch(()=>{
            if (!cancelled) setAutomationStack(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        environment,
        skip
    ]);
    const isStackSettled = automationStack !== undefined;
    const shouldRunQuery = !skip && Boolean(cloudId) && Boolean(automationStack);
    const { data: data, loading: loading } = (0, $dK51B.useExperimentalQuery)({
        url: `/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/rest/v1/studioContext`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        parseResult: (response)=>{
            const spaceAri = response?.spaceARI;
            return {
                studioSpaceAri: typeof spaceAri === 'string' && (0, $5QN2y.StudioSpaceAri).check(spaceAri) ? (0, $5QN2y.StudioSpaceAri).parse(spaceAri) : null
            };
        },
        skip: !shouldRunQuery,
        fetchPolicy: 'cache-first'
    });
    return {
        studioSpaceAri: data?.studioSpaceAri ?? null,
        // Loading until we have a definitive answer: while the automation stack is still resolving, or
        // while the studioContext query for a valid stack is in flight. Once the stack settles to no
        // value (or is skipped) there is nothing to fetch, so this is false and the ARI is `null`.
        isLoading: !skip && (!isStackSettled || shouldRunQuery && loading)
    };
};
module.exports["useStudioSpaceAri"] = $e7f6ba06f42fb231$export$d053c5e11724145b;

});

parcelRegister("5QN2y", function(module, exports) {

var $elerM = parcelRequire("elerM");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/studio/space/manifest.ts
var $4427d971687b91a2$var$studioSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $elerM.StudioSpaceAriResourceOwner),
    resourceType: (0, $elerM.StudioSpaceAriResourceType),
    resourceIdSlug: "{workspaceId}/{spaceId}",
    resourceIdSegmentFormats: {
        workspaceId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/,
        spaceId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/studio/space/index.ts
var $4427d971687b91a2$export$9d14a8e162eb6058 = class _StudioSpaceAri extends (0, $9j37t.RegisteredAri) {
    get workspaceId() {
        return this._workspaceId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4427d971687b91a2$var$studioSpaceAriStaticOpts.qualifier,
            platformQualifier: $4427d971687b91a2$var$studioSpaceAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $4427d971687b91a2$var$studioSpaceAriStaticOpts.resourceOwner,
            resourceType: $4427d971687b91a2$var$studioSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.workspaceId}/${opts.spaceId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $4427d971687b91a2$var$studioSpaceAriStaticOpts);
        return new _StudioSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $4427d971687b91a2$var$studioSpaceAriStaticOpts);
        return new _StudioSpaceAri(opts);
    }
    getVariables() {
        return {
            workspaceId: this.workspaceId,
            spaceId: this.spaceId
        };
    }
    constructor(opts){
        super(opts), this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
};
module.exports["StudioSpaceAri"] = $4427d971687b91a2$export$9d14a8e162eb6058;

});

parcelRegister("elerM", function(module, exports) {
// src/studio/space/types.ts
var $a70e3bbf91600e1a$export$7273abcabf6247f5 = "studio", $a70e3bbf91600e1a$export$136946b303fa22e0 = "space";
module.exports["StudioSpaceAriResourceOwner"] = $a70e3bbf91600e1a$export$7273abcabf6247f5;
module.exports["StudioSpaceAriResourceType"] = $a70e3bbf91600e1a$export$136946b303fa22e0;

});

parcelRegister("9KNO1", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $1UApO = parcelRequire("1UApO");

/**
 * Here we will check if devWatch is running and if so, we will use the associated dev stack.
 */ const $0691681f8bad8323$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await (0, $f7B1p.cfetch)('https://localhost:8082/devStack.json', {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'omit'
        });
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from https://localhost:8082/devStack.json with error: ${e}`);
        return null;
    }
};
const $0691681f8bad8323$export$6123178d3f5fb24d = async (environment)=>{
    switch(environment){
        case 'DEVELOPMENT':
        case 'STAGING':
            return await $0691681f8bad8323$var$getAutomationDevStackFromLocalServer() || window.localStorage.getItem((0, $1UApO.keys).AUTOMATION_PLATFORM_STACK) || 'staging';
        default:
            return 'pro';
    }
};
module.exports["getAutomationStack"] = $0691681f8bad8323$export$6123178d3f5fb24d;

});

parcelRegister("5v7QA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $kSwu1 = parcelRequire("kSwu1");

const $9b11c5b093926f82$export$242890b69747c0cf = (0, $kSwu1.defineMessages)({
    dismiss: {
        id: "automation-discovery.common.dismiss",
        defaultMessage: "Not now"
    },
    showMeHow: {
        id: "automation-discovery.common.show-me-how",
        defaultMessage: "Show me how"
    },
    spotlightCta: {
        id: "automation-discovery.manual-trigger.cta.text",
        defaultMessage: "Build rule"
    },
    spotlightDismiss: {
        id: "automation-discovery.manual-trigger.dismiss",
        defaultMessage: "Done"
    }
});
const $9b11c5b093926f82$export$eaeae0ae54954c9a = (0, $kSwu1.defineMessages)({
    header: {
        id: "automation-discovery.hover-page-title.header",
        defaultMessage: "Auto-archive old pages?"
    },
    message: {
        id: "automation-discovery.hover-page-title.message",
        defaultMessage: "This page hasn\u2019t been updated lately. An Automation rule could archive old pages once a month."
    }
});
const $9b11c5b093926f82$export$6216ba99d37b53d2 = (0, $kSwu1.defineMessages)({
    header: {
        id: "automation-discovery.archive.from-archive-modal",
        defaultMessage: "Confluence can auto-archive old pages"
    },
    message: {
        id: "automation-discovery.archive.message",
        defaultMessage: "Try building this Automation rule: Archive pages in this space that haven\u2019t been updated in at least 3 months."
    },
    success: {
        id: "automation-discovery.archive.success",
        defaultMessage: "Your page was archived"
    },
    successHeader: {
        id: "automation-discovery.archive.success-header",
        defaultMessage: "Archived successfully"
    },
    viewInArchive: {
        id: "automation-discovery.archive.view-in-archive",
        defaultMessage: "View in archive"
    }
});
const $9b11c5b093926f82$export$e252be6159b8f418 = (0, $kSwu1.defineMessages)({
    title: {
        id: "automation-discovery.add-label.title",
        defaultMessage: "Confluence can auto-add labels"
    },
    message: {
        id: "automation-discovery.add-label.message",
        defaultMessage: "Try building this Automation rule: When the user you choose publishes a new page, label it with their name."
    }
});
const $9b11c5b093926f82$export$1f7318de30c66816 = (0, $kSwu1.defineMessages)({
    title: {
        id: "automation-discovery.content-reviewer-nudge-action.title",
        defaultMessage: "Get proactive content suggestions"
    },
    secondaryTitle: {
        id: "automation-discovery.content-reviewer-nudge-action.secondary-title",
        defaultMessage: "Automate the next content review."
    },
    iconLabel: {
        id: "automation-discovery.content-reviewer-nudge-action.icon-label",
        defaultMessage: "Automation icon"
    },
    readyForReviewState: {
        id: "automation-discovery.content-state.default.status.ready.for.review",
        defaultMessage: "Ready for review"
    }
});
const $9b11c5b093926f82$export$aa8b5eb5f277dfbd = (0, $kSwu1.defineMessages)({
    title: {
        id: "automation-discovery.meeting-notes-nudge-action.title",
        defaultMessage: "Auto-receive an email with your meeting recap"
    },
    secondaryTitle: {
        id: "automation-discovery.meeting-notes-nudge-action.secondary-title",
        defaultMessage: "Get a summary of your meeting notes straight to your inbox."
    },
    iconLabel: {
        id: "automation-discovery.meeting-notes-nudge-action.icon-label",
        defaultMessage: "Automation icon"
    }
});
const $9b11c5b093926f82$export$defcdcbe29897057 = (0, $kSwu1.defineMessages)({
    success: {
        id: "automation-discovery.meeting-notes.success",
        defaultMessage: "Your page was published"
    },
    title: {
        id: "automation-discovery.meeting-notes.title",
        defaultMessage: "Confluence can auto-publish pages"
    },
    message: {
        id: "automation-discovery.meeting-notes.message",
        defaultMessage: "Try building this Automation rule: Publish a new Meeting notes page according to your meeting schedule."
    },
    ctaText: {
        id: "automation-discovery.meeting-notes.cta.text",
        defaultMessage: "Auto-summarize pages?"
    },
    modalBody: {
        id: "automation-discovery.meeting-notes.modal.body",
        defaultMessage: "{publishedPageTitle} was successfully published in the {spaceName} space"
    },
    successIconLabel: {
        id: "automation-discovery.meeting-notes.success.icon.label",
        defaultMessage: "Success check icon"
    },
    modalCloseIconLabel: {
        id: "automation-discovery.meeting-notes.modal.close.icon.label",
        defaultMessage: "Close icon for modal"
    }
});
const $9b11c5b093926f82$export$ce468634859ccf2b = (0, $kSwu1.defineMessages)({
    ctaText: {
        id: "automation-discovery.jira-link.cta.text",
        defaultMessage: "Auto-link Jira issues?"
    }
});
const $9b11c5b093926f82$export$51183073ec843a06 = (0, $kSwu1.defineMessages)({
    title: {
        id: "automation-discovery.manual-trigger.title",
        defaultMessage: "Page automation menu"
    },
    body: {
        id: "automation-discovery.manual-trigger.body",
        defaultMessage: "Teammates can apply rules from this menu to a single page."
    }
});
const $9b11c5b093926f82$export$4cf5be76251112af = (0, $kSwu1.defineMessages)({
    title: {
        id: "automation-discovery.verified-content.title",
        defaultMessage: "Want to manage your verified pages?"
    },
    body: {
        id: "automation-discovery.verified-content.body",
        defaultMessage: "Use Confluence automation to schedule reviews for verified content."
    }
});
const $9b11c5b093926f82$export$6b1f7d6fd8c7714c = (0, $kSwu1.defineMessages)({
    productivityTimeSavedMessage: {
        id: "automation-discovery.productivity-insights.time-saved.message",
        defaultMessage: "Save your team <b>{timeSaved, plural, one {{timeSaved} minute} other {{timeSaved} minutes}}</b> per quarter by setting up this automation rule!"
    }
});
module.exports["commonI18n"] = $9b11c5b093926f82$export$242890b69747c0cf;
module.exports["hoverPageTitleI18n"] = $9b11c5b093926f82$export$eaeae0ae54954c9a;
module.exports["archiveMessagesI18n"] = $9b11c5b093926f82$export$6216ba99d37b53d2;
module.exports["labelMessagesI18n"] = $9b11c5b093926f82$export$e252be6159b8f418;
module.exports["contentReviewerNudgeI18n"] = $9b11c5b093926f82$export$1f7318de30c66816;
module.exports["meetingNotesNudgeI18n"] = $9b11c5b093926f82$export$aa8b5eb5f277dfbd;
module.exports["meetingNotesI18n"] = $9b11c5b093926f82$export$defcdcbe29897057;
module.exports["jiraLinkI18n"] = $9b11c5b093926f82$export$ce468634859ccf2b;
module.exports["productivityInsightsI18n"] = $9b11c5b093926f82$export$6b1f7d6fd8c7714c;

});

parcelRegister("hTxAd", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $tgs13 = parcelRequire("tgs13");

const $a5f7b05a2384a497$export$9f585226e9430b76 = (experienceKey)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem(experienceKey, true, (0, $tgs13.TWENTY_EIGHT_DAYS_IN_SECONDS));
};
module.exports["markDiscoveryExperienceAsSeen"] = $a5f7b05a2384a497$export$9f585226e9430b76;

});

parcelRegister("tgs13", function(module, exports) {
const $2e9fe66aaea8de6a$export$f09b8e10e3913161 = 2419200;
const $2e9fe66aaea8de6a$export$885b9d72bc39ecdb = 2592000000;
const $2e9fe66aaea8de6a$export$6ec716a28918c083 = 31536000;
module.exports["TWENTY_EIGHT_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$f09b8e10e3913161;
module.exports["THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$6ec716a28918c083;

});

parcelRegister("7IVHS", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $8128430585027637$export$2fdcc866a6c73972 = ({ configKey: configKey, fallback: fallback })=>(0, $1xpoY.default).getString(configKey, fallback) || fallback;
/**
 * Matches `{{VARIABLE}}` placeholders in a prompt template. The variable name is captured
 * so it can be swapped for a consumer-supplied value. Unknown tokens are left untouched.
 */ const $8128430585027637$var$PROMPT_TEMPLATE_TOKEN_PATTERN = /\{\{([A-Z0-9_]+)\}\}/gu;
const $8128430585027637$export$62be7f63b49db843 = (config, variables)=>{
    const template = $8128430585027637$export$2fdcc866a6c73972(config);
    return template.replace($8128430585027637$var$PROMPT_TEMPLATE_TOKEN_PATTERN, (token, name)=>Object.prototype.hasOwnProperty.call(variables, name) ? variables[name] : token);
};
module.exports["resolveDynamicConfigStringValue"] = $8128430585027637$export$2fdcc866a6c73972;
module.exports["resolvePromptTemplate"] = $8128430585027637$export$62be7f63b49db843;

});

parcelRegister("kv1hV", function(module, exports) {
const $66e5837ebdc1ee84$export$e65b3021b246816a = {
    contentId: null,
    title: null,
    adf: null,
    sourceTemplateEntityId: null
};
const $66e5837ebdc1ee84$export$84cec395ea080001 = (contentId, title, adf, sourceTemplateEntityId = null)=>{
    $66e5837ebdc1ee84$export$e65b3021b246816a.contentId = contentId;
    $66e5837ebdc1ee84$export$e65b3021b246816a.title = title;
    $66e5837ebdc1ee84$export$e65b3021b246816a.adf = adf;
    $66e5837ebdc1ee84$export$e65b3021b246816a.sourceTemplateEntityId = sourceTemplateEntityId;
};
module.exports["pageJustPublishedSignal"] = $66e5837ebdc1ee84$export$e65b3021b246816a;
module.exports["setPageJustPublishedSignal"] = $66e5837ebdc1ee84$export$84cec395ea080001;

});

parcelRegister("d0Ide", function(module, exports) {
var $fe73de88bf54921d$export$288b04954abdcf5 = /*#__PURE__*/ function(EventSourceName) {
    EventSourceName["ADD_LABEL_TO_PAGE"] = "automationDiscoveryWhenLabelAddedToPage";
    EventSourceName["MEETING_NOTES"] = "automationDiscoveryWhenPublishingMeetingNotes";
    EventSourceName["ARCHIVE_PAGE"] = "automationDiscoveryWhenArchivingPage";
    EventSourceName["HOVER_OVER_PAGE_TITLE"] = "automationDiscoveryFromHoverOverPageTitle";
    EventSourceName["JIRA_LINK"] = "automationDiscoveryJiraLink";
    EventSourceName["MANUAL_TRIGGER"] = "automationDiscoveryManualTrigger";
    EventSourceName["MANUAL_TRIGGER_SMART_BUTTON"] = "automationDiscoveryManualTriggerSmartButton";
    EventSourceName["IN_CONTEXT_RULE_BUILDER"] = "automationDiscoveryInContextRuleBuilder";
    EventSourceName["VERIFED_CONTENT"] = "automationDiscoveryVerifiedContent";
    EventSourceName["BULK_ARCHIVE"] = "automationDiscoveryBulkArchive";
    EventSourceName["GLOBAL_PUBLIC_LINKS"] = "automationDiscoveryGlobalPermissions";
    EventSourceName["PAGE_PUBLIC_LINKS"] = "automationDiscoverPageShare";
    EventSourceName["BULK_ASSIGN"] = "automationDiscoverySpaceAssignedBulk";
    EventSourceName["SINGLE_ASSIGN"] = "automationDiscoverySpaceAssignedSingle";
    EventSourceName["DEFAULT_SPACE_ASSIGN"] = "automationDiscoveryDefaultSpaceAssigned";
    EventSourceName["WHITE_BOARDS"] = "automationDiscoveryPublishWhiteBoards";
    EventSourceName["SHARE_SLACK"] = "automationDiscoveryShareSlack";
    EventSourceName["BULK_CHANGE_OWNER"] = "automationDiscoveryBulkChangePageOwner";
    EventSourceName["PRODUCT_REQUIREMENTS"] = "automationDiscoveryProductRequirements";
    EventSourceName["FEEDBACK_ANALYSIS"] = "automationDiscoveryFeedbackAnalysis";
    EventSourceName["RELEASE_NOTES"] = "automationDiscoveryReleaseNotes";
    return EventSourceName;
}({});
module.exports["EventSourceName"] = $fe73de88bf54921d$export$288b04954abdcf5;

});

parcelRegister("7cI9Q", function(module, exports) {

var $k6kVI = parcelRequire("k6kVI");


var $aLdKz = parcelRequire("aLdKz");


var $3Zshf = parcelRequire("3Zshf");

const $1e68e6c6a2b14c55$export$8a52743dc019e414 = ({ title: title, sourceTemplateEntityId: sourceTemplateEntityId })=>{
    const matchedTitle = !!title && (0, $aLdKz.matchMeetingSignal)(title, (0, $3Zshf.MEETING_NOTES_TITLE_KEYWORDS));
    const matchedTemplate = !!sourceTemplateEntityId && (0, $k6kVI.matchesMeetingTemplate)({
        idType: 'other',
        id: sourceTemplateEntityId
    });
    return {
        matches: matchedTitle || matchedTemplate,
        matchedTitle: matchedTitle,
        matchedTemplate: matchedTemplate
    };
};
module.exports["matchesMeetingNotesSignal"] = $1e68e6c6a2b14c55$export$8a52743dc019e414;

});

parcelRegister("3Zshf", function(module, exports) {
/**
 * English-only title keywords for the meeting notes automation discovery nudge.
 *
 * Title only: the body-content keywords were removed because matching them
 * against the page body fired on far too many pages.
 *
 * Forked from `@confluence/experiment-meeting-signal-core`, which defines the
 * same keywords with `defineMessages` so they can be localized. That package is
 * shared with the Loom meeting-signal experiment (and `content-renderer` /
 * `editor-features`), so it keeps its localized catalogues and is deliberately
 * left untouched.
 *
 * The nudge is English-only: it opens an English Rovo conversation that builds
 * an English automation rule, so a localized trigger would surface a nudge whose
 * entire downstream experience is still English. These are matching inputs, not
 * user-facing copy, so they are plain constants and are not extracted for
 * translation.
 *
 * Matched whole-word and case-insensitively - see `matchMeetingSignal`. Frozen
 * so the compiled-regex cache in `matchMeetingSignal` (keyed on array identity)
 * stays warm across renders.
 */ const $39187320d0bc68b6$export$bccdab800b5f4dd5 = Object.freeze([
    'meeting',
    'meetings',
    'sync',
    'standup',
    'daily standup',
    'huddle',
    'check-in',
    '1:1',
    'kickoff',
    'review',
    'demo',
    'showcase',
    'working session',
    'office hours',
    'town hall',
    'all hands',
    'leadership sync',
    'staff meeting',
    'team meeting',
    'customer call',
    'discovery call',
    'design review',
    'architecture review',
    'backlog refinement',
    'agenda',
    'meeting agenda',
    'meeting notes',
    'discussion topics',
    'discussion',
    'decisions',
    'decision log',
    'attendees',
    'participants',
    'outcomes',
    'parking lot'
]);
module.exports["MEETING_NOTES_TITLE_KEYWORDS"] = $39187320d0bc68b6$export$bccdab800b5f4dd5;

});

parcelRegister("lpWis", function(module, exports) {

var $xxVn2 = parcelRequire("xxVn2");


var $jMyy4 = parcelRequire("jMyy4");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $d9tcB = parcelRequire("d9tcB");


var $bQm3c = parcelRequire("bQm3c");


var $355fY = parcelRequire("355fY");


var $fuH8U = parcelRequire("fuH8U");

// Both must be granted on the linked Studio space to build an automation there:
// the workspace-scoped `manage-automation` and the space-scoped `create-element`.
const $312ad01cd65d8d36$var$STUDIO_MANAGE_AUTOMATION_PERMISSION = 'workspace/manage-automation';
const $312ad01cd65d8d36$var$STUDIO_CREATE_ELEMENT_PERMISSION = 'space/create-element';
const $312ad01cd65d8d36$var$isPermitted = (data, permissionId)=>data?.bulkPermitted?.some((row)=>row?.permissionId === permissionId && row?.permitted === true) ?? false;
const $312ad01cd65d8d36$export$4b7b5a9f45d10e8b = ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    const hasBaseEligibility = Boolean(isRovoLLMEnabled && !isAnonymousUser && cloudId);
    const { studioSpaceAri: studioSpaceAri, isLoading: isStudioSpaceLoading } = (0, $355fY.useStudioSpaceAri)({
        skip: skip || !hasBaseEligibility
    });
    const principalId = (0, $fuH8U.getUserAri)(userId)?.toString() ?? null;
    const resourceId = studioSpaceAri?.toString() ?? null;
    const canRunPermissionCheck = Boolean(!skip && hasBaseEligibility && principalId && resourceId);
    const { data: data, loading: isStudioPermissionsLoading } = (0, $jMyy4.useQueryInterop)((0, $xxVn2.default), {
        skip: !canRunPermissionCheck,
        variables: {
            principalIds: [
                principalId,
                principalId
            ],
            resourceIds: [
                resourceId,
                resourceId
            ],
            permissionIds: [
                $312ad01cd65d8d36$var$STUDIO_MANAGE_AUTOMATION_PERMISSION,
                $312ad01cd65d8d36$var$STUDIO_CREATE_ELEMENT_PERMISSION
            ],
            dontRequirePrincipalsInSite: [
                true,
                true
            ]
        },
        fetchPolicy: 'cache-first',
        onError: (error)=>{
            if ((0, $aMcHK.isStatusCodeError)(error, '403') || (0, $aMcHK.isStatusCodeError)(error, '404')) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "automation-discovery"
    });
    const canCreateStudioAutomation = Boolean($312ad01cd65d8d36$var$isPermitted(data, $312ad01cd65d8d36$var$STUDIO_MANAGE_AUTOMATION_PERMISSION) && $312ad01cd65d8d36$var$isPermitted(data, $312ad01cd65d8d36$var$STUDIO_CREATE_ELEMENT_PERMISSION));
    return {
        canCreateStudioAutomation: canCreateStudioAutomation,
        isLoading: isStudioSpaceLoading || isStudioPermissionsLoading
    };
};
module.exports["useStudioPermissions"] = $312ad01cd65d8d36$export$4b7b5a9f45d10e8b;

});

parcelRegister("xxVn2", function(module, exports) {
/**
 * @generated SignedSource<<75695f3ffc9f48047b62dc69f3e57a8d>>
 * @relayHash 75ba97e12aabd0b01457d730b2d08e64
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID de9ab7032969bd4271b73a7321ebd7de8133c05b971f1b1e9cb63170f25fad3e
const $d01bdd659bebf77d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "dontRequirePrincipalsInSite"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permissionIds"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceIds"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "dontRequirePrincipalsInSite",
                    "variableName": "dontRequirePrincipalsInSite"
                },
                {
                    "kind": "Variable",
                    "name": "permissionIds",
                    "variableName": "permissionIds"
                },
                {
                    "kind": "Variable",
                    "name": "principalIds",
                    "variableName": "principalIds"
                },
                {
                    "kind": "Variable",
                    "name": "resourceIds",
                    "variableName": "resourceIds"
                }
            ],
            "concreteType": "BulkPermittedResponse",
            "kind": "LinkedField",
            "name": "bulkPermitted",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "permissionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permitted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useStudioPermissionsQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useStudioPermissionsQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "75ba97e12aabd0b01457d730b2d08e64",
            "id": "de9ab7032969bd4271b73a7321ebd7de8133c05b971f1b1e9cb63170f25fad3e",
            "metadata": {},
            "name": "useStudioPermissionsQuery",
            "operationKind": "query",
            "text": "query useStudioPermissionsQuery($principalIds:[String],$resourceIds:[String],$permissionIds:[String],$dontRequirePrincipalsInSite:[Boolean]){bulkPermitted(principalIds:$principalIds,resourceIds:$resourceIds,permissionIds:$permissionIds,dontRequirePrincipalsInSite:$dontRequirePrincipalsInSite){permissionId,permitted}}"
        }
    };
}();
$d01bdd659bebf77d$var$node.hash = "b0e4a1240e10b4a1d2d14d3f9cc8b8e3";
var $d01bdd659bebf77d$export$2e2bcd8739ae039 = $d01bdd659bebf77d$var$node;
module.exports["default"] = $d01bdd659bebf77d$export$2e2bcd8739ae039;

});

parcelRegister("fuH8U", function(module, exports) {

var $2khPJ = parcelRequire("2khPJ");

const $c1c2eeaa5050cd7d$export$aca8186b03c6237e = (userId)=>{
    if (!userId) return null;
    try {
        return (0, $2khPJ.IdentityUserAri).create({
            userId: userId
        });
    } catch (error) {
        return null;
    }
};
module.exports["getUserAri"] = $c1c2eeaa5050cd7d$export$aca8186b03c6237e;

});

parcelRegister("dWpd3", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $eb4732679a1ccd43$var$initialState = {
    activeContent: null,
    eligibleForChangeboarding: false
};
const $eb4732679a1ccd43$var$actions = {
    setActiveContent: (activeContent)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                activeContent: activeContent
            });
        },
    setEligibleForChangeboarding: (eligibleForChangeboarding)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                eligibleForChangeboarding: eligibleForChangeboarding
            });
        }
};
const $eb4732679a1ccd43$var$AudioButtonWrapperStore = (0, $8s9DV.createStore)({
    name: 'AudioButtonWrapperStore',
    initialState: $eb4732679a1ccd43$var$initialState,
    actions: $eb4732679a1ccd43$var$actions
});
const $eb4732679a1ccd43$export$ab1ee966cd621cb0 = (0, $kBr4q.createStateHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore, {
    selector: (state)=>({
            activeContent: state.activeContent,
            eligibleForChangeboarding: state.eligibleForChangeboarding
        })
});
const $eb4732679a1ccd43$export$9980b31ff728dec1 = (0, $kBr4q.createActionsHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore);
module.exports["useAudioButtonWrapperStore"] = $eb4732679a1ccd43$export$ab1ee966cd621cb0;
module.exports["useAudioButtonWrapperActions"] = $eb4732679a1ccd43$export$9980b31ff728dec1;

});

parcelRegister("aFH5a", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ed8521afef12d373$var$NO_ACTIONS = [];
let $ed8521afef12d373$var$snapshot = $ed8521afef12d373$var$NO_ACTIONS;
const $ed8521afef12d373$var$listeners = new Set();
const $ed8521afef12d373$var$emit = ()=>{
    $ed8521afef12d373$var$listeners.forEach((listener)=>listener());
};
const $ed8521afef12d373$var$subscribe = (onStoreChange)=>{
    $ed8521afef12d373$var$listeners.add(onStoreChange);
    return ()=>{
        $ed8521afef12d373$var$listeners.delete(onStoreChange);
    };
};
const $ed8521afef12d373$var$getSnapshot = ()=>$ed8521afef12d373$var$snapshot;
const $ed8521afef12d373$var$areEntriesEqual = (a, b)=>a.length === b.length && a.every((entry, i)=>entry.actionId === b[i].actionId && entry.action === b[i].action);
const $ed8521afef12d373$export$c21ac61fca04729 = (actions)=>{
    const next = actions.length === 0 ? $ed8521afef12d373$var$NO_ACTIONS : actions;
    if ($ed8521afef12d373$var$areEntriesEqual($ed8521afef12d373$var$snapshot, next)) return;
    $ed8521afef12d373$var$snapshot = next;
    $ed8521afef12d373$var$emit();
};
const $ed8521afef12d373$export$f71b85e36a5a3521 = ()=>{
    $ed8521afef12d373$export$c21ac61fca04729($ed8521afef12d373$var$NO_ACTIONS);
};
const $ed8521afef12d373$export$db1e7e408db21c75 = ()=>{
    $ed8521afef12d373$var$snapshot = $ed8521afef12d373$var$NO_ACTIONS;
    $ed8521afef12d373$var$listeners.clear();
};
const $ed8521afef12d373$export$9c407703b648a682 = ()=>(0, $cozmU.useSyncExternalStore)($ed8521afef12d373$var$subscribe, $ed8521afef12d373$var$getSnapshot, $ed8521afef12d373$var$getSnapshot);
module.exports["publishAutomationNudgeActions"] = $ed8521afef12d373$export$c21ac61fca04729;
module.exports["clearAutomationNudgeActions"] = $ed8521afef12d373$export$f71b85e36a5a3521;
module.exports["useAutomationNudgeActions"] = $ed8521afef12d373$export$9c407703b648a682;

});

parcelRegister("1AJi3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPoYT = parcelRequire("dPoYT");


var $kQqCc = parcelRequire("kQqCc");


var $93Gae = parcelRequire("93Gae");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar', autoFocusInput = true)=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi,
            autoFocusInput: autoFocusInput
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    const openConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar', autoFocusInput = true)=>{
        openConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi,
            autoFocusInput: autoFocusInput
        });
    }, [
        openConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $cozmU.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            openConversationAssistant: openConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        openConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("dStyd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3upRY = parcelRequire("3upRY");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $arQY7 = parcelRequire("arQY7");


var $ekCm6 = parcelRequire("ekCm6");


var $eFbDl = parcelRequire("eFbDl");


var $iMnC5 = parcelRequire("iMnC5");

const $4d36537dd1ad55e2$var$styles = {
    showBorder: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrulfZc"
}; // The fixed partition/resource-owner/resource-type segments of an identity user ARI — only the
// account id itself varies. Matched by prefix rather than via `@atlassian/ari` (an internal
// package this public package can't depend on).
const $4d36537dd1ad55e2$var$IDENTITY_USER_ARI_PREFIX = 'ari:cloud:identity::user/'; /**
                                                               * Parses the account id needed for the picture fetch from whatever identity a caller carries —
                                                               * either the bare account id, or the full identity ARI (callers that already have one on hand
                                                               * don't need to strip it first).
                                                               */ 
const $4d36537dd1ad55e2$var$parseIdentityAccountId = (value)=>{
    const trimmed = value?.trim();
    if (!trimmed) return undefined;
    return trimmed.startsWith($4d36537dd1ad55e2$var$IDENTITY_USER_ARI_PREFIX) ? trimmed.slice($4d36537dd1ad55e2$var$IDENTITY_USER_ARI_PREFIX.length) : trimmed;
};
const $4d36537dd1ad55e2$var$FetchedAgentAvatar = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { accountId: accountId, agentName: agentName, fallback: fallback, showBorder: showBorder, size: size, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry } = t0;
    let t1;
    if ($[0] !== accountId) {
        t1 = {
            accountId: accountId
        };
        $[0] = accountId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            fetchPolicy: "store-or-network"
        };
        $[2] = t2;
    } else t2 = $[2];
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $3upRY.default), t1, t2);
    let t3;
    if ($[3] !== data.user?.picture) {
        t3 = data.user?.picture?.trim();
        $[3] = data.user?.picture;
        $[4] = t3;
    } else t3 = $[4];
    const picture = t3;
    if (!picture) return fallback;
    let t4;
    if ($[5] !== agentName || $[6] !== data.user?.name) {
        t4 = data.user?.name?.trim() || agentName;
        $[5] = agentName;
        $[6] = data.user?.name;
        $[7] = t4;
    } else t4 = $[7];
    const name = t4;
    if (!showBorder) {
        let t5;
        if ($[8] !== UNSAFE_isUpdatedGeometry || $[9] !== name || $[10] !== picture || $[11] !== size) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                appearance: "hexagon",
                src: picture,
                name: name,
                label: name,
                size: size,
                borderColor: "transparent",
                UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
            });
            $[8] = UNSAFE_isUpdatedGeometry;
            $[9] = name;
            $[10] = picture;
            $[11] = size;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
    const t5 = (0, $ekCm6.AVATAR_SIZES)[size];
    const t6 = (0, $ekCm6.AVATAR_SIZES)[size];
    let t7;
    if ($[13] !== t5 || $[14] !== t6) {
        t7 = {
            height: t5,
            width: t6
        };
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== UNSAFE_isUpdatedGeometry || $[17] !== name || $[18] !== picture || $[19] !== size) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            src: picture,
            name: name,
            label: name,
            size: size,
            UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
        });
        $[16] = UNSAFE_isUpdatedGeometry;
        $[17] = name;
        $[18] = picture;
        $[19] = size;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== t7 || $[22] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "resolved-agent-avatar-border",
            xcss: $4d36537dd1ad55e2$var$styles.showBorder,
            style: t7
        }, t8);
        $[21] = t7;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
} : ({ accountId: accountId, agentName: agentName, fallback: fallback, showBorder: showBorder, size: size, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $3upRY.default), {
        accountId: accountId
    }, {
        fetchPolicy: 'store-or-network'
    });
    const picture = data.user?.picture?.trim();
    if (!picture) return fallback;
    const name = data.user?.name?.trim() || agentName;
    if (!showBorder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "hexagon",
        src: picture,
        name: name,
        label: name,
        size: size,
        borderColor: "transparent",
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "resolved-agent-avatar-border",
        xcss: $4d36537dd1ad55e2$var$styles.showBorder,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $ekCm6.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $ekCm6.AVATAR_SIZES)[size]
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "hexagon",
        src: picture,
        name: name,
        label: name,
        size: size,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    }));
};
const $4d36537dd1ad55e2$export$4e9b8ef47b20fa25 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { agentIdentityAccountId: agentIdentityAccountId, agentName: agentName, fallback: fallback, showBorder: t1, size: t2, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry } = t0;
    const showBorder = t1 === undefined ? false : t1;
    const size = t2 === undefined ? "medium" : t2;
    let t3;
    if ($[0] !== UNSAFE_isUpdatedGeometry || $[1] !== agentName || $[2] !== fallback || $[3] !== size) {
        t3 = fallback ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "hexagon",
            name: agentName,
            size: size,
            UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
        });
        $[0] = UNSAFE_isUpdatedGeometry;
        $[1] = agentName;
        $[2] = fallback;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    const resolvedFallback = t3;
    let t4;
    if ($[5] !== agentIdentityAccountId) {
        t4 = $4d36537dd1ad55e2$var$parseIdentityAccountId(agentIdentityAccountId);
        $[5] = agentIdentityAccountId;
        $[6] = t4;
    } else t4 = $[6];
    const accountId = t4;
    if (!accountId) return resolvedFallback;
    let t5;
    if ($[7] !== size) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
            appearance: "hexagon",
            size: size
        });
        $[7] = size;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== UNSAFE_isUpdatedGeometry || $[10] !== accountId || $[11] !== agentName || $[12] !== resolvedFallback || $[13] !== showBorder || $[14] !== size) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d36537dd1ad55e2$var$FetchedAgentAvatar, {
            accountId: accountId,
            agentName: agentName,
            fallback: resolvedFallback,
            showBorder: showBorder,
            UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry,
            size: size
        });
        $[9] = UNSAFE_isUpdatedGeometry;
        $[10] = accountId;
        $[11] = agentName;
        $[12] = resolvedFallback;
        $[13] = showBorder;
        $[14] = size;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t5 || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t5
        }, t6);
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== resolvedFallback || $[20] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: resolvedFallback
        }, t7);
        $[19] = resolvedFallback;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
} : ({ agentIdentityAccountId: agentIdentityAccountId, agentName: agentName, fallback: fallback, showBorder: showBorder = false, size: size = 'medium', UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry })=>{
    const resolvedFallback = fallback ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "hexagon",
        name: agentName,
        size: size,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry
    });
    const accountId = $4d36537dd1ad55e2$var$parseIdentityAccountId(agentIdentityAccountId);
    if (!accountId) return resolvedFallback;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: resolvedFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
            appearance: "hexagon",
            size: size
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4d36537dd1ad55e2$var$FetchedAgentAvatar, {
        accountId: accountId,
        agentName: agentName,
        fallback: resolvedFallback,
        showBorder: showBorder,
        UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry,
        size: size
    })));
};
module.exports["ResolvedAgentAvatar"] = $4d36537dd1ad55e2$export$4e9b8ef47b20fa25;

});

parcelRegister("3upRY", function(module, exports) {
/**
 * @generated SignedSource<<765322731b31afdb0584c134ed53e12a>>
 * @relayHash 07c2f9612a7a8401a21c6ad1a0936b2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aa69c7a83a201b1f2a5cdca116d15f149410a79d7ce49e3fafb7ce1e4a4e38d5
const $9f11dc73dc13bcc3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ResolvedAgentAvatarQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ResolvedAgentAvatarQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "aa69c7a83a201b1f2a5cdca116d15f149410a79d7ce49e3fafb7ce1e4a4e38d5",
            "metadata": {},
            "name": "ResolvedAgentAvatarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9f11dc73dc13bcc3$var$node.hash = "a2c97e7ac7feca789629a3b50c6150aa";
var $9f11dc73dc13bcc3$export$2e2bcd8739ae039 = $9f11dc73dc13bcc3$var$node;
module.exports["default"] = $9f11dc73dc13bcc3$export$2e2bcd8739ae039;

});

parcelRegister("02cx8", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4c5988c837301b49$export$d4c72bab9d6cc13a = {
    actions: [],
    copiedPageContentId: null,
    copiedPageActions: [],
    agentMentionId: null,
    agentMentionInsertionCount: 0,
    resolvedAgentMentionId: null,
    agentMentionContext: null,
    agentMentionPrompt: null,
    agentMentionName: null,
    agentMentionParentNodeType: null,
    agentMentionNodeLocalId: null
};
const $4c5988c837301b49$export$e324594224ef24da = {
    setActions: (actions)=>({ setState: setState })=>{
            setState({
                actions: actions
            });
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                context: context
            });
        },
    removeContext: ()=>({ setState: setState })=>{
            setState({
                context: undefined
            });
        },
    removeActions: ()=>({ setState: setState })=>{
            setState({
                actions: []
            });
        },
    setCopiedPageState: ({ contentId: contentId, actions: copiedPageActions })=>({ setState: setState })=>{
            setState({
                copiedPageContentId: contentId,
                copiedPageActions: copiedPageActions
            });
        },
    clearCopiedPageState: ()=>({ setState: setState })=>{
            setState({
                copiedPageContentId: null,
                copiedPageActions: []
            });
        },
    setAgentMentionState: (state)=>({ setState: setState, getState: getState })=>{
            // Only reset resolvedAgentMentionId when the agent itself changes — not when
            // agentMentionContext updates (user typing after the mention) — to prevent the nudge
            // from flashing on every keystroke while the resolved UUID is already available.
            const current = getState();
            // Reset resolvedAgentMentionId when the agent changes OR when a new insertion
            // is made for the same agent — the insertion count increase means a new fetch
            // is about to start, and the old resolved UUID should not persist if it fails.
            const shouldResetResolved = state.agentMentionId !== current.agentMentionId || state.agentMentionInsertionCount !== current.agentMentionInsertionCount;
            setState({
                ...state,
                ...shouldResetResolved ? {
                    resolvedAgentMentionId: null
                } : {}
            });
        },
    setResolvedAgentMentionId: (resolvedAgentMentionId)=>({ setState: setState })=>{
            setState({
                resolvedAgentMentionId: resolvedAgentMentionId
            });
        }
};
const $4c5988c837301b49$export$e72cf4a64160987e = (0, $8s9DV.createStore)({
    initialState: $4c5988c837301b49$export$d4c72bab9d6cc13a,
    actions: $4c5988c837301b49$export$e324594224ef24da,
    name: 'EditorRovoButtonActionsStore'
});
const $4c5988c837301b49$export$b95031893a3d9d63 = (0, $kBr4q.createActionsHook)($4c5988c837301b49$export$e72cf4a64160987e);
const $4c5988c837301b49$export$c693678b9cc11679 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.actions
});
const $4c5988c837301b49$export$59213a5c9f9d59b8 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.context
});
const $4c5988c837301b49$export$55e2629117d47ccd = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.copiedPageContentId
});
const $4c5988c837301b49$export$775383c2d1c66c92 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.copiedPageActions
});
const $4c5988c837301b49$export$f47243b349b78626 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionId
});
const $4c5988c837301b49$export$65c1c9c4f5245bef = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionInsertionCount
});
const $4c5988c837301b49$export$c4372fb8872a2f0b = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.resolvedAgentMentionId
});
const $4c5988c837301b49$export$5c060a79a26e7361 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionContext
});
const $4c5988c837301b49$export$4f371676b9a398fe = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionPrompt
});
const $4c5988c837301b49$export$95a191dd4fa0d1fd = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionName
});
const $4c5988c837301b49$export$f79a54b315516f9f = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionParentNodeType
});
const $4c5988c837301b49$export$af8dd61c1ae633af = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionNodeLocalId ?? null
});
module.exports["useEditorRovoButtonActions"] = $4c5988c837301b49$export$b95031893a3d9d63;
module.exports["useEditorRovoButtonActionsActions"] = $4c5988c837301b49$export$c693678b9cc11679;
module.exports["useEditorRovoButtonActionsContext"] = $4c5988c837301b49$export$59213a5c9f9d59b8;
module.exports["useEditorRovoButtonCopiedPageContentId"] = $4c5988c837301b49$export$55e2629117d47ccd;
module.exports["useEditorRovoButtonCopiedPageActions"] = $4c5988c837301b49$export$775383c2d1c66c92;
module.exports["useEditorRovoButtonAgentMentionId"] = $4c5988c837301b49$export$f47243b349b78626;
module.exports["useEditorRovoButtonAgentMentionInsertionCount"] = $4c5988c837301b49$export$65c1c9c4f5245bef;
module.exports["useEditorRovoButtonResolvedAgentMentionId"] = $4c5988c837301b49$export$c4372fb8872a2f0b;
module.exports["useEditorRovoButtonAgentMentionContext"] = $4c5988c837301b49$export$5c060a79a26e7361;
module.exports["useEditorRovoButtonAgentMentionPrompt"] = $4c5988c837301b49$export$4f371676b9a398fe;
module.exports["useEditorRovoButtonAgentMentionName"] = $4c5988c837301b49$export$95a191dd4fa0d1fd;
module.exports["useEditorRovoButtonAgentMentionNodeLocalId"] = $4c5988c837301b49$export$af8dd61c1ae633af;

});

parcelRegister("jQDPt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cJ0FD = parcelRequire("cJ0FD");


var $gP4Ah = parcelRequire("gP4Ah");


var $iKq5p = parcelRequire("iKq5p");


var $aDLTK = parcelRequire("aDLTK");


var $d1E9z = parcelRequire("d1E9z");


var $4dGeq = parcelRequire("4dGeq");


var $7lEy4 = parcelRequire("7lEy4");


var $gLHF9 = parcelRequire("gLHF9");


var $3ZJWK = parcelRequire("3ZJWK");


var $6691T = parcelRequire("6691T");

const $2c0f5767430884e4$var$createIcon = (src)=>()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: src,
            alt: ''
        });
const $2c0f5767430884e4$var$defaultIcon = $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($7lEy4))));
const $2c0f5767430884e4$export$cbe04d535daede57 = {
    Analyze: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($gP4Ah)))),
    Brainstorm: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($iKq5p)))),
    Review: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($3ZJWK)))),
    Summarize: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($6691T)))),
    Create: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($aDLTK)))),
    Execute: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($d1E9z)))),
    Find: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($4dGeq)))),
    Learn: $2c0f5767430884e4$var$createIcon((0, (/*@__PURE__*/$parcel$interopDefault($gLHF9))))
};
const $2c0f5767430884e4$export$8581fc8a588fa6e0 = $2c0f5767430884e4$var$defaultIcon;
const $2c0f5767430884e4$export$9b54dda66a3b3d54 = (useCase)=>{
    if (useCase === undefined || !(useCase in $2c0f5767430884e4$export$cbe04d535daede57)) return $2c0f5767430884e4$var$defaultIcon;
    return $2c0f5767430884e4$export$cbe04d535daede57[useCase];
};
module.exports["getUseCaseIcon"] = $2c0f5767430884e4$export$9b54dda66a3b3d54;

});

parcelRegister("gP4Ah", function(module, exports) {
module.exports = new URL("analyze-icon.5c4c7ecb.svg", import.meta.url).toString();

});

parcelRegister("iKq5p", function(module, exports) {
module.exports = new URL("brainstorm-icon.f24d96f2.svg", import.meta.url).toString();

});

parcelRegister("aDLTK", function(module, exports) {
module.exports = new URL("create-icon.59c93a6c.svg", import.meta.url).toString();

});

parcelRegister("d1E9z", function(module, exports) {
module.exports = new URL("execute-icon.d7c359b6.svg", import.meta.url).toString();

});

parcelRegister("4dGeq", function(module, exports) {
module.exports = new URL("find-icon.63225fe6.svg", import.meta.url).toString();

});

parcelRegister("7lEy4", function(module, exports) {
module.exports = new URL("general-prompt-icon.5618909f.svg", import.meta.url).toString();

});

parcelRegister("gLHF9", function(module, exports) {
module.exports = new URL("learn-icon.7e0ca0d6.svg", import.meta.url).toString();

});

parcelRegister("3ZJWK", function(module, exports) {
module.exports = new URL("review-icon.7da7ded4.svg", import.meta.url).toString();

});

parcelRegister("6691T", function(module, exports) {
module.exports = new URL("summarize-icon.5a91c5af.svg", import.meta.url).toString();

});

parcelRegister("c9vDa", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $dTEBe = parcelRequire("dTEBe");


var $1nHVU = parcelRequire("1nHVU");


var $1AJi3 = parcelRequire("1AJi3");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $eCmUm = parcelRequire("eCmUm");


var $3WsfO = parcelRequire("3WsfO");


var $25qMx = parcelRequire("25qMx");


var $ep3mz = parcelRequire("ep3mz");


var $jln20 = parcelRequire("jln20");


var $d9tcB = parcelRequire("d9tcB");


var $bQm3c = parcelRequire("bQm3c");


var $gRU1O = parcelRequire("gRU1O");


const $9df5a079aa3d567d$var$remixObjectPagePopupLoader = ()=>(parcelRequire("6NM5b"));
const $9df5a079aa3d567d$var$RemixObjectPagePopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "WW0_T",
    name: "RemixObjectPagePopup",
    loader: async ()=>(await $9df5a079aa3d567d$var$remixObjectPagePopupLoader()).RemixObjectPagePopup
}); // Split out rather than imported directly: this provider is part of the eager

// ObjectSidebarControl chunk, and PageRemixSubmitOwner pulls in the conversation assistant.
// Background priority because the coordinator is invisible until the user submits in Rovo, so it
// must not hold the page-load metric — BACKGROUND is the one priority excluded from the UFO hold.
const $9df5a079aa3d567d$var$PageRemixSubmitOwner = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "Xy3Xy",
    name: "PageRemixSubmitOwner",
    loader: async ()=>(await (parcelRequire("bsZnK"))).PageRemixSubmitOwner
});
const $9df5a079aa3d567d$var$stablePopupTriggerStyle = null;
const $9df5a079aa3d567d$var$POPUP_TRIGGER_TEST_ID = 'object-sidebar-remix-popup-trigger'; // Covers the Remix button, matching the legacy overlay trigger, so `left-end` lines the popup up
// with the button rather than with wherever this provider renders.
const $9df5a079aa3d567d$var$anchoredPopupTriggerStyle = null;
const $9df5a079aa3d567d$var$ignorePopupAnchor = ()=>{};
const $9df5a079aa3d567d$var$legacySession = {
    hasAdapter: false,
    isObjectSidebarRemixModalOpen: false,
    isRemixStartBlockedByActiveFlow: false,
    isRovoRemixStarted: false,
    markRovoRemixStarted: ()=>{},
    clearRovoRemixStarted: ()=>{},
    retainedLifecycleToken: undefined,
    admitLifecycle: ()=>true,
    admitObjectSidebarRemixLifecycle: ()=>'legacy',
    admitRetainedObjectSidebarRemixLifecycle: ()=>({
            status: 'legacy'
        }),
    openObjectSidebarRemixModal: ()=>{},
    releaseCurrentRetainedLifecycle: ()=>{},
    releaseRetainedLifecycleForToken: ()=>{},
    releaseRetainedLifecycleWithoutEnd: ()=>{},
    closeObjectSidebarRemixModal: ()=>{},
    stopObjectSidebarRemixThinking: ()=>{},
    observeLegacyPhase: ()=>{},
    registerPopupAnchor: $9df5a079aa3d567d$var$ignorePopupAnchor
}; /**
    * The page the last mounted Object Sidebar session saw. Module scope, so it survives the remount
    * that navigating to another host tree causes (a folder, space overview or database, or straight
    * into editing another page).
    */ 
let $9df5a079aa3d567d$var$lastSeenPageContentId;
const $9df5a079aa3d567d$var$ObjectSidebarRemixLifecycleSessionContext = /*#__PURE__*/ (0, $cozmU.createContext)($9df5a079aa3d567d$var$legacySession);
const $9df5a079aa3d567d$export$dd4ef3ed24572382 = ({ children: children, lifecycleAdapter: lifecycleAdapter, contentBodyValue: contentBodyValue, getAdfDocument: getAdfDocument, isRemixEntryEligible: isRemixEntryEligible = false, isObjectSidebarExpanded: isObjectSidebarExpanded = false })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { width: rightSidebarWidth } = rightSidebarContext.getCurrent() || {};
    const { openConversationAssistant: openConversationAssistant, isConversationAssistantSidebarActive: isConversationAssistantSidebarActive, mode: mode } = (0, $1AJi3.useToggleConversationAssistant)();
    const lifecycleOwner = (0, $eCmUm.useObjectSidebarRemixLifecycleOwner)();
    const { isLoggedIn: isLoggedIn, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)(); // Match App.jsx: only mount conversation-assistant when Rovo chat is allowed for this user.
    // Without this, variant2 eagerly mounts PageRemixSubmitOwner on tenants where Rovo is off,
    // which fetches conversation history, 404s, and shows a misleading toast on page load.
    const isRovoEnabled = isRovoLLMEnabled && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS; /**
                                                                                                                       * Latched on the first expand, never cleared.
                                                                                                                       *
                                                                                                                       * The coordinator has to outlive the Remix button, which unmounts whenever the Object Sidebar
                                                                                                                       * collapses — that is the submit-dropping bug this host exists to fix. But hosting it
                                                                                                                       * unconditionally would mount the conversation assistant, and its history fetch, on every
                                                                                                                       * view-page and edit-page load even for people who never open the sidebar. Latching keeps both
                                                                                                                       * properties: nothing is paid until the sidebar is opened once, and a later collapse cannot
                                                                                                                       * unmount the coordinator.
                                                                                                                       *
                                                                                                                       * Starts false so the server never renders the coordinator, which also keeps this branch out of
                                                                                                                       * the SSR/hydration comparison. The button cannot be clicked before the first expand, so there
                                                                                                                       * is no submit to miss while this is still false.
                                                                                                                       */ 
    const [hasObjectSidebarBeenExpanded, setHasObjectSidebarBeenExpanded] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isObjectSidebarExpanded) setHasObjectSidebarBeenExpanded(true);
    }, [
        isObjectSidebarExpanded
    ]);
    const shouldHostRovoRemixOwner = isRemixEntryEligible && isRovoEnabled && hasObjectSidebarBeenExpanded && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-remix-menu-multivariant', 'cohort', 'variant2');
    const retainedLifecycleRef = (0, $cozmU.useRef)(undefined);
    const [retainedLifecycleToken, setRetainedLifecycleToken] = (0, $cozmU.useState)();
    const [isRovoRemixStarted, setIsRovoRemixStarted] = (0, $cozmU.useState)(false);
    const markRovoRemixStarted = (0, $cozmU.useCallback)(()=>setIsRovoRemixStarted(true), []);
    const clearRovoRemixStarted = (0, $cozmU.useCallback)(()=>setIsRovoRemixStarted(false), []); /**
                                                                                      * Clears the started flag when the Rovo panel closes.
                                                                                      *
                                                                                      * Closing the Rovo panel publishes nothing to subscribe to, so the only way to notice it is to
                                                                                      * watch whether the panel is showing. The same click that starts the Remix also asks the panel
                                                                                      * to open, so a close is only acted on once the panel has been seen open at least once.
                                                                                      *
                                                                                      * This lives here rather than in the Remix button because the flag lives here. The button
                                                                                      * unmounts whenever the Object Sidebar collapses, so an observer there would miss a close that
                                                                                      * happened while collapsed and the button would come back still looking selected.
                                                                                      */ 
    const isRovoPanelOpen = isConversationAssistantSidebarActive || mode !== undefined;
    const hasSeenRovoPanelOpenRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isRovoPanelOpen) {
            hasSeenRovoPanelOpenRef.current = true;
            return;
        }
        if (!hasSeenRovoPanelOpenRef.current) return;
        hasSeenRovoPanelOpenRef.current = false;
        clearRovoRemixStarted(); // Keep holding Remix for a generation handed off to Rovo Chat. Confluence opts out of aborting
    // on close (`preventAbortRequestsOnStandaloneChatClose`), so the turn keeps running, and the
    // app-level watcher releases the hold once its conversation settles.
    }, [
        clearRovoRemixStarted,
        isRovoPanelOpen
    ]); // A handed-off generation belongs to the page it started on, so stop holding Remix for it once an
    // Object Sidebar is on another page. Not on unmount: switching between view and edit mounts a
    // new Object Sidebar tree for the same page, and the watcher and timers still end the hold.
    // An unknown id (e.g. mid route change) is skipped, so it neither releases nor hides a change.
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    (0, $cozmU.useEffect)(()=>{
        if (pageContentId === undefined) return;
        if ($9df5a079aa3d567d$var$lastSeenPageContentId !== undefined && $9df5a079aa3d567d$var$lastSeenPageContentId !== pageContentId) (0, $1nHVU.releaseRemixHandoffHolds)('object-sidebar', 'left-page');
        $9df5a079aa3d567d$var$lastSeenPageContentId = pageContentId;
    }, [
        pageContentId
    ]); // One no-exposure read per mounted Rovo owner decides the Rovo-sidebar submit path.
    // Exposure is recorded on the Remix button click, not here.
    const isLifecycleTreatmentEnabledForRovoOwnerRef = (0, $cozmU.useRef)(undefined);
    if (isLifecycleTreatmentEnabledForRovoOwnerRef.current === undefined) isLifecycleTreatmentEnabledForRovoOwnerRef.current = (0, $eCmUm.isObjectSidebarRemixLifecycleEnabled)();
    const isLifecycleTreatmentEnabledForRovoOwner = isLifecycleTreatmentEnabledForRovoOwnerRef.current; // Read at render, like the click-time check in the button, so the affordance and the start
    // path agree. Only the treatment decides this, so it matches the Rovo page picker, which
    // cannot see this sidebar's lifecycle adapter.
    const isLifecycleTreatmentEnabled = (0, $eCmUm.isObjectSidebarRemixLifecycleEnabled)();
    const isRemixStartBlockedByActiveFlow = (0, $eCmUm.useIsObjectSidebarRemixStartBlocked)(isLifecycleTreatmentEnabled);
    const [activePopupSession, setActivePopupSession] = (0, $cozmU.useState)();
    const activePopupSessionRef = (0, $cozmU.useRef)(undefined);
    const commitActivePopupSession = (0, $cozmU.useCallback)((popupSession)=>{
        activePopupSessionRef.current = popupSession;
        setActivePopupSession(popupSession);
    }, []);
    const isConversationAssistantSidebarActiveRef = (0, $cozmU.useRef)(isConversationAssistantSidebarActive);
    isConversationAssistantSidebarActiveRef.current = isConversationAssistantSidebarActive;
    const reportLifecycleDiagnostic = (0, $3WsfO.useObjectSidebarRemixLifecycleDiagnostics)();
    const reportParityObserverFailure = (0, $cozmU.useCallback)((operation)=>{
        try {
            reportLifecycleDiagnostic('failed', {
                operation: operation
            });
        } catch  {}
    }, [
        reportLifecycleDiagnostic
    ]);
    const observeLegacyPhase = (0, $cozmU.useCallback)((token, phase, entryPath)=>{
        try {
            lifecycleAdapter?.observeLegacyPhase?.(token, phase, entryPath);
        } catch  {
            reportParityObserverFailure('recordLegacyParityPhase'); // Parity observation must never affect the existing lifecycle.
        }
    }, [
        lifecycleAdapter,
        reportParityObserverFailure
    ]);
    const observePageRemixLegacyPhase = (0, $cozmU.useCallback)((phase_0, entryPath_0, token_0)=>observeLegacyPhase(token_0, phase_0, entryPath_0), [
        observeLegacyPhase
    ]);
    const logOwnerDestroyedWithActiveFlow = (0, $cozmU.useCallback)((transferPending)=>{
        reportLifecycleDiagnostic('observed', {
            operation: 'ownerDestroyedWithActiveFlow',
            terminalReason: 'cancelled',
            ...transferPending ? {
                transferPending: true
            } : {}
        });
    }, [
        reportLifecycleDiagnostic
    ]);
    const logOwnerDestroyedWithActiveFlowRef = (0, $cozmU.useRef)(logOwnerDestroyedWithActiveFlow);
    logOwnerDestroyedWithActiveFlowRef.current = logOwnerDestroyedWithActiveFlow;
    const logDuplicateTerminalAttempt = (0, $cozmU.useCallback)((reason)=>{
        reportLifecycleDiagnostic('observed', {
            operation: 'duplicateTerminalAttempt',
            terminalReason: reason
        });
    }, [
        reportLifecycleDiagnostic
    ]);
    const releaseCurrentRetainedLifecycle = (0, $cozmU.useCallback)((reason_0)=>{
        const retainedLifecycle = retainedLifecycleRef.current;
        if (!retainedLifecycle) return;
        retainedLifecycleRef.current = undefined;
        setRetainedLifecycleToken(undefined);
        retainedLifecycle.lifecycle.settleTerminal();
        retainedLifecycle.lifecycle.end(reason_0);
    }, []);
    const releaseRetainedLifecycleForToken = (0, $cozmU.useCallback)((expectedToken, reason_1)=>{
        const retainedLifecycle_0 = retainedLifecycleRef.current;
        if (!expectedToken) return;
        if (!retainedLifecycle_0 || retainedLifecycle_0.token !== expectedToken) {
            logDuplicateTerminalAttempt(reason_1);
            return;
        }
        retainedLifecycleRef.current = undefined;
        setRetainedLifecycleToken(undefined);
        retainedLifecycle_0.lifecycle.settleTerminal();
        retainedLifecycle_0.lifecycle.end(reason_1);
    }, [
        logDuplicateTerminalAttempt
    ]);
    const releaseRetainedLifecycleWithoutEnd = (0, $cozmU.useCallback)((expectedToken_0)=>{
        const retainedLifecycle_1 = retainedLifecycleRef.current;
        if (!expectedToken_0 || !retainedLifecycle_1 || retainedLifecycle_1.token !== expectedToken_0) return;
         // The owner already released on the accepted INSERTED; only the session's token remains.
        retainedLifecycleRef.current = undefined;
        setRetainedLifecycleToken(undefined);
    }, []);
    const admitObjectSidebarRemixLifecycle = (0, $cozmU.useCallback)((request = {})=>{
        // The lifecycle adapter owns rollout at the Object Sidebar Remix start boundary.
        // Disabled/control outcomes fall through to the legacy path.
        const lifecycleRetention = (0, $eCmUm.admitAndRetainObjectSidebarRemixLifecycle)({
            // Admission consumes only startFlow; the Object Sidebar adapter replaces the
            // shared observeLegacyPhase callback with its sidebar-specific signature.
            adapter: lifecycleAdapter ? {
                startFlow: lifecycleAdapter.startFlow
            } : undefined,
            owner: lifecycleOwner,
            request: {
                kind: 'create',
                ...request.conversationId !== undefined && {
                    conversationId: request.conversationId
                }
            }
        });
        if (lifecycleRetention.status === 'active-flow-rejected' || lifecycleRetention.status === 'infrastructure-failure') return 'rejected';
        if (lifecycleRetention.status === 'retained') {
            const token_1 = Symbol('object-sidebar-remix-lifecycle');
            try {
                lifecycleAdapter?.bindObservationToken?.(lifecycleRetention.lifecycle.remixId, token_1);
            } catch  {
                reportParityObserverFailure('bindParityObservationToken'); // A parity observer must never affect lifecycle retention.
            }
            retainedLifecycleRef.current = {
                token: token_1,
                lifecycle: lifecycleRetention.lifecycle
            };
            setRetainedLifecycleToken(token_1);
            const popupSession_0 = activePopupSessionRef.current;
            if (popupSession_0) commitActivePopupSession({
                ...popupSession_0,
                lifecycleToken: token_1
            });
            return 'retained';
        }
        return 'legacy';
    }, [
        commitActivePopupSession,
        lifecycleAdapter,
        lifecycleOwner,
        reportParityObserverFailure
    ]);
    const admitRetainedObjectSidebarRemixLifecycle = (0, $cozmU.useCallback)((request_0 = {})=>{
        const status = admitObjectSidebarRemixLifecycle(request_0);
        if (status !== 'retained') return {
            status: status
        };
        const retained = retainedLifecycleRef.current;
        if (!retained?.lifecycle.conversationId) return {
            status: 'rejected'
        };
        const { token: token_2, lifecycle: lifecycle } = retained;
        return {
            status: status,
            conversationId: lifecycle.conversationId,
            lifecycle: lifecycle,
            observationToken: token_2,
            remixId: lifecycle.remixId,
            transition: (event)=>lifecycle.transition(event),
            isCurrent: ()=>retainedLifecycleRef.current?.token === token_2 && (lifecycle.isCurrent?.() ?? true)
        };
    }, [
        admitObjectSidebarRemixLifecycle
    ]);
    const admitLifecycle = (0, $cozmU.useCallback)((request_1 = {})=>admitObjectSidebarRemixLifecycle(request_1) !== 'rejected', [
        admitObjectSidebarRemixLifecycle
    ]);
    const rovoRemixAdfSourceRef = (0, $cozmU.useRef)({
        contentBodyValue: contentBodyValue,
        getAdfDocument: getAdfDocument
    });
    rovoRemixAdfSourceRef.current = {
        contentBodyValue: contentBodyValue,
        getAdfDocument: getAdfDocument
    };
    const loadRovoRemixAdfDocument = (0, $cozmU.useCallback)(()=>(0, $gRU1O.loadObjectSidebarRemixAdf)(rovoRemixAdfSourceRef.current), []); /**
                                                                                                                     * Terminal handler for the Rovo-sidebar coordinator.
                                                                                                                     *
                                                                                                                     * Uses the request-scoped token supplied by PageRemixModal when present. Legacy close callers
                                                                                                                     * do not have a token, so those use the current retained lifecycle.
                                                                                                                     */ 
    const closeRovoRemixOwner = (0, $cozmU.useCallback)((options)=>{
        const hasRequestToken = options !== undefined && Object.prototype.hasOwnProperty.call(options, 'observationToken');
        const retainedLifecycle_2 = retainedLifecycleRef.current;
        const retainedToken = hasRequestToken ? options?.observationToken : retainedLifecycle_2?.token;
        if (options?.preserveRemixLifecycle) {
            // Intentional transfer into the staging preview: the owner UI hides, the lifecycle stays.
            clearRovoRemixStarted();
            return;
        }
        if (!retainedToken) {
            if (!hasRequestToken) clearRovoRemixStarted();
            return;
        }
        const release = (token_3)=>{
            if (options?.remixLifecycleAlreadySettled) {
                // The machine already tore down on an accepted INSERTED; drop the token without `end`.
                releaseRetainedLifecycleWithoutEnd(token_3);
                return;
            }
            releaseRetainedLifecycleForToken(token_3, options?.remixLifecycleEndReason ?? 'cancelled');
        };
        if (hasRequestToken && retainedLifecycle_2?.token !== retainedToken) {
            release(retainedToken);
            return;
        }
        clearRovoRemixStarted();
        release(retainedToken);
    }, [
        clearRovoRemixStarted,
        releaseRetainedLifecycleForToken,
        releaseRetainedLifecycleWithoutEnd
    ]);
    const stopRovoRemixThinking = (0, $cozmU.useCallback)(()=>{
        clearRovoRemixStarted();
    }, [
        clearRovoRemixStarted
    ]);
    const openObjectSidebarRemixModal = (0, $cozmU.useCallback)((adfDocument, loadAdfDocument, { isLifecycleTreatment: isLifecycleTreatment })=>{
        commitActivePopupSession({
            adfDocument: adfDocument,
            loadAdfDocument: loadAdfDocument,
            isLifecycleTreatment: isLifecycleTreatment,
            isModalOpen: true,
            lifecycleToken: retainedLifecycleRef.current?.token,
            sessionToken: Symbol('object-sidebar-remix-popup-session'),
            isTransferPending: false
        });
    }, [
        commitActivePopupSession
    ]);
    const closeObjectSidebarRemixModal = (0, $cozmU.useCallback)((options_0)=>{
        const popupSession_1 = activePopupSessionRef.current;
        if (!popupSession_1) return;
        commitActivePopupSession({
            ...popupSession_1,
            isModalOpen: false,
            isTransferPending: Boolean(options_0?.preserveRemixLifecycle)
        });
        if (options_0?.preserveRemixLifecycle) return;
        if (options_0?.remixLifecycleAlreadySettled) {
            releaseRetainedLifecycleWithoutEnd(popupSession_1.lifecycleToken);
            return;
        }
        const reason_2 = options_0?.remixLifecycleEndReason ?? 'cancelled';
        if (popupSession_1.lifecycleToken) releaseRetainedLifecycleForToken(popupSession_1.lifecycleToken, reason_2);
        else releaseCurrentRetainedLifecycle(reason_2);
    }, [
        commitActivePopupSession,
        releaseCurrentRetainedLifecycle,
        releaseRetainedLifecycleForToken,
        releaseRetainedLifecycleWithoutEnd
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!pageContentId || !activePopupSession?.isModalOpen || isRemixStartBlockedByActiveFlow || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-ce-maui-close-object-sidebar-on-selection-remix', 'isEnabled', true)) return;
        return (0, $25qMx.subscribeToObjectSidebarRemixPickerClose)((requestedContentId)=>{
            if (requestedContentId === pageContentId) closeObjectSidebarRemixModal();
        });
    }, [
        activePopupSession?.isModalOpen,
        closeObjectSidebarRemixModal,
        isRemixStartBlockedByActiveFlow,
        pageContentId
    ]);
    const closeObjectSidebarRemixModalForSession = (0, $cozmU.useCallback)((expectedSessionToken, options_1)=>{
        const popupSession_2 = activePopupSessionRef.current;
        if (!popupSession_2 || popupSession_2.sessionToken !== expectedSessionToken) {
            if (options_1?.remixLifecycleEndReason) logDuplicateTerminalAttempt(options_1.remixLifecycleEndReason);
            return;
        }
        commitActivePopupSession({
            ...popupSession_2,
            isModalOpen: false,
            isTransferPending: Boolean(options_1?.preserveRemixLifecycle)
        });
        if (options_1?.preserveRemixLifecycle) return;
        if (options_1?.remixLifecycleAlreadySettled) {
            releaseRetainedLifecycleWithoutEnd(popupSession_2.lifecycleToken);
            return;
        }
        const reason_3 = options_1?.remixLifecycleEndReason ?? 'cancelled';
        if (popupSession_2.lifecycleToken) releaseRetainedLifecycleForToken(popupSession_2.lifecycleToken, reason_3);
        else releaseCurrentRetainedLifecycle(reason_3);
    }, [
        commitActivePopupSession,
        logDuplicateTerminalAttempt,
        releaseCurrentRetainedLifecycle,
        releaseRetainedLifecycleForToken,
        releaseRetainedLifecycleWithoutEnd
    ]);
    const stopObjectSidebarRemixThinking = (0, $cozmU.useCallback)((options_2)=>{
        if (!options_2?.reopenModal) return;
        const popupSession_3 = activePopupSessionRef.current;
        if (popupSession_3) commitActivePopupSession({
            ...popupSession_3,
            isModalOpen: true
        });
    }, [
        commitActivePopupSession
    ]);
    const stopObjectSidebarRemixThinkingForSession = (0, $cozmU.useCallback)((expectedSessionToken_0, options_3)=>{
        if (!options_3?.reopenModal) return;
        const popupSession_4 = activePopupSessionRef.current;
        if (popupSession_4?.sessionToken === expectedSessionToken_0) commitActivePopupSession({
            ...popupSession_4,
            isModalOpen: true
        });
    }, [
        commitActivePopupSession
    ]);
    const handleOpenSidebarConversation = (0, $cozmU.useCallback)((conversationId)=>{
        (0, $dTEBe.updatePageRovoParams)({
            pathway: 'chat',
            conversationId: conversationId
        });
        if (!isConversationAssistantSidebarActiveRef.current) openConversationAssistant('sidebar');
    }, [
        openConversationAssistant
    ]);
    const [popupAnchorElement, setPopupAnchorElement] = (0, $cozmU.useState)(null);
    const renderPopupTrigger = (0, $cozmU.useCallback)(({ ref: ref, ...triggerProps })=>{
        if (popupAnchorElement) return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ...triggerProps,
            ref: ref,
            "aria-hidden": "true",
            "data-testid": $9df5a079aa3d567d$var$POPUP_TRIGGER_TEST_ID,
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d _0jFU0VN91d _1pp6NdYbGa"
            ])
        }), popupAnchorElement);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ...triggerProps,
            ref: ref,
            "aria-hidden": "true",
            "data-testid": $9df5a079aa3d567d$var$POPUP_TRIGGER_TEST_ID,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _39xV02HZdu _0jFU0VHZdu _1pp6NdYbGa"
            ])
        });
    }, [
        popupAnchorElement
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const retainedLifecycle_3 = retainedLifecycleRef.current;
            if (!retainedLifecycle_3) return;
            retainedLifecycleRef.current = undefined;
            logOwnerDestroyedWithActiveFlowRef.current(activePopupSessionRef.current?.isTransferPending ?? false);
            retainedLifecycle_3.lifecycle.end('cancelled');
        };
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            hasAdapter: lifecycleAdapter !== undefined,
            isObjectSidebarRemixModalOpen: activePopupSession?.isModalOpen ?? false,
            isRemixStartBlockedByActiveFlow: isRemixStartBlockedByActiveFlow,
            isRovoRemixStarted: isRovoRemixStarted,
            markRovoRemixStarted: markRovoRemixStarted,
            clearRovoRemixStarted: clearRovoRemixStarted,
            retainedLifecycleToken: retainedLifecycleToken,
            admitLifecycle: admitLifecycle,
            admitObjectSidebarRemixLifecycle: admitObjectSidebarRemixLifecycle,
            admitRetainedObjectSidebarRemixLifecycle: admitRetainedObjectSidebarRemixLifecycle,
            openObjectSidebarRemixModal: openObjectSidebarRemixModal,
            releaseCurrentRetainedLifecycle: releaseCurrentRetainedLifecycle,
            releaseRetainedLifecycleForToken: releaseRetainedLifecycleForToken,
            releaseRetainedLifecycleWithoutEnd: releaseRetainedLifecycleWithoutEnd,
            closeObjectSidebarRemixModal: closeObjectSidebarRemixModal,
            stopObjectSidebarRemixThinking: stopObjectSidebarRemixThinking,
            observeLegacyPhase: observeLegacyPhase,
            // Only the treatment hosts the popup here, so control never tracks the Remix button.
            registerPopupAnchor: isLifecycleTreatmentEnabled ? setPopupAnchorElement : $9df5a079aa3d567d$var$ignorePopupAnchor
        }), [
        admitLifecycle,
        admitObjectSidebarRemixLifecycle,
        admitRetainedObjectSidebarRemixLifecycle,
        activePopupSession?.isModalOpen,
        clearRovoRemixStarted,
        closeObjectSidebarRemixModal,
        isLifecycleTreatmentEnabled,
        isRemixStartBlockedByActiveFlow,
        isRovoRemixStarted,
        lifecycleAdapter,
        markRovoRemixStarted,
        openObjectSidebarRemixModal,
        releaseCurrentRetainedLifecycle,
        releaseRetainedLifecycleForToken,
        releaseRetainedLifecycleWithoutEnd,
        retainedLifecycleToken,
        stopObjectSidebarRemixThinking,
        observeLegacyPhase
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9df5a079aa3d567d$var$ObjectSidebarRemixLifecycleSessionContext.Provider, {
        value: value
    }, children, shouldHostRovoRemixOwner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9df5a079aa3d567d$var$PageRemixSubmitOwner, {
        loadAdfDocument: loadRovoRemixAdfDocument,
        onOpenSidebarConversation: handleOpenSidebarConversation,
        onClose: closeRovoRemixOwner,
        onStopThinking: stopRovoRemixThinking,
        onAdmitRemixLifecycle: lifecycleAdapter ? admitLifecycle : undefined,
        onAdmitRetainedRemixLifecycle: lifecycleAdapter && isLifecycleTreatmentEnabledForRovoOwner ? admitRetainedObjectSidebarRemixLifecycle : undefined,
        isRemixLifecycleTreatmentEnabled: isLifecycleTreatmentEnabledForRovoOwner,
        shouldWaitForRemixHandoffBeforeClose: retainedLifecycleToken !== undefined,
        onObserveLegacyPhase: observePageRemixLegacyPhase
    }) : null, activePopupSession ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9df5a079aa3d567d$var$RemixObjectPagePopup, {
        adfDocument: activePopupSession.adfDocument,
        loadAdfDocument: activePopupSession.loadAdfDocument,
        isModalOpen: activePopupSession.isModalOpen,
        isRemixStartBlocked: isRemixStartBlockedByActiveFlow,
        onClose: (options_4)=>closeObjectSidebarRemixModalForSession(activePopupSession.sessionToken, options_4),
        onStopThinking: (options_5)=>stopObjectSidebarRemixThinkingForSession(activePopupSession.sessionToken, options_5),
        popupRepositionKey: rightSidebarWidth,
        onOpenSidebarConversation: handleOpenSidebarConversation,
        onAdmitRetainedRemixLifecycle: admitRetainedObjectSidebarRemixLifecycle,
        isRemixLifecycleTreatmentEnabled: activePopupSession.isLifecycleTreatment,
        shouldWaitForRemixHandoffBeforeClose: activePopupSession.lifecycleToken !== undefined,
        onObserveLegacyPhase: observePageRemixLegacyPhase,
        trigger: renderPopupTrigger
    }) : null);
};
const $9df5a079aa3d567d$export$a75eec40de8c7652 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($9df5a079aa3d567d$var$ObjectSidebarRemixLifecycleSessionContext);
} : ()=>(0, $cozmU.useContext)($9df5a079aa3d567d$var$ObjectSidebarRemixLifecycleSessionContext);
module.exports["ObjectSidebarRemixLifecycleSessionProvider"] = $9df5a079aa3d567d$export$dd4ef3ed24572382;
module.exports["useObjectSidebarRemixLifecycleSession"] = $9df5a079aa3d567d$export$a75eec40de8c7652;

});

parcelRegister("gRU1O", function(module, exports) {
const $9b8c31cc34971291$export$670048d24d0f904b = (value)=>{
    try {
        const parsed = JSON.parse(value);
        if (!parsed || parsed.type !== 'doc') return null;
        return parsed;
    } catch  {
        return null;
    }
};
const $9b8c31cc34971291$export$92447e18d256e861 = async ({ contentBodyValue: contentBodyValue, getAdfDocument: getAdfDocument })=>{
    if (getAdfDocument) return getAdfDocument();
    if (!contentBodyValue) return null;
    return $9b8c31cc34971291$export$670048d24d0f904b(contentBodyValue);
};
module.exports["parseObjectSidebarRemixAdf"] = $9b8c31cc34971291$export$670048d24d0f904b;
module.exports["loadObjectSidebarRemixAdf"] = $9b8c31cc34971291$export$92447e18d256e861;

});

parcelRegister("6NM5b", function(module, exports) {

let $4f3c9dde46921eee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4f3c9dde46921eee$var$load("6wr18"),
    $4f3c9dde46921eee$var$load("gQb60"),
    $4f3c9dde46921eee$var$load("iLt7f"),
    $4f3c9dde46921eee$var$load("iDzF1"),
    $4f3c9dde46921eee$var$load("dEA3e"),
    $4f3c9dde46921eee$var$load("ffEVr"),
    $4f3c9dde46921eee$var$load("8J2eZ")
]).then(()=>parcelRequire('gbIFX'));

});

parcelRegister("bsZnK", function(module, exports) {

let $8591ec6b4d8255ce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8591ec6b4d8255ce$var$load("6wr18"),
    $8591ec6b4d8255ce$var$load("gQb60"),
    $8591ec6b4d8255ce$var$load("iLt7f"),
    $8591ec6b4d8255ce$var$load("iDzF1"),
    $8591ec6b4d8255ce$var$load("dEA3e"),
    $8591ec6b4d8255ce$var$load("ffEVr"),
    $8591ec6b4d8255ce$var$load("eBaA7")
]).then(()=>parcelRequire('icbnP'));

});

parcelRegister("6pfrs", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aGFDz = parcelRequire("aGFDz");


var $krYZG = parcelRequire("krYZG");


var $lpNn5 = parcelRequire("lpNn5");


var $1sCHt = parcelRequire("1sCHt");


var $4u3xL = parcelRequire("4u3xL");


var $8uM2K = parcelRequire("8uM2K");


var $dF5G8 = parcelRequire("dF5G8");


var $kaHvi = parcelRequire("kaHvi");

const $3fcb9442c8413bbb$var$containerStyles = null;
const $3fcb9442c8413bbb$var$dotStyles = null;
const $3fcb9442c8413bbb$var$i18n = (0, $kSwu1.defineMessages)({
    unseenSuggestionsLabel: {
        id: "object-sidebar-components.review.button.unseen-suggestions.label",
        defaultMessage: "New suggestions available"
    }
});
const $3fcb9442c8413bbb$var$analyticsContext = {
    source: (0, $kaHvi.AnalyticContexts).Source,
    name: `${(0, $kaHvi.AnalyticContexts).Source}ReviewButton`,
    attributes: {
        source: (0, $kaHvi.AnalyticContexts).Source,
        name: `${(0, $kaHvi.AnalyticContexts).Source}ReviewButton`
    }
};
const $3fcb9442c8413bbb$export$5712c6a61ac0c67e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { onStartThinking: onStartThinking, fireAnalyticsEvent: fireAnalyticsEvent, isDisabled: isDisabled, isVisible: isVisible, showNotificationDot: t1 } = t0;
    const showNotificationDot = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const hasFiredExposureRef = (0, $cozmU.useRef)(false);
    let t2;
    let t3;
    if ($[0] !== fireAnalyticsEvent || $[1] !== isVisible) {
        t2 = ()=>{
            if (!isVisible || !fireAnalyticsEvent || hasFiredExposureRef.current) return;
            fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).EXPOSED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                source: (0, $kaHvi.AnalyticContexts).Source,
                attributes: {
                    entryPoint: (0, $aGFDz.AiSuggestionsEntryPointValue).OBJECT_SIDEBAR_CONTROL
                }
            });
            hasFiredExposureRef.current = true;
        };
        t3 = [
            isVisible,
            fireAnalyticsEvent
        ];
        $[0] = fireAnalyticsEvent;
        $[1] = isVisible;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dF5G8.reviewButtonMessages).reviewSuggestionsLabel);
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_3iDTPbccYA _1mT5xdRAKS"
        ]);
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== formatMessage) {
        t6 = formatMessage((0, $dF5G8.reviewButtonMessages).reviewSuggestionsLabel);
        $[6] = formatMessage;
        $[7] = t6;
    } else t6 = $[7];
    const t7 = isRovoButtonEnabled ? "default" : "circle";
    let t8;
    if ($[8] !== isDisabled || $[9] !== onStartThinking || $[10] !== t6 || $[11] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))),
            appearance: "subtle",
            label: t6,
            testId: "object-sidebar-review-button",
            shape: t7,
            onClick: onStartThinking,
            isDisabled: isDisabled,
            analyticsContext: $3fcb9442c8413bbb$var$analyticsContext
        });
        $[8] = isDisabled;
        $[9] = onStartThinking;
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== formatMessage || $[14] !== showNotificationDot) {
        t9 = showNotificationDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "object-sidebar-review-button-notification-dot",
            role: "status",
            "aria-label": formatMessage($3fcb9442c8413bbb$var$i18n.unseenSuggestionsLabel),
            className: (0, $hekY6.default)([
                "_0bjKvDS5Zs _30huDKPmZ8 _0KLXruZFWO _3iDTPbvLZJ _0jFU0VgVvo _39xV02gVvo _1pp6NdYbGa _1mT5xdWVPG _4ApkO24Y4b _2IhTon4Y4b"
            ])
        });
        $[13] = formatMessage;
        $[14] = showNotificationDot;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== t8 || $[17] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: t4,
            delay: 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t5
        }, t8, t9));
        $[16] = t8;
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    return t10;
} : ({ onStartThinking: onStartThinking, fireAnalyticsEvent: fireAnalyticsEvent, isDisabled: isDisabled, isVisible: isVisible, showNotificationDot: showNotificationDot = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const hasFiredExposureRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isVisible || !fireAnalyticsEvent || hasFiredExposureRef.current) return;
        fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).EXPOSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_SUGGESTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            source: (0, $kaHvi.AnalyticContexts).Source,
            attributes: {
                entryPoint: (0, $aGFDz.AiSuggestionsEntryPointValue).OBJECT_SIDEBAR_CONTROL
            }
        });
        hasFiredExposureRef.current = true;
    }, [
        isVisible,
        fireAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dF5G8.reviewButtonMessages).reviewSuggestionsLabel),
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbccYA _1mT5xdRAKS"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))),
        appearance: "subtle",
        label: formatMessage((0, $dF5G8.reviewButtonMessages).reviewSuggestionsLabel),
        testId: "object-sidebar-review-button",
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        onClick: onStartThinking,
        isDisabled: isDisabled,
        analyticsContext: $3fcb9442c8413bbb$var$analyticsContext
    }), showNotificationDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "object-sidebar-review-button-notification-dot",
        role: "status",
        "aria-label": formatMessage($3fcb9442c8413bbb$var$i18n.unseenSuggestionsLabel),
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _30huDKPmZ8 _0KLXruZFWO _3iDTPbvLZJ _0jFU0VgVvo _39xV02gVvo _1pp6NdYbGa _1mT5xdWVPG _4ApkO24Y4b _2IhTon4Y4b"
        ])
    })));
};
module.exports["ReviewButton"] = $3fcb9442c8413bbb$export$5712c6a61ac0c67e;

});

parcelRegister("aGFDz", function(module, exports) {
var $36806560a48d4677$export$8b2fb347c2f49add = /*#__PURE__*/ function(AiSuggestionsEntryPointValue) {
    AiSuggestionsEntryPointValue["PRIMARY_TOOLBAR"] = "primaryToolbar";
    /**
   * @private
   * @deprecated Legacy entry point retained for backwards compatibility.
   * Use `SUGGESTIONS_PANEL_EMPTY_STATE` for the standalone suggestions panel.
   */ AiSuggestionsEntryPointValue["COMMENTS_EMPTY_STATE"] = "commentsEmptyState";
    AiSuggestionsEntryPointValue["SUGGESTIONS_PANEL_EMPTY_STATE"] = "suggestionsPanelEmptyState";
    AiSuggestionsEntryPointValue["SUGGESTIONS_PANEL_HEADER"] = "suggestionsPanelHeader";
    AiSuggestionsEntryPointValue["OBJECT_SIDEBAR_CONTROL"] = "objectSidebarControl";
    /**
   * @private
   * @deprecated Legacy automatic-generation entry point retained for backwards compatibility.
   */ AiSuggestionsEntryPointValue["SUGGESTIONS_PANEL_MOUNT"] = "suggestionsPanelMount";
    /** The "Review" button on the follow-up card after the last suggestion is actioned. */ AiSuggestionsEntryPointValue["FOLLOW_UP_CARD"] = "followUpCard";
    return AiSuggestionsEntryPointValue;
}({});
var $36806560a48d4677$export$ce4d3fb7efb5ebd7 = /*#__PURE__*/ function(AiSuggestionsRightRailEntryPointValue) {
    AiSuggestionsRightRailEntryPointValue["SUGGESTIONS_PANEL"] = "suggestionsPanel";
    AiSuggestionsRightRailEntryPointValue["SUGGESTIONS_TAB"] = "suggestionsTab";
    // Will be deprecated.
    AiSuggestionsRightRailEntryPointValue["SUGGESTION_CARD"] = "suggestionCard";
    return AiSuggestionsRightRailEntryPointValue;
}({});
var $36806560a48d4677$export$edfb4a7c9b0f2530 = /*#__PURE__*/ function(AiSuggestionsRegenerationTriggerValue) {
    AiSuggestionsRegenerationTriggerValue["PANEL_OPEN"] = "panelOpen";
    AiSuggestionsRegenerationTriggerValue["REVIEW_COMPLETED"] = "reviewCompleted";
    AiSuggestionsRegenerationTriggerValue["SUGGESTION_SELECTED"] = "suggestionSelected";
    AiSuggestionsRegenerationTriggerValue["SUGGESTIONS_UPDATED"] = "suggestionsUpdated";
    return AiSuggestionsRegenerationTriggerValue;
}({});
var $36806560a48d4677$export$d51545309fb621fd = /*#__PURE__*/ function(AiSuggestionsRegenerationOutcomeValue) {
    AiSuggestionsRegenerationOutcomeValue["REMOVED"] = "removed";
    AiSuggestionsRegenerationOutcomeValue["STILL_STALE"] = "stillStale";
    AiSuggestionsRegenerationOutcomeValue["UPDATED"] = "updated";
    return AiSuggestionsRegenerationOutcomeValue;
}({});
module.exports["AiSuggestionsEntryPointValue"] = $36806560a48d4677$export$8b2fb347c2f49add;
module.exports["AiSuggestionsRightRailEntryPointValue"] = $36806560a48d4677$export$ce4d3fb7efb5ebd7;
module.exports["AiSuggestionsRegenerationTriggerValue"] = $36806560a48d4677$export$edfb4a7c9b0f2530;
module.exports["AiSuggestionsRegenerationOutcomeValue"] = $36806560a48d4677$export$d51545309fb621fd;

});

parcelRegister("kaHvi", function(module, exports) {
const $d2d09f413114cc28$export$c368c465ccae661 = {
    Source: 'objectSidebar'
};
module.exports["AnalyticContexts"] = $d2d09f413114cc28$export$c368c465ccae661;

});

parcelRegister("hMNzI", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


var $kcIQr = parcelRequire("kcIQr");


var $9wGTI = parcelRequire("9wGTI");

/* FloatingTableOfContentsPopupButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");





var $kSwu1 = parcelRequire("kSwu1");


var $4nIKB = parcelRequire("4nIKB");


var $1sCHt = parcelRequire("1sCHt");


var $7Y8M5 = parcelRequire("7Y8M5");


var $kwzZh = parcelRequire("kwzZh");


var $6OpMl = parcelRequire("6OpMl");


var $clm0n = parcelRequire("clm0n");


var $4n1IT = parcelRequire("4n1IT");


var $lpNn5 = parcelRequire("lpNn5");


var $32x2E = parcelRequire("32x2E");


var $bQm3c = parcelRequire("bQm3c");


var $2FDVd = parcelRequire("2FDVd");

/* TableOfContents.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");

function $d6960769b20023b0$var$countActiveHeadingLevels(activeHeadingLevels, currentHeadingLevel) {
    return Number(currentHeadingLevel > 1 && activeHeadingLevels[0]) + Number(currentHeadingLevel > 2 && activeHeadingLevels[1]) + Number(currentHeadingLevel > 3 && activeHeadingLevels[2]) + Number(currentHeadingLevel > 4 && activeHeadingLevels[3]) + Number(currentHeadingLevel > 5 && activeHeadingLevels[4]);
}
function $d6960769b20023b0$export$21592148bad60f1e(items) {
    const activeHeadingLevels = Array(6).fill(false);
    return items.map((item)=>{
        const indentation = $d6960769b20023b0$var$countActiveHeadingLevels(activeHeadingLevels, item.level);
        // Keep preceding higher-level headings as ancestors, replace the current
        // level, and discard all lower-level headings from the previous section.
        activeHeadingLevels.fill(false, item.level - 1);
        activeHeadingLevels[item.level - 1] = true;
        return indentation;
    });
}


const $a640476dca505e96$var$styles = {
    container: "_0bjKvD8fU6 _39xV02JYcJ _1EqgXlJYcJ _0NUa3rOm3a _2WAcuGIZbP _0KLXruoI2d _2OUyjtGk8v _0Of8r25zaO _1Znuxb8HPE _1wydGW5zaO _2Zuz6Q8HPE",
    list: "_1LMyvKYbGa _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0aNu0LYbGa _3iDTPbQ4SZ _0aFT5vbt8w _42d1HA1Y8M",
    row: "_1LMyvKYbGa _4ouGXIdnbC _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0aNu0LYbGa",
    item: "_0bjKvDKxmn _2sNsIgmnOE _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _24h04i2Njc _39xV02N91d _4ouGXIdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyu7p2s _0jFU0V9DVM _2fwxA57p2s _0Of8r2FQfX _1wydGWFQfX _2Zuz6Q8HPE _1Znuxb8HPE _1kk5Tkf7mX _0KLXru66of _1UtDYzZpcK _2nTuUYZpcK _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126 _0clgaMZpcK _3WzCGi98eZ _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLN4oS",
    text: "_4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7",
    selected: "_0KLXruY9q9 _1UtDYzjTy9 _2nTuUYjTy9 _10n1R5jTy9 _1eOmH6sumd _0clgaMjTy9 _3gzVzLXsxn"
};
const $a640476dca505e96$var$indentationStyles = {
    0: "_2XsHFMPgdg",
    1: "_2XsHFM8HPE",
    2: "_2XsHFMNHnM",
    3: "_2XsHFMNHnM _2Zuz6Q8HPE",
    4: "_2XsHFMp0Oa",
    5: "_2XsHFMp0Oa _2Zuz6Q8HPE"
};
function $a640476dca505e96$var$TableOfContentsRowContent({ item: item, renderEmoji: renderEmoji }) {
    if (!item.content) return item.text;
    return item.content.map((segment, index)=>{
        if (segment.type === 'emoji') return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), {
            key: index
        }, renderEmoji?.(segment));
        return segment.text;
    });
}
function $a640476dca505e96$var$TableOfContentsRow({ indentation: indentation, item: item, isSelected: isSelected, onItemClicked: onItemClicked, onSelect: onSelect, renderEmoji: renderEmoji }) {
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        onItemClicked?.(item); // Preserve native anchor behaviour for modifier/middle clicks so users
        // can open the heading link in a new tab, copy it, etc.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        onSelect(item);
    }, [
        item,
        onItemClicked,
        onSelect
    ]); // Links to the same heading anchor as the "copy heading link" button.
    const href = `#${encodeURIComponent(item.headingId)}`;
    return /*#__PURE__*/ $cozmU.createElement("li", {
        className: (0, $hekY6.default)([
            $a640476dca505e96$var$styles.row,
            $a640476dca505e96$var$indentationStyles[indentation]
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        "aria-current": isSelected ? 'location' : undefined,
        href: href,
        onClick: handleClick,
        xcss: (0, $w6R6I.cx)($a640476dca505e96$var$styles.item, isSelected && $a640476dca505e96$var$styles.selected)
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        title: item.text,
        className: (0, $hekY6.default)([
            $a640476dca505e96$var$styles.text
        ])
    }, /*#__PURE__*/ $cozmU.createElement($a640476dca505e96$var$TableOfContentsRowContent, {
        item: item,
        renderEmoji: renderEmoji
    }))));
}
function $a640476dca505e96$export$65a20d5539dff777({ items: items, onItemClicked: onItemClicked, onSelect: onSelect, selectedHeadingId: selectedHeadingId, label: label, emptyState: emptyState, maxHeight: maxHeight, renderEmoji: renderEmoji }) {
    const indentationByItem = (0, $cozmU.useMemo)(()=>(0, $d6960769b20023b0$export$21592148bad60f1e)(items), [
        items
    ]);
    const selectedItemIndex = (0, $cozmU.useMemo)(()=>items.findIndex((item)=>item.headingId === selectedHeadingId), [
        items,
        selectedHeadingId
    ]);
    if (items.length === 0) return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            maxHeight: maxHeight
        },
        className: (0, $hekY6.default)([
            $a640476dca505e96$var$styles.container
        ])
    }, emptyState ?? null);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            maxHeight: maxHeight
        },
        className: (0, $hekY6.default)([
            $a640476dca505e96$var$styles.container
        ])
    }, /*#__PURE__*/ $cozmU.createElement("nav", {
        "aria-label": label
    }, /*#__PURE__*/ $cozmU.createElement("ul", {
        className: (0, $hekY6.default)([
            $a640476dca505e96$var$styles.list
        ])
    }, items.map((item, index)=>/*#__PURE__*/ $cozmU.createElement($a640476dca505e96$var$TableOfContentsRow, {
            indentation: indentationByItem[index],
            key: item.headingId,
            item: item,
            isSelected: index === selectedItemIndex,
            onItemClicked: onItemClicked,
            onSelect: onSelect,
            renderEmoji: renderEmoji
        })))));
}






var $202oG = parcelRequire("202oG");

const $911130830731c441$var$MAX_SCROLL_SELECTION_LOOKAHEAD_PX = 80;
const $911130830731c441$var$MAX_SCROLL_SELECTION_LOOKAHEAD_RATIO = 0.2;
const $911130830731c441$var$SCROLL_BOUNDARY_TOLERANCE_PX = 1;
function $911130830731c441$export$fd2d0505fc98cd69(items, getHeadingElement) {
    return items.flatMap((item)=>{
        const element = getHeadingElement(item.headingId);
        if (!element) return [];
        const scrollMarginTop = Number.parseFloat(element.ownerDocument.defaultView?.getComputedStyle(element).scrollMarginTop ?? '');
        return [
            {
                element: element,
                headingId: item.headingId,
                scrollMarginTop: Number.isFinite(scrollMarginTop) ? scrollMarginTop : 0
            }
        ];
    });
}
function $911130830731c441$export$606ab41112d661b6(resolvedHeadings, scrollBoundaryTop, scrollContainerHeight) {
    const scrollSelectionLookahead = Math.min($911130830731c441$var$MAX_SCROLL_SELECTION_LOOKAHEAD_PX, Math.max(0, scrollContainerHeight * $911130830731c441$var$MAX_SCROLL_SELECTION_LOOKAHEAD_RATIO));
    let firstRenderedHeadingId;
    for(let index = resolvedHeadings.length - 1; index >= 0; index--){
        const { element: element, headingId: headingId, scrollMarginTop: scrollMarginTop } = resolvedHeadings[index];
        const headingRect = element.getBoundingClientRect();
        if (headingRect.width === 0 && headingRect.height === 0) continue;
        firstRenderedHeadingId = headingId;
        if (headingRect.top <= scrollBoundaryTop + scrollSelectionLookahead + scrollMarginTop + $911130830731c441$var$SCROLL_BOUNDARY_TOLERANCE_PX) return headingId;
    }
    return firstRenderedHeadingId;
}
function $911130830731c441$export$21cb54c8a4b797bd(scrollContainer, ownerWindow, onScroll) {
    let animationFrameId;
    const scheduleScrollUpdate = ()=>{
        if (animationFrameId !== undefined) return;
        animationFrameId = ownerWindow.requestAnimationFrame(()=>{
            animationFrameId = undefined;
            onScroll();
        });
    };
    scrollContainer.addEventListener('scroll', scheduleScrollUpdate, {
        passive: true
    });
    return ()=>{
        scrollContainer.removeEventListener('scroll', scheduleScrollUpdate);
        if (animationFrameId !== undefined) ownerWindow.cancelAnimationFrame(animationFrameId);
    };
}


const $b52c1b00568353bd$var$EDITOR_SCROLL_CONTAINER_SELECTOR = '[data-editor-scroll-container="true"]';
function $b52c1b00568353bd$export$12f5252b097ff8c(items, isEnabled) {
    const [selectedHeadingId, setSelectedHeadingId] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled || items.length === 0) {
            setSelectedHeadingId(undefined);
            return;
        }
        const headingElements = (0, $202oG.getHeadingIdsToElements)();
        const resolvedHeadings = (0, $911130830731c441$export$fd2d0505fc98cd69)(items, (headingId)=>headingElements.get(headingId));
        const scrollContainer = resolvedHeadings[0]?.element.closest($b52c1b00568353bd$var$EDITOR_SCROLL_CONTAINER_SELECTOR);
        const ownerWindow = scrollContainer?.ownerDocument.defaultView;
        if (!scrollContainer || !ownerWindow) {
            setSelectedHeadingId(undefined);
            return;
        }
        const updateSelectedHeading = ()=>{
            const scrollContainerRect = scrollContainer.getBoundingClientRect();
            const nextSelectedHeadingId = (0, $911130830731c441$export$606ab41112d661b6)(resolvedHeadings, scrollContainerRect.top, scrollContainerRect.height);
            setSelectedHeadingId((currentSelectedHeadingId)=>currentSelectedHeadingId === nextSelectedHeadingId ? currentSelectedHeadingId : nextSelectedHeadingId);
        };
        updateSelectedHeading();
        return (0, $911130830731c441$export$21cb54c8a4b797bd)(scrollContainer, ownerWindow, updateSelectedHeading);
    }, [
        isEnabled,
        items
    ]);
    return selectedHeadingId;
}






const $9c2d3015ca1487b7$var$VIEW_PAGE_SCROLL_CONTAINER_ID = 'AkMainContent';
function $9c2d3015ca1487b7$export$821dad9045c8f29d(items, isEnabled, triggerRef) {
    const [selectedHeadingId, setSelectedHeadingId] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled || items.length === 0) {
            setSelectedHeadingId(undefined);
            return;
        }
        const ownerDocument = triggerRef.current?.ownerDocument;
        const ownerWindow = ownerDocument?.defaultView;
        if (!ownerDocument || !ownerWindow) {
            setSelectedHeadingId(undefined);
            return;
        }
        const resolvedHeadings = (0, $911130830731c441$export$fd2d0505fc98cd69)(items, (headingId)=>ownerDocument.getElementById(headingId));
        const scrollContainer = ownerDocument.getElementById($9c2d3015ca1487b7$var$VIEW_PAGE_SCROLL_CONTAINER_ID);
        const scrollTarget = scrollContainer ?? ownerDocument;
        const updateSelectedHeading = ()=>{
            const scrollContainerRect = scrollContainer?.getBoundingClientRect();
            const nextSelectedHeadingId = (0, $911130830731c441$export$606ab41112d661b6)(resolvedHeadings, scrollContainerRect?.top ?? 0, scrollContainerRect?.height ?? ownerWindow.innerHeight);
            setSelectedHeadingId((currentSelectedHeadingId)=>currentSelectedHeadingId === nextSelectedHeadingId ? currentSelectedHeadingId : nextSelectedHeadingId);
        };
        updateSelectedHeading();
        return (0, $911130830731c441$export$21cb54c8a4b797bd)(scrollTarget, ownerWindow, updateSelectedHeading);
    }, [
        isEnabled,
        items,
        triggerRef
    ]);
    return selectedHeadingId;
}


const $72b4eb5e7f963d5f$var$DEFAULT_POPUP_OFFSET = [
    8,
    16
];
const $72b4eb5e7f963d5f$var$SIDEBAR_POPUP_OFFSET = [
    0,
    8
];
const $72b4eb5e7f963d5f$var$CONFLUENCE_HEADER_HEIGHT = '56px';
const $72b4eb5e7f963d5f$var$TOC_EMOJI_HEIGHT = 16;
const $72b4eb5e7f963d5f$var$buttonContainerStyles = null;
const $72b4eb5e7f963d5f$var$changeboardingIndicatorStyles = null;
const $72b4eb5e7f963d5f$var$i18n = (0, $kSwu1.defineMessages)({
    emptyToc: {
        id: "floating-table-of-contents-common.empty-toc",
        defaultMessage: "Add headings to navigate your content."
    }
});
function $72b4eb5e7f963d5f$var$getOutlineMaxHeight(isToolbarDocked) {
    const toolbarHeight = isToolbarDocked ? (0, $7Y8M5.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)() : '0px';
    return `calc(60dvh - ${toolbarHeight} - ${$72b4eb5e7f963d5f$var$CONFLUENCE_HEADER_HEIGHT})`;
}
function $72b4eb5e7f963d5f$var$useRenderTableOfContentsEmoji() {
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    return (0, $cozmU.useCallback)((emoji)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OpMl.default), {
            emojiId: {
                id: emoji.id,
                shortName: emoji.shortName,
                fallback: emoji.text
            },
            emojiProvider: (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
                cloudId: cloudId,
                userId: userId
            }),
            fitToHeight: $72b4eb5e7f963d5f$var$TOC_EMOJI_HEIGHT,
            showTooltip: true
        }), [
        cloudId,
        userId
    ]);
}
function $72b4eb5e7f963d5f$var$PopupPositioningReference({ popupRef: popupRef, positioningRef: positioningRef }) {
    (0, $cozmU.useEffect)(()=>{
        // Popup positions from its trigger ref. Point that ref at the supplied container while
        // leaving the actual trigger button in its existing place in the DOM and tab order.
        const mergedPopupRef = (0, $4nIKB.mergeRefs)([
            popupRef
        ]);
        mergedPopupRef.current = positioningRef.current;
        return ()=>{
            mergedPopupRef.current = null;
        };
    }, [
        popupRef,
        positioningRef
    ]);
    return null;
}
function $72b4eb5e7f963d5f$var$PositionedPopupContent({ children: children, contentRef: contentRef, onHeightChange: onHeightChange, positioningRef: positioningRef }) {
    (0, $cozmU.useLayoutEffect)(()=>{
        const positioningElement = positioningRef?.current;
        const popupContent = contentRef.current;
        if (!positioningElement || !popupContent) return;
        const positioningElementHeight = positioningElement.getBoundingClientRect().height;
        const updateHeight = ()=>{
            onHeightChange(popupContent.getBoundingClientRect().height, positioningElementHeight);
        };
        updateHeight();
        if (typeof ResizeObserver === 'undefined') return;
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(popupContent);
        return ()=>resizeObserver.disconnect();
    }, [
        contentRef,
        onHeightChange,
        positioningRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: contentRef
    }, children);
}
function $72b4eb5e7f963d5f$export$99a5213711981ec8({ items: items, onItemClicked: onItemClicked, onSelect: onSelect, onOpenChange: onOpenChange, isToolbarDocked: isToolbarDocked = false, isReady: isReady = true, popupPositioningRef: popupPositioningRef, popupRepositionKey: popupRepositionKey, scrollMode: scrollMode = 'renderer', showChangeboardingIndicator: showChangeboardingIndicator = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [sidebarPopupOffset, setSidebarPopupOffset] = (0, $cozmU.useState)($72b4eb5e7f963d5f$var$SIDEBAR_POPUP_OFFSET);
    const triggerRef = (0, $cozmU.useRef)(null);
    const popupContentRef = (0, $cozmU.useRef)(null);
    const editorScrollSelectedHeadingId = (0, $b52c1b00568353bd$export$12f5252b097ff8c)(items, isOpen && scrollMode === 'editor');
    const rendererScrollSelectedHeadingId = (0, $9c2d3015ca1487b7$export$821dad9045c8f29d)(items, isOpen && scrollMode === 'renderer', triggerRef);
    const scrollSelectedHeadingId = scrollMode === 'editor' ? editorScrollSelectedHeadingId : rendererScrollSelectedHeadingId;
    const renderEmoji = $72b4eb5e7f963d5f$var$useRenderTableOfContentsEmoji();
    const buttonLabel = formatMessage((0, $2FDVd.tableOfContentsButtonMessages).buttonLabel);
    const updatePopupOffset = (0, $cozmU.useCallback)((popupContentHeight, positioningElementHeight)=>{
        // `left-end` bottom-aligns the popup; shift shorter content up to align the top instead.
        const verticalOffset = Math.min(popupContentHeight - positioningElementHeight, 0);
        setSidebarPopupOffset([
            verticalOffset,
            $72b4eb5e7f963d5f$var$SIDEBAR_POPUP_OFFSET[1]
        ]);
    }, []);
    const updateIsOpen = (0, $cozmU.useCallback)((nextIsOpen)=>{
        // Notify consumers first so content updates are batched into the popup's opening render.
        onOpenChange?.(nextIsOpen);
        setIsOpen(nextIsOpen);
    }, [
        onOpenChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        const positioningElement = popupPositioningRef?.current;
        if (!isOpen || !positioningElement) return;
        const handlePositioningElementClick = (event)=>{
            const eventPath = event.composedPath();
            const isTriggerClick = triggerRef.current && eventPath.includes(triggerRef.current);
            const isPopupContentClick = popupContentRef.current && eventPath.includes(popupContentRef.current);
            if (!isTriggerClick && !isPopupContentClick) updateIsOpen(false);
        };
        positioningElement.addEventListener('click', handlePositioningElementClick);
        return ()=>positioningElement.removeEventListener('click', handlePositioningElementClick);
    }, [
        isOpen,
        popupPositioningRef,
        updateIsOpen
    ]);
    const handleTriggerClick = (0, $cozmU.useCallback)(()=>{
        if (!isReady) return;
        updateIsOpen(!isOpen);
    }, [
        isOpen,
        isReady,
        updateIsOpen
    ]);
    const renderPopupContent = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($72b4eb5e7f963d5f$var$PositionedPopupContent, {
            contentRef: popupContentRef,
            onHeightChange: updatePopupOffset,
            positioningRef: popupPositioningRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a640476dca505e96$export$65a20d5539dff777), {
            emptyState: formatMessage($72b4eb5e7f963d5f$var$i18n.emptyToc),
            items: items,
            label: buttonLabel,
            maxHeight: $72b4eb5e7f963d5f$var$getOutlineMaxHeight(isToolbarDocked),
            onItemClicked: onItemClicked,
            onSelect: onSelect,
            renderEmoji: renderEmoji,
            selectedHeadingId: scrollSelectedHeadingId
        })), [
        buttonLabel,
        formatMessage,
        isToolbarDocked,
        items,
        onItemClicked,
        onSelect,
        popupPositioningRef,
        renderEmoji,
        scrollSelectedHeadingId,
        updatePopupOffset
    ]);
    const handlePopupClose = (0, $cozmU.useCallback)((event)=>{
        updateIsOpen(false);
        if (event?.type === 'keydown') requestAnimationFrame(()=>triggerRef.current?.focus());
    }, [
        updateIsOpen
    ]);
    const renderPopupTrigger = (0, $cozmU.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, popupPositioningRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($72b4eb5e7f963d5f$var$PopupPositioningReference, {
            popupRef: triggerProps.ref,
            positioningRef: popupPositioningRef
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: buttonLabel,
            position: "left"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbccYA _1mT5xdRAKS"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            ...triggerProps,
            appearance: "subtle",
            ref: popupPositioningRef ? // Popup's ref is redirected to the container; keep the button ref for focus.
            (0, $4nIKB.mergeRefs)([
                triggerRef
            ]) : (0, $4nIKB.mergeRefs)([
                triggerProps.ref,
                triggerRef
            ]),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($clm0n))),
            isSelected: isOpen,
            label: buttonLabel,
            onClick: handleTriggerClick,
            testId: "sidebar-table-of-contents-button"
        }), showChangeboardingIndicator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": "floating-table-of-contents-changeboarding-indicator",
            className: (0, $hekY6.default)([
                "_0bjKvDS5Zs _3vBAKHxCOs _3hxITi6wH8 _2V7sgO2M4S _0KLXrutfbE _3iDTPbvLZJ _0jFU0VZimw _39xV02Zimw _1pp6NdYbGa _1mT5xdWVPG _4ApkO2FQfX _2IhTonFQfX"
            ])
        }) : null))), [
        buttonLabel,
        handleTriggerClick,
        isOpen,
        popupPositioningRef,
        showChangeboardingIndicator
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup // Remount the positioning layer when an external layout change moves its reference.
    ), {
        key: popupRepositionKey,
        autoFocus: false,
        label: buttonLabel,
        content: renderPopupContent,
        isOpen: isOpen,
        onClose: handlePopupClose,
        offset: popupPositioningRef ? sidebarPopupOffset : $72b4eb5e7f963d5f$var$DEFAULT_POPUP_OFFSET,
        placement: "left-end",
        shouldDisableFocusLock: true,
        shouldReturnFocus: false,
        trigger: renderPopupTrigger
    });
}



var $jTt8P = parcelRequire("jTt8P");




function $b0ed91ec0e9afe3f$var$isHeadingLevel(level) {
    return typeof level === 'number' && level >= 1 && level <= 6;
}
function $b0ed91ec0e9afe3f$var$formatDate(timestamp) {
    const millis = Number(timestamp);
    if (!Number.isFinite(millis)) return '';
    return new Intl.DateTimeFormat(undefined, {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    }).format(new Date(millis));
}
function $b0ed91ec0e9afe3f$var$getInlineNodeText(node) {
    if (node.type === 'date') return $b0ed91ec0e9afe3f$var$formatDate(node.attrs?.timestamp);
    return node.text ?? node.attrs?.text ?? node.attrs?.shortName ?? '';
}
function $b0ed91ec0e9afe3f$var$getInlineContent(heading) {
    return (heading.content ?? []).flatMap((node)=>{
        if (!node) return [];
        if (node.type === 'emoji') return [
            {
                type: 'emoji',
                shortName: node.attrs?.shortName ?? '',
                id: node.attrs?.id,
                text: node.attrs?.text
            }
        ];
        const text = $b0ed91ec0e9afe3f$var$getInlineNodeText(node);
        return text ? [
            {
                type: 'text',
                text: text
            }
        ] : [];
    });
}
function $b0ed91ec0e9afe3f$var$createTableOfContentsItem(heading, headingId, position) {
    const level = heading.attrs?.level;
    if (!$b0ed91ec0e9afe3f$var$isHeadingLevel(level)) return undefined;
    const content = $b0ed91ec0e9afe3f$var$getInlineContent(heading);
    const text = content.map((segment)=>segment.type === 'emoji' ? segment.text || segment.shortName : segment.text).join('') || headingId;
    return {
        text: text,
        content: content,
        headingId: headingId,
        level: level,
        ...position === undefined ? {} : {
            position: position
        }
    };
}
function $b0ed91ec0e9afe3f$export$50a9fde73cdd9018(value) {
    if (!value) return [];
    try {
        const document = JSON.parse(value);
        const headingIds = new Set();
        const items = [];
        (0, $jTt8P.traverse)(document, {
            heading: (heading)=>{
                const headingId = (0, $202oG.getHeadingId)(heading, headingIds);
                if (headingId) {
                    const item = $b0ed91ec0e9afe3f$var$createTableOfContentsItem(heading, headingId);
                    if (item) items.push(item);
                }
            }
        });
        return items;
    } catch  {
        return [];
    }
}
function $b0ed91ec0e9afe3f$export$2f59fffc03219521(doc) {
    const headingIds = new Set();
    const items = [];
    doc.descendants((node, position)=>{
        if (node.type.name !== 'heading') return true;
        const heading = node.toJSON();
        const headingId = (0, $202oG.getHeadingId)(heading, headingIds);
        if (headingId) {
            const item = $b0ed91ec0e9afe3f$var$createTableOfContentsItem(heading, headingId, position);
            if (item) items.push(item);
        }
        return false;
    });
    return items;
}



var $d282Z = parcelRequire("d282Z");


var $ivb8S = parcelRequire("ivb8S");


var $jln20 = parcelRequire("jln20");


var $5qQdB = parcelRequire("5qQdB");

const $a31ab96fdcbe9b1f$var$EMPTY_ITEMS = [];
const $a31ab96fdcbe9b1f$var$SELECTED_RENDERER_HEADING_CLASS_NAME = 'floating-table-of-contents-selected-heading';
const $a31ab96fdcbe9b1f$var$SELECTED_RENDERER_HEADING_STYLE_ID = 'floating-table-of-contents-selected-heading-styles';
const $a31ab96fdcbe9b1f$var$RENDERER_HEADING_WRAPPER_TEST_ID = 'renderer-heading-wrapper';
function $a31ab96fdcbe9b1f$var$injectSelectedRendererHeadingStyles() {
    if (typeof document === 'undefined') return;
    // Keep this idempotent: inserting a style element causes a full style recalculation
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- guarded above
    if (document.getElementById($a31ab96fdcbe9b1f$var$SELECTED_RENDERER_HEADING_STYLE_ID)) return;
    const background = "var(--ds-background-accent-blue-subtler, #CFE1FD)";
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- guarded above
    const style = document.createElement('style');
    style.id = $a31ab96fdcbe9b1f$var$SELECTED_RENDERER_HEADING_STYLE_ID;
    style.textContent = `.${$a31ab96fdcbe9b1f$var$SELECTED_RENDERER_HEADING_CLASS_NAME}{background:${background};background-clip:content-box;isolation:isolate;contain:paint}`;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- guarded above
    document.head.appendChild(style);
}
function $a31ab96fdcbe9b1f$var$updateHeadingHash(headingId) {
    if (typeof window === 'undefined') return;
    const nextHash = `#${encodeURIComponent(headingId)}`;
    if (window.location.hash !== nextHash) window.history.pushState(null, '', nextHash);
}
const $a31ab96fdcbe9b1f$var$EditorTableOfContentsPopupButton = (0, $3u0dr.isReactCompilerActiveV2)() ? function EditorTableOfContentsPopupButton(t0) {
    const $ = (0, $bDgLe.c)(22);
    const { editorApi: editorApi, popupPositioningRef: popupPositioningRef, popupRepositionKey: popupRepositionKey, sendButtonClickedEvent: sendButtonClickedEvent, sendItemClickedEvent: sendItemClickedEvent, sendNavigationFailure: sendNavigationFailure, showChangeboardingIndicator: showChangeboardingIndicator, scrollToEditorHeading: scrollToEditorHeading } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "floatingTableOfContents",
            "userPreferences"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const { hasHeadings: hasHeadings, isToolbarDocked: isToolbarDocked } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorApi, t1, $a31ab96fdcbe9b1f$var$_temp);
    const [items, setItems] = (0, $cozmU.useState)($a31ab96fdcbe9b1f$var$EMPTY_ITEMS);
    let t2;
    if ($[1] !== editorApi?.core || $[2] !== sendButtonClickedEvent) {
        t2 = (isOpen)=>{
            if (!isOpen) {
                setItems($a31ab96fdcbe9b1f$var$EMPTY_ITEMS);
                return;
            }
            editorApi?.core.actions.execute((t3)=>{
                const { tr: tr } = t3;
                const editorItems = (0, $b0ed91ec0e9afe3f$export$2f59fffc03219521)(tr.doc);
                setItems(editorItems);
                sendButtonClickedEvent(editorItems.length);
                return null;
            });
        };
        $[1] = editorApi?.core;
        $[2] = sendButtonClickedEvent;
        $[3] = t2;
    } else t2 = $[3];
    const onOpenChange = t2;
    let t3;
    if ($[4] !== items || $[5] !== sendItemClickedEvent) {
        t3 = (item)=>{
            sendItemClickedEvent({
                headingCount: items.length,
                headingLevel: item.level,
                headingPosition: items.indexOf(item) + 1
            });
        };
        $[4] = items;
        $[5] = sendItemClickedEvent;
        $[6] = t3;
    } else t3 = $[6];
    const onItemClicked = t3;
    let t4;
    if ($[7] !== editorApi || $[8] !== items.length || $[9] !== scrollToEditorHeading || $[10] !== sendNavigationFailure) {
        t4 = (item_0)=>{
            if (item_0.position === undefined) {
                sendNavigationFailure("missingEditorPosition", items.length);
                return;
            }
            const selectHeadingCommand = editorApi?.floatingTableOfContents?.commands.selectHeading(item_0.position);
            if (!editorApi || !selectHeadingCommand) {
                sendNavigationFailure("editorCommandUnavailable", items.length);
                return;
            }
            if (!editorApi.core.actions.execute(selectHeadingCommand)) {
                sendNavigationFailure("editorCommandFailed", items.length);
                return;
            }
            $a31ab96fdcbe9b1f$var$updateHeadingHash(item_0.headingId);
            scrollToEditorHeading?.(item_0.headingId);
        };
        $[7] = editorApi;
        $[8] = items.length;
        $[9] = scrollToEditorHeading;
        $[10] = sendNavigationFailure;
        $[11] = t4;
    } else t4 = $[11];
    const onSelect = t4;
    const t5 = Boolean(editorApi);
    const t6 = showChangeboardingIndicator && hasHeadings;
    let t7;
    if ($[12] !== isToolbarDocked || $[13] !== items || $[14] !== onItemClicked || $[15] !== onOpenChange || $[16] !== onSelect || $[17] !== popupPositioningRef || $[18] !== popupRepositionKey || $[19] !== t5 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72b4eb5e7f963d5f$export$99a5213711981ec8), {
            isReady: t5,
            isToolbarDocked: isToolbarDocked,
            items: items,
            onItemClicked: onItemClicked,
            onOpenChange: onOpenChange,
            onSelect: onSelect,
            popupPositioningRef: popupPositioningRef,
            popupRepositionKey: popupRepositionKey,
            scrollMode: "editor",
            showChangeboardingIndicator: t6
        });
        $[12] = isToolbarDocked;
        $[13] = items;
        $[14] = onItemClicked;
        $[15] = onOpenChange;
        $[16] = onSelect;
        $[17] = popupPositioningRef;
        $[18] = popupRepositionKey;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    return t7;
} : function EditorTableOfContentsPopupButton({ editorApi: editorApi, popupPositioningRef: popupPositioningRef, popupRepositionKey: popupRepositionKey, sendButtonClickedEvent: sendButtonClickedEvent, sendItemClickedEvent: sendItemClickedEvent, sendNavigationFailure: sendNavigationFailure, showChangeboardingIndicator: showChangeboardingIndicator, scrollToEditorHeading: scrollToEditorHeading }) {
    const { hasHeadings: hasHeadings, isToolbarDocked: isToolbarDocked } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorApi, [
        'floatingTableOfContents',
        'userPreferences'
    ], (states)=>({
            hasHeadings: states.floatingTableOfContentsState?.hasHeadings ?? false,
            isToolbarDocked: states.userPreferencesState?.preferences.toolbarDockingPosition === 'top'
        }));
    const [items, setItems] = (0, $cozmU.useState)($a31ab96fdcbe9b1f$var$EMPTY_ITEMS);
    const onOpenChange = (0, $cozmU.useCallback)((isOpen)=>{
        if (!isOpen) {
            setItems($a31ab96fdcbe9b1f$var$EMPTY_ITEMS);
            return;
        }
        editorApi?.core.actions.execute(({ tr: tr })=>{
            const editorItems = (0, $b0ed91ec0e9afe3f$export$2f59fffc03219521)(tr.doc);
            setItems(editorItems);
            sendButtonClickedEvent(editorItems.length);
            return null;
        });
    }, [
        editorApi,
        sendButtonClickedEvent
    ]);
    const onItemClicked = (0, $cozmU.useCallback)((item)=>{
        sendItemClickedEvent({
            headingCount: items.length,
            headingLevel: item.level,
            headingPosition: items.indexOf(item) + 1
        });
    }, [
        items,
        sendItemClickedEvent
    ]);
    const onSelect = (0, $cozmU.useCallback)((item_0)=>{
        if (item_0.position === undefined) {
            sendNavigationFailure('missingEditorPosition', items.length);
            return;
        }
        const selectHeadingCommand = editorApi?.floatingTableOfContents?.commands.selectHeading(item_0.position);
        if (!editorApi || !selectHeadingCommand) {
            sendNavigationFailure('editorCommandUnavailable', items.length);
            return;
        }
        if (!editorApi.core.actions.execute(selectHeadingCommand)) {
            sendNavigationFailure('editorCommandFailed', items.length);
            return;
        }
        $a31ab96fdcbe9b1f$var$updateHeadingHash(item_0.headingId);
        scrollToEditorHeading?.(item_0.headingId);
    }, [
        editorApi,
        items.length,
        scrollToEditorHeading,
        sendNavigationFailure
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72b4eb5e7f963d5f$export$99a5213711981ec8), {
        isReady: Boolean(editorApi),
        isToolbarDocked: isToolbarDocked,
        items: items,
        onItemClicked: onItemClicked,
        onOpenChange: onOpenChange,
        onSelect: onSelect,
        popupPositioningRef: popupPositioningRef,
        popupRepositionKey: popupRepositionKey,
        scrollMode: "editor",
        showChangeboardingIndicator: showChangeboardingIndicator && hasHeadings
    });
};
function $a31ab96fdcbe9b1f$var$_temp(states) {
    return {
        hasHeadings: states.floatingTableOfContentsState?.hasHeadings ?? false,
        isToolbarDocked: states.userPreferencesState?.preferences.toolbarDockingPosition === "top"
    };
}
const $a31ab96fdcbe9b1f$var$ViewTableOfContentsPopupButton = (0, $3u0dr.isReactCompilerActiveV2)() ? function ViewTableOfContentsPopupButton(t0) {
    const $ = (0, $bDgLe.c)(24);
    const { contentBodyValue: contentBodyValue, popupPositioningRef: popupPositioningRef, popupRepositionKey: popupRepositionKey, sendButtonClickedEvent: sendButtonClickedEvent, sendItemClickedEvent: sendItemClickedEvent, sendNavigationFailure: sendNavigationFailure, showChangeboardingIndicator: showChangeboardingIndicator } = t0;
    let t1;
    if ($[0] !== contentBodyValue) {
        t1 = (0, $b0ed91ec0e9afe3f$export$50a9fde73cdd9018)(contentBodyValue);
        $[0] = contentBodyValue;
        $[1] = t1;
    } else t1 = $[1];
    const items = t1;
    const selectedHeadingRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[2] !== items || $[3] !== sendItemClickedEvent) {
        t2 = (item)=>{
            sendItemClickedEvent({
                headingCount: items.length,
                headingLevel: item.level,
                headingPosition: items.indexOf(item) + 1
            });
        };
        $[2] = items;
        $[3] = sendItemClickedEvent;
        $[4] = t2;
    } else t2 = $[4];
    const onItemClicked = t2;
    let t3;
    if ($[5] !== items.length || $[6] !== sendButtonClickedEvent) {
        t3 = (isOpen)=>{
            if (isOpen) sendButtonClickedEvent(items.length);
        };
        $[5] = items.length;
        $[6] = sendButtonClickedEvent;
        $[7] = t3;
    } else t3 = $[7];
    const onOpenChange = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            selectedHeadingRef.current?.classList.remove($a31ab96fdcbe9b1f$var$SELECTED_RENDERER_HEADING_CLASS_NAME);
            selectedHeadingRef.current = null;
        };
        $[8] = t4;
    } else t4 = $[8];
    const clearSelectedHeading = t4;
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[9] = t5;
    } else t5 = $[9];
    (0, $cozmU.useEffect)($a31ab96fdcbe9b1f$var$_temp2, t5);
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            if (typeof document === "undefined") return;
            const rendererRoot = document.getElementById("main-content");
            rendererRoot?.addEventListener("click", clearSelectedHeading);
            return ()=>{
                rendererRoot?.removeEventListener("click", clearSelectedHeading);
                clearSelectedHeading();
            };
        };
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== contentBodyValue) {
        t7 = [
            clearSelectedHeading,
            contentBodyValue
        ];
        $[11] = contentBodyValue;
        $[12] = t7;
    } else t7 = $[12];
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[13] !== items.length || $[14] !== sendNavigationFailure) {
        t8 = (item_0)=>{
            if (typeof document === "undefined") {
                sendNavigationFailure("documentUnavailable", items.length);
                return;
            }
            const heading = document.getElementById(item_0.headingId);
            if (!heading) {
                sendNavigationFailure("rendererHeadingNotFound", items.length);
                return;
            }
            $a31ab96fdcbe9b1f$var$updateHeadingHash(item_0.headingId);
            clearSelectedHeading();
            const headingWrapper = heading.parentElement;
            if (headingWrapper?.getAttribute("data-testid") === $a31ab96fdcbe9b1f$var$RENDERER_HEADING_WRAPPER_TEST_ID) {
                headingWrapper.classList.add($a31ab96fdcbe9b1f$var$SELECTED_RENDERER_HEADING_CLASS_NAME);
                selectedHeadingRef.current = headingWrapper;
            }
            heading.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        };
        $[13] = items.length;
        $[14] = sendNavigationFailure;
        $[15] = t8;
    } else t8 = $[15];
    const onSelect = t8;
    const t9 = showChangeboardingIndicator && items.length > 0;
    let t10;
    if ($[16] !== items || $[17] !== onItemClicked || $[18] !== onOpenChange || $[19] !== onSelect || $[20] !== popupPositioningRef || $[21] !== popupRepositionKey || $[22] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72b4eb5e7f963d5f$export$99a5213711981ec8), {
            items: items,
            onItemClicked: onItemClicked,
            onOpenChange: onOpenChange,
            onSelect: onSelect,
            popupPositioningRef: popupPositioningRef,
            popupRepositionKey: popupRepositionKey,
            scrollMode: "renderer",
            showChangeboardingIndicator: t9
        });
        $[16] = items;
        $[17] = onItemClicked;
        $[18] = onOpenChange;
        $[19] = onSelect;
        $[20] = popupPositioningRef;
        $[21] = popupRepositionKey;
        $[22] = t9;
        $[23] = t10;
    } else t10 = $[23];
    return t10;
} : function ViewTableOfContentsPopupButton({ contentBodyValue: contentBodyValue, popupPositioningRef: popupPositioningRef, popupRepositionKey: popupRepositionKey, sendButtonClickedEvent: sendButtonClickedEvent, sendItemClickedEvent: sendItemClickedEvent, sendNavigationFailure: sendNavigationFailure, showChangeboardingIndicator: showChangeboardingIndicator }) {
    const items = (0, $cozmU.useMemo)(()=>(0, $b0ed91ec0e9afe3f$export$50a9fde73cdd9018)(contentBodyValue), [
        contentBodyValue
    ]);
    const selectedHeadingRef = (0, $cozmU.useRef)(null);
    const onItemClicked = (0, $cozmU.useCallback)((item)=>{
        sendItemClickedEvent({
            headingCount: items.length,
            headingLevel: item.level,
            headingPosition: items.indexOf(item) + 1
        });
    }, [
        items,
        sendItemClickedEvent
    ]);
    const onOpenChange = (0, $cozmU.useCallback)((isOpen)=>{
        if (isOpen) sendButtonClickedEvent(items.length);
    }, [
        items.length,
        sendButtonClickedEvent
    ]);
    const clearSelectedHeading = (0, $cozmU.useCallback)(()=>{
        selectedHeadingRef.current?.classList.remove($a31ab96fdcbe9b1f$var$SELECTED_RENDERER_HEADING_CLASS_NAME);
        selectedHeadingRef.current = null;
    }, []);
    (0, $cozmU.useEffect)(()=>{
        $a31ab96fdcbe9b1f$var$injectSelectedRendererHeadingStyles();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (typeof document === 'undefined') return;
        const rendererRoot = document.getElementById('main-content');
        rendererRoot?.addEventListener('click', clearSelectedHeading);
        return ()=>{
            rendererRoot?.removeEventListener('click', clearSelectedHeading);
            clearSelectedHeading();
        };
    }, [
        clearSelectedHeading,
        contentBodyValue
    ]);
    const onSelect = (0, $cozmU.useCallback)((item_0)=>{
        if (typeof document === 'undefined') {
            sendNavigationFailure('documentUnavailable', items.length);
            return;
        }
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- guarded above
        const heading = document.getElementById(item_0.headingId);
        if (!heading) {
            sendNavigationFailure('rendererHeadingNotFound', items.length);
            return;
        }
        $a31ab96fdcbe9b1f$var$updateHeadingHash(item_0.headingId);
        clearSelectedHeading();
        const headingWrapper = heading.parentElement;
        if (headingWrapper?.getAttribute('data-testid') === $a31ab96fdcbe9b1f$var$RENDERER_HEADING_WRAPPER_TEST_ID) {
            headingWrapper.classList.add($a31ab96fdcbe9b1f$var$SELECTED_RENDERER_HEADING_CLASS_NAME);
            selectedHeadingRef.current = headingWrapper;
        }
        heading.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, [
        clearSelectedHeading,
        items.length,
        sendNavigationFailure
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72b4eb5e7f963d5f$export$99a5213711981ec8), {
        items: items,
        onItemClicked: onItemClicked,
        onOpenChange: onOpenChange,
        onSelect: onSelect,
        popupPositioningRef: popupPositioningRef,
        popupRepositionKey: popupRepositionKey,
        scrollMode: "renderer",
        showChangeboardingIndicator: showChangeboardingIndicator && items.length > 0
    });
};
function $a31ab96fdcbe9b1f$var$_temp2() {
    $a31ab96fdcbe9b1f$var$injectSelectedRendererHeadingStyles();
}
const $a31ab96fdcbe9b1f$export$710d202105415718 = (0, $3u0dr.isReactCompilerActiveV2)() ? function TableOfContentsPopupButton(t0) {
    const $ = (0, $bDgLe.c)(31);
    const { isDisabled: t1, contentBodyValue: contentBodyValue, contentType: contentType, editorApi: editorApi, pageMode: pageMode, popupPositioningRef: popupPositioningRef, scrollToEditorHeading: scrollToEditorHeading } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    let t2;
    if ($[0] !== rightSidebarContext) {
        t2 = rightSidebarContext.getCurrent() || {};
        $[0] = rightSidebarContext;
        $[1] = t2;
    } else t2 = $[1];
    const { width: rightSidebarWidth } = t2;
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const [hasInteractedLocally, setHasInteractedLocally] = (0, $cozmU.useState)(false);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $d282Z.ONBOARDING_INSIGHTS).FLOATING_TABLE_OF_CONTENTS
        ];
        $[2] = t3;
    } else t3 = $[2];
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(t3);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    let t4;
    if ($[3] !== onboardingStateData) {
        t4 = (0, $ivb8S.deserializeState)(onboardingStateData);
        $[3] = onboardingStateData;
        $[4] = t4;
    } else t4 = $[4];
    const { hasFloatingTableOfContentsBeenInteractedWith: hasFloatingTableOfContentsBeenInteractedWith } = t4;
    const hasInteracted = hasInteractedLocally || Boolean(hasFloatingTableOfContentsBeenInteractedWith);
    const showChangeboardingIndicator = !onboardingStateLoading && !onboardingStateError && !hasInteracted;
    const t5 = contentType ?? "unknown";
    const t6 = pageMode ?? "unknown";
    let t7;
    if ($[5] !== t5 || $[6] !== t6) {
        t7 = {
            contentType: t5,
            pageMode: t6
        };
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    const analyticsAttributes = t7;
    let t8;
    if ($[8] !== analyticsAttributes || $[9] !== createEvent || $[10] !== hasInteracted || $[11] !== setOnboardingState) {
        t8 = (headingCount)=>{
            if (headingCount > 0 && !hasInteracted) {
                setHasInteractedLocally(true);
                setOnboardingState({
                    key: (0, $d282Z.ONBOARDING_INSIGHTS).FLOATING_TABLE_OF_CONTENTS,
                    value: "true"
                });
            }
            createEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "floatingTableOfContents",
                    source: "contentWrapper",
                    attributes: {
                        ...analyticsAttributes,
                        headingCount: headingCount
                    }
                }
            }).fire();
        };
        $[8] = analyticsAttributes;
        $[9] = createEvent;
        $[10] = hasInteracted;
        $[11] = setOnboardingState;
        $[12] = t8;
    } else t8 = $[12];
    const sendButtonClickedEvent = t8;
    let t9;
    if ($[13] !== analyticsAttributes || $[14] !== createEvent) {
        t9 = (itemAttributes)=>{
            createEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "headingItem",
                    actionSubjectId: "floatingTableOfContents",
                    source: "contentWrapper",
                    attributes: {
                        ...analyticsAttributes,
                        ...itemAttributes
                    }
                }
            }).fire();
        };
        $[13] = analyticsAttributes;
        $[14] = createEvent;
        $[15] = t9;
    } else t9 = $[15];
    const sendItemClickedEvent = t9;
    let t10;
    if ($[16] !== analyticsAttributes || $[17] !== createEvent) {
        t10 = (failureReason, headingCount_0)=>{
            createEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "failed",
                    actionSubject: "headingItem",
                    actionSubjectId: "floatingTableOfContents",
                    source: "contentWrapper",
                    attributes: {
                        ...analyticsAttributes,
                        failureReason: failureReason,
                        headingCount: headingCount_0
                    }
                }
            }).fire();
        };
        $[16] = analyticsAttributes;
        $[17] = createEvent;
        $[18] = t10;
    } else t10 = $[18];
    const sendNavigationFailure = t10;
    if (isDisabled && !(0, $9wGTI.fg)("confluence_object_sidebar_buttons_vc_fix")) {
        let t11;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5qQdB.TableOfContentsButtonPlaceholder), null);
            $[19] = t11;
        } else t11 = $[19];
        return t11;
    }
    let t11;
    if ($[20] !== contentBodyValue || $[21] !== editorApi || $[22] !== isDisabled || $[23] !== popupPositioningRef || $[24] !== rightSidebarWidth || $[25] !== scrollToEditorHeading || $[26] !== sendButtonClickedEvent || $[27] !== sendItemClickedEvent || $[28] !== sendNavigationFailure || $[29] !== showChangeboardingIndicator) {
        t11 = editorApi || isDisabled && (0, $9wGTI.fg)("confluence_object_sidebar_buttons_vc_fix") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a31ab96fdcbe9b1f$var$EditorTableOfContentsPopupButton, {
            editorApi: editorApi,
            popupPositioningRef: popupPositioningRef,
            popupRepositionKey: rightSidebarWidth,
            sendButtonClickedEvent: sendButtonClickedEvent,
            sendItemClickedEvent: sendItemClickedEvent,
            sendNavigationFailure: sendNavigationFailure,
            showChangeboardingIndicator: showChangeboardingIndicator,
            scrollToEditorHeading: scrollToEditorHeading
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a31ab96fdcbe9b1f$var$ViewTableOfContentsPopupButton, {
            contentBodyValue: contentBodyValue,
            popupPositioningRef: popupPositioningRef,
            popupRepositionKey: rightSidebarWidth,
            sendButtonClickedEvent: sendButtonClickedEvent,
            sendItemClickedEvent: sendItemClickedEvent,
            sendNavigationFailure: sendNavigationFailure,
            showChangeboardingIndicator: showChangeboardingIndicator
        });
        $[20] = contentBodyValue;
        $[21] = editorApi;
        $[22] = isDisabled;
        $[23] = popupPositioningRef;
        $[24] = rightSidebarWidth;
        $[25] = scrollToEditorHeading;
        $[26] = sendButtonClickedEvent;
        $[27] = sendItemClickedEvent;
        $[28] = sendNavigationFailure;
        $[29] = showChangeboardingIndicator;
        $[30] = t11;
    } else t11 = $[30];
    return t11;
} : function TableOfContentsPopupButton({ isDisabled: isDisabled = false, contentBodyValue: contentBodyValue, contentType: contentType, editorApi: editorApi, pageMode: pageMode, popupPositioningRef: popupPositioningRef, scrollToEditorHeading: scrollToEditorHeading }) {
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { width: rightSidebarWidth } = rightSidebarContext.getCurrent() || {};
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const [hasInteractedLocally, setHasInteractedLocally] = (0, $cozmU.useState)(false);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $d282Z.ONBOARDING_INSIGHTS).FLOATING_TABLE_OF_CONTENTS
    ]);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { hasFloatingTableOfContentsBeenInteractedWith: hasFloatingTableOfContentsBeenInteractedWith } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const hasInteracted = hasInteractedLocally || Boolean(hasFloatingTableOfContentsBeenInteractedWith);
    const showChangeboardingIndicator = !onboardingStateLoading && !onboardingStateError && !hasInteracted;
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            contentType: contentType ?? 'unknown',
            pageMode: pageMode ?? 'unknown'
        }), [
        contentType,
        pageMode
    ]);
    const sendButtonClickedEvent = (0, $cozmU.useCallback)((headingCount)=>{
        if (headingCount > 0 && !hasInteracted) {
            setHasInteractedLocally(true);
            setOnboardingState({
                key: (0, $d282Z.ONBOARDING_INSIGHTS).FLOATING_TABLE_OF_CONTENTS,
                value: 'true'
            });
        }
        createEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'floatingTableOfContents',
                source: 'contentWrapper',
                attributes: {
                    ...analyticsAttributes,
                    headingCount: headingCount
                }
            }
        }).fire();
    }, [
        analyticsAttributes,
        createEvent,
        hasInteracted,
        setOnboardingState
    ]);
    const sendItemClickedEvent = (0, $cozmU.useCallback)((itemAttributes)=>{
        createEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'headingItem',
                actionSubjectId: 'floatingTableOfContents',
                source: 'contentWrapper',
                attributes: {
                    ...analyticsAttributes,
                    ...itemAttributes
                }
            }
        }).fire();
    }, [
        analyticsAttributes,
        createEvent
    ]);
    const sendNavigationFailure = (0, $cozmU.useCallback)((failureReason, headingCount_0)=>{
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'headingItem',
                actionSubjectId: 'floatingTableOfContents',
                source: 'contentWrapper',
                attributes: {
                    ...analyticsAttributes,
                    failureReason: failureReason,
                    headingCount: headingCount_0
                }
            }
        }).fire();
    }, [
        analyticsAttributes,
        createEvent
    ]);
    // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    if (isDisabled && !(0, $9wGTI.fg)('confluence_object_sidebar_buttons_vc_fix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5qQdB.TableOfContentsButtonPlaceholder), null);
    // Render the editor button while the editor loads (rather than a placeholder) so the trigger's
    // DOM stays mounted once `editorApi` arrives; replacing it is a VC mutation.
    // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    return editorApi || isDisabled && (0, $9wGTI.fg)('confluence_object_sidebar_buttons_vc_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a31ab96fdcbe9b1f$var$EditorTableOfContentsPopupButton, {
        editorApi: editorApi,
        popupPositioningRef: popupPositioningRef,
        popupRepositionKey: rightSidebarWidth,
        sendButtonClickedEvent: sendButtonClickedEvent,
        sendItemClickedEvent: sendItemClickedEvent,
        sendNavigationFailure: sendNavigationFailure,
        showChangeboardingIndicator: showChangeboardingIndicator,
        scrollToEditorHeading: scrollToEditorHeading
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a31ab96fdcbe9b1f$var$ViewTableOfContentsPopupButton, {
        contentBodyValue: contentBodyValue,
        popupPositioningRef: popupPositioningRef,
        popupRepositionKey: rightSidebarWidth,
        sendButtonClickedEvent: sendButtonClickedEvent,
        sendItemClickedEvent: sendItemClickedEvent,
        sendNavigationFailure: sendNavigationFailure,
        showChangeboardingIndicator: showChangeboardingIndicator
    });
};
module.exports["TableOfContentsPopupButton"] = $a31ab96fdcbe9b1f$export$710d202105415718;

});

parcelRegister("202oG", function(module, exports) {

var $2lPWP = parcelRequire("2lPWP");

function $2cfd9ea7d82f1add$export$dbad71934afee167(node, headingIds) {
    if (!node?.content?.length) return;
    // We are not use node.textContent here, because we would like to handle cases where
    // headings only contain inline blocks like emoji, status and date.
    const nodeContent = node.content.reduce((acc, currentNode)=>acc.concat($2cfd9ea7d82f1add$var$getText(currentNode) || ''), '').trim().replace(/\s/g, '-');
    if (!nodeContent) return;
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(nodeContent, headingIds);
}
const $2cfd9ea7d82f1add$var$getText = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : ''}]`;
};
function $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter = 0) {
    if (counter === 0 && !headingIds.has(baseId)) {
        headingIds.add(baseId);
        return baseId;
    } else if (counter !== 0) {
        const headingId = `${baseId}.${counter}`;
        if (!headingIds.has(headingId)) {
            headingIds.add(headingId);
            return headingId;
        }
    }
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter + 1);
}
const $2cfd9ea7d82f1add$var$HEADINGS = new Set([
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6'
]);
function* $2cfd9ea7d82f1add$var$getHeadingIds() {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorElement = document.getElementById('ak-editor-textarea');
    const children = editorElement?.getElementsByTagName('*') ?? [];
    const headingIds = new Set();
    const editorTransformer = new (0, $2lPWP.JSONTransformer)();
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($2cfd9ea7d82f1add$var$HEADINGS.has(child.tagName)) {
            const pmNode = child.pmViewDesc?.node;
            if (!pmNode) continue;
            // Copied from TOC
            const adf = editorTransformer.encode(pmNode);
            let adfObject = adf;
            if (typeof adf === 'string') try {
                adfObject = JSON.parse(adf);
            } catch (err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            }
            const headingId = $2cfd9ea7d82f1add$export$dbad71934afee167(adfObject, headingIds);
            if (!headingId) continue;
            yield [
                headingId,
                child,
                pmNode
            ];
        }
    }
}
const $2cfd9ea7d82f1add$export$817005c72dc2688 = ()=>{
    const headingIdToElement = new Map();
    for (const [headingId, child, _] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        headingIdToElement.set(headingId, child);
        // A bit inefficient, but there's sometimes a discrepancy between the hashed ID and the generated ID. The least impactful solution is to just add both.
        headingIdToElement.set(encodeURIComponent(headingId), child);
    }
    return headingIdToElement;
};
const $2cfd9ea7d82f1add$export$e2a78e613c648859 = (node)=>{
    for (const [headingId, _, pmNode] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        if (node === pmNode) return headingId;
    }
    return undefined;
};
module.exports["getHeadingId"] = $2cfd9ea7d82f1add$export$dbad71934afee167;
module.exports["getHeadingIdsToElements"] = $2cfd9ea7d82f1add$export$817005c72dc2688;
module.exports["getHeadingIdForNode"] = $2cfd9ea7d82f1add$export$e2a78e613c648859;

});

parcelRegister("4Ep2c", function(module, exports) {

let $362e5130ab4d084a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $362e5130ab4d084a$var$load("6wr18"),
    $362e5130ab4d084a$var$load("isCfG"),
    $362e5130ab4d084a$var$load("j6yAY"),
    $362e5130ab4d084a$var$load("flgjz"),
    $362e5130ab4d084a$var$load("f3qSD"),
    $362e5130ab4d084a$var$load("lFmKr"),
    $362e5130ab4d084a$var$load("do5z1"),
    $362e5130ab4d084a$var$load("aOIZj"),
    $362e5130ab4d084a$var$load("ffEVr"),
    $362e5130ab4d084a$var$load("7EorR"),
    $362e5130ab4d084a$var$load("aEk9k")
]).then(()=>parcelRequire('e1z3L'));

});

parcelRegister("gRv41", function(module, exports) {

var $g4Rov = parcelRequire("g4Rov");


var $hq8YP = parcelRequire("hq8YP");

const $94124018bc78b0e0$export$9b1c009846eb666 = ()=>{
    const state = (0, $g4Rov.useAtom)((0, $hq8YP.herState));
    return {
        // State
        isHerActive: state.isHerActive,
        voiceState: state.voiceState,
        isExpanded: state.isExpanded,
        isAnimating: state.isAnimating,
        contentId: state.contentId,
        contentType: state.contentType,
        cloudID: state.cloudID,
        textPreview: state.textPreview,
        tasks: state.tasks,
        notifications: state.notifications,
        rovoMessage: state.rovoMessage,
        toggleHer: // Actions
        $hq8YP.toggleHer,
        openHer: $hq8YP.openHer,
        closeHer: $hq8YP.closeHer,
        setExpanded: $hq8YP.setExpanded,
        setAnimating: $hq8YP.setAnimating,
        setVoiceState: $hq8YP.setVoiceState,
        appendTextPreview: $hq8YP.appendTextPreview,
        clearTextPreview: $hq8YP.clearTextPreview,
        addNotification: $hq8YP.addNotification,
        removeNotification: $hq8YP.removeNotification,
        setRovoMessage: $hq8YP.setRovoMessage,
        clearRovoMessage: $hq8YP.clearRovoMessage
    };
};
module.exports["useHerStore"] = $94124018bc78b0e0$export$9b1c009846eb666;

});

parcelRegister("hq8YP", function(module, exports) {

var $avHQ3 = parcelRequire("avHQ3");

const $b2100637eed5fa2c$var$initialState = {
    isHerActive: false,
    voiceState: 'inactive',
    isExpanded: true,
    isAnimating: true,
    contentId: null,
    contentType: 'page',
    cloudID: '',
    textPreview: '',
    tasks: {},
    notifications: {},
    rovoMessage: null
};
const $b2100637eed5fa2c$export$b1d93e626697721f = (0, $avHQ3.e)($b2100637eed5fa2c$var$initialState);
const $b2100637eed5fa2c$export$780673425ffb59a7 = (contentId, cloudID, contentType)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: !prevState.isHerActive,
            voiceState: !prevState.isHerActive ? 'active' : 'inactive',
            // Reset to expanded when opening
            isExpanded: !prevState.isHerActive ? true : prevState.isExpanded,
            isAnimating: !prevState.isHerActive ? true : prevState.isAnimating,
            contentId: !prevState.isHerActive ? contentId ?? null : null,
            contentType: !prevState.isHerActive ? contentType ?? 'page' : 'page',
            cloudID: !prevState.isHerActive ? cloudID ?? prevState.cloudID : prevState.cloudID,
            textPreview: !prevState.isHerActive ? '' : prevState.textPreview,
            rovoMessage: null
        }));
};
const $b2100637eed5fa2c$export$cc30aca21148df52 = (contentId, cloudID, contentType)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: true,
            voiceState: 'active',
            isExpanded: true,
            isAnimating: true,
            contentId: contentId ?? null,
            contentType: contentType ?? 'page',
            cloudID: cloudID ?? prevState.cloudID,
            rovoMessage: null
        }));
};
const $b2100637eed5fa2c$export$d1dd051dd158cf2a = ()=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: false,
            voiceState: 'inactive',
            contentId: null,
            contentType: 'page',
            textPreview: '',
            rovoMessage: null
        }));
};
const $b2100637eed5fa2c$export$daffe9b53f21fd39 = (expanded)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isExpanded: expanded
        }));
};
const $b2100637eed5fa2c$export$3a38c3c547ba462b = (animating)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isAnimating: animating
        }));
};
const $b2100637eed5fa2c$export$ac68b93fefb1be03 = (voiceState)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            voiceState: voiceState
        }));
};
const $b2100637eed5fa2c$export$52a0cc4030ebe376 = (text)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            textPreview: prevState.textPreview + text
        }));
};
const $b2100637eed5fa2c$export$cd85393335c99d14 = ()=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            textPreview: ''
        }));
};
const $b2100637eed5fa2c$export$38a248e5348a1dc = (task)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            tasks: {
                ...prevState.tasks,
                [task.task_id]: task
            }
        }));
};
const $b2100637eed5fa2c$export$e8e0154b7bb02be4 = (task)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            tasks: {
                ...prevState.tasks,
                [task.task_id]: task
            }
        }));
};
const $b2100637eed5fa2c$export$e0f6ca2291a97572 = (taskId)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>{
        const { [taskId]: _, ...rest } = prevState.tasks;
        return {
            ...prevState,
            tasks: rest
        };
    });
};
const $b2100637eed5fa2c$export$c7def531c087da85 = (notification)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            notifications: {
                ...prevState.notifications,
                [notification.id]: notification
            }
        }));
};
const $b2100637eed5fa2c$export$92eb0ea44f8c9242 = (notificationId)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>{
        const { [notificationId]: _, ...rest } = prevState.notifications;
        return {
            ...prevState,
            notifications: rest
        };
    });
};
const $b2100637eed5fa2c$export$2a6b13a8b8066c3f = (rovoMessage)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            rovoMessage: rovoMessage
        }));
};
const $b2100637eed5fa2c$export$aaa1dffe3c1b0b3c = ()=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            rovoMessage: null
        }));
};
module.exports["herState"] = $b2100637eed5fa2c$export$b1d93e626697721f;
module.exports["toggleHer"] = $b2100637eed5fa2c$export$780673425ffb59a7;
module.exports["openHer"] = $b2100637eed5fa2c$export$cc30aca21148df52;
module.exports["closeHer"] = $b2100637eed5fa2c$export$d1dd051dd158cf2a;
module.exports["setExpanded"] = $b2100637eed5fa2c$export$daffe9b53f21fd39;
module.exports["setAnimating"] = $b2100637eed5fa2c$export$3a38c3c547ba462b;
module.exports["setVoiceState"] = $b2100637eed5fa2c$export$ac68b93fefb1be03;
module.exports["appendTextPreview"] = $b2100637eed5fa2c$export$52a0cc4030ebe376;
module.exports["clearTextPreview"] = $b2100637eed5fa2c$export$cd85393335c99d14;
module.exports["addTask"] = $b2100637eed5fa2c$export$38a248e5348a1dc;
module.exports["updateTask"] = $b2100637eed5fa2c$export$e8e0154b7bb02be4;
module.exports["removeTask"] = $b2100637eed5fa2c$export$e0f6ca2291a97572;
module.exports["addNotification"] = $b2100637eed5fa2c$export$c7def531c087da85;
module.exports["removeNotification"] = $b2100637eed5fa2c$export$92eb0ea44f8c9242;
module.exports["setRovoMessage"] = $b2100637eed5fa2c$export$2a6b13a8b8066c3f;
module.exports["clearRovoMessage"] = $b2100637eed5fa2c$export$aaa1dffe3c1b0b3c;

});

parcelRegister("5xmyM", function(module, exports) {
/* Constellation.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $eaJeF = parcelRequire("eaJeF");


var $gQ9Eg = parcelRequire("gQ9Eg");

const $fabf221486fb548f$var$styles = {
    canvas: "_3iDTPbvLZJ _0jFU0VN91d _39xV02N91d"
}; /**
    * Decorative Canvas renderer for the Enterprise HER constellation.
    *
    * The host owns sizing and interaction semantics. This component bridges
    * React lifecycle and current render props into the imperative Canvas renderer.
    */ 
function $fabf221486fb548f$export$7468f4fdd4f00d6c(props) {
    const canvasRef = (0, $cozmU.useRef)(null);
    const paintStyle = (0, $gQ9Eg.useConstellationPaintStyle)();
    const renderStateRef = (0, $cozmU.useRef)({
        paintStyle: paintStyle,
        props: props
    });
    renderStateRef.current = {
        paintStyle: paintStyle,
        props: props
    };
    (0, $cozmU.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        return (0, $eaJeF.startConstellationCanvas)(canvas, ()=>renderStateRef.current);
    }, []);
    return /*#__PURE__*/ $cozmU.createElement("canvas", {
        "aria-hidden": "true",
        "data-testid": "rovo-voice-constellation",
        ref: canvasRef,
        tabIndex: -1,
        className: (0, $hekY6.default)([
            $fabf221486fb548f$var$styles.canvas
        ])
    });
}
module.exports["Constellation"] = $fabf221486fb548f$export$7468f4fdd4f00d6c;

});

parcelRegister("eaJeF", function(module, exports) {

var $lj1QA = parcelRequire("lj1QA");


var $lL7oH = parcelRequire("lL7oH");


var $ashLd = parcelRequire("ashLd");

const $92047f7417ffbd83$var$getDevicePixelRatio = ()=>Math.max(window.devicePixelRatio || 1, 1);
const $92047f7417ffbd83$var$getAudioLevelForPose = ({ active: active, getAudioLevel: getAudioLevel, pose: pose })=>{
    if (!active || pose !== 'listening' && pose !== 'speaking') return 0;
    return Math.min(1, Math.max(0, getAudioLevel()));
};
const $92047f7417ffbd83$var$getSimulationInput = ({ paintStyle: paintStyle, props: props })=>({
        active: props.active,
        audioLevel: $92047f7417ffbd83$var$getAudioLevelForPose(props),
        dotColors: paintStyle.dotColors,
        paused: props.paused,
        pose: props.pose
    });
function $92047f7417ffbd83$export$d4cb3da0bdf04587(canvas, context) {
    const cssWidth = canvas.clientWidth || (0, $lj1QA.CONSTELLATION_SIZE);
    const cssHeight = canvas.clientHeight || (0, $lj1QA.CONSTELLATION_SIZE);
    const pixelRatio = $92047f7417ffbd83$var$getDevicePixelRatio();
    const backingWidth = Math.round(cssWidth * pixelRatio);
    const backingHeight = Math.round(cssHeight * pixelRatio);
    if (canvas.width !== backingWidth) canvas.width = backingWidth;
    if (canvas.height !== backingHeight) canvas.height = backingHeight;
    context.setTransform(backingWidth / (0, $lj1QA.CONSTELLATION_SIZE), 0, 0, backingHeight / (0, $lj1QA.CONSTELLATION_SIZE), 0, 0);
    return pixelRatio;
}
const $92047f7417ffbd83$var$observeCanvasSize = (canvas, context)=>{
    let pixelRatio = 1;
    const resize = ()=>{
        pixelRatio = $92047f7417ffbd83$export$d4cb3da0bdf04587(canvas, context);
    };
    const resizeObserver = new ResizeObserver(resize);
    resize();
    resizeObserver.observe(canvas);
    return {
        disconnect: ()=>resizeObserver.disconnect(),
        syncPixelRatio: ()=>{
            if ($92047f7417ffbd83$var$getDevicePixelRatio() !== pixelRatio) resize();
        }
    };
};
const $92047f7417ffbd83$var$startAnimationLoop = (context, simulation, getRenderState, syncPixelRatio)=>{
    let animationFrameId = 0;
    const drawFrame = (timestampMs)=>{
        syncPixelRatio();
        const renderState = getRenderState();
        const frame = (0, $ashLd.advanceConstellationSimulation)(simulation, $92047f7417ffbd83$var$getSimulationInput(renderState), timestampMs);
        (0, $lL7oH.paintConstellationFrame)(context, frame, {
            glowOpacity: renderState.paintStyle.glowOpacity,
            twg: {
                ...renderState.paintStyle.twgGraph,
                opacity: simulation.twgOpacity,
                timeSeconds: simulation.elapsedSeconds
            }
        });
        animationFrameId = requestAnimationFrame(drawFrame);
    };
    animationFrameId = requestAnimationFrame(drawFrame);
    return ()=>cancelAnimationFrame(animationFrameId);
};
const $92047f7417ffbd83$export$a091e4ab71ec2fa2 = (canvas, getRenderState)=>{
    const context = canvas.getContext('2d');
    if (!context) return;
    const simulation = (0, $ashLd.createConstellationSimulation)($92047f7417ffbd83$var$getSimulationInput(getRenderState()), 0);
    const sizeObserver = $92047f7417ffbd83$var$observeCanvasSize(canvas, context);
    const stopAnimationLoop = $92047f7417ffbd83$var$startAnimationLoop(context, simulation, getRenderState, sizeObserver.syncPixelRatio);
    return ()=>{
        stopAnimationLoop();
        sizeObserver.disconnect();
    };
};
module.exports["startConstellationCanvas"] = $92047f7417ffbd83$export$a091e4ab71ec2fa2;

});

parcelRegister("lj1QA", function(module, exports) {
const $be43ea9f6097eee7$export$d62caa5ee8102f31 = 48;
const $be43ea9f6097eee7$export$4e2ea8c10128b986 = $be43ea9f6097eee7$export$d62caa5ee8102f31 / 2;
const $be43ea9f6097eee7$export$61efd683900ed9ae = 19;
const $be43ea9f6097eee7$export$c5b7bba8c79a7b8c = Math.ceil(4 * $be43ea9f6097eee7$export$d62caa5ee8102f31 / 48 * 2) / 2;
const $be43ea9f6097eee7$export$b4c6dc2020422714 = $be43ea9f6097eee7$export$d62caa5ee8102f31 * 0.36;
const $be43ea9f6097eee7$export$dc69e5d5552aff41 = Math.PI * 2;
const $be43ea9f6097eee7$export$c6140092ef9278ff = (1 + Math.sqrt(5)) / 2;
module.exports["CONSTELLATION_SIZE"] = $be43ea9f6097eee7$export$d62caa5ee8102f31;
module.exports["CONSTELLATION_CENTER"] = $be43ea9f6097eee7$export$4e2ea8c10128b986;
module.exports["CONSTELLATION_DOT_COUNT"] = $be43ea9f6097eee7$export$61efd683900ed9ae;
module.exports["CONSTELLATION_DOT_DIAMETER"] = $be43ea9f6097eee7$export$c5b7bba8c79a7b8c;
module.exports["CONSTELLATION_FORMATION_RADIUS"] = $be43ea9f6097eee7$export$b4c6dc2020422714;
module.exports["FULL_ROTATION_RADIANS"] = $be43ea9f6097eee7$export$dc69e5d5552aff41;
module.exports["GOLDEN_RATIO"] = $be43ea9f6097eee7$export$c6140092ef9278ff;

});

parcelRegister("lL7oH", function(module, exports) {

var $gQ9Eg = parcelRequire("gQ9Eg");


var $lj1QA = parcelRequire("lj1QA");


var $5jgP8 = parcelRequire("5jgP8");

const $175f0ce845e20c92$var$TWG_LINE_WIDTH = 0.9;
const $175f0ce845e20c92$var$TWG_DASH_LENGTH = 0.1;
const $175f0ce845e20c92$var$TWG_DASH_GAP = 3.2;
const $175f0ce845e20c92$var$TWG_DASH_SPEEDS = [
    5,
    8,
    11
];
const $175f0ce845e20c92$var$TWG_PULSE_HALO_RADIUS = 2.4;
const $175f0ce845e20c92$var$TWG_PULSE_CORE_RADIUS = 1.1;
const $175f0ce845e20c92$var$GLOW_FALLOFF_POWER = 1.5;
const $175f0ce845e20c92$var$MAXIMUM_GLOW_SPREAD = (0, $lj1QA.CONSTELLATION_SIZE) / 48 * 2.6;
const $175f0ce845e20c92$var$DEFAULT_GLOW_OPACITY = 0.42;
const $175f0ce845e20c92$var$GLOW_OPACITY_AT_CORE_EDGE = 0.3;
const $175f0ce845e20c92$var$BRIGHTNESS_GLINT_POWER = 4;
const $175f0ce845e20c92$var$MAXIMUM_BASE_BRIGHTNESS_BOOST = 0.3;
const $175f0ce845e20c92$var$MAXIMUM_GLOW_BRIGHTNESS_BOOST = 0.45;
const $175f0ce845e20c92$var$clamp = (value, min = 0, max = 1)=>Math.max(min, Math.min(max, value));
const $175f0ce845e20c92$var$paintTwgGraph = (context, frame, { color: color, edgeOpacity: edgeOpacity, opacity: opacity, pulseHaloOpacity: pulseHaloOpacity, timeSeconds: timeSeconds })=>{
    if (opacity <= 0) return;
    context.save();
    context.strokeStyle = color;
    context.lineCap = 'round';
    context.lineWidth = $175f0ce845e20c92$var$TWG_LINE_WIDTH;
    context.setLineDash([
        $175f0ce845e20c92$var$TWG_DASH_LENGTH,
        $175f0ce845e20c92$var$TWG_DASH_GAP
    ]);
    (0, $5jgP8.TWG_CONNECTIONS).forEach(([fromIndex, toIndex], connectionIndex)=>{
        const from = frame[fromIndex];
        const to = frame[toIndex];
        const direction = connectionIndex % 2 === 0 ? -1 : 1;
        const dashSpeed = $175f0ce845e20c92$var$TWG_DASH_SPEEDS[connectionIndex % $175f0ce845e20c92$var$TWG_DASH_SPEEDS.length];
        context.globalAlpha = opacity * edgeOpacity;
        context.lineDashOffset = direction * timeSeconds * dashSpeed;
        context.beginPath();
        context.moveTo(from.x, from.y);
        context.lineTo(to.x, to.y);
        context.stroke();
    });
    context.fillStyle = color;
    (0, $5jgP8.getTwgTravelingPulses)(frame, timeSeconds).forEach(({ strength: strength, x: x, y: y })=>{
        context.globalAlpha = opacity * strength * pulseHaloOpacity;
        context.beginPath();
        context.arc(x, y, $175f0ce845e20c92$var$TWG_PULSE_HALO_RADIUS, 0, (0, $lj1QA.FULL_ROTATION_RADIANS));
        context.fill();
        context.globalAlpha = opacity * strength;
        context.beginPath();
        context.arc(x, y, $175f0ce845e20c92$var$TWG_PULSE_CORE_RADIUS, 0, (0, $lj1QA.FULL_ROTATION_RADIANS));
        context.fill();
    });
    context.restore();
};
const $175f0ce845e20c92$var$paintDotGlow = (context, dot, radius, glowStrength, glowOpacity)=>{
    if (glowStrength <= 0 || glowOpacity <= 0) return;
    const glowRadius = radius + $175f0ce845e20c92$var$MAXIMUM_GLOW_SPREAD * glowStrength;
    const coreEdge = radius / glowRadius;
    const glow = context.createRadialGradient(dot.x, dot.y, 0, dot.x, dot.y, glowRadius);
    glow.addColorStop(0, 'rgba(255,255,255,1)');
    glow.addColorStop(coreEdge, `rgba(255,255,255,${$175f0ce845e20c92$var$GLOW_OPACITY_AT_CORE_EDGE})`);
    glow.addColorStop(1, 'rgba(255,255,255,0)');
    context.save();
    context.fillStyle = glow;
    context.globalAlpha = glowStrength * glowOpacity;
    context.beginPath();
    context.arc(dot.x, dot.y, glowRadius, 0, (0, $lj1QA.FULL_ROTATION_RADIANS));
    context.fill();
    context.restore();
};
const $175f0ce845e20c92$var$getVisualGlowStrength = (glowStrength)=>Math.pow($175f0ce845e20c92$var$clamp(glowStrength), $175f0ce845e20c92$var$GLOW_FALLOFF_POWER);
const $175f0ce845e20c92$var$getCoreBrightnessMultiplier = ({ brightness: brightness, glowStrength: glowStrength })=>1 + Math.pow($175f0ce845e20c92$var$clamp(brightness), $175f0ce845e20c92$var$BRIGHTNESS_GLINT_POWER) * $175f0ce845e20c92$var$MAXIMUM_BASE_BRIGHTNESS_BOOST + $175f0ce845e20c92$var$getVisualGlowStrength(glowStrength) * $175f0ce845e20c92$var$MAXIMUM_GLOW_BRIGHTNESS_BOOST;
const $175f0ce845e20c92$var$paintDot = (context, dot)=>{
    const radius = (0, $lj1QA.CONSTELLATION_DOT_DIAMETER) / 2 * dot.scale;
    context.save();
    context.fillStyle = (0, $gQ9Eg.brightenColor)(dot.color, $175f0ce845e20c92$var$getCoreBrightnessMultiplier(dot));
    context.beginPath();
    context.arc(dot.x, dot.y, radius, 0, (0, $lj1QA.FULL_ROTATION_RADIANS));
    context.fill();
    context.restore();
};
const $175f0ce845e20c92$export$99da3e2ab29b5ec3 = (context, frame, options = {})=>{
    context.clearRect(0, 0, (0, $lj1QA.CONSTELLATION_SIZE), (0, $lj1QA.CONSTELLATION_SIZE));
    if (options.twg) $175f0ce845e20c92$var$paintTwgGraph(context, frame, options.twg);
    frame.forEach((dot)=>{
        const radius = (0, $lj1QA.CONSTELLATION_DOT_DIAMETER) / 2 * dot.scale;
        $175f0ce845e20c92$var$paintDotGlow(context, dot, radius, $175f0ce845e20c92$var$getVisualGlowStrength(dot.glowStrength), options.glowOpacity ?? $175f0ce845e20c92$var$DEFAULT_GLOW_OPACITY);
    });
    frame.forEach((dot)=>$175f0ce845e20c92$var$paintDot(context, dot));
};
module.exports["paintConstellationFrame"] = $175f0ce845e20c92$export$99da3e2ab29b5ec3;

});

parcelRegister("gQ9Eg", function(module, exports) {

var $89bON = parcelRequire("89bON");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $e0068339bde14e56$var$clampColorChannel = (value)=>Math.max(0, Math.min(255, value));
const $e0068339bde14e56$var$parseHexColor = (color)=>{
    const channels = color.match(/[A-Fa-f0-9]{2}/g);
    if (!color.startsWith('#') || color.length !== 7 || channels?.length !== 3) return null;
    const [red, green, blue] = channels.map((channel)=>Number.parseInt(channel, 16));
    return {
        red: red,
        green: green,
        blue: blue
    };
};
const $e0068339bde14e56$var$formatRgbColor = ({ blue: blue, green: green, red: red })=>`rgb(${[
        red,
        green,
        blue
    ].map((channel)=>Math.round($e0068339bde14e56$var$clampColorChannel(channel))).join(',')})`;
const $e0068339bde14e56$export$60b9b1d06062cf6d = (color, multiplier)=>{
    const channels = $e0068339bde14e56$var$parseHexColor(color);
    if (!channels) return color;
    return $e0068339bde14e56$var$formatRgbColor({
        red: channels.red * multiplier,
        green: channels.green * multiplier,
        blue: channels.blue * multiplier
    });
};
const $e0068339bde14e56$export$c436c10e1af3b8b1 = {
    active: [
        '#1868DB',
        '#AF59E1',
        '#6A9A23',
        '#FCA700'
    ],
    inactive: '#6B6E76'
};
const $e0068339bde14e56$export$18e34bdaf740712f = {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Canvas requires a concrete color when token CSS is unavailable.
    color: '#505258',
    edgeOpacity: 0.8,
    pulseHaloOpacity: 0.3
};
const $e0068339bde14e56$var$DARK_TWG_COLOR_FALLBACK = '#FFFFFF';
const $e0068339bde14e56$var$DARK_TWG_EDGE_OPACITY = 0.75;
const $e0068339bde14e56$var$DARK_TWG_PULSE_HALO_OPACITY = 0.35;
const $e0068339bde14e56$var$DARK_GLOW_OPACITY = 0.58;
const $e0068339bde14e56$var$resolveConstellationPaintStyle = (colorMode)=>({
        dotColors: {
            active: [
                (0, $89bON.getTokenValue)('color.rovo.icon.blue', $e0068339bde14e56$export$c436c10e1af3b8b1.active[0]),
                (0, $89bON.getTokenValue)('color.rovo.icon.purple', $e0068339bde14e56$export$c436c10e1af3b8b1.active[1]),
                (0, $89bON.getTokenValue)('color.rovo.icon.lime', $e0068339bde14e56$export$c436c10e1af3b8b1.active[2]),
                (0, $89bON.getTokenValue)('color.rovo.icon.saffron', $e0068339bde14e56$export$c436c10e1af3b8b1.active[3])
            ],
            inactive: (0, $89bON.getTokenValue)('color.icon.subtlest', $e0068339bde14e56$export$c436c10e1af3b8b1.inactive)
        },
        glowOpacity: colorMode === 'dark' ? $e0068339bde14e56$var$DARK_GLOW_OPACITY : 0,
        twgGraph: {
            color: colorMode === 'dark' ? (0, $89bON.getTokenValue)('color.icon', $e0068339bde14e56$var$DARK_TWG_COLOR_FALLBACK) : (0, $89bON.getTokenValue)('color.icon.subtle', $e0068339bde14e56$export$18e34bdaf740712f.color),
            edgeOpacity: colorMode === 'dark' ? $e0068339bde14e56$var$DARK_TWG_EDGE_OPACITY : $e0068339bde14e56$export$18e34bdaf740712f.edgeOpacity,
            pulseHaloOpacity: colorMode === 'dark' ? $e0068339bde14e56$var$DARK_TWG_PULSE_HALO_OPACITY : $e0068339bde14e56$export$18e34bdaf740712f.pulseHaloOpacity
        }
    });
const $e0068339bde14e56$export$1064cb111ec0016 = ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return $e0068339bde14e56$var$resolveConstellationPaintStyle(colorMode);
};
module.exports["brightenColor"] = $e0068339bde14e56$export$60b9b1d06062cf6d;
module.exports["useConstellationPaintStyle"] = $e0068339bde14e56$export$1064cb111ec0016;

});

parcelRegister("5jgP8", function(module, exports) {

var $lj1QA = parcelRequire("lj1QA");


var $ckprS = parcelRequire("ckprS");

const $28720d63fd231f28$var$TWG_REFERENCE_SIZE = 56;
const $28720d63fd231f28$var$GLIMMER_BASE_SPEED_RADIANS_PER_SECOND = 1.15;
const $28720d63fd231f28$var$GLIMMER_SPEED_RANGE_RADIANS_PER_SECOND = 0.3;
const $28720d63fd231f28$var$GLIMMER_PHASE_OFFSET_RADIANS = 2.41;
const $28720d63fd231f28$var$TRANSMIT_PERIOD_SECONDS = 3.2;
const $28720d63fd231f28$var$TRANSMIT_VARIATION_OFFSET = 5;
const $28720d63fd231f28$var$TRANSMIT_FOCUS_POWER = 4;
const $28720d63fd231f28$var$BASE_BRIGHTNESS = 0.4;
const $28720d63fd231f28$var$GLIMMER_BRIGHTNESS = 0.42;
const $28720d63fd231f28$var$TRANSMIT_BRIGHTNESS = 0.3;
const $28720d63fd231f28$var$BASE_SCALE = 0.94;
const $28720d63fd231f28$var$GLIMMER_SCALE = 0.1;
const $28720d63fd231f28$var$TRANSMIT_SCALE = 0.16;
const $28720d63fd231f28$var$SWAY_REFERENCE_PIXELS = 0.28;
const $28720d63fd231f28$var$HORIZONTAL_SWAY_SPEED_RADIANS_PER_SECOND = 1.3;
const $28720d63fd231f28$var$HORIZONTAL_SWAY_PHASE_OFFSET_RADIANS = 2.17;
const $28720d63fd231f28$var$VERTICAL_SWAY_SPEED_RADIANS_PER_SECOND = 1.1;
const $28720d63fd231f28$var$VERTICAL_SWAY_PHASE_OFFSET_RADIANS = 1.73;
const $28720d63fd231f28$var$PULSE_CURVE_RADIANS = Math.PI;
const $28720d63fd231f28$var$GLOW_CONCENTRATION_POWER = 1.5;
const $28720d63fd231f28$export$d13b5483c9c2f13c = [
    [
        0,
        1
    ],
    [
        0,
        2
    ],
    [
        0,
        3
    ],
    [
        0,
        4
    ],
    [
        0,
        5
    ],
    [
        0,
        6
    ],
    [
        1,
        7
    ],
    [
        1,
        8
    ],
    [
        1,
        2
    ],
    [
        2,
        9
    ],
    [
        2,
        10
    ],
    [
        2,
        3
    ],
    [
        3,
        11
    ],
    [
        3,
        12
    ],
    [
        4,
        13
    ],
    [
        4,
        14
    ],
    [
        4,
        5
    ],
    [
        5,
        15
    ],
    [
        5,
        16
    ],
    [
        5,
        6
    ],
    [
        6,
        17
    ],
    [
        6,
        18
    ]
];
const $28720d63fd231f28$var$TWG_PULSE_CONFIGS = [
    {
        activeDurationSeconds: 1,
        connectionSequenceOffset: 41,
        phaseOffsetSeconds: 0.35,
        restDurationSeconds: 0.6
    },
    {
        activeDurationSeconds: 0.8,
        connectionSequenceOffset: 73,
        phaseOffsetSeconds: 1.05,
        restDurationSeconds: 1
    }
];
// Retains the irregular hub-and-spoke formation
const $28720d63fd231f28$var$TWG_REFERENCE_POINTS = [
    [
        29.7,
        27.8
    ],
    [
        39,
        32.4
    ],
    [
        27,
        39.4
    ],
    [
        17.2,
        37.3
    ],
    [
        15.8,
        24.5
    ],
    [
        27.9,
        14.7
    ],
    [
        38.6,
        20.8
    ],
    [
        49,
        36.6
    ],
    [
        47.2,
        25.7
    ],
    [
        26.2,
        50
    ],
    [
        36.6,
        46
    ],
    [
        19,
        47.7
    ],
    [
        9.5,
        39
    ],
    [
        11.7,
        16.5
    ],
    [
        6.3,
        24
    ],
    [
        26.4,
        6.7
    ],
    [
        16.8,
        10.2
    ],
    [
        45,
        15.7
    ],
    [
        39.5,
        10.3
    ]
];
const $28720d63fd231f28$var$REFERENCE_TO_CONSTELLATION_SCALE = (0, $lj1QA.CONSTELLATION_SIZE) / $28720d63fd231f28$var$TWG_REFERENCE_SIZE;
const $28720d63fd231f28$var$TWG_BASE_POSITIONS = $28720d63fd231f28$var$TWG_REFERENCE_POINTS.map(([x, y])=>({
        x: x * $28720d63fd231f28$var$REFERENCE_TO_CONSTELLATION_SCALE,
        y: y * $28720d63fd231f28$var$REFERENCE_TO_CONSTELLATION_SCALE
    }));
const $28720d63fd231f28$var$getGlimmerStrength = (index, timeSeconds)=>{
    const glimmerSpeed = $28720d63fd231f28$var$GLIMMER_BASE_SPEED_RADIANS_PER_SECOND + (0, $ckprS.getStableVariation)(index) * $28720d63fd231f28$var$GLIMMER_SPEED_RANGE_RADIANS_PER_SECOND;
    return (0, $ckprS.getSineWaveStrength)(timeSeconds * glimmerSpeed + index * $28720d63fd231f28$var$GLIMMER_PHASE_OFFSET_RADIANS);
};
const $28720d63fd231f28$var$getTransmitStrength = (index, timeSeconds)=>{
    const cycleProgress = (0, $ckprS.getRepeatingProgress)(timeSeconds / $28720d63fd231f28$var$TRANSMIT_PERIOD_SECONDS + (0, $ckprS.getStableVariation)(index + $28720d63fd231f28$var$TRANSMIT_VARIATION_OFFSET));
    // Lets each transmission swell and fade without a hard cycle reset.
    return Math.sin(cycleProgress * $28720d63fd231f28$var$PULSE_CURVE_RADIANS) ** $28720d63fd231f28$var$TRANSMIT_FOCUS_POWER;
};
const $28720d63fd231f28$var$getSwayOffset = (index, timeSeconds)=>{
    const swayDistance = $28720d63fd231f28$var$SWAY_REFERENCE_PIXELS * $28720d63fd231f28$var$REFERENCE_TO_CONSTELLATION_SCALE;
    return {
        x: Math.sin(timeSeconds * $28720d63fd231f28$var$HORIZONTAL_SWAY_SPEED_RADIANS_PER_SECOND + index * $28720d63fd231f28$var$HORIZONTAL_SWAY_PHASE_OFFSET_RADIANS) * swayDistance,
        y: Math.cos(timeSeconds * $28720d63fd231f28$var$VERTICAL_SWAY_SPEED_RADIANS_PER_SECOND + index * $28720d63fd231f28$var$VERTICAL_SWAY_PHASE_OFFSET_RADIANS) * swayDistance
    };
};
const $28720d63fd231f28$export$4a920940f8679248 = ({ color: color, index: index, timeSeconds: timeSeconds })=>{
    const basePosition = $28720d63fd231f28$var$TWG_BASE_POSITIONS[index];
    const glimmerStrength = $28720d63fd231f28$var$getGlimmerStrength(index, timeSeconds);
    const transmitStrength = $28720d63fd231f28$var$getTransmitStrength(index, timeSeconds);
    const swayOffset = $28720d63fd231f28$var$getSwayOffset(index, timeSeconds);
    return {
        brightness: Math.min(1, $28720d63fd231f28$var$BASE_BRIGHTNESS + glimmerStrength * $28720d63fd231f28$var$GLIMMER_BRIGHTNESS + transmitStrength * $28720d63fd231f28$var$TRANSMIT_BRIGHTNESS),
        color: color,
        glowStrength: (0, $ckprS.getGlowSparkStrength)(Math.max(glimmerStrength, transmitStrength), $28720d63fd231f28$var$GLOW_CONCENTRATION_POWER),
        scale: $28720d63fd231f28$var$BASE_SCALE + glimmerStrength * $28720d63fd231f28$var$GLIMMER_SCALE + transmitStrength * $28720d63fd231f28$var$TRANSMIT_SCALE,
        x: basePosition.x + swayOffset.x,
        y: basePosition.y + swayOffset.y
    };
};
const $28720d63fd231f28$var$createTravelingPulse = (dots, timeSeconds, config)=>{
    const cycleDuration = config.activeDurationSeconds + config.restDurationSeconds;
    const elapsedSeconds = timeSeconds + config.phaseOffsetSeconds;
    const cycleIndex = Math.floor(elapsedSeconds / cycleDuration);
    const timeInCycle = elapsedSeconds % cycleDuration;
    if (timeInCycle > config.activeDurationSeconds) return null;
    const pulseProgress = timeInCycle / config.activeDurationSeconds;
    const travelProgress = 0.5 - 0.5 * Math.cos(pulseProgress * $28720d63fd231f28$var$PULSE_CURVE_RADIANS);
    const connectionIndex = Math.floor((0, $ckprS.getStableVariation)(cycleIndex + config.connectionSequenceOffset) * $28720d63fd231f28$export$d13b5483c9c2f13c.length);
    const [fromIndex, toIndex] = $28720d63fd231f28$export$d13b5483c9c2f13c[connectionIndex];
    const from = dots[fromIndex];
    const to = dots[toIndex];
    return {
        strength: Math.sin(pulseProgress * $28720d63fd231f28$var$PULSE_CURVE_RADIANS),
        x: from.x + (to.x - from.x) * travelProgress,
        y: from.y + (to.y - from.y) * travelProgress
    };
};
const $28720d63fd231f28$export$2c3e84796a305c4e = (dots, timeSeconds)=>$28720d63fd231f28$var$TWG_PULSE_CONFIGS.map((config)=>$28720d63fd231f28$var$createTravelingPulse(dots, timeSeconds, config)).filter((pulse)=>pulse !== null);
module.exports["TWG_CONNECTIONS"] = $28720d63fd231f28$export$d13b5483c9c2f13c;
module.exports["createTwgDot"] = $28720d63fd231f28$export$4a920940f8679248;
module.exports["getTwgTravelingPulses"] = $28720d63fd231f28$export$2c3e84796a305c4e;

});

parcelRegister("ckprS", function(module, exports) {
/**
 * Produces a repeatable value from 0 to 1 for an input such as a dot index.
 * Poses use it to give dots different speeds, amplitudes, or timing without those values changing between frames.
 */ const $94c22d93c566093f$export$6f68e22801365f54 = (input)=>{
    const value = Math.sin(input * 12.9898) * 43758.5453;
    return value - Math.floor(value);
};
const $94c22d93c566093f$export$28b647ee11ee8768 = (value, target)=>{
    const distance = Math.abs(value - target);
    return Math.min(distance, 1 - distance);
};
const $94c22d93c566093f$export$daa17f62b6780f62 = (timeSeconds, durationSeconds)=>timeSeconds % durationSeconds / durationSeconds;
const $94c22d93c566093f$export$e2cb095b4cab2076 = (value)=>value - Math.floor(value);
const $94c22d93c566093f$export$483ee82d51c85f50 = (angleRadians)=>0.5 + 0.5 * Math.sin(angleRadians);
const $94c22d93c566093f$export$714e982f88adcabc = (activityStrength, concentrationPower, maximumStrength = 1)=>Math.max(0, Math.min(1, activityStrength)) ** concentrationPower * maximumStrength;
module.exports["getStableVariation"] = $94c22d93c566093f$export$6f68e22801365f54;
module.exports["getWrappedCycleDistance"] = $94c22d93c566093f$export$28b647ee11ee8768;
module.exports["getCycleProgress"] = $94c22d93c566093f$export$daa17f62b6780f62;
module.exports["getRepeatingProgress"] = $94c22d93c566093f$export$e2cb095b4cab2076;
module.exports["getSineWaveStrength"] = $94c22d93c566093f$export$483ee82d51c85f50;
module.exports["getGlowSparkStrength"] = $94c22d93c566093f$export$714e982f88adcabc;

});

parcelRegister("ashLd", function(module, exports) {

var $lj1QA = parcelRequire("lj1QA");


var $8TNgV = parcelRequire("8TNgV");

const $0e99b094985f85e4$var$MAX_FRAME_DELTA_SECONDS = 0.032;
const $0e99b094985f85e4$var$AUDIO_ATTACK_RATE = 14;
const $0e99b094985f85e4$var$AUDIO_RELEASE_RATE = 4.5;
const $0e99b094985f85e4$var$BASE_DOT_STIFFNESS = 42;
const $0e99b094985f85e4$var$DOT_STIFFNESS_INDEX_STEP = 13;
const $0e99b094985f85e4$var$DOT_STIFFNESS_PATTERN_SIZE = 9;
const $0e99b094985f85e4$var$DOT_STIFFNESS_VARIATION = 1.1;
const $0e99b094985f85e4$var$VELOCITY_DAMPING_RATE = 7.2;
const $0e99b094985f85e4$var$APPEARANCE_RESPONSE_RATE = 10;
const $0e99b094985f85e4$var$TWG_LAYER_RESPONSE_RATE = 2.6;
const $0e99b094985f85e4$var$SOFT_WALL_START_RATIO = 1 / Math.sqrt((0, $lj1QA.GOLDEN_RATIO));
const $0e99b094985f85e4$var$interpolate = (from, to, progress)=>from + (to - from) * progress;
const $0e99b094985f85e4$var$clampAudioLevel = (audioLevel)=>Math.min(1, Math.max(0, audioLevel));
const $0e99b094985f85e4$var$getAudioGain = (audioLevel)=>0.4 + 1.1 * audioLevel;
const $0e99b094985f85e4$var$getFrameDeltaSeconds = (previousTimestampMs, timestampMs)=>Math.min($0e99b094985f85e4$var$MAX_FRAME_DELTA_SECONDS, Math.max(0, timestampMs - previousTimestampMs) / 1000);
const $0e99b094985f85e4$var$updateSmoothedAudioLevel = (simulation, audioLevel, deltaSeconds)=>{
    const clampedAudioLevel = $0e99b094985f85e4$var$clampAudioLevel(audioLevel);
    const responseRate = clampedAudioLevel > simulation.smoothedAudioLevel ? $0e99b094985f85e4$var$AUDIO_ATTACK_RATE : $0e99b094985f85e4$var$AUDIO_RELEASE_RATE;
    simulation.smoothedAudioLevel += (clampedAudioLevel - simulation.smoothedAudioLevel) * Math.min(1, deltaSeconds * responseRate);
};
const $0e99b094985f85e4$var$createSimulationTargets = (simulation, input)=>(0, $8TNgV.createConstellationFrame)({
        active: input.active,
        audioGain: $0e99b094985f85e4$var$getAudioGain(simulation.smoothedAudioLevel),
        dotColors: input.dotColors,
        pose: input.pose,
        timeSeconds: simulation.elapsedSeconds
    });
const $0e99b094985f85e4$var$getDotStiffness = (index)=>$0e99b094985f85e4$var$BASE_DOT_STIFFNESS + index * $0e99b094985f85e4$var$DOT_STIFFNESS_INDEX_STEP % $0e99b094985f85e4$var$DOT_STIFFNESS_PATTERN_SIZE * $0e99b094985f85e4$var$DOT_STIFFNESS_VARIATION;
const $0e99b094985f85e4$var$updateDotPosition = (dot, target, index, deltaSeconds)=>{
    const stiffness = $0e99b094985f85e4$var$getDotStiffness(index);
    const damping = Math.exp(-$0e99b094985f85e4$var$VELOCITY_DAMPING_RATE * deltaSeconds);
    // Damped spring motion lets a dot preserve momentum while approaching its target position.
    dot.velocityX = (dot.velocityX + (target.x - dot.x) * stiffness * deltaSeconds) * damping;
    dot.velocityY = (dot.velocityY + (target.y - dot.y) * stiffness * deltaSeconds) * damping;
    dot.x += dot.velocityX * deltaSeconds;
    dot.y += dot.velocityY * deltaSeconds;
};
const $0e99b094985f85e4$var$updateDotAppearance = (dot, target, deltaSeconds)=>{
    // Allows dot brightness and scale to change independent of frame rate.
    const progress = 1 - Math.exp(-$0e99b094985f85e4$var$APPEARANCE_RESPONSE_RATE * deltaSeconds);
    dot.brightness = $0e99b094985f85e4$var$interpolate(dot.brightness, target.brightness, progress);
    dot.glowStrength = $0e99b094985f85e4$var$interpolate(dot.glowStrength, target.glowStrength, progress);
    dot.scale = $0e99b094985f85e4$var$interpolate(dot.scale, target.scale, progress);
    dot.color = target.color;
};
const $0e99b094985f85e4$var$keepDotInsideSoftWall = (dot)=>{
    const offsetX = dot.x - (0, $lj1QA.CONSTELLATION_CENTER);
    const offsetY = dot.y - (0, $lj1QA.CONSTELLATION_CENTER);
    const distanceFromCenter = Math.hypot(offsetX, offsetY);
    const maximumDistance = (0, $lj1QA.CONSTELLATION_CENTER) - (0, $lj1QA.CONSTELLATION_DOT_DIAMETER) / 2 * dot.scale;
    const normalizedDistance = distanceFromCenter / maximumDistance;
    if (normalizedDistance <= $0e99b094985f85e4$var$SOFT_WALL_START_RATIO) return;
    // Tanh soft wall: compresses overshoot near the edge without visibly hard-clamping motion.
    const compressedDistance = maximumDistance * ($0e99b094985f85e4$var$SOFT_WALL_START_RATIO + (1 - $0e99b094985f85e4$var$SOFT_WALL_START_RATIO) * Math.tanh((normalizedDistance - $0e99b094985f85e4$var$SOFT_WALL_START_RATIO) / (1 - $0e99b094985f85e4$var$SOFT_WALL_START_RATIO)));
    const compression = compressedDistance / distanceFromCenter;
    dot.x = (0, $lj1QA.CONSTELLATION_CENTER) + offsetX * compression;
    dot.y = (0, $lj1QA.CONSTELLATION_CENTER) + offsetY * compression;
};
const $0e99b094985f85e4$var$advanceDot = (dot, target, index, deltaSeconds)=>{
    $0e99b094985f85e4$var$updateDotPosition(dot, target, index, deltaSeconds);
    $0e99b094985f85e4$var$updateDotAppearance(dot, target, deltaSeconds);
    $0e99b094985f85e4$var$keepDotInsideSoftWall(dot);
};
const $0e99b094985f85e4$var$updateTwgOpacity = (simulation, pose, deltaSeconds)=>{
    const targetOpacity = pose === 'twg' ? 1 : 0;
    const progress = Math.min(1, deltaSeconds * $0e99b094985f85e4$var$TWG_LAYER_RESPONSE_RATE);
    // Fades the TWG connections in and out as the formation changes pose.
    simulation.twgOpacity += (targetOpacity - simulation.twgOpacity) * progress;
};
const $0e99b094985f85e4$export$97a291abb564072a = (input, timestampMs)=>({
        dots: (0, $8TNgV.createConstellationFrame)({
            active: input.active,
            audioGain: $0e99b094985f85e4$var$getAudioGain($0e99b094985f85e4$var$clampAudioLevel(input.audioLevel)),
            dotColors: input.dotColors,
            pose: input.pose,
            timeSeconds: 0
        }).map((dot)=>({
                ...dot,
                velocityX: 0,
                velocityY: 0
            })),
        elapsedSeconds: 0,
        lastTimestampMs: timestampMs,
        smoothedAudioLevel: $0e99b094985f85e4$var$clampAudioLevel(input.audioLevel),
        twgOpacity: input.pose === 'twg' ? 1 : 0
    });
const $0e99b094985f85e4$export$ea2c625b6a78cd39 = (simulation, input, timestampMs)=>{
    const deltaSeconds = $0e99b094985f85e4$var$getFrameDeltaSeconds(simulation.lastTimestampMs, timestampMs);
    simulation.lastTimestampMs = timestampMs;
    if (input.paused) return simulation.dots;
    simulation.elapsedSeconds += deltaSeconds;
    $0e99b094985f85e4$var$updateSmoothedAudioLevel(simulation, input.audioLevel, deltaSeconds);
    $0e99b094985f85e4$var$updateTwgOpacity(simulation, input.pose, deltaSeconds);
    const targets = $0e99b094985f85e4$var$createSimulationTargets(simulation, input);
    simulation.dots.forEach((dot, index)=>{
        $0e99b094985f85e4$var$advanceDot(dot, targets[index], index, deltaSeconds);
    });
    return simulation.dots;
};
module.exports["createConstellationSimulation"] = $0e99b094985f85e4$export$97a291abb564072a;
module.exports["advanceConstellationSimulation"] = $0e99b094985f85e4$export$ea2c625b6a78cd39;

});

parcelRegister("8TNgV", function(module, exports) {

var $bGZ89 = parcelRequire("bGZ89");


var $4ZOeR = parcelRequire("4ZOeR");


var $kW20w = parcelRequire("kW20w");


var $31ErE = parcelRequire("31ErE");


var $cCdXi = parcelRequire("cCdXi");


var $4bGEs = parcelRequire("4bGEs");


var $hTib8 = parcelRequire("hTib8");


var $aMTd6 = parcelRequire("aMTd6");


var $5jgP8 = parcelRequire("5jgP8");

// Assigned color for each dot in the constellation
const $cf12af25315a0c17$var$CONSTELLATION_DOT_COLOR_INDEXES = [
    0,
    3,
    2,
    1,
    3,
    2,
    1,
    3,
    2,
    1,
    0,
    3,
    2,
    1,
    0,
    3,
    2,
    1,
    0
];
const $cf12af25315a0c17$export$9b871352ef096c71 = ({ active: active, audioGain: audioGain, dotColors: dotColors, pose: pose, timeSeconds: timeSeconds })=>{
    return $cf12af25315a0c17$var$CONSTELLATION_DOT_COLOR_INDEXES.map((colorIndex, index)=>{
        const input = {
            color: active ? dotColors.active[colorIndex] : dotColors.inactive,
            index: index,
            timeSeconds: timeSeconds
        };
        switch(pose){
            case 'still':
                return (0, $aMTd6.createStillDot)({
                    ...input,
                    active: active
                });
            case 'listening':
                return (0, $4bGEs.createListeningDot)({
                    ...input,
                    audioGain: audioGain
                });
            case 'speaking':
                return (0, $hTib8.createSpeakingDot)({
                    ...input,
                    audioGain: audioGain
                });
            case 'eq':
                return (0, $kW20w.createEqualizerDot)(input);
            case 'twg':
                return (0, $5jgP8.createTwgDot)(input);
            case 'gyre':
                return (0, $31ErE.createGyreDot)(input);
            case 'agent':
                return (0, $bGZ89.createAgentDot)(input);
            case 'cursor':
                return (0, $4ZOeR.createCursorDot)(input);
            case 'infinity':
                return (0, $cCdXi.createInfinityDot)(input);
        }
    });
};
module.exports["createConstellationFrame"] = $cf12af25315a0c17$export$9b871352ef096c71;

});

parcelRegister("bGZ89", function(module, exports) {

var $lj1QA = parcelRequire("lj1QA");


var $ckprS = parcelRequire("ckprS");

const $17580e0862d7fcd5$var$NUCLEUS_INDEX = 0;
const $17580e0862d7fcd5$var$INNER_HEXAGON_START_INDEX = 1;
const $17580e0862d7fcd5$var$INNER_HEXAGON_DOT_COUNT = 6;
const $17580e0862d7fcd5$var$OUTER_HEXAGON_START_INDEX = $17580e0862d7fcd5$var$INNER_HEXAGON_START_INDEX + $17580e0862d7fcd5$var$INNER_HEXAGON_DOT_COUNT;
const $17580e0862d7fcd5$var$OUTER_HEXAGON_DOT_COUNT = 12;
const $17580e0862d7fcd5$var$HEXAGON_ROTATION_RADIANS = -Math.PI / 2;
const $17580e0862d7fcd5$var$OUTER_HEXAGON_RADIUS = (0, $lj1QA.CONSTELLATION_FORMATION_RADIUS) * 1.18;
const $17580e0862d7fcd5$var$INNER_HEXAGON_RADIUS = $17580e0862d7fcd5$var$OUTER_HEXAGON_RADIUS * 0.5;
const $17580e0862d7fcd5$var$COMET_PERIOD_SECONDS = 2.4;
const $17580e0862d7fcd5$var$SECOND_COMET_PHASE_OFFSET = 0.5;
const $17580e0862d7fcd5$var$OUTER_BASE_BRIGHTNESS = 0.5;
const $17580e0862d7fcd5$var$OUTER_COMET_BRIGHTNESS = 0.5;
const $17580e0862d7fcd5$var$INNER_BASE_BRIGHTNESS = 0.68;
const $17580e0862d7fcd5$var$INNER_BREATH_AMPLITUDE = 0.16;
const $17580e0862d7fcd5$var$INNER_BREATH_SPEED_RADIANS_PER_SECOND = 1.1;
const $17580e0862d7fcd5$var$INNER_BREATH_PHASE_OFFSET_RADIANS = -Math.PI / 3;
const $17580e0862d7fcd5$var$getHexagonVertex = (vertexIndex, radius)=>{
    const angle = $17580e0862d7fcd5$var$HEXAGON_ROTATION_RADIANS + vertexIndex / $17580e0862d7fcd5$var$INNER_HEXAGON_DOT_COUNT * (0, $lj1QA.FULL_ROTATION_RADIANS);
    return [
        (0, $lj1QA.CONSTELLATION_CENTER) + Math.cos(angle) * radius,
        (0, $lj1QA.CONSTELLATION_CENTER) + Math.sin(angle) * radius
    ];
};
const $17580e0862d7fcd5$var$getOuterHexagonPosition = (positionIndex)=>{
    const vertexIndex = Math.floor(positionIndex / 2);
    const vertex = $17580e0862d7fcd5$var$getHexagonVertex(vertexIndex, $17580e0862d7fcd5$var$OUTER_HEXAGON_RADIUS);
    // Even positions use a vertex; odd positions sit halfway along the following edge.
    if (positionIndex % 2 === 0) return vertex;
    const nextVertex = $17580e0862d7fcd5$var$getHexagonVertex((vertexIndex + 1) % $17580e0862d7fcd5$var$INNER_HEXAGON_DOT_COUNT, $17580e0862d7fcd5$var$OUTER_HEXAGON_RADIUS);
    return [
        (vertex[0] + nextVertex[0]) / 2,
        (vertex[1] + nextVertex[1]) / 2
    ];
};
const $17580e0862d7fcd5$var$getOuterCometBrightness = (positionIndex, timeSeconds)=>{
    const positionProgress = positionIndex / $17580e0862d7fcd5$var$OUTER_HEXAGON_DOT_COUNT;
    const cometProgress = timeSeconds / $17580e0862d7fcd5$var$COMET_PERIOD_SECONDS + positionProgress;
    const firstComet = (1 - (0, $ckprS.getRepeatingProgress)(cometProgress)) ** 2;
    const secondComet = (1 - (0, $ckprS.getRepeatingProgress)(cometProgress + $17580e0862d7fcd5$var$SECOND_COMET_PHASE_OFFSET)) ** 2;
    return $17580e0862d7fcd5$var$OUTER_BASE_BRIGHTNESS + $17580e0862d7fcd5$var$OUTER_COMET_BRIGHTNESS * Math.min(1, firstComet + secondComet);
};
const $17580e0862d7fcd5$export$b6ff58c3457a7c0f = ({ color: color, index: index, timeSeconds: timeSeconds })=>{
    if (index === $17580e0862d7fcd5$var$NUCLEUS_INDEX) return {
        brightness: 1,
        color: color,
        glowStrength: 0,
        scale: 1,
        x: (0, $lj1QA.CONSTELLATION_CENTER),
        y: (0, $lj1QA.CONSTELLATION_CENTER)
    };
    if (index < $17580e0862d7fcd5$var$OUTER_HEXAGON_START_INDEX) {
        const innerVertexIndex = index - $17580e0862d7fcd5$var$INNER_HEXAGON_START_INDEX;
        const [x, y] = $17580e0862d7fcd5$var$getHexagonVertex(innerVertexIndex, $17580e0862d7fcd5$var$INNER_HEXAGON_RADIUS);
        return {
            brightness: $17580e0862d7fcd5$var$INNER_BASE_BRIGHTNESS + $17580e0862d7fcd5$var$INNER_BREATH_AMPLITUDE * Math.sin(timeSeconds * $17580e0862d7fcd5$var$INNER_BREATH_SPEED_RADIANS_PER_SECOND + innerVertexIndex * $17580e0862d7fcd5$var$INNER_BREATH_PHASE_OFFSET_RADIANS),
            color: color,
            glowStrength: 0,
            scale: 1,
            x: x,
            y: y
        };
    }
    const outerPositionIndex = index - $17580e0862d7fcd5$var$OUTER_HEXAGON_START_INDEX;
    const [x, y] = $17580e0862d7fcd5$var$getOuterHexagonPosition(outerPositionIndex);
    const brightness = $17580e0862d7fcd5$var$getOuterCometBrightness(outerPositionIndex, timeSeconds);
    return {
        brightness: brightness,
        color: color,
        glowStrength: (brightness - $17580e0862d7fcd5$var$OUTER_BASE_BRIGHTNESS) / $17580e0862d7fcd5$var$OUTER_COMET_BRIGHTNESS,
        scale: 1,
        x: x,
        y: y
    };
};
module.exports["createAgentDot"] = $17580e0862d7fcd5$export$b6ff58c3457a7c0f;

});

parcelRegister("4ZOeR", function(module, exports) {

var $lj1QA = parcelRequire("lj1QA");


var $ckprS = parcelRequire("ckprS");

const $4db15c4b7725e5db$var$CURSOR_REFERENCE_WIDTH = 13.8;
const $4db15c4b7725e5db$var$CURSOR_REFERENCE_HEIGHT = 14.2;
const $4db15c4b7725e5db$var$CURSOR_BOX_RATIO = 0.72;
const $4db15c4b7725e5db$var$CURSOR_APEX_POSITION_INDEX = 0;
const $4db15c4b7725e5db$var$HIGHLIGHT_CYCLES_AROUND_CURSOR = 2;
const $4db15c4b7725e5db$var$HIGHLIGHT_SPEED_RADIANS_PER_SECOND = 1.7;
const $4db15c4b7725e5db$var$HIGHLIGHT_PHASE_VARIATION = 0.6;
const $4db15c4b7725e5db$var$HIGHLIGHT_BRIGHTNESS = 0.26;
const $4db15c4b7725e5db$var$BASE_BRIGHTNESS = 0.42;
const $4db15c4b7725e5db$var$CLICK_BRIGHTNESS = 0.55;
const $4db15c4b7725e5db$var$CLICK_PERIOD_SECONDS = 2.3;
const $4db15c4b7725e5db$var$CLICK_GAUSSIAN_WIDTH = 0.075;
const $4db15c4b7725e5db$var$CLICK_TRAVEL_REFERENCE_PIXELS = 2.4;
const $4db15c4b7725e5db$var$CLICK_TRAVEL_STRENGTH = 0.7;
// Controls how tightly the glow follows the highlight traveling around the cursor outline.
const $4db15c4b7725e5db$var$HIGHLIGHT_GLOW_CONCENTRATION_POWER = 1.5;
const $4db15c4b7725e5db$var$HIGHLIGHT_GLOW_STRENGTH = 1;
const $4db15c4b7725e5db$var$APEX_CLICK_GLOW_STRENGTH = 0.5;
const $4db15c4b7725e5db$var$SWAY_REFERENCE_PIXELS = 0.55;
const $4db15c4b7725e5db$var$HORIZONTAL_SWAY_SPEED_RADIANS_PER_SECOND = 1.3;
const $4db15c4b7725e5db$var$HORIZONTAL_SWAY_PHASE_OFFSET_RADIANS = 1.7;
const $4db15c4b7725e5db$var$VERTICAL_SWAY_SPEED_RADIANS_PER_SECOND = 1.1;
const $4db15c4b7725e5db$var$VERTICAL_SWAY_PHASE_OFFSET_RADIANS = 1.3;
const $4db15c4b7725e5db$var$MINIMUM_APEX_DISTANCE_PIXELS = 1;
const $4db15c4b7725e5db$var$APEX_VISIBILITY_OFFSET_PIXELS = 0.6;
const $4db15c4b7725e5db$var$CURSOR_VERTICES = [
    [
        0,
        0
    ],
    [
        $4db15c4b7725e5db$var$CURSOR_REFERENCE_WIDTH,
        7.6
    ],
    [
        8,
        9.2
    ],
    [
        5.9,
        $4db15c4b7725e5db$var$CURSOR_REFERENCE_HEIGHT
    ]
];
const $4db15c4b7725e5db$var$CURSOR_SEGMENTS = $4db15c4b7725e5db$var$CURSOR_VERTICES.map((from, index)=>{
    const to = $4db15c4b7725e5db$var$CURSOR_VERTICES[(index + 1) % $4db15c4b7725e5db$var$CURSOR_VERTICES.length];
    return {
        from: from,
        length: Math.hypot(to[0] - from[0], to[1] - from[1]),
        to: to
    };
});
const $4db15c4b7725e5db$var$CURSOR_PERIMETER = $4db15c4b7725e5db$var$CURSOR_SEGMENTS.reduce((total, segment)=>total + segment.length, 0);
const $4db15c4b7725e5db$var$REFERENCE_TO_CONSTELLATION_SCALE = (0, $lj1QA.CONSTELLATION_SIZE) * $4db15c4b7725e5db$var$CURSOR_BOX_RATIO / $4db15c4b7725e5db$var$CURSOR_REFERENCE_HEIGHT;
const $4db15c4b7725e5db$var$CURSOR_OFFSET_X = ((0, $lj1QA.CONSTELLATION_SIZE) - $4db15c4b7725e5db$var$CURSOR_REFERENCE_WIDTH * $4db15c4b7725e5db$var$REFERENCE_TO_CONSTELLATION_SCALE) / 2;
const $4db15c4b7725e5db$var$CURSOR_OFFSET_Y = ((0, $lj1QA.CONSTELLATION_SIZE) - $4db15c4b7725e5db$var$CURSOR_REFERENCE_HEIGHT * $4db15c4b7725e5db$var$REFERENCE_TO_CONSTELLATION_SCALE) / 2;
const $4db15c4b7725e5db$var$getPositionOnSegment = (segment, progress)=>[
        $4db15c4b7725e5db$var$CURSOR_OFFSET_X + (segment.from[0] + (segment.to[0] - segment.from[0]) * progress) * $4db15c4b7725e5db$var$REFERENCE_TO_CONSTELLATION_SCALE,
        $4db15c4b7725e5db$var$CURSOR_OFFSET_Y + (segment.from[1] + (segment.to[1] - segment.from[1]) * progress) * $4db15c4b7725e5db$var$REFERENCE_TO_CONSTELLATION_SCALE
    ];
const $4db15c4b7725e5db$var$getPointAlongCursor = (perimeterDistance)=>{
    let remainingDistance = perimeterDistance;
    for (const segment of $4db15c4b7725e5db$var$CURSOR_SEGMENTS){
        if (remainingDistance <= segment.length) return $4db15c4b7725e5db$var$getPositionOnSegment(segment, remainingDistance / segment.length);
        remainingDistance -= segment.length;
    }
    const finalSegment = $4db15c4b7725e5db$var$CURSOR_SEGMENTS[$4db15c4b7725e5db$var$CURSOR_SEGMENTS.length - 1];
    return $4db15c4b7725e5db$var$getPositionOnSegment(finalSegment, 1);
};
const $4db15c4b7725e5db$var$CURSOR_BASE_POSITIONS = Array.from({
    length: (0, $lj1QA.CONSTELLATION_DOT_COUNT)
}, (_, index)=>$4db15c4b7725e5db$var$getPointAlongCursor(index / (0, $lj1QA.CONSTELLATION_DOT_COUNT) * $4db15c4b7725e5db$var$CURSOR_PERIMETER));
const $4db15c4b7725e5db$var$getClickStrength = (timeSeconds)=>{
    const cycleProgress = (0, $ckprS.getCycleProgress)(timeSeconds, $4db15c4b7725e5db$var$CLICK_PERIOD_SECONDS);
    const distanceFromClick = (0, $ckprS.getWrappedCycleDistance)(cycleProgress, 0);
    // Gaussian pulse: creates a short, smooth click at the start of each cycle.
    return Math.exp(-0.5 * (distanceFromClick / $4db15c4b7725e5db$var$CLICK_GAUSSIAN_WIDTH) ** 2);
};
const $4db15c4b7725e5db$var$getHighlightStrength = (index, timeSeconds)=>{
    const positionProgress = index / (0, $lj1QA.CONSTELLATION_DOT_COUNT);
    return (0, $ckprS.getSineWaveStrength)(positionProgress * (0, $lj1QA.FULL_ROTATION_RADIANS) * $4db15c4b7725e5db$var$HIGHLIGHT_CYCLES_AROUND_CURSOR - timeSeconds * $4db15c4b7725e5db$var$HIGHLIGHT_SPEED_RADIANS_PER_SECOND + $4db15c4b7725e5db$var$HIGHLIGHT_PHASE_VARIATION * (0, $ckprS.getStableVariation)(index));
};
const $4db15c4b7725e5db$var$getAnimatedCursorPosition = (index, timeSeconds, clickStrength)=>{
    const [baseX, baseY] = $4db15c4b7725e5db$var$CURSOR_BASE_POSITIONS[index];
    const [apexX, apexY] = $4db15c4b7725e5db$var$CURSOR_BASE_POSITIONS[$4db15c4b7725e5db$var$CURSOR_APEX_POSITION_INDEX];
    const distanceToApex = Math.max($4db15c4b7725e5db$var$MINIMUM_APEX_DISTANCE_PIXELS, Math.hypot(apexX - baseX, apexY - baseY));
    const clickTravelDistance = $4db15c4b7725e5db$var$CLICK_TRAVEL_REFERENCE_PIXELS * ((0, $lj1QA.CONSTELLATION_SIZE) / 48) * $4db15c4b7725e5db$var$CLICK_TRAVEL_STRENGTH * clickStrength;
    const swayDistance = $4db15c4b7725e5db$var$SWAY_REFERENCE_PIXELS * ((0, $lj1QA.CONSTELLATION_SIZE) / 48);
    const apexOffset = index === $4db15c4b7725e5db$var$CURSOR_APEX_POSITION_INDEX ? -$4db15c4b7725e5db$var$APEX_VISIBILITY_OFFSET_PIXELS : 0;
    return [
        baseX + apexOffset + Math.sin(timeSeconds * $4db15c4b7725e5db$var$HORIZONTAL_SWAY_SPEED_RADIANS_PER_SECOND + index * $4db15c4b7725e5db$var$HORIZONTAL_SWAY_PHASE_OFFSET_RADIANS) * swayDistance + (apexX - baseX) / distanceToApex * clickTravelDistance,
        baseY + apexOffset + Math.cos(timeSeconds * $4db15c4b7725e5db$var$VERTICAL_SWAY_SPEED_RADIANS_PER_SECOND + index * $4db15c4b7725e5db$var$VERTICAL_SWAY_PHASE_OFFSET_RADIANS) * swayDistance + (apexY - baseY) / distanceToApex * clickTravelDistance
    ];
};
const $4db15c4b7725e5db$export$1b8daf2e8c824ff3 = ({ color: color, index: index, timeSeconds: timeSeconds })=>{
    const clickStrength = $4db15c4b7725e5db$var$getClickStrength(timeSeconds);
    const highlightStrength = $4db15c4b7725e5db$var$getHighlightStrength(index, timeSeconds);
    const [x, y] = $4db15c4b7725e5db$var$getAnimatedCursorPosition(index, timeSeconds, clickStrength);
    return {
        brightness: $4db15c4b7725e5db$var$BASE_BRIGHTNESS + $4db15c4b7725e5db$var$HIGHLIGHT_BRIGHTNESS * highlightStrength + $4db15c4b7725e5db$var$CLICK_BRIGHTNESS * clickStrength,
        color: color,
        glowStrength: Math.min(1, (0, $ckprS.getGlowSparkStrength)(highlightStrength, $4db15c4b7725e5db$var$HIGHLIGHT_GLOW_CONCENTRATION_POWER, $4db15c4b7725e5db$var$HIGHLIGHT_GLOW_STRENGTH) + (index === $4db15c4b7725e5db$var$CURSOR_APEX_POSITION_INDEX ? clickStrength * $4db15c4b7725e5db$var$APEX_CLICK_GLOW_STRENGTH : 0)),
        scale: 1,
        x: x,
        y: y
    };
};
module.exports["createCursorDot"] = $4db15c4b7725e5db$export$1b8daf2e8c824ff3;

});

parcelRegister("kW20w", function(module, exports) {

var $lj1QA = parcelRequire("lj1QA");


var $ckprS = parcelRequire("ckprS");

const $d87a928bc36481e8$var$MIN_FREQUENCY_RADIANS_PER_SECOND = 2.6;
const $d87a928bc36481e8$var$FREQUENCY_RANGE_RADIANS_PER_SECOND = 2.5;
const $d87a928bc36481e8$var$FREQUENCY_VARIATION_OFFSET = 8;
const $d87a928bc36481e8$var$DOT_PHASE_OFFSET_RADIANS = 0.72;
const $d87a928bc36481e8$var$PRIMARY_WAVE_WEIGHT = 0.618;
const $d87a928bc36481e8$var$SECONDARY_WAVE_WEIGHT = 0.382;
const $d87a928bc36481e8$var$SECONDARY_PHASE_RATIO = 0.7;
const $d87a928bc36481e8$var$MIN_AMPLITUDE_RATIO = 0.09;
const $d87a928bc36481e8$var$AMPLITUDE_RANGE_RATIO = 0.11;
const $d87a928bc36481e8$var$AMPLITUDE_VARIATION_OFFSET = 11;
const $d87a928bc36481e8$var$GLOW_CONCENTRATION_POWER = 2;
const $d87a928bc36481e8$var$MAXIMUM_GLOW_STRENGTH = 0.55;
const $d87a928bc36481e8$export$626e6915a5a13f0b = ({ color: color, index: index, timeSeconds: timeSeconds })=>{
    const frequency = $d87a928bc36481e8$var$MIN_FREQUENCY_RADIANS_PER_SECOND + $d87a928bc36481e8$var$FREQUENCY_RANGE_RADIANS_PER_SECOND * (0, $ckprS.getStableVariation)(index + $d87a928bc36481e8$var$FREQUENCY_VARIATION_OFFSET);
    const phase = index * $d87a928bc36481e8$var$DOT_PHASE_OFFSET_RADIANS;
    // Blends two phase-shifted sine waves into one irregular motion.
    const wave = $d87a928bc36481e8$var$PRIMARY_WAVE_WEIGHT * Math.sin(timeSeconds * frequency + phase) + $d87a928bc36481e8$var$SECONDARY_WAVE_WEIGHT * // The golden ratio keeps the secondary wave from repeating the primary wave's cycle.
    Math.sin(timeSeconds * frequency * (0, $lj1QA.GOLDEN_RATIO) - phase * $d87a928bc36481e8$var$SECONDARY_PHASE_RATIO);
    const amplitude = (0, $lj1QA.CONSTELLATION_SIZE) * ($d87a928bc36481e8$var$MIN_AMPLITUDE_RATIO + $d87a928bc36481e8$var$AMPLITUDE_RANGE_RATIO * (0, $ckprS.getStableVariation)(index + $d87a928bc36481e8$var$AMPLITUDE_VARIATION_OFFSET));
    return {
        brightness: 0.45 + 0.55 * Math.min(1, Math.abs(wave)),
        color: color,
        glowStrength: (0, $ckprS.getGlowSparkStrength)(Math.abs(wave), $d87a928bc36481e8$var$GLOW_CONCENTRATION_POWER, $d87a928bc36481e8$var$MAXIMUM_GLOW_STRENGTH),
        scale: 0.62,
        x: (0, $lj1QA.CONSTELLATION_CENTER) - (0, $lj1QA.CONSTELLATION_FORMATION_RADIUS) + index / ((0, $lj1QA.CONSTELLATION_DOT_COUNT) - 1) * (0, $lj1QA.CONSTELLATION_FORMATION_RADIUS) * 2,
        y: (0, $lj1QA.CONSTELLATION_CENTER) + wave * amplitude
    };
};
module.exports["createEqualizerDot"] = $d87a928bc36481e8$export$626e6915a5a13f0b;

});

parcelRegister("31ErE", function(module, exports) {

var $lj1QA = parcelRequire("lj1QA");


var $ckprS = parcelRequire("ckprS");


var $j9ohr = parcelRequire("j9ohr");

const $0b491397ecae102a$var$GLOW_DWELL_SECONDS = 0.6;
const $0b491397ecae102a$var$GLOW_SEQUENCE_OFFSET = 31;
const $0b491397ecae102a$var$INNER_RING_RADIUS_RATIO = 0.52;
const $0b491397ecae102a$var$OUTER_RING_RADIUS_RATIO = 1.05;
const $0b491397ecae102a$var$INNER_RING_ROTATION_RADIANS_PER_SECOND = -0.59;
const $0b491397ecae102a$var$OUTER_RING_ROTATION_RADIANS_PER_SECOND = 0.91;
const $0b491397ecae102a$var$RESTING_BRIGHTNESS = 0.58;
const $0b491397ecae102a$var$getGlowingDotIndex = (timeSeconds)=>{
    const step = Math.floor(timeSeconds / $0b491397ecae102a$var$GLOW_DWELL_SECONDS);
    const selectedIndex = Math.floor((0, $ckprS.getStableVariation)(step + $0b491397ecae102a$var$GLOW_SEQUENCE_OFFSET) * (0, $lj1QA.CONSTELLATION_DOT_COUNT));
    const previousIndex = Math.floor((0, $ckprS.getStableVariation)(step + $0b491397ecae102a$var$GLOW_SEQUENCE_OFFSET - 1) * (0, $lj1QA.CONSTELLATION_DOT_COUNT));
    return selectedIndex === previousIndex ? (selectedIndex + 1) % (0, $lj1QA.CONSTELLATION_DOT_COUNT) : selectedIndex;
};
const $0b491397ecae102a$export$fd123e4e85f40875 = ({ color: color, index: index, timeSeconds: timeSeconds })=>{
    const { count: count, ringIndex: ringIndex } = (0, $j9ohr.getRingCoordinates)(index);
    const isCenterDot = index === 0;
    const isInnerRing = count === (0, $j9ohr.INNER_RING_DOT_COUNT);
    const isGlowing = index === $0b491397ecae102a$var$getGlowingDotIndex(timeSeconds);
    const radiusRatio = isInnerRing ? $0b491397ecae102a$var$INNER_RING_RADIUS_RATIO : $0b491397ecae102a$var$OUTER_RING_RADIUS_RATIO;
    const rotationSpeed = isInnerRing ? $0b491397ecae102a$var$INNER_RING_ROTATION_RADIANS_PER_SECOND : $0b491397ecae102a$var$OUTER_RING_ROTATION_RADIANS_PER_SECOND;
    const point = isCenterDot ? {
        x: (0, $lj1QA.CONSTELLATION_CENTER),
        y: (0, $lj1QA.CONSTELLATION_CENTER)
    } : (0, $j9ohr.getRingPoint)(ringIndex, count, (0, $lj1QA.CONSTELLATION_FORMATION_RADIUS) * radiusRatio, timeSeconds * rotationSpeed);
    return {
        ...point,
        brightness: isGlowing ? 1 : $0b491397ecae102a$var$RESTING_BRIGHTNESS,
        color: color,
        glowStrength: isGlowing ? 1 : 0,
        scale: 1
    };
};
module.exports["createGyreDot"] = $0b491397ecae102a$export$fd123e4e85f40875;

});

parcelRegister("j9ohr", function(module, exports) {

var $lj1QA = parcelRequire("lj1QA");

const $28462c8e1987cb00$var$INNER_RING_RADIUS = (0, $lj1QA.CONSTELLATION_SIZE) * 8 / 48;
const $28462c8e1987cb00$export$8c76fbe5bd78eaa7 = (0, $lj1QA.CONSTELLATION_SIZE) * 14 / 48;
const $28462c8e1987cb00$export$15dc2d7d0b66bd6f = 6;
const $28462c8e1987cb00$var$OUTER_RING_DOT_COUNT = 12;
const $28462c8e1987cb00$var$CENTER_DOT_INDEX = 0;
const $28462c8e1987cb00$var$TOP_ANGLE_RADIANS = -Math.PI / 2;
const $28462c8e1987cb00$export$f16b1c868efd8057 = (index)=>{
    if (index === $28462c8e1987cb00$var$CENTER_DOT_INDEX) return {
        count: 1,
        radius: 0,
        ringIndex: $28462c8e1987cb00$var$CENTER_DOT_INDEX
    };
    if (index <= $28462c8e1987cb00$export$15dc2d7d0b66bd6f) return {
        count: $28462c8e1987cb00$export$15dc2d7d0b66bd6f,
        radius: $28462c8e1987cb00$var$INNER_RING_RADIUS,
        ringIndex: index - 1
    };
    return {
        count: $28462c8e1987cb00$var$OUTER_RING_DOT_COUNT,
        radius: $28462c8e1987cb00$export$8c76fbe5bd78eaa7,
        ringIndex: index - $28462c8e1987cb00$export$15dc2d7d0b66bd6f - 1
    };
};
const $28462c8e1987cb00$export$20a09b6b865d75e7 = (index, count, radius, rotation)=>{
    const angle = $28462c8e1987cb00$var$TOP_ANGLE_RADIANS + index / count * (0, $lj1QA.FULL_ROTATION_RADIANS) + rotation;
    return {
        x: (0, $lj1QA.CONSTELLATION_CENTER) + Math.cos(angle) * radius,
        y: (0, $lj1QA.CONSTELLATION_CENTER) + Math.sin(angle) * radius
    };
};
module.exports["OUTER_RING_RADIUS"] = $28462c8e1987cb00$export$8c76fbe5bd78eaa7;
module.exports["INNER_RING_DOT_COUNT"] = $28462c8e1987cb00$export$15dc2d7d0b66bd6f;
module.exports["getRingCoordinates"] = $28462c8e1987cb00$export$f16b1c868efd8057;
module.exports["getRingPoint"] = $28462c8e1987cb00$export$20a09b6b865d75e7;

});

parcelRegister("cCdXi", function(module, exports) {

var $lj1QA = parcelRequire("lj1QA");

const $591ab679b45b5436$var$STREAM_SPEED_RADIANS_PER_SECOND = 1.15;
const $591ab679b45b5436$var$CREST_SPEED_RADIANS_PER_SECOND = 2.85;
const $591ab679b45b5436$var$CREST_WIDTH_RADIANS = 0.55;
const $591ab679b45b5436$var$HORIZONTAL_RADIUS_RATIO = 1.15;
const $591ab679b45b5436$var$VERTICAL_TO_HORIZONTAL_RATIO = 1.25;
const $591ab679b45b5436$var$VERTICAL_RADIUS_RATIO = $591ab679b45b5436$var$HORIZONTAL_RADIUS_RATIO * $591ab679b45b5436$var$VERTICAL_TO_HORIZONTAL_RATIO;
const $591ab679b45b5436$var$BASE_BRIGHTNESS = 0.4;
const $591ab679b45b5436$var$CREST_BRIGHTNESS = 0.6;
const $591ab679b45b5436$var$wrapRadiansToPi = (angleRadians)=>((angleRadians + Math.PI) % (0, $lj1QA.FULL_ROTATION_RADIANS) + (0, $lj1QA.FULL_ROTATION_RADIANS)) % (0, $lj1QA.FULL_ROTATION_RADIANS) - Math.PI;
const $591ab679b45b5436$var$getInfinityPosition = (angleRadians)=>{
    const sine = Math.sin(angleRadians);
    const cosine = Math.cos(angleRadians);
    const lemniscateDenominator = 1 + sine ** 2;
    // Bernoulli lemniscate: the vertical correction rounds each loop without
    // making the complete infinity mark taller than it is wide.
    return {
        x: (0, $lj1QA.CONSTELLATION_CENTER) + (0, $lj1QA.CONSTELLATION_FORMATION_RADIUS) * $591ab679b45b5436$var$HORIZONTAL_RADIUS_RATIO * cosine / lemniscateDenominator,
        y: (0, $lj1QA.CONSTELLATION_CENTER) + (0, $lj1QA.CONSTELLATION_FORMATION_RADIUS) * $591ab679b45b5436$var$VERTICAL_RADIUS_RATIO * sine * cosine / lemniscateDenominator
    };
};
const $591ab679b45b5436$export$4b6547ba489e3151 = ({ color: color, index: index, timeSeconds: timeSeconds })=>{
    const streamAngleRadians = index / (0, $lj1QA.CONSTELLATION_DOT_COUNT) * (0, $lj1QA.FULL_ROTATION_RADIANS) + timeSeconds * $591ab679b45b5436$var$STREAM_SPEED_RADIANS_PER_SECOND;
    const crestDistanceRadians = $591ab679b45b5436$var$wrapRadiansToPi(streamAngleRadians - timeSeconds * $591ab679b45b5436$var$CREST_SPEED_RADIANS_PER_SECOND);
    // Gaussian packet: creates a bright crest that overtakes the moving stream.
    const crest = Math.exp(-((crestDistanceRadians / $591ab679b45b5436$var$CREST_WIDTH_RADIANS) ** 2));
    return {
        ...$591ab679b45b5436$var$getInfinityPosition(streamAngleRadians),
        brightness: $591ab679b45b5436$var$BASE_BRIGHTNESS + $591ab679b45b5436$var$CREST_BRIGHTNESS * crest,
        color: color,
        glowStrength: crest,
        scale: 1
    };
};
module.exports["createInfinityDot"] = $591ab679b45b5436$export$4b6547ba489e3151;

});

parcelRegister("4bGEs", function(module, exports) {

var $ckprS = parcelRequire("ckprS");


var $j9ohr = parcelRequire("j9ohr");

const $78825f141c2b09f5$var$LISTENING_ROTATION_RADIANS_PER_SECOND = 10 * Math.PI / 180;
const $78825f141c2b09f5$var$LISTENING_RADIAL_BOB_AMPLITUDE = 1.35;
const $78825f141c2b09f5$var$LISTENING_PULSE_RADIANS_PER_SECOND = 3.8;
const $78825f141c2b09f5$var$DOT_PHASE_OFFSET_RADIANS = 0.9;
// Controls how tightly the glow follows each dot's movement.
const $78825f141c2b09f5$var$GLOW_CONCENTRATION_POWER = 2;
const $78825f141c2b09f5$var$MAXIMUM_GLOW_STRENGTH = 0.9;
const $78825f141c2b09f5$export$cf42a64065a9f8fd = ({ audioGain: audioGain, color: color, index: index, timeSeconds: timeSeconds })=>{
    const { count: count, radius: radius, ringIndex: ringIndex } = (0, $j9ohr.getRingCoordinates)(index);
    const pulse = Math.sin(timeSeconds * $78825f141c2b09f5$var$LISTENING_PULSE_RADIANS_PER_SECOND + index * $78825f141c2b09f5$var$DOT_PHASE_OFFSET_RADIANS);
    // Neighboring movement overlap slightly
    const glowStrength = (0, $ckprS.getGlowSparkStrength)(pulse, $78825f141c2b09f5$var$GLOW_CONCENTRATION_POWER, $78825f141c2b09f5$var$MAXIMUM_GLOW_STRENGTH);
    return {
        ...(0, $j9ohr.getRingPoint)(ringIndex, count, radius + pulse * $78825f141c2b09f5$var$LISTENING_RADIAL_BOB_AMPLITUDE * audioGain, timeSeconds * $78825f141c2b09f5$var$LISTENING_ROTATION_RADIANS_PER_SECOND),
        brightness: 0.68 + (pulse + 1) * 0.12 * audioGain,
        color: color,
        glowStrength: glowStrength,
        scale: 0.92 + (pulse + 1) * 0.065 * audioGain
    };
};
module.exports["createListeningDot"] = $78825f141c2b09f5$export$cf42a64065a9f8fd;

});

parcelRegister("hTib8", function(module, exports) {

var $lj1QA = parcelRequire("lj1QA");


var $ckprS = parcelRequire("ckprS");


var $j9ohr = parcelRequire("j9ohr");

const $540ff46b95f4256e$var$ANIMATION_DURATION = 2.4;
const $540ff46b95f4256e$var$SPEAKING_BEATS = [
    {
        center: 0.12,
        width: 0.075
    },
    {
        center: 0.42,
        width: 0.09
    },
    {
        center: 0.74,
        width: 0.11
    }
];
const $540ff46b95f4256e$var$CENTER_DOT_RADIAL_RESPONSE = 0.3;
const $540ff46b95f4256e$var$RADIAL_PULSE_BASELINE = 0.28;
const $540ff46b95f4256e$var$RADIAL_TRAVEL_RATIO = 0.055;
const $540ff46b95f4256e$var$ROTATION_RADIANS_PER_SECOND = 0.21;
const $540ff46b95f4256e$var$GLOW_WAVE_RADIANS_PER_SECOND = 2.9;
const $540ff46b95f4256e$var$GLOW_PHASE_OFFSET_RADIANS = 1.7;
// Controls how tightly the glow follows the traveling highlight around the formation.
const $540ff46b95f4256e$var$GLOW_CONCENTRATION_POWER = 2;
const $540ff46b95f4256e$var$MINIMUM_GLOW_ENVELOPE = 0.35;
const $540ff46b95f4256e$var$SPEAKING_GLOW_ENVELOPE = 0.65;
const $540ff46b95f4256e$var$getSpeakingCadence = (timeSeconds)=>{
    const cycle = (0, $ckprS.getCycleProgress)(timeSeconds, $540ff46b95f4256e$var$ANIMATION_DURATION);
    // Gaussian pulses: creates three smooth, uneven speaking beats during each cycle.
    return Math.max(...$540ff46b95f4256e$var$SPEAKING_BEATS.map(({ center: center, width: width })=>Math.exp(-0.5 * ((0, $ckprS.getWrappedCycleDistance)(cycle, center) / width) ** 2)));
};
const $540ff46b95f4256e$export$3777a35c1b6cd760 = ({ audioGain: audioGain, color: color, index: index, timeSeconds: timeSeconds })=>{
    const { count: count, radius: radius, ringIndex: ringIndex } = (0, $j9ohr.getRingCoordinates)(index);
    const isCenterDot = index === 0;
    const pulse = $540ff46b95f4256e$var$getSpeakingCadence(timeSeconds);
    const radialResponse = isCenterDot ? $540ff46b95f4256e$var$CENTER_DOT_RADIAL_RESPONSE : radius / (0, $j9ohr.OUTER_RING_RADIUS);
    const glowWave = (0, $ckprS.getSineWaveStrength)(timeSeconds * $540ff46b95f4256e$var$GLOW_WAVE_RADIANS_PER_SECOND + index * $540ff46b95f4256e$var$GLOW_PHASE_OFFSET_RADIANS);
    // Ensures that the formation pulses together
    const glowStrength = (0, $ckprS.getGlowSparkStrength)(glowWave, $540ff46b95f4256e$var$GLOW_CONCENTRATION_POWER) * ($540ff46b95f4256e$var$MINIMUM_GLOW_ENVELOPE + pulse * $540ff46b95f4256e$var$SPEAKING_GLOW_ENVELOPE);
    const radialBurst = (pulse - $540ff46b95f4256e$var$RADIAL_PULSE_BASELINE) * (0, $lj1QA.CONSTELLATION_SIZE) * $540ff46b95f4256e$var$RADIAL_TRAVEL_RATIO * audioGain * radialResponse;
    return {
        ...(0, $j9ohr.getRingPoint)(ringIndex, count, radius + radialBurst, timeSeconds * $540ff46b95f4256e$var$ROTATION_RADIANS_PER_SECOND),
        brightness: isCenterDot ? 1 : 0.66 + pulse * 0.34 * audioGain,
        color: color,
        glowStrength: glowStrength,
        scale: isCenterDot ? 1.02 + pulse * 0.34 * audioGain : 0.94 + pulse * 0.2 * audioGain
    };
};
module.exports["createSpeakingDot"] = $540ff46b95f4256e$export$3777a35c1b6cd760;

});

parcelRegister("aMTd6", function(module, exports) {

var $ckprS = parcelRequire("ckprS");


var $j9ohr = parcelRequire("j9ohr");

const $a8e103f0f3c97ce7$var$PULSE_RADIANS_PER_SECOND = 3.2;
const $a8e103f0f3c97ce7$var$DOT_PHASE_OFFSET_RADIANS = 0.9;
const $a8e103f0f3c97ce7$var$RADIAL_BOB_AMPLITUDE = 2.5;
const $a8e103f0f3c97ce7$var$STILL_MOVEMENT_MULTIPLIER = 0.08; // When still, this allows the dots to move ever so slightly
const $a8e103f0f3c97ce7$var$BASE_BRIGHTNESS = 0.68;
const $a8e103f0f3c97ce7$var$BRIGHTNESS_PULSE_AMPLITUDE = 0.14;
const $a8e103f0f3c97ce7$var$BASE_SCALE = 0.9;
const $a8e103f0f3c97ce7$var$SCALE_PULSE_AMPLITUDE = 0.1;
const $a8e103f0f3c97ce7$var$ACTIVE_GLOW_CONCENTRATION_POWER = 2.5;
const $a8e103f0f3c97ce7$var$ACTIVE_MAXIMUM_GLOW_STRENGTH = 0.55;
const $a8e103f0f3c97ce7$export$97ce524c16dad698 = ({ active: active, color: color, index: index, timeSeconds: timeSeconds })=>{
    const { count: count, radius: radius, ringIndex: ringIndex } = (0, $j9ohr.getRingCoordinates)(index);
    const pulse = Math.sin(timeSeconds * $a8e103f0f3c97ce7$var$PULSE_RADIANS_PER_SECOND + index * $a8e103f0f3c97ce7$var$DOT_PHASE_OFFSET_RADIANS);
    return {
        ...(0, $j9ohr.getRingPoint)(ringIndex, count, radius + pulse * $a8e103f0f3c97ce7$var$RADIAL_BOB_AMPLITUDE * $a8e103f0f3c97ce7$var$STILL_MOVEMENT_MULTIPLIER, 0),
        brightness: $a8e103f0f3c97ce7$var$BASE_BRIGHTNESS + (pulse + 1) * $a8e103f0f3c97ce7$var$BRIGHTNESS_PULSE_AMPLITUDE * $a8e103f0f3c97ce7$var$STILL_MOVEMENT_MULTIPLIER,
        color: color,
        glowStrength: active ? (0, $ckprS.getGlowSparkStrength)(pulse, $a8e103f0f3c97ce7$var$ACTIVE_GLOW_CONCENTRATION_POWER, $a8e103f0f3c97ce7$var$ACTIVE_MAXIMUM_GLOW_STRENGTH) : 0,
        scale: $a8e103f0f3c97ce7$var$BASE_SCALE + (pulse + 1) * $a8e103f0f3c97ce7$var$SCALE_PULSE_AMPLITUDE * $a8e103f0f3c97ce7$var$STILL_MOVEMENT_MULTIPLIER
    };
};
module.exports["createStillDot"] = $a8e103f0f3c97ce7$export$97ce524c16dad698;

});

parcelRegister("kONYb", function(module, exports) {

let $f27f3d1a111e48ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f27f3d1a111e48ff$var$load("1jVx9").then(()=>parcelRequire('3D12W'));

});

parcelRegister("9BuFn", function(module, exports) {

let $6fdf5b71ee4eada2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6fdf5b71ee4eada2$var$load("hNY6U"),
    $6fdf5b71ee4eada2$var$load("k3amn")
]).then(()=>parcelRequire('5A18u'));

});

parcelRegister("2sYsz", function(module, exports) {

let $1cbd1856e38901ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cbd1856e38901ac$var$load("2Hp35").then(()=>parcelRequire('dRspb'));

});

parcelRegister("cv9SU", function(module, exports) {

let $91a00c2ab4957bf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91a00c2ab4957bf9$var$load("1dIEH").then(()=>parcelRequire('1hCz7'));

});

parcelRegister("3zDXO", function(module, exports) {

let $29a3a3f56e45a9db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $29a3a3f56e45a9db$var$load("6wr18"),
    $29a3a3f56e45a9db$var$load("ffEVr"),
    $29a3a3f56e45a9db$var$load("lX2ZR")
]).then(()=>parcelRequire('bl7WT'));

});

parcelRegister("jyQuB", function(module, exports) {

let $e3d9e936067b1c66$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3d9e936067b1c66$var$load("4wPZ7").then(()=>parcelRequire('eQF4d'));

});

parcelRegister("k2dFi", function(module, exports) {

let $e95e98277584e5a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e95e98277584e5a6$var$load("gQb60"),
    $e95e98277584e5a6$var$load("iDzF1"),
    $e95e98277584e5a6$var$load("03wX9")
]).then(()=>parcelRequire('7kAeI'));

});

parcelRegister("iLeiU", function(module, exports) {

let $da87b63fb0561847$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $da87b63fb0561847$var$load("7jsCb"),
    $da87b63fb0561847$var$load("60a9E"),
    $da87b63fb0561847$var$load("cyTuQ"),
    $da87b63fb0561847$var$load("cN2rp"),
    $da87b63fb0561847$var$load("6e5Dd")
]).then(()=>parcelRequire('8woNY'));

});

parcelRegister("jzzzm", function(module, exports) {

let $e3fce08b1c6fd2f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3fce08b1c6fd2f4$var$load("31msE").then(()=>parcelRequire('9POeP'));

});

parcelRegister("3R9tJ", function(module, exports) {

let $2cedac92278937c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cedac92278937c5$var$load("KSMZE").then(()=>parcelRequire('jFrMf'));

});

parcelRegister("d6NtA", function(module, exports) {
var $54fed5011c3efebd$export$c32b36f46293e67b = /*#__PURE__*/ function(MicrosEnvironmentType) {
    MicrosEnvironmentType["local"] = "local";
    MicrosEnvironmentType["dev"] = "dev";
    MicrosEnvironmentType["staging"] = "staging";
    MicrosEnvironmentType["prod"] = "prod";
    return MicrosEnvironmentType;
}({});
const $54fed5011c3efebd$export$6dd1bbd39f571125 = ()=>false;
const $54fed5011c3efebd$export$23da1d24a38b0bde = ()=>globalThis.ssrContext.environmentType === "staging";
const $54fed5011c3efebd$export$64471597a28217e6 = ()=>$54fed5011c3efebd$export$6dd1bbd39f571125() || $54fed5011c3efebd$export$23da1d24a38b0bde() || globalThis.ssrContext.environmentType === "dev";
const $54fed5011c3efebd$export$4bd44a2aa29d3d6e = ()=>globalThis.ssrContext.environment;
const $54fed5011c3efebd$export$1038046b28a1d92e = ()=>globalThis.ssrContext.environmentType;
const $54fed5011c3efebd$export$94e128262c4fa6c3 = ()=>globalThis.ssrContext.entryScriptVersionId;
const $54fed5011c3efebd$export$4caa72c46cbac3be = ()=>globalThis.ssrContext?.runtimeImageVersion ?? 'unknown';
const $54fed5011c3efebd$export$7d4093513f0cae50 = ()=>globalThis.ssrContext?.isInShadow === true;
function $54fed5011c3efebd$export$bcbc3e9e1c9133d4() {
    return globalThis.ssrContext.isInIC === true;
}
function $54fed5011c3efebd$export$4b05536c6e03cc69() {
    return globalThis.ssrContext?.isInFedramp === true;
}
function $54fed5011c3efebd$export$9cbc7f94bfb6210() {
    return globalThis.ssrContext.icName;
}
function $54fed5011c3efebd$export$eb7aff7f8b96b11f() {
    return globalThis.ssrContext.isInGCP === true;
}
function $54fed5011c3efebd$export$f0bc966c9609c798() {
    return globalThis.ssrContext.cellName;
}
module.exports["isLocal"] = $54fed5011c3efebd$export$6dd1bbd39f571125;

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetailsQuery", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetailsQuery);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("cdsKI")).ConfluenceSpaceType);
/* eslint-disable check-multiple-entry-point-exports/check-multiple-entry-point-exports */ 
var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $cdsKI = parcelRequire("cdsKI");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await (parcelRequire("19UMq"))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("5SzHz", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '', { includeSpaceTypeSettings: includeSpaceTypeSettings = false } = {})=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        },
        __callerPackage__: "space-utils"
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '', options)=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey, options);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("jLyos", function(module, exports) {

var $a2WOL = parcelRequire("a2WOL");


var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $a2WOL.default);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b,
        __callerPackage__: "space-utils"
    });
};
module.exports["preloadPersonalSpaceDetailsQuery"] = $51133d1487ddd8f7$export$945871a9cdda3d0b;
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("a2WOL", function(module, exports) {
/**
 * @generated SignedSource<<99c90ef1034a28215bdf926b84b02699>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;
module.exports["default"] = $fb9284d373020379$export$2e2bcd8739ae039;

});

parcelRegister("cdsKI", function(module, exports) {
var $56af74994ed7dcb5$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
module.exports["ConfluenceSpaceType"] = $56af74994ed7dcb5$export$2fabe69f8125d5a7;

});

parcelRegister("19UMq", function(module, exports) {

let $0d82ad0bc4ef7433$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0d82ad0bc4ef7433$var$load("Wowvf"),
    $0d82ad0bc4ef7433$var$load("4g6rd"),
    $0d82ad0bc4ef7433$var$load("7EorR"),
    $0d82ad0bc4ef7433$var$load("7qpjD")
]).then(()=>parcelRequire('bgmQP'));

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("5SS4O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $8A2GO = parcelRequire("8A2GO");

const $65e219e9f9df9520$var$store = (0, $8s9DV.createStore)({
    initialState: {
        cache: {},
        epoch: 0
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            },
        deleteCacheEntry: (key)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const cache = {
                    ...state.cache
                };
                delete cache[key];
                setState({
                    cache: cache
                });
            },
        clearCache: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    cache: {},
                    epoch: getState().epoch + 1
                });
            }
    }
});
const $65e219e9f9df9520$var$getCacheEpoch = ()=>(0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store).storeState.getState().epoch;
const $65e219e9f9df9520$export$467f2e03eb04239a = ()=>{
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    storeApi.actions.clearCache();
};
const $65e219e9f9df9520$var$selector = (0, $fjHkB.createSelector)((state)=>state.cache, (state)=>state.epoch, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
 * and it will determine whether to rerender the component
 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
 *
 * e.g. for `enabled` true condition:
 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
 *
 * To test this, run the unit test, and then force this function to return new stuff on every call
 * e.g. `return { ...result, random: Math.random() };`
 * it will result in increase renderCount in the unit test
 */ (cache, epoch, key, initialQueryEnabled)=>({
        ...cache[key] ?? {
            data: null,
            error: null,
            isFetching: initialQueryEnabled
        },
        epoch: epoch
    }));
const $65e219e9f9df9520$var$useCacheEntry = (0, $kBr4q.createHook)($65e219e9f9df9520$var$store, {
    selector: $65e219e9f9df9520$var$selector
});
const $65e219e9f9df9520$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return;
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) must refetch and surface the error via its normal
        // path. Remove the warm entry so the failed prefetch does not poison the
        // shared cache for the cold path — unless the key has since been cleared
        // and refilled, in which case the entry is another request's to remove.
        if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) actions.deleteCacheEntry(queryKey);
        onError?.(error);
    });
};
const $65e219e9f9df9520$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $cozmU.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $65e219e9f9df9520$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            // The clear already dropped this request's entry, and whatever is under the key now
            // belongs to a later request — so write nothing at all, including `isFetching: false`.
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error);
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $cozmU.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $cbY7C.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry,
        cache.epoch
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["clearQueryCache"] = $65e219e9f9df9520$export$467f2e03eb04239a;
module.exports["prefetchQuery"] = $65e219e9f9df9520$export$96097db97bddd5cd;
module.exports["useQuery"] = $65e219e9f9df9520$export$dd0a697e1782aedd;

});

parcelRegister("isp1U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $iDrrr = parcelRequire("iDrrr");


var $2A9fJ = parcelRequire("2A9fJ");

const $2def26aed08f588d$var$fetchProfileData = (0, $dOBRD.default)(async ()=>{
    const data = await (0, $2A9fJ.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email
    };
});
const $2def26aed08f588d$export$2d8258e5f5afe915 = async ()=>(await $2def26aed08f588d$var$fetchProfileData()).aaid;
const $2def26aed08f588d$export$3c814b55c7cbb1fb = (0, $cozmU.createContext)(null);
const $2def26aed08f588d$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $2def26aed08f588d$var$toProfileControllerData = (profileData, profileStatus, isProfileStatusEnabled)=>isProfileStatusEnabled ? {
        ...profileData,
        profileStatus: profileStatus
    } : profileData;
const $2def26aed08f588d$export$68afc71177137005 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (preFetchedProfileData)=>{
    const $ = (0, $bDgLe.c)(6);
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $iDrrr.fg)("rovo-chat-ai-inbox");
        $[0] = t0;
    } else t0 = $[0];
    const isProfileStatusEnabled = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>$2def26aed08f588d$var$toProfileControllerData($2def26aed08f588d$var$emptyProfileData, "loading", isProfileStatusEnabled);
        $[1] = t1;
    } else t1 = $[1];
    const [profileData, setProfileData] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[2] !== preFetchedProfileData || $[3] !== profileContextData) {
        t2 = ()=>{
            if (preFetchedProfileData) setProfileData($2def26aed08f588d$var$toProfileControllerData(preFetchedProfileData, preFetchedProfileData.aaid ? "ready" : "unavailable", isProfileStatusEnabled));
            else if (profileContextData) setProfileData($2def26aed08f588d$var$toProfileControllerData(profileContextData, profileContextData.aaid ? "ready" : "unavailable", isProfileStatusEnabled));
            else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData($2def26aed08f588d$var$toProfileControllerData(data, data.aaid ? "ready" : "unavailable", isProfileStatusEnabled))).catch(()=>setProfileData($2def26aed08f588d$var$toProfileControllerData($2def26aed08f588d$var$emptyProfileData, "unavailable", isProfileStatusEnabled)));
        };
        t3 = [
            setProfileData,
            isProfileStatusEnabled,
            profileContextData,
            preFetchedProfileData
        ];
        $[2] = preFetchedProfileData;
        $[3] = profileContextData;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return profileData;
} : (preFetchedProfileData)=>{
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    const isProfileStatusEnabled = (0, $iDrrr.fg)('rovo-chat-ai-inbox');
    const [profileData, setProfileData] = (0, $cozmU.useState)(()=>$2def26aed08f588d$var$toProfileControllerData($2def26aed08f588d$var$emptyProfileData, 'loading', isProfileStatusEnabled));
    (0, $cozmU.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData($2def26aed08f588d$var$toProfileControllerData(preFetchedProfileData, preFetchedProfileData.aaid ? 'ready' : 'unavailable', isProfileStatusEnabled));
        else if (profileContextData) setProfileData($2def26aed08f588d$var$toProfileControllerData(profileContextData, profileContextData.aaid ? 'ready' : 'unavailable', isProfileStatusEnabled));
        else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData($2def26aed08f588d$var$toProfileControllerData(data, data.aaid ? 'ready' : 'unavailable', isProfileStatusEnabled))).catch(()=>setProfileData($2def26aed08f588d$var$toProfileControllerData($2def26aed08f588d$var$emptyProfileData, 'unavailable', isProfileStatusEnabled)));
    }, [
        setProfileData,
        isProfileStatusEnabled,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};
module.exports["fetchProfileAaid"] = $2def26aed08f588d$export$2d8258e5f5afe915;
module.exports["ProfileContext"] = $2def26aed08f588d$export$3c814b55c7cbb1fb;
module.exports["useProfileController"] = $2def26aed08f588d$export$68afc71177137005;

});

parcelRegister("2A9fJ", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");

const $baf5ee02956fd5a8$export$3e32638432616b6 = async ()=>{
    const response = await (0, $jTKfH.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};
module.exports["me"] = $baf5ee02956fd5a8$export$3e32638432616b6;

});

parcelRegister("76xix", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");


const $de0bfd2141159d80$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("d8UlV"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $de0bfd2141159d80$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? "" : t3;
    const height = t4 === undefined ? "" : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-animated-icon",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de0bfd2141159d80$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-animated-icon",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de0bfd2141159d80$var$LazyRovoLoadingGif, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});
module.exports["LazyAnimatedRovoIcon"] = $de0bfd2141159d80$export$7ea4e54699cd5224;

});

parcelRegister("d8UlV", function(module, exports) {

let $9917bc308f190038$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9917bc308f190038$var$load("b7fR4").then(()=>parcelRequire('9r8so'));

});

parcelRegister("5n93X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b8aeb40a0dd9aac20350a989eb3c9ba>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e96216f98bcdad5$var$_react = $3e96216f98bcdad5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3e96216f98bcdad5$var$_iconNew = $3e96216f98bcdad5$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $3e96216f98bcdad5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cloud-arrow-up
 * Usage guidance:
 * Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e96216f98bcdad5$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $3e96216f98bcdad5$var$_react.default.createElement($3e96216f98bcdad5$var$_iconNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$3e96216f98bcdad5$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $3e96216f98bcdad5$var$_default = module.exports.default = $3e96216f98bcdad5$var$CloudArrowUpIcon;

});

parcelRegister("9DTaz", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $281f0207d5f06906$export$eb38a1b15192a777 = (helpText, description)=>{
    const availableHelpText = typeof helpText === 'string' && helpText.trim() ? helpText : '';
    if ((0, $iDrrr.fg)('chat_skill_helptext_enabled') && availableHelpText) return availableHelpText;
    const availableDescription = typeof description === 'string' ? description : '';
    return availableDescription || availableHelpText;
};
module.exports["resolveSkillDisplayDescription"] = $281f0207d5f06906$export$eb38a1b15192a777;

});

parcelRegister("f6VI9", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $9DTaz = parcelRequire("9DTaz");

const $ae2233479ab8cd62$var$ROVO_SPACE_ALLOWED_STRATUS_SKILL_NAMES = new Set([
    'WorkItemWorkflowContextMinion',
    'JiraWorkItemCreateMinion',
    'JiraPermissionsSkill',
    'JiraNavigationMinion'
]);
/**
 * Rovo Space conversations support Anthropic skills plus a small set of
 * Stratus skills that provide the Jira capabilities required in that context.
 */ function $ae2233479ab8cd62$var$isSkillAllowedInRovoSpace(node) {
    return node.source === 'ANTHROPIC' || node.source === 'STRATUS' && Boolean(node.name && $ae2233479ab8cd62$var$ROVO_SPACE_ALLOWED_STRATUS_SKILL_NAMES.has(node.name));
}
function $ae2233479ab8cd62$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $ae2233479ab8cd62$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const displayDescription = node.description ?? '';
    const trimmedDescription = displayDescription.length > 150 ? `${displayDescription.slice(0, 147)}...` : displayDescription;
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        ...node.integrationKey?.key ? {
            productKey: node.integrationKey.key
        } : {},
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    const productKey = primaryIntegration?.key ?? node.integrationKeys?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] || ((0, $iDrrr.fg)('rovo_skill_tag_label_wrapping') ? node.name : '') || '',
        name: node.displayName ?? node.name ?? '',
        description: node.description ?? '',
        helpText: (0, $9DTaz.resolveSkillDisplayDescription)(node.helpText, node.description),
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        ...productKey ? {
            productKey: productKey
        } : {},
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$db36004670a5626e(edge?.node) ? $ae2233479ab8cd62$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$7d1ba2a7b9e1a07(edge?.node) ? $ae2233479ab8cd62$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$faef8b68e529d4a7(edges, options = {}) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($ae2233479ab8cd62$export$db36004670a5626e(node)) {
            // Legacy directory items do not expose the source needed to establish
            // eligibility for a Rovo Space conversation.
            if (options.restrictToRovoSpaceSkills) return null;
            return $ae2233479ab8cd62$export$74ea09dd5afceb60(node);
        }
        if ($ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node)) {
            if (options.restrictToRovoSpaceSkills && !$ae2233479ab8cd62$var$isSkillAllowedInRovoSpace(node)) return null;
            return $ae2233479ab8cd62$export$fd76a94f4a001a14(node);
        }
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $ae2233479ab8cd62$export$74ea09dd5afceb60;
module.exports["parseConvoAiSkillEdges"] = $ae2233479ab8cd62$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $ae2233479ab8cd62$export$faef8b68e529d4a7;

});

parcelRegister("aJNFh", function(module, exports) {

var $f6VI9 = parcelRequire("f6VI9");

const $71f78acdff7635c4$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Unified GraphQL query — convoai_availableSkills.
 */ const $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY = `
  query ConvoAiAvailableSkillsQuery(
    $first: Int
    $cloudId: ID!
  ) {
    convoai_availableSkills(
      first: $first
      cloudId: $cloudId
    )
    @optIn(to: "ConvoAiAvailableSkills")
    {
      edges {
        node {
          __typename
          ... on ConvoAiSkill {
            id
            name
            description
            displayName
            slashCommand
						helpText
            iconUrl
            iconKey
            color
            source
            tags
            category
            integrationKeys
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
/**
 * Session-level cache for fetched skills.
 * Keyed by `${cloudId}` to avoid redundant network requests.
 * Skills are cached for the lifetime of the page (matching Relay store behavior).
 * A page refresh will fetch fresh data.
 */ const $71f78acdff7635c4$var$skillsCache = new Map();
function $71f78acdff7635c4$export$e6cf70cf6554c856() {
    $71f78acdff7635c4$var$skillsCache.clear();
}
/**
 * Fetch skills using the new unified convoai_availableSkills endpoint.
 */ async function $71f78acdff7635c4$var$fetchSkillsUnified(cloudId) {
    const response = await fetch($71f78acdff7635c4$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 150
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length || json.data?.convoai_availableSkills?.errors?.length) return [];
    const edges = json.data?.convoai_availableSkills?.edges;
    return (0, $f6VI9.parseConvoAiSkillEdges)(edges);
}
async function $71f78acdff7635c4$export$268d57ae88e7df66(cloudId) {
    const cacheKey = cloudId;
    const cached = $71f78acdff7635c4$var$skillsCache.get(cacheKey);
    if (cached) return cached;
    try {
        const skills = await $71f78acdff7635c4$var$fetchSkillsUnified(cloudId);
        $71f78acdff7635c4$var$skillsCache.set(cacheKey, skills);
        return skills;
    } catch  {
        // Silently fail — the insert menu will just not show skills
        return [];
    }
}
module.exports["clearSkillsCache"] = $71f78acdff7635c4$export$e6cf70cf6554c856;
module.exports["fetchSkills"] = $71f78acdff7635c4$export$268d57ae88e7df66;

});

parcelRegister("k1Pvg", function(module, exports) {
const $facdac86f4ba08d8$export$49073de218c0e4d6 = {
    AI_MATE: 'ai-mate',
    AI_MATE_ACTIONS: 'ai-mate-actions',
    AI_MATE_INSERT_URLS: 'ai-mate-chat-inserts',
    AI_MATE_CHAT_INPUT_OVERLAY: 'ai-mate-chat-input-overlay',
    AI_MATE_AIFC: 'ai-mate-aifc',
    ROVO_REMIX_LAUNCH: 'rovo-remix-launch',
    ROVO_REMIX: 'rovo-remix',
    ROVO_SKILLS: 'rovo-skills',
    AVP: 'avp'
};
const $facdac86f4ba08d8$export$cf942cb14ec363bb = 'custom-skill-deleted';
const $facdac86f4ba08d8$export$69d3cd8e04a34bd6 = 'jira-inline-agent-creation-agent-assigned';
const $facdac86f4ba08d8$export$273aa0a3b01f12a3 = 'jira-work-items-creating';
const $facdac86f4ba08d8$export$6c48beaef33b5d07 = 'jira-work-items-created';
const $facdac86f4ba08d8$export$141a1577d8898865 = 'jira-work-items-create-failed';
const $facdac86f4ba08d8$export$5007e3a11d326b89 = 'confluence-content-finalized';
module.exports["Topics"] = $facdac86f4ba08d8$export$49073de218c0e4d6;
module.exports["CUSTOM_SKILL_DELETED_EVENT"] = $facdac86f4ba08d8$export$cf942cb14ec363bb;
module.exports["JIRA_INLINE_AGENT_CREATION_AGENT_ASSIGNED_EVENT"] = $facdac86f4ba08d8$export$69d3cd8e04a34bd6;
module.exports["JIRA_WORK_ITEMS_CREATING_EVENT"] = $facdac86f4ba08d8$export$273aa0a3b01f12a3;
module.exports["JIRA_WORK_ITEMS_CREATED_EVENT"] = $facdac86f4ba08d8$export$6c48beaef33b5d07;
module.exports["JIRA_WORK_ITEMS_CREATE_FAILED_EVENT"] = $facdac86f4ba08d8$export$141a1577d8898865;
module.exports["CONFLUENCE_CONTENT_FINALIZED_EVENT"] = $facdac86f4ba08d8$export$5007e3a11d326b89;

});

parcelRegister("8lt5O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $464fa95e1d18f18e$var$rovoEntitlementStore = (0, $8s9DV.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $464fa95e1d18f18e$var$useStateHook = (0, $kBr4q.createStateHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$66d5dd4be64dea43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const result = $464fa95e1d18f18e$var$useStateHook();
    let t0;
    if ($[0] !== result) {
        t0 = {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
        $[0] = result;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const result = $464fa95e1d18f18e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $464fa95e1d18f18e$export$8004893135276275 = (0, $kBr4q.createActionsHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$d03a05ad8547472c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { isRovoEnabled: isRovoEnabled } = t0;
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    setIsRovoEnabled(isRovoEnabled);
    return null;
} : ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    (0, $cozmU.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $464fa95e1d18f18e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $464fa95e1d18f18e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $464fa95e1d18f18e$export$d03a05ad8547472c;

});

parcelRegister("blKf8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2zlSy = parcelRequire("2zlSy");

const $25b69de57535dd1e$export$c85ba824665b708f = (0, $cozmU.createContext)((0, $2zlSy.initialState));
module.exports["uiConfig"] = $25b69de57535dd1e$export$c85ba824665b708f;

});

parcelRegister("2zlSy", function(module, exports) {
const $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a = {
    fullScreen: false,
    externalEmbed: false,
    preserveUrlConversationId: false,
    skipAutoConversationSelection: false,
    isContextPanelEnabled: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    disableSettingsModal: false,
    enableSkills: true,
    enableAutoSuggest: true,
    enableMiniModalResize: true,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        backButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true,
        maxModeButton: true,
        shouldShowConversationActions: true,
        shouldShowContextBanner: true
    }
};
module.exports["initialState"] = $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a;

});

parcelRegister("dSCNl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $blKf8 = parcelRequire("blKf8");

const $78dfed354051ab06$export$e83755c3ab7a4493 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $blKf8.uiConfig));
} : ()=>(0, $cozmU.useContext)((0, $blKf8.uiConfig));
module.exports["useUIConfig"] = $78dfed354051ab06$export$e83755c3ab7a4493;

});

parcelRegister("kYruZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5660d388ea5e45af$export$cc43ac18fa8b23d = (0, $cozmU.createContext)(false);
module.exports["ConversationAssistantLoadingContext"] = $5660d388ea5e45af$export$cc43ac18fa8b23d;

});

parcelRegister("fGDv8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $b8pma = parcelRequire("b8pma");


var $kYruZ = parcelRequire("kYruZ");


var $7Myh3 = parcelRequire("7Myh3");


var $1EO92 = parcelRequire("1EO92");

const $11be68f9ade9fe63$var$conversationAssistantLazy = (0, $cozmU.lazy)(()=>(0, $7Myh3.importConversationAssistant)().then((module)=>({
            default: module.ConversationAssistant
        })));
const $11be68f9ade9fe63$var$createLoadingComponent = ()=>{
    return (0, $b8pma.default)({
        name: 'LoadingConversationAssistantBundle'
    });
};
const $11be68f9ade9fe63$var$conversationAssistantLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "hDEDK",
    name: "conversationAssistantLoadable",
    loader: ()=>(0, $7Myh3.importConversationAssistant)().then((m)=>m.ConversationAssistant),
    loading: $11be68f9ade9fe63$var$createLoadingComponent
});
const $11be68f9ade9fe63$var$AsyncConversationAssistant = Object.assign((props)=>{
    if (props.modeConfig?.mode === 'mini-modal' && (0, $4o0zT.isExperimentEnabled)('rovo_chat_mini_modal_stable_open') && !(props.skipChatUI ?? Boolean(props.overridingChildren))) // Own both bundle-loading stages here so the same fallback stays mounted throughout.
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: 'LoadingConversationAssistantBundle'
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1EO92.MiniModalLoadingFallback), {
            topOffset: props.topOffset ?? 80,
            isNav4Enabled: props.isNav4Enabled ?? false
        }))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kYruZ.ConversationAssistantLoadingContext).Provider, {
        value: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11be68f9ade9fe63$var$conversationAssistantLazy, props)));
    if ((0, $iDrrr.fg)('aimate_conversation_assistant_async_loading')) return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: $11be68f9ade9fe63$var$createLoadingComponent()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11be68f9ade9fe63$var$conversationAssistantLazy, props));
    if (props.useChildrenAsLoadingFallback && props.overridingChildren) return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: props.overridingChildren
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11be68f9ade9fe63$var$conversationAssistantLazy, props));
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11be68f9ade9fe63$var$conversationAssistantLoadable, props);
}, {
    preload: ()=>{
        // React.lazy has no preload API, so warm the shared chunk directly on the R19
        // lazy path; keep react-loadable's preload (which also marks it loaded) otherwise.
        if ((0, $iDrrr.fg)('aimate_conversation_assistant_async_loading')) (0, $7Myh3.importConversationAssistant)();
        else $11be68f9ade9fe63$var$conversationAssistantLoadable.preload();
    }
});
var $11be68f9ade9fe63$export$2e2bcd8739ae039 = $11be68f9ade9fe63$var$AsyncConversationAssistant;
module.exports["default"] = $11be68f9ade9fe63$export$2e2bcd8739ae039;

});

parcelRegister("1EO92", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $cZI7g = parcelRequire("cZI7g");

const $dc578d44443cbcad$var$styles = {
    wrapper: "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _24h04i2Njc _39xV02N91d _0jFU0VIZbP _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _0GwItXFlnN _0hPCNLFlnN _2OUyjtGk8v",
    wrapperNav3: "_3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _3138425zaO _2C2kUQ8fU6 _1Lz9lo8fU6"
};
const $dc578d44443cbcad$export$f671f9d800124a4d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { topOffset: topOffset, isNav4Enabled: isNav4Enabled } = t0;
    const t1 = !isNav4Enabled && $dc578d44443cbcad$var$styles.wrapperNav3;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($dc578d44443cbcad$var$styles.wrapper, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = isNav4Enabled ? undefined : "calc(100% - var(--ds-space-150, 12px))";
    let t4;
    if ($[2] !== t3) {
        t4 = {
            width: t3
        };
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== topOffset) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZI7g.MiniModalLoadingContent), {
            topOffset: topOffset
        });
        $[4] = topOffset;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t2 || $[7] !== t4 || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "data-rovo-chat-panel": "true",
            xcss: t2,
            style: t4
        }, t5);
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
} : ({ topOffset: topOffset, isNav4Enabled: isNav4Enabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "data-rovo-chat-panel": "true",
        xcss: (0, $w6R6I.cx)($dc578d44443cbcad$var$styles.wrapper, !isNav4Enabled && $dc578d44443cbcad$var$styles.wrapperNav3),
        style: {
            width: isNav4Enabled ? undefined : `calc(100% - ${"var(--ds-space-150, 12px)"})`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZI7g.MiniModalLoadingContent), {
        topOffset: topOffset
    }));
module.exports["MiniModalLoadingFallback"] = $dc578d44443cbcad$export$f671f9d800124a4d;

});

parcelRegister("cZI7g", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $76xix = parcelRequire("76xix");

const $7b6b110029c7c7dd$var$styles = {
    miniModalMainContainer: "_0bjKvDKxmn _39xV02Hakr _0KLXruqi9L _2OUyjtGk8v _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    rovoIcon: "_39xV02pJKa _0jFU0VpJKa"
};
const $7b6b110029c7c7dd$export$260a88fcf31c36a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { topOffset: topOffset } = t0;
    const t1 = `min(320px, calc(100vh - ${topOffset}px))`;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            height: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $7b6b110029c7c7dd$var$styles.rovoIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76xix.LazyAnimatedRovoIcon), {
            alt: "",
            testId: "rovo-loading-animation"
        }));
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "conversation-assistant-mini-modal-main-container",
            xcss: $7b6b110029c7c7dd$var$styles.miniModalMainContainer,
            style: t2
        }, t3);
        $[3] = t2;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : ({ topOffset: topOffset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "conversation-assistant-mini-modal-main-container",
        xcss: $7b6b110029c7c7dd$var$styles.miniModalMainContainer,
        style: {
            height: `min(320px, calc(100vh - ${topOffset}px))`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7b6b110029c7c7dd$var$styles.rovoIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76xix.LazyAnimatedRovoIcon), {
        alt: "",
        testId: "rovo-loading-animation"
    })));
module.exports["MiniModalLoadingContent"] = $7b6b110029c7c7dd$export$260a88fcf31c36a6;

});

parcelRegister("9aRNV", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $09ecffa85d56d9ae$var$store = (0, $8s9DV.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
     * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
     * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
     */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
     * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
     */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            },
        setConvoStarterActionPrompt: (convoStarterActionPrompt)=>({ setState: setState })=>{
                setState({
                    convoStarterActionPrompt: convoStarterActionPrompt
                });
            }
    }
});
const $09ecffa85d56d9ae$export$83a8985e8d377ba1 = (0, $kBr4q.createHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$74d7aed167e24a67 = (0, $kBr4q.createActionsHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$d6ed3fb83640b335 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$4be353558b8b8a37 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store, {
    selector: (state)=>state.convoStarterActionPrompt
});
module.exports["useConversationActionsStore"] = $09ecffa85d56d9ae$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $09ecffa85d56d9ae$export$74d7aed167e24a67;
module.exports["useConversationActionsStoreState"] = $09ecffa85d56d9ae$export$d6ed3fb83640b335;

});

parcelRegister("5BOJB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $4m5jb = parcelRequire("4m5jb");


var $bGNkz = parcelRequire("bGNkz");


var $9aRNV = parcelRequire("9aRNV");


var $6iQ4q = parcelRequire("6iQ4q");


var $3TxKn = parcelRequire("3TxKn");


var $iLyZq = parcelRequire("iLyZq");

const $ebee8f54e12cc0bd$var$dismissActiveAction = (action, clearAction)=>{
    try {
        (0, $iLyZq.getActionOnDismiss)(action)?.();
    } finally{
        clearAction();
    }
};
const $ebee8f54e12cc0bd$export$e60c4e7dea337eb3 = ()=>{
    (0, $6cFsl.di)((0, $3TxKn.useChatStoreActions), (0, $9aRNV.useConversationActionsStoreActions), (0, $9aRNV.useConversationActionsStore), (0, $bGNkz.useUIStoreActions));
    const { setActiveAction_UNSAFE: setActiveAction_UNSAFE } = (0, $9aRNV.useConversationActionsStoreActions)();
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const [{ activeAction: activeAction }] = (0, $9aRNV.useConversationActionsStore)();
    const activeActionRef = (0, $cozmU.useRef)(activeAction);
    // Keep clearActiveAction safe for hook instances that did not set the action.
    (0, $cozmU.useEffect)(()=>{
        activeActionRef.current = activeAction;
    }, [
        activeAction
    ]);
    const setActiveAction = (0, $cozmU.useCallback)((action, options)=>{
        activeActionRef.current = action;
        setActiveAction_UNSAFE(action);
        if (action) {
            if (!options?.preserveSelectedConversation) setSelectedConversation({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                sourceAgentId: (0, $6iQ4q.DEFAULT_AGENT).id
            });
            setActiveMenu('none');
        }
    }, [
        setActiveAction_UNSAFE,
        setSelectedConversation,
        setActiveMenu
    ]);
    const clearActiveAction = (0, $cozmU.useCallback)(()=>{
        $ebee8f54e12cc0bd$var$dismissActiveAction(activeActionRef.current, ()=>{
            activeActionRef.current = undefined;
            setActiveAction_UNSAFE(undefined);
        });
    }, [
        setActiveAction_UNSAFE
    ]);
    return {
        activeAction: activeAction,
        setActiveAction: setActiveAction,
        clearActiveAction: clearActiveAction
    };
};
module.exports["useActiveAction"] = $ebee8f54e12cc0bd$export$e60c4e7dea337eb3;

});

parcelRegister("iLyZq", function(module, exports) {

var $gR7ri = parcelRequire("gR7ri");

const $3bc7276fe39ce470$export$42c34726e4093ea = (action)=>(0, $gR7ri.getConversationActionWithAssistantMetadata)(action)?.onDismiss;
module.exports["getActionOnDismiss"] = $3bc7276fe39ce470$export$42c34726e4093ea;

});

parcelRegister("gR7ri", function(module, exports) {
const $e7fea99b17cf91ca$export$89c94a468e7458db = (action)=>action;
module.exports["getConversationActionWithAssistantMetadata"] = $e7fea99b17cf91ca$export$89c94a468e7458db;

});

parcelRegister("jz8lo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $5BOJB = parcelRequire("5BOJB");


var $6iWVH = parcelRequire("6iWVH");


var $jmjWc = parcelRequire("jmjWc");


var $lpaq2 = parcelRequire("lpaq2");


const $133397c2abdefdc4$var$LazyRovoChatRemixView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "b2tBI",
    name: "LazyRovoChatRemixView",
    loader: async ()=>(await (parcelRequire("j8pn5"))).RovoChatRemixView
});
const $133397c2abdefdc4$var$isOpenRovoRemixSidebarPayload = (payload)=>payload.type === 'open-rovo-remix-sidebar';
const $133397c2abdefdc4$var$createRovoRemixAction = (session)=>{
    return {
        id: `confluence-rovo-remix:${crypto.randomUUID()}`,
        title: 'Remix',
        handleType: (0, $6iWVH.HandleActionType).Base,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        presentation: {
            hideActionHeader: true,
            suppressPromptLibrary: true,
            fillAvailableHeight: true
        },
        viewConfig: {
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($133397c2abdefdc4$var$LazyRovoChatRemixView, {
                    renderRovoChatRemixPicker: (0, $lpaq2.renderRovoChatRemixPicker),
                    session: session
                })
        }
    };
};
const $133397c2abdefdc4$export$96c35e5f3a6712f8 = ()=>{
    const { setActiveAction: setActiveAction } = (0, $5BOJB.useActiveAction)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleEvent = (0, $cozmU.useCallback)((payload)=>{
        if (!$133397c2abdefdc4$var$isOpenRovoRemixSidebarPayload(payload)) return;
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'rovoChatRemixScreen',
                source: payload.source,
                attributes: {
                    entryPoint: payload.source,
                    product: 'confluence'
                }
            }
        }).fire();
        setActiveAction($133397c2abdefdc4$var$createRovoRemixAction({
            consumer: payload.data.remixConsumer,
            scope: payload.data.remixPreset
        }), {
            preserveSelectedConversation: true
        });
    }, [
        createAnalyticsEvent,
        setActiveAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hdBxM.Subscriber), {
        consumeOnceKey: "confluence-rovo-remix-action-launcher",
        onEvent: handleEvent,
        topic: (0, $k1Pvg.Topics).ROVO_REMIX_LAUNCH,
        triggerLatest: true
    });
};
module.exports["RovoRemixActionLauncher"] = $133397c2abdefdc4$export$96c35e5f3a6712f8;

});

parcelRegister("lpaq2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


const $3c479359d4e5ebbf$var$LazyRovoChatRemixPickerAdapter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HAlgh",
    name: "LazyRovoChatRemixPickerAdapter",
    loader: async ()=>(await (parcelRequire("bE0aw"))).RovoChatRemixPickerAdapter
});
const $3c479359d4e5ebbf$export$ff3dbf3fd6d623a0 = ({ isDisabled: isDisabled, onSelect: onSelect, preset: preset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c479359d4e5ebbf$var$LazyRovoChatRemixPickerAdapter, {
        isDisabled: isDisabled,
        onSelect: onSelect,
        preset: preset
    });
module.exports["renderRovoChatRemixPicker"] = $3c479359d4e5ebbf$export$ff3dbf3fd6d623a0;

});

parcelRegister("bE0aw", function(module, exports) {

let $87a38fa146a56a5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $87a38fa146a56a5f$var$load("6wr18"),
    $87a38fa146a56a5f$var$load("iLt7f"),
    $87a38fa146a56a5f$var$load("7BITa"),
    $87a38fa146a56a5f$var$load("hnpcA"),
    $87a38fa146a56a5f$var$load("ffEVr"),
    $87a38fa146a56a5f$var$load("j1ofJ")
]).then(()=>parcelRequire('fK5VE'));

});

parcelRegister("j8pn5", function(module, exports) {

let $dee271e3522ab0d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dee271e3522ab0d6$var$load("kT6dz"),
    $dee271e3522ab0d6$var$load("1BcpX"),
    $dee271e3522ab0d6$var$load("dEA3e"),
    $dee271e3522ab0d6$var$load("bqdgP"),
    $dee271e3522ab0d6$var$load("6dLts"),
    $dee271e3522ab0d6$var$load("jdPbE"),
    $dee271e3522ab0d6$var$load("khIi2"),
    $dee271e3522ab0d6$var$load("eEjUf"),
    $dee271e3522ab0d6$var$load("ahEIC"),
    $dee271e3522ab0d6$var$load("hkiCw"),
    $dee271e3522ab0d6$var$load("7I4uK"),
    $dee271e3522ab0d6$var$load("hUbK8"),
    $dee271e3522ab0d6$var$load("dC1cd"),
    $dee271e3522ab0d6$var$load("dGWq4"),
    $dee271e3522ab0d6$var$load("2j57H"),
    $dee271e3522ab0d6$var$load("7zFX6"),
    $dee271e3522ab0d6$var$load("fRPBy"),
    $dee271e3522ab0d6$var$load("lPKve"),
    $dee271e3522ab0d6$var$load("h4jve"),
    $dee271e3522ab0d6$var$load("1005C"),
    $dee271e3522ab0d6$var$load("j8gsU"),
    $dee271e3522ab0d6$var$load("2o5fZ"),
    $dee271e3522ab0d6$var$load("a1ETE"),
    $dee271e3522ab0d6$var$load("cN2rp"),
    $dee271e3522ab0d6$var$load("j5aD5"),
    $dee271e3522ab0d6$var$load("8dKKv"),
    $dee271e3522ab0d6$var$load("5wjYh"),
    $dee271e3522ab0d6$var$load("VXbA1"),
    $dee271e3522ab0d6$var$load("kfGHh"),
    $dee271e3522ab0d6$var$load("lIiD7"),
    $dee271e3522ab0d6$var$load("bJbqV"),
    $dee271e3522ab0d6$var$load("hLB9K"),
    $dee271e3522ab0d6$var$load("1ET6p"),
    $dee271e3522ab0d6$var$load("bQgoi"),
    $dee271e3522ab0d6$var$load("ea3NB"),
    $dee271e3522ab0d6$var$load("7qcPK"),
    $dee271e3522ab0d6$var$load("aqMLH"),
    $dee271e3522ab0d6$var$load("ctdyb"),
    $dee271e3522ab0d6$var$load("11yNG"),
    $dee271e3522ab0d6$var$load("gQYVn"),
    $dee271e3522ab0d6$var$load("cpTbC"),
    $dee271e3522ab0d6$var$load("fhT77"),
    $dee271e3522ab0d6$var$load("kMyku"),
    $dee271e3522ab0d6$var$load("hG1ar"),
    $dee271e3522ab0d6$var$load("he7Ox"),
    $dee271e3522ab0d6$var$load("9BBvG"),
    $dee271e3522ab0d6$var$load("cYv6T"),
    $dee271e3522ab0d6$var$load("el1U6"),
    $dee271e3522ab0d6$var$load("2yyll"),
    $dee271e3522ab0d6$var$load("2hPbk"),
    $dee271e3522ab0d6$var$load("icYyL"),
    $dee271e3522ab0d6$var$load("6wr18"),
    $dee271e3522ab0d6$var$load("ffEVr"),
    $dee271e3522ab0d6$var$load("gnocL"),
    $dee271e3522ab0d6$var$load("1audf"),
    $dee271e3522ab0d6$var$load("bpBPu"),
    $dee271e3522ab0d6$var$load("Wowvf"),
    $dee271e3522ab0d6$var$load("4g6rd"),
    $dee271e3522ab0d6$var$load("abBST"),
    $dee271e3522ab0d6$var$load("hhss7"),
    $dee271e3522ab0d6$var$load("7EorR"),
    $dee271e3522ab0d6$var$load("7XiLa")
]).then(()=>parcelRequire('f7cmi'));

});

parcelRegister("dbZCH", function(module, exports) {

var $2XyGK = parcelRequire("2XyGK");


var $PX2xE = parcelRequire("PX2xE");

const $704ed0928bc2ea63$export$6c2b92cb1ff351f1 = ()=>(0, $2XyGK.registerInferredProjectPopupContent)((0, $PX2xE.InferredProjectPopupContent));
module.exports["registerInferredProjectPopup"] = $704ed0928bc2ea63$export$6c2b92cb1ff351f1;

});

parcelRegister("PX2xE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $36WdE = parcelRequire("36WdE");


var $4o1RV = parcelRequire("4o1RV");

const $3cd466a5de7ba5b4$export$ca915380b1b0ae60 = (project)=>{
    const { shimUrl: shimUrl } = (0, $4o1RV.useNavigationPolicy)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36WdE.InferredProjectPopupContent), {
        ...project,
        shimUrl: shimUrl
    });
};
module.exports["InferredProjectPopupContent"] = $3cd466a5de7ba5b4$export$ca915380b1b0ae60;

});

parcelRegister("36WdE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $d5gEx = parcelRequire("d5gEx");


const $9ac7a8b407b71565$var$InferredProjectPopup = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("gTJY5")).then((module)=>({
            default: module.InferredProjectPopup
        })));
Object.assign($9ac7a8b407b71565$var$InferredProjectPopup, {
    displayName: 'lazy(InferredProjectPopup)'
});
const $9ac7a8b407b71565$export$ca915380b1b0ae60 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ac7a8b407b71565$var$InferredProjectPopup, props)));
module.exports["InferredProjectPopupContent"] = $9ac7a8b407b71565$export$ca915380b1b0ae60;

});

parcelRegister("gTJY5", function(module, exports) {

let $c4d570b5699fdc45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c4d570b5699fdc45$var$load("lhr3j"),
    $c4d570b5699fdc45$var$load("6wr18"),
    $c4d570b5699fdc45$var$load("lg3b1"),
    $c4d570b5699fdc45$var$load("iWnyc"),
    $c4d570b5699fdc45$var$load("hhss7"),
    $c4d570b5699fdc45$var$load("ffEVr"),
    $c4d570b5699fdc45$var$load("Wowvf"),
    $c4d570b5699fdc45$var$load("4g6rd"),
    $c4d570b5699fdc45$var$load("7EorR"),
    $c4d570b5699fdc45$var$load("27osy")
]).then(()=>parcelRequire('6T3IK'));

});

parcelRegister("jXXTm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c95ca5773a013d33452a456ad3fda3ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e891fc467a4625b3$var$_react = $e891fc467a4625b3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e891fc467a4625b3$var$_iconNew = $e891fc467a4625b3$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $e891fc467a4625b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/atom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e891fc467a4625b3$var$AtomIcon = (props)=>/*#__PURE__*/ $e891fc467a4625b3$var$_react.default.createElement($e891fc467a4625b3$var$_iconNew.default, Object.assign({
        name: "AtomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.87 1.42c1.566-.567 3.258-.667 4.318.393 1.059 1.059.959 2.75.392 4.317A11 11 0 0 1 13.683 8c.376.635.678 1.265.897 1.87.567 1.566.667 3.258-.393 4.318-1.059 1.059-2.75.959-4.317.392A11 11 0 0 1 8 13.683a11 11 0 0 1-1.87.897c-1.566.567-3.258.667-4.317-.393-1.06-1.059-.96-2.75-.393-4.317.219-.605.52-1.235.896-1.87a11 11 0 0 1-.896-1.87c-.567-1.566-.667-3.258.393-4.317C2.872.753 4.563.853 6.13 1.42c.605.219 1.235.52 1.87.896a11 11 0 0 1 1.87-.896M3.26 9.397a9 9 0 0 0-.43.983c-.521 1.44-.362 2.342.043 2.747s1.306.564 2.747.043a9 9 0 0 0 .983-.43 17 17 0 0 1-1.785-1.558A17 17 0 0 1 3.26 9.397m9.48 0a17.4 17.4 0 0 1-3.343 3.342q.507.258.983.431c1.44.521 2.342.362 2.747-.043s.564-1.306.043-2.747a9 9 0 0 0-.43-.983M8 4.099a15.5 15.5 0 0 0-2.121 1.78A15.5 15.5 0 0 0 4.099 8a15.4 15.4 0 0 0 1.78 2.121A15.5 15.5 0 0 0 8 11.901a15.5 15.5 0 0 0 2.121-1.78A15.5 15.5 0 0 0 11.901 8a15.5 15.5 0 0 0-1.78-2.121A15.5 15.5 0 0 0 8 4.099M5.62 2.83c-1.44-.521-2.342-.362-2.747.043S2.31 4.18 2.83 5.62q.173.475.43.983c.46-.607.981-1.207 1.558-1.785A17 17 0 0 1 6.603 3.26a9 9 0 0 0-.983-.43m7.507.043c-.405-.405-1.306-.564-2.747-.043a9 9 0 0 0-.983.43c.607.46 1.207.981 1.785 1.558a17 17 0 0 1 1.557 1.785 9 9 0 0 0 .431-.983c.521-1.44.362-2.342-.043-2.747"/><path fill="currentcolor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$e891fc467a4625b3$var$AtomIcon.displayName = 'AtomIcon';
var $e891fc467a4625b3$var$_default = module.exports.default = $e891fc467a4625b3$var$AtomIcon;

});

parcelRegister("c3lyu", function(module, exports) {
const $be21f0b9ea195bc3$export$6ba840931da50680 = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
module.exports["isRecord"] = $be21f0b9ea195bc3$export$6ba840931da50680;

});

parcelRegister("fw2IV", function(module, exports) {
/**
 * Registered in `atlassian-cookies` as a STARTS_WITH pattern under `Products.ALL`, covering
 * everything after it. Keys losing this prefix are blocked in every product.
 */ const $b9890677bf0186b6$var$CACHE_KEY_PREFIX = 'rovo-potd:';
/** Bump when the shape stored under a key changes incompatibly. */ const $b9890677bf0186b6$var$CACHE_KEY_VERSION = 'v1';
/** Key order is not part of the request, so it must not change the entry a caller lands on. */ const $b9890677bf0186b6$var$stableStringify = (value)=>{
    if (Array.isArray(value)) return `[${value.map($b9890677bf0186b6$var$stableStringify).join(',')}]`;
    if (typeof value === 'object' && value !== null) {
        const entries = Object.entries(value).filter(([, entryValue])=>entryValue !== undefined).sort(([left], [right])=>left < right ? -1 : 1).map(([key, entryValue])=>`${JSON.stringify(key)}:${$b9890677bf0186b6$var$stableStringify(entryValue)}`);
        return `{${entries.join(',')}}`;
    }
    return JSON.stringify(value) ?? 'null';
};
const $b9890677bf0186b6$var$getArgsFingerprint = (args)=>{
    const fingerprint = args === undefined ? '{}' : $b9890677bf0186b6$var$stableStringify(args);
    return fingerprint === '{}' ? 'default' : fingerprint;
};
const $b9890677bf0186b6$export$2b81a9244368ace9 = ({ slug: slug, accountId: accountId, args: args })=>`${$b9890677bf0186b6$var$CACHE_KEY_PREFIX}${$b9890677bf0186b6$var$CACHE_KEY_VERSION}:${slug}:${accountId}:${$b9890677bf0186b6$var$getArgsFingerprint(args)}`;
module.exports["getGeneratedCacheKey"] = $b9890677bf0186b6$export$2b81a9244368ace9;

});

parcelRegister("01fMp", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");


var $conW6 = parcelRequire("conW6");


var $c3lyu = parcelRequire("c3lyu");


var $fw2IV = parcelRequire("fw2IV");

const $92dfc9cec0c5dccc$export$844dcb22a9dfd40a = (slug)=>`/gateway/api/potd/${slug}/generate`;
/**
 * Outlives every mount, so remounting does not re-ask and two surfaces mounted together share one
 * answer. It is also what keeps a consent-blocked storage write from costing a request per mount.
 */ const $92dfc9cec0c5dccc$var$memoryCache = new Map();
/** One entry per key while a request is open, so concurrent callers share a single POST. */ const $92dfc9cec0c5dccc$var$inFlightRequests = new Map();
const $92dfc9cec0c5dccc$var$requestOutput = async ({ slug: slug, args: args }, fetchFn)=>{
    const performFetch = fetchFn ?? globalThis.fetch;
    if (typeof performFetch !== 'function') return null;
    const response = await performFetch($92dfc9cec0c5dccc$export$844dcb22a9dfd40a(slug), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            args: args ?? {}
        })
    });
    const body = response.ok ? await response.json() : null;
    return (0, $c3lyu.isRecord)(body) && body.status === 'ok' ? body.output : null;
};
/**
 * Issues the network request and writes whatever comes back into both caches, whatever the
 * outcome, so a repeated read (or a repeated refresh) at most asks once for as long as the request
 * is open. Shared by `fetchGenerated` and `refreshGenerated` — the only difference between the two
 * is whether a cache hit is allowed to short-circuit this.
 */ const $92dfc9cec0c5dccc$var$requestAndCache = (request, cacheKey, { parse: parse, getExpiresAt: getExpiresAt, fetchFn: fetchFn })=>{
    const pendingRequest = $92dfc9cec0c5dccc$var$requestOutput(request, fetchFn).catch(()=>null).then((output)=>{
        const data = parse(output);
        const generatedAt = Date.now();
        const expiresAt = getExpiresAt(generatedAt);
        // Recorded whatever the outcome, `null` included, so one page load asks at most once.
        $92dfc9cec0c5dccc$var$memoryCache.set(cacheKey, {
            expiresAt: expiresAt,
            data: data
        });
        if (data !== null) // The served `output`, not `data`, so reading another of its fields later needs no new
        // cache version.
        (0, $conW6.writeBrowserStorageCache)((0, $7dBf8.AtlBrowserStorageLocal), cacheKey, {
            expiresAt: expiresAt,
            generatedAt: generatedAt,
            value: output
        });
        return data;
    }).finally(()=>{
        $92dfc9cec0c5dccc$var$inFlightRequests.delete(cacheKey);
    });
    $92dfc9cec0c5dccc$var$inFlightRequests.set(cacheKey, pendingRequest);
    return pendingRequest;
};
const $92dfc9cec0c5dccc$export$35e92f217ceb9ac9 = async (request, options)=>{
    const cacheKey = (0, $fw2IV.getGeneratedCacheKey)(request);
    const now = Date.now();
    const memoryEntry = $92dfc9cec0c5dccc$var$memoryCache.get(cacheKey);
    if (memoryEntry !== undefined && memoryEntry.expiresAt > now) return memoryEntry.data;
    const storedEntry = (0, $conW6.readBrowserStorageCache)((0, $7dBf8.AtlBrowserStorageLocal), cacheKey, options.parse, now);
    if (storedEntry !== null) {
        $92dfc9cec0c5dccc$var$memoryCache.set(cacheKey, {
            expiresAt: storedEntry.expiresAt,
            data: storedEntry.value
        });
        return storedEntry.value;
    }
    const openRequest = $92dfc9cec0c5dccc$var$inFlightRequests.get(cacheKey);
    if (openRequest !== undefined) return openRequest;
    return $92dfc9cec0c5dccc$var$requestAndCache(request, cacheKey, options);
};
const $92dfc9cec0c5dccc$export$c356c98ff4cbe122 = async (request, options)=>{
    const cacheKey = (0, $fw2IV.getGeneratedCacheKey)(request);
    const openRequest = $92dfc9cec0c5dccc$var$inFlightRequests.get(cacheKey);
    if (openRequest !== undefined) return openRequest;
    return $92dfc9cec0c5dccc$var$requestAndCache(request, cacheKey, options);
};
const $92dfc9cec0c5dccc$export$448d1ea4f6afdf87 = (request, parse, output, timestamps)=>{
    const cacheKey = (0, $fw2IV.getGeneratedCacheKey)(request);
    // An expired entry stays out of memory, so it cannot overwrite the record of a request that failed.
    if (timestamps.expiresAt > Date.now()) $92dfc9cec0c5dccc$var$memoryCache.set(cacheKey, {
        expiresAt: timestamps.expiresAt,
        data: parse(output)
    });
    (0, $conW6.writeBrowserStorageCache)((0, $7dBf8.AtlBrowserStorageLocal), cacheKey, {
        ...timestamps,
        value: output
    });
};
const $92dfc9cec0c5dccc$export$3038deefa7da4758 = ()=>{
    $92dfc9cec0c5dccc$var$memoryCache.clear();
    $92dfc9cec0c5dccc$var$inFlightRequests.clear();
};
module.exports["getGenerateEndpoint"] = $92dfc9cec0c5dccc$export$844dcb22a9dfd40a;
module.exports["fetchGenerated"] = $92dfc9cec0c5dccc$export$35e92f217ceb9ac9;
module.exports["replaceGeneratedOutput"] = $92dfc9cec0c5dccc$export$448d1ea4f6afdf87;

});

parcelRegister("conW6", function(module, exports) {

var $c3lyu = parcelRequire("c3lyu");

const $1f656b41504bea8f$export$5b34ec7f39633cbe = (storage, key, parseValue, now)=>{
    try {
        const cached = JSON.parse(storage.getItem(key) ?? 'null');
        if (!(0, $c3lyu.isRecord)(cached) || typeof cached.expiresAt !== 'number' || cached.expiresAt <= now) return null;
        const value = parseValue(cached.value);
        return value === null ? null : {
            expiresAt: cached.expiresAt,
            value: value
        };
    } catch  {
        return null;
    }
};
const $1f656b41504bea8f$export$b9416c674486703b = (storage, key, entry)=>{
    try {
        storage.setItem(key, JSON.stringify(entry)).catch(()=>undefined);
    } catch  {
    // Caching is optional and must not affect the caller's behavior. A write blocked by consent
    // needs no handling here: the caller has already kept the value in memory for this page load.
    }
};
module.exports["readBrowserStorageCache"] = $1f656b41504bea8f$export$5b34ec7f39633cbe;
module.exports["writeBrowserStorageCache"] = $1f656b41504bea8f$export$b9416c674486703b;

});

parcelRegister("f0mIG", function(module, exports) {

var $01fMp = parcelRequire("01fMp");


var $crUKl = parcelRequire("crUKl");

const $a3ec8dda875a65c8$export$b464e5802454e37c = 'prompt-of-the-day';
const $a3ec8dda875a65c8$export$c9da951bc690df99 = (0, $01fMp.getGenerateEndpoint)($a3ec8dda875a65c8$export$b464e5802454e37c);
/**
 * A suggestion is stale once the day it belongs to is over. A rolling 24h window would instead keep
 * yesterday's prompt until the same hour tomorrow for anyone who loaded the page late in the day.
 */ const $a3ec8dda875a65c8$var$getNextLocalMidnight = (now)=>{
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    return midnight.getTime();
};
const $a3ec8dda875a65c8$export$ff610c3b7744ac4d = {
    parse: (0, $crUKl.parsePromptsFromOutput),
    getExpiresAt: $a3ec8dda875a65c8$var$getNextLocalMidnight
};
const $a3ec8dda875a65c8$export$86033784e77d9857 = ({ accountId: accountId, args: args }, { fetchFn: fetchFn } = {})=>(0, $01fMp.fetchGenerated)({
        slug: $a3ec8dda875a65c8$export$b464e5802454e37c,
        accountId: accountId,
        args: args
    }, {
        ...$a3ec8dda875a65c8$export$ff610c3b7744ac4d,
        fetchFn: fetchFn
    });
module.exports["PROMPT_OF_THE_DAY_SLUG"] = $a3ec8dda875a65c8$export$b464e5802454e37c;
module.exports["PROMPT_OF_THE_DAY_OPTIONS"] = $a3ec8dda875a65c8$export$ff610c3b7744ac4d;
module.exports["fetchPromptOfTheDay"] = $a3ec8dda875a65c8$export$86033784e77d9857;

});

parcelRegister("crUKl", function(module, exports) {

var $c3lyu = parcelRequire("c3lyu");

const $66f890305a22b1ce$var$parseNonEmptyString = (value)=>{
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    return trimmed === '' ? null : trimmed;
};
const $66f890305a22b1ce$var$parseNonEmptyStrings = (value)=>{
    if (!Array.isArray(value)) return undefined;
    const strings = value.map($66f890305a22b1ce$var$parseNonEmptyString).filter((item)=>item !== null);
    return strings.length > 0 ? strings : undefined;
};
// Optional and best-effort: anything malformed is dropped, never the prompt it belongs to.
const $66f890305a22b1ce$var$parseMetadata = (value)=>{
    if (!(0, $c3lyu.isRecord)(value) || !(0, $c3lyu.isRecord)(value.highlights)) return undefined;
    const shortPrompt = $66f890305a22b1ce$var$parseNonEmptyStrings(value.highlights.shortPrompt);
    return shortPrompt !== undefined ? {
        highlights: {
            shortPrompt: shortPrompt
        }
    } : undefined;
};
const $66f890305a22b1ce$var$parsePrompt = (value)=>{
    if (!(0, $c3lyu.isRecord)(value)) return null;
    const shortPrompt = $66f890305a22b1ce$var$parseNonEmptyString(value.shortPrompt);
    if (shortPrompt === null) return null;
    const title = $66f890305a22b1ce$var$parseNonEmptyString(value.title);
    const expandedPrompt = $66f890305a22b1ce$var$parseNonEmptyString(value.expandedPrompt);
    const sources = $66f890305a22b1ce$var$parseNonEmptyStrings(value.sources);
    const metadata = $66f890305a22b1ce$var$parseMetadata(value.metadata);
    return {
        shortPrompt: shortPrompt,
        ...title !== null && {
            title: title
        },
        ...expandedPrompt !== null && {
            expandedPrompt: expandedPrompt
        },
        ...sources !== undefined && {
            sources: sources
        },
        ...metadata !== undefined && {
            metadata: metadata
        }
    };
};
const $66f890305a22b1ce$export$c994a8fcec78361 = (output)=>{
    if (!(0, $c3lyu.isRecord)(output) || !Array.isArray(output.prompts)) return null;
    const prompts = output.prompts.map($66f890305a22b1ce$var$parsePrompt);
    return prompts.length > 0 && prompts.every((prompt)=>prompt !== null) ? prompts : null;
};
module.exports["parsePromptsFromOutput"] = $66f890305a22b1ce$export$c994a8fcec78361;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");


var $c5JFM = parcelRequire("c5JFM");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(12);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
        $[0] = t0;
    } else t0 = $[0];
    const includeMeetingRecorderEligibility = t0;
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t1;
    if ($[1] !== cloudId) {
        t1 = {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        };
        $[1] = cloudId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== activationId || $[4] !== cloudId) {
        t2 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[3] = activationId;
        $[4] = cloudId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            headers: {
                ...t2
            }
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const t4 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t5;
    if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            variables: t1,
            context: t3,
            skip: t4
        };
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        ...t5,
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const includeMeetingRecorderEligibility = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__),
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== initLoomEntryPointVariant || $[5] !== loading || $[6] !== skip || $[7] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = initLoomEntryPointVariant;
        $[5] = loading;
        $[6] = skip;
        $[7] = userId;
        $[8] = t5;
        $[9] = t6;
    } else {
        t5 = $[8];
        t6 = $[9];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[10] = t7;
        } else t7 = $[10];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("fu2Vq"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $cozmU.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("fu2Vq", function(module, exports) {

let $b45bed3ed025790a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b45bed3ed025790a$var$load("6wr18"),
    $b45bed3ed025790a$var$load("dQT3c"),
    $b45bed3ed025790a$var$load("4nZ85"),
    $b45bed3ed025790a$var$load("ffEVr"),
    $b45bed3ed025790a$var$load("kHXvF"),
    $b45bed3ed025790a$var$load("iWnyc"),
    $b45bed3ed025790a$var$load("hhss7"),
    $b45bed3ed025790a$var$load("Wowvf"),
    $b45bed3ed025790a$var$load("4g6rd"),
    $b45bed3ed025790a$var$load("7EorR"),
    $b45bed3ed025790a$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("zCcSI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kwzZh = parcelRequire("kwzZh");


var $6mKj3 = parcelRequire("6mKj3");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $jyA9t = parcelRequire("jyA9t");


var $c96tF = parcelRequire("c96tF");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$var$AGENT_MENU_CREATE_SOURCE = 'confluence-rovo-agent-menu-create-agent';
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $cozmU.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    // Keep the config object identity stable when its semantic inputs are stable.
    const assistanceServiceConfig = (0, $cozmU.useMemo)(()=>({
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        }), [
        assistanceServiceConfigHeaders
    ]);
    return (0, $cozmU.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            product: 'confluence',
            orgId: orgId,
            assistanceServiceConfig: assistanceServiceConfig,
            emojiProvider: emojiProvider,
            userId: userId ?? undefined,
            preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
            preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
        }), [
        assistanceServiceConfig,
        cloudId,
        emojiProvider,
        orgId,
        preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose,
        userId
    ]);
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $kSwu1.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const navigateToObject = (0, $cozmU.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $cozmU.useCallback)(({ feedbackVariant: feedbackVariant, sourceEntryPoint: sourceEntryPoint, currentConversationId: currentConversationId, traceId: traceId, requestId: requestId, remixMetadata: remixMetadata, contentType: contentType, contentMode: contentMode })=>{
        if (shouldHideFeedback) return;
        if (feedbackVariant === undefined) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: feedbackVariant,
            sourceEntryPoint: sourceEntryPoint,
            contentType: contentType,
            contentMode: contentMode,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined,
            traceId: traceId,
            requestId: requestId,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    const handleCreateAgent = (0, $cozmU.useCallback)(()=>{
        if (!(0, $6mKj3.expVal)('cc_contextual_agent_creation_v2', 'isEnabled', false)) return;
        openModal({
            entryPoint: $e34c3f63766da5b3$var$AGENT_MENU_CREATE_SOURCE,
            initialOutcomeType: 'agent',
            lockInitialOutcomeType: true
        });
    }, [
        openModal
    ]);
    // Keep uiConfig identity stable when handler/greeting inputs are stable.
    return (0, $cozmU.useMemo)(()=>({
            customHandlers: {
                onCreateAgentClick: handleCreateAgent,
                handleSubmitSmartCreate: navigateToObject,
                handleCloseSmartCreate: handleCloseSmartCreate
            },
            elements: {
                voiceDictationButton: true,
                shouldShowGreeting: shouldShowGreeting ?? undefined
            },
            customGreeting: customGreeting ?? undefined
        }), [
        customGreeting,
        handleCloseSmartCreate,
        handleCreateAgent,
        navigateToObject,
        shouldShowGreeting
    ]);
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("jyA9t", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    isLoomRecorderOpen: false,
    attachedLoomVideo: null,
    submittedWithLoomAttachment: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    initialPrompt: undefined,
    initialOutcomeType: undefined,
    lockInitialOutcomeType: false,
    remixConversationId: null,
    onboardingData: undefined,
    onOnboardingSubmit: undefined,
    totalSteps: undefined,
    submitCallback: undefined,
    onCloseCallback: undefined,
    onOpenCallback: undefined,
    onSubmitCallback: undefined,
    editorInsertionAcknowledgement: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, initialPrompt: initialPrompt, initialOutcomeType: initialOutcomeType, lockInitialOutcomeType: lockInitialOutcomeType, submitCallback: submitCallback, onCloseCallback: onCloseCallback, onOpenCallback: onOpenCallback, onSubmitCallback: onSubmitCallback, editorInsertionAcknowledgement: editorInsertionAcknowledgement, remixConversationId: remixConversationIdFromOpen, onboardingData: onboardingData, onOnboardingSubmit: onOnboardingSubmit, totalSteps: totalSteps })=>({ setState: setState })=>{
            const floating = isFloating ?? false;
            const remixConversationId = floating && remixConversationIdFromOpen !== undefined && remixConversationIdFromOpen !== null && remixConversationIdFromOpen !== '' ? remixConversationIdFromOpen : null;
            setState({
                showSmartCreationModal: true,
                // A fresh open is never behind the recorder; clearing here also
                // recovers if a prior recorder session left the flag stuck on.
                isLoomRecorderOpen: false,
                // A fresh open never carries a prior session's attachment.
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: floating,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                initialPrompt: initialPrompt,
                initialOutcomeType: initialOutcomeType ?? undefined,
                // Lock requires an initial outcome type — guard against misuse.
                lockInitialOutcomeType: Boolean(initialOutcomeType && lockInitialOutcomeType),
                remixConversationId: remixConversationId,
                onboardingData: onboardingData ?? undefined,
                onOnboardingSubmit: onOnboardingSubmit ?? undefined,
                totalSteps: totalSteps ?? undefined,
                submitCallback: submitCallback ?? undefined,
                onCloseCallback: onCloseCallback ?? undefined,
                onOpenCallback: onOpenCallback ?? undefined,
                onSubmitCallback: onSubmitCallback ?? undefined,
                editorInsertionAcknowledgement: editorInsertionAcknowledgement ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                isLoomRecorderOpen: false,
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown',
                initialPrompt: undefined,
                initialOutcomeType: undefined,
                lockInitialOutcomeType: false,
                remixConversationId: null,
                onboardingData: undefined,
                onOnboardingSubmit: undefined,
                onCloseCallback: undefined,
                onOpenCallback: undefined,
                onSubmitCallback: undefined,
                editorInsertionAcknowledgement: undefined
            });
        },
    setLoomRecorderOpen: (isLoomRecorderOpen)=>({ setState: setState })=>{
            setState({
                isLoomRecorderOpen: isLoomRecorderOpen
            });
        },
    setAttachedLoomVideo: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                attachedLoomVideo: attachedLoomVideo
            });
        },
    setSubmittedWithLoomAttachment: (submittedWithLoomAttachment)=>({ setState: setState })=>{
            setState({
                submittedWithLoomAttachment: submittedWithLoomAttachment
            });
        },
    // Atomically reads-and-clears the marker from live store state (not a
    // render-lagged hook value) so the create/finalize step sees the value set
    // by the submit that immediately preceded it, and never fires twice or leaks
    // onto a later create.
    consumeSubmittedWithLoomAttachment: ()=>({ getState: getState, setState: setState })=>{
            const submitted = getState().submittedWithLoomAttachment;
            if (submitted) setState({
                submittedWithLoomAttachment: false
            });
            return submitted;
        },
    // Attaches a just-recorded Loom and forces the modal open. A recording can
    // finish after the modal was closed mid-record (reopened via global create,
    // then dismissed); the orphaned SDK "Add to prompt" callback fires here, so
    // reopening lets the attachment land on a visible modal instead of nowhere.
    attachLoomVideoAndOpenModal: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                attachedLoomVideo: attachedLoomVideo
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $kBr4q.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $kBr4q.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $kBr4q.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("4sZo0", function(module, exports) {

var $3U8XR = parcelRequire("3U8XR");


var $6ahXt = parcelRequire("6ahXt");

async function* $0629cd50fffd508d$export$e45226161c660403(response) {
    // Read the response body only if the status is 200 and the body is not null
    if (response.status === 200 && response.body) try {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            const decodedValue = decoder.decode(value);
            done = doneReading;
            buffer = `${buffer}${decodedValue}`;
            // Split the buffer by line breaks
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                const line = lines.shift();
                const parsedData = JSON.parse(line);
                yield parsedData;
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return;
    } catch (parsingError) {
        let errorText = '';
        if (typeof parsingError === 'string') errorText = parsingError.toUpperCase();
        else if (parsingError instanceof Error) errorText = parsingError.message;
        yield {
            type: 'ERROR',
            message: {
                content: `[Stream Error]: ${errorText}. locked status: ${response.body.locked}. statusCode: ${response.status}`,
                message_template: (0, $6ahXt.ConvoAIErrorMessage).UNEXPECTED,
                status_code: (0, $6ahXt.CONVOAI_DEFAULT_ERROR_CODE)
            }
        };
        return;
    }
    // parse the response body as text which should be safe
    const responseText = await response.text();
    try {
        // try to parse the response body as json
        const responseJson = JSON.parse(responseText);
        // covered HTTP errors only from this doc
        // https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3420210503/Error+message+formats+-+assistance-service
        // Kept for extra error handling security as we migrate to convo-ai from agent service
        yield (0, $3U8XR.match)({
            status: response.status,
            body: response.body,
            text: responseText,
            json: responseJson
        }).returnType().with({
            status: 201
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: No answer was generated by Open AI. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $6ahXt.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 400
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: BAD_REQUEST or NO_AGENT or EXCEEDING_CONTEXT_LENGTH_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $6ahXt.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 403
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: FEATURE_DISABLED_ON_SITE or FEATURE_DISABLED or HIPAA_CONTENT_DETECTED. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $6ahXt.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 429
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: RATE_LIMIT or OPENAI_RATE_LIMIT_USER_ABUSE. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $6ahXt.ConvoAIErrorMessage).RATE_LIMIT,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 500
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: INTERNAL_SERVER_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $6ahXt.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            body: (0, $3U8XR.P).nullish
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[Error]: response.body is missing. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $6ahXt.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).otherwise(({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: OTHER_SERVER_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $6ahXt.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            }));
    } catch (error) {
        yield {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: UNABLE_TO_PARSE_HTTP_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $6ahXt.ConvoAIErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }
}
module.exports["readStream"] = $0629cd50fffd508d$export$e45226161c660403;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _0hPCNLDIqT _0KLXruoI2d _1mT5xdRAKS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _0hPCNLDIqT _0KLXruoI2d _1mT5xdRAKS",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYENHnM _4xdlr0FlnN",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYENHnM _4xdlr0FlnN",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2Xe1MPzUZr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2Xe1MPzUZr",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDKxmn _30huDKQaTT _2uo31foI2d _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _30huDKQaTT _2uo31foI2d _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $e5ba90f4b97bd7c1$var$i18n = (0, $kSwu1.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("gd8AW", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $8s9DV.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $kBr4q.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $kBr4q.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");

var $esV19 = parcelRequire("esV19");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $6Mfv2.default)((0, $gkHoc.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $esV19.default)(cutoffDate) ? (0, $6Mfv2.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("1I9Gw", function(module, exports) {
const $f0a04d35c062874d$export$1598149f6f3f7d46 = (spaceKey)=>{
    return spaceKey?.[0] === '~';
};
module.exports["isPersonalSpace"] = $f0a04d35c062874d$export$1598149f6f3f7d46;

});

parcelRegister("9Ke0t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79d00c97b076e624cafe200482318a3d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7183465f1a1868e6$var$_react = $7183465f1a1868e6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7183465f1a1868e6$var$_iconNew = $7183465f1a1868e6$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7183465f1a1868e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GenerativeIndicator".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/generative-indicator
 * Usage guidance:
 * Reserved for indicating generative and suggested content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7183465f1a1868e6$var$GenerativeIndicatorIcon = (props)=>/*#__PURE__*/ $7183465f1a1868e6$var$_react.default.createElement($7183465f1a1868e6$var$_iconNew.default, Object.assign({
        name: "GenerativeIndicatorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.117 1.009a.75.75 0 0 1 .588.484l1.55 4.251 4.252 1.55A.75.75 0 0 1 15 8v.002a.75.75 0 0 1-.493.704l-4.252 1.55-1.55 4.252a.75.75 0 0 1-.704.493h-.002a.75.75 0 0 1-.704-.493l-1.55-4.252-4.252-1.55A.75.75 0 0 1 1 8.001v-.002a.75.75 0 0 1 .493-.704l4.251-1.55 1.55-4.252.049-.106A.75.75 0 0 1 7.999 1h.002z"/>`
    }, props));
$7183465f1a1868e6$var$GenerativeIndicatorIcon.displayName = 'GenerativeIndicatorIcon';
var $7183465f1a1868e6$var$_default = module.exports.default = $7183465f1a1868e6$var$GenerativeIndicatorIcon;

});

parcelRegister("3Am3T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $cozmU.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { contentId: contentId, children: children } = t0;
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    let t1;
    if ($[0] !== children || $[1] !== commentCounts) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
            value: commentCounts
        }, children);
        $[0] = children;
        $[1] = commentCounts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("dF5G8", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $eefe01aff44a51d3$export$2e8f8ad7223eff71 = (0, $kSwu1.defineMessages)({
    reviewSuggestionsLabel: {
        id: "object-sidebar-components.review-suggestions.button.label",
        defaultMessage: "Review suggestions"
    }
});
module.exports["reviewButtonMessages"] = $eefe01aff44a51d3$export$2e8f8ad7223eff71;

});

parcelRegister("2FDVd", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $75070bb589e76133$export$3cce5d4c8b8a1da0 = (0, $kSwu1.defineMessages)({
    buttonLabel: {
        id: "floating-table-of-contents-common.button-label",
        defaultMessage: "Table of contents"
    }
});
module.exports["tableOfContentsButtonMessages"] = $75070bb589e76133$export$3cce5d4c8b8a1da0;

});

parcelRegister("5qQdB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $lpNn5 = parcelRequire("lpNn5");


var $clm0n = parcelRequire("clm0n");


var $2FDVd = parcelRequire("2FDVd");

function $b7ce1064e1aa0864$export$c7e43f4a82ad66db() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const label = formatMessage((0, $2FDVd.tableOfContentsButtonMessages).buttonLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: label,
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($clm0n))),
        label: label,
        isDisabled: true,
        testId: "sidebar-table-of-contents-button"
    }));
}
module.exports["TableOfContentsButtonPlaceholder"] = $b7ce1064e1aa0864$export$c7e43f4a82ad66db;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $cozmU = parcelRequire("cozmU");


var $4L9ve = parcelRequire("4L9ve");

const $c085ac79a8833850$export$453b7c79178856e5 = (_contentId)=>{
    // Get processed comment data from the Comments Data Manager store
    const { isDataProcessed: isDataProcessed, openInlineComments: openInlineComments, openFooterComments: openFooterComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    return (0, $cozmU.useMemo)(()=>{
        if (isDataProcessed) return {
            unresolvedInlineCommentsCount: openInlineComments.length,
            footerCommentsCount: openFooterComments.length
        };
        // Fallback when data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        isDataProcessed,
        openInlineComments.length,
        openFooterComments.length
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});


//# sourceMappingURL=ObjectSidebarControl.f1dfe845.js.map
